{
  "targetPlay": {
    "id": "target",
    "matchId": "10517",
    "sequenceId": "148.0",
    "frames": [
      {
        "ball": {
          "x": 3.21,
          "y": -8.7,
          "z": 0.53
        },
        "homePlayers": [
          {
            "x": 0.06,
            "y": -20.68
          },
          {
            "x": 19.89,
            "y": -14.56
          },
          {
            "x": 12.38,
            "y": -11.65
          },
          {
            "x": 21.82,
            "y": 9.38
          },
          {
            "x": 44.95,
            "y": -5.5
          },
          {
            "x": 3.05,
            "y": -8.32
          },
          {
            "x": 9.61,
            "y": -25.89
          },
          {
            "x": 7.18,
            "y": -14.03
          },
          {
            "x": 23.17,
            "y": -3.28
          },
          {
            "x": 11.65,
            "y": 0.25
          },
          {
            "x": 19.89,
            "y": -24.89
          }
        ],
        "awayPlayers": [
          {
            "x": 16.01,
            "y": -16.07
          },
          {
            "x": -4.15,
            "y": -19.95
          },
          {
            "x": 6.52,
            "y": -24.32
          },
          {
            "x": 15.76,
            "y": -23.92
          },
          {
            "x": 5.55,
            "y": -14.14
          },
          {
            "x": -1.71,
            "y": -6.51
          },
          {
            "x": -34.71,
            "y": -5.15
          },
          {
            "x": 7.05,
            "y": -11.51
          },
          {
            "x": -0.37,
            "y": 5.56
          },
          {
            "x": -6.05,
            "y": -32.88
          },
          {
            "x": 18.0,
            "y": 7.89
          }
        ],
        "time": 0.0
      },
      {
        "ball": {
          "x": 1.55,
          "y": -8.53,
          "z": 0.01
        },
        "homePlayers": [
          {
            "x": -0.64,
            "y": -19.9
          },
          {
            "x": 19.41,
            "y": -13.46
          },
          {
            "x": 12.04,
            "y": -10.87
          },
          {
            "x": 21.27,
            "y": 9.67
          },
          {
            "x": 44.7,
            "y": -5.31
          },
          {
            "x": 2.37,
            "y": -9.31
          },
          {
            "x": 8.86,
            "y": -26.07
          },
          {
            "x": 6.77,
            "y": -13.5
          },
          {
            "x": 22.98,
            "y": -2.85
          },
          {
            "x": 11.09,
            "y": 0.84
          },
          {
            "x": 19.74,
            "y": -24.22
          }
        ],
        "awayPlayers": [
          {
            "x": 15.25,
            "y": -15.56
          },
          {
            "x": -4.3,
            "y": -18.92
          },
          {
            "x": 5.42,
            "y": -23.85
          },
          {
            "x": 16.0,
            "y": -23.32
          },
          {
            "x": 4.79,
            "y": -13.18
          },
          {
            "x": -1.17,
            "y": -6.94
          },
          {
            "x": -35.02,
            "y": -5.01
          },
          {
            "x": 7.23,
            "y": -10.36
          },
          {
            "x": -0.62,
            "y": 5.66
          },
          {
            "x": -6.07,
            "y": -33.02
          },
          {
            "x": 17.7,
            "y": 7.75
          }
        ],
        "time": 0.334
      },
      {
        "ball": {
          "x": 0.56,
          "y": -8.24,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -1.79,
            "y": -19.67
          },
          {
            "x": 18.73,
            "y": -12.65
          },
          {
            "x": 11.56,
            "y": -10.29
          },
          {
            "x": 20.45,
            "y": 10.23
          },
          {
            "x": 44.45,
            "y": -5.14
          },
          {
            "x": 1.29,
            "y": -10.35
          },
          {
            "x": 7.86,
            "y": -26.2
          },
          {
            "x": 6.15,
            "y": -13.33
          },
          {
            "x": 22.69,
            "y": -2.43
          },
          {
            "x": 10.09,
            "y": 1.64
          },
          {
            "x": 19.54,
            "y": -24.04
          }
        ],
        "awayPlayers": [
          {
            "x": 14.31,
            "y": -15.21
          },
          {
            "x": -4.98,
            "y": -18.18
          },
          {
            "x": 3.93,
            "y": -23.43
          },
          {
            "x": 15.9,
            "y": -22.8
          },
          {
            "x": 3.49,
            "y": -12.54
          },
          {
            "x": -1.16,
            "y": -7.86
          },
          {
            "x": -35.54,
            "y": -5.0
          },
          {
            "x": 7.09,
            "y": -9.17
          },
          {
            "x": -1.16,
            "y": 5.65
          },
          {
            "x": -6.05,
            "y": -33.26
          },
          {
            "x": 17.35,
            "y": 7.79
          }
        ],
        "time": 0.667
      },
      {
        "ball": {
          "x": -0.56,
          "y": -11.39,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -3.32,
            "y": -20.05
          },
          {
            "x": 17.87,
            "y": -11.94
          },
          {
            "x": 10.85,
            "y": -9.91
          },
          {
            "x": 19.38,
            "y": 10.79
          },
          {
            "x": 44.11,
            "y": -4.95
          },
          {
            "x": -0.09,
            "y": -11.6
          },
          {
            "x": 6.58,
            "y": -26.29
          },
          {
            "x": 5.37,
            "y": -13.38
          },
          {
            "x": 22.02,
            "y": -2.0
          },
          {
            "x": 8.68,
            "y": 2.5
          },
          {
            "x": 18.88,
            "y": -24.11
          }
        ],
        "awayPlayers": [
          {
            "x": 13.19,
            "y": -14.95
          },
          {
            "x": -6.34,
            "y": -17.75
          },
          {
            "x": 2.19,
            "y": -23.16
          },
          {
            "x": 15.31,
            "y": -22.51
          },
          {
            "x": 1.79,
            "y": -12.56
          },
          {
            "x": -1.89,
            "y": -9.12
          },
          {
            "x": -35.99,
            "y": -5.0
          },
          {
            "x": 6.41,
            "y": -8.24
          },
          {
            "x": -2.08,
            "y": 5.39
          },
          {
            "x": -6.02,
            "y": -33.56
          },
          {
            "x": 16.78,
            "y": 7.87
          }
        ],
        "time": 1.001
      },
      {
        "ball": {
          "x": -2.6,
          "y": -13.36,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -5.02,
            "y": -20.66
          },
          {
            "x": 16.77,
            "y": -11.3
          },
          {
            "x": 10.02,
            "y": -9.61
          },
          {
            "x": 18.17,
            "y": 11.11
          },
          {
            "x": 43.76,
            "y": -4.75
          },
          {
            "x": -1.62,
            "y": -12.82
          },
          {
            "x": 5.25,
            "y": -26.34
          },
          {
            "x": 4.48,
            "y": -13.48
          },
          {
            "x": 21.52,
            "y": -1.82
          },
          {
            "x": 6.98,
            "y": 3.39
          },
          {
            "x": 17.73,
            "y": -24.31
          }
        ],
        "awayPlayers": [
          {
            "x": 11.96,
            "y": -14.87
          },
          {
            "x": -8.07,
            "y": -17.64
          },
          {
            "x": 0.28,
            "y": -22.9
          },
          {
            "x": 14.13,
            "y": -22.4
          },
          {
            "x": -0.03,
            "y": -13.24
          },
          {
            "x": -3.05,
            "y": -10.35
          },
          {
            "x": -36.61,
            "y": -5.08
          },
          {
            "x": 5.32,
            "y": -7.56
          },
          {
            "x": -3.28,
            "y": 5.16
          },
          {
            "x": -5.95,
            "y": -33.76
          },
          {
            "x": 16.07,
            "y": 8.05
          }
        ],
        "time": 1.335
      },
      {
        "ball": {
          "x": -4.65,
          "y": -14.72,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -6.96,
            "y": -21.28
          },
          {
            "x": 16.14,
            "y": -11.05
          },
          {
            "x": 9.12,
            "y": -9.43
          },
          {
            "x": 16.68,
            "y": 11.16
          },
          {
            "x": 43.47,
            "y": -4.68
          },
          {
            "x": -3.41,
            "y": -14.03
          },
          {
            "x": 3.83,
            "y": -26.5
          },
          {
            "x": 3.46,
            "y": -13.62
          },
          {
            "x": 20.4,
            "y": -1.79
          },
          {
            "x": 5.07,
            "y": 4.32
          },
          {
            "x": 16.47,
            "y": -24.63
          }
        ],
        "awayPlayers": [
          {
            "x": 10.72,
            "y": -14.83
          },
          {
            "x": -10.02,
            "y": -17.71
          },
          {
            "x": -1.79,
            "y": -22.68
          },
          {
            "x": 13.45,
            "y": -22.43
          },
          {
            "x": -1.96,
            "y": -14.16
          },
          {
            "x": -4.54,
            "y": -11.81
          },
          {
            "x": -37.3,
            "y": -5.07
          },
          {
            "x": 3.96,
            "y": -7.39
          },
          {
            "x": -4.75,
            "y": 4.83
          },
          {
            "x": -5.93,
            "y": -33.9
          },
          {
            "x": 14.86,
            "y": 8.18
          }
        ],
        "time": 1.668
      },
      {
        "ball": {
          "x": -6.26,
          "y": -16.07,
          "z": 0.03
        },
        "homePlayers": [
          {
            "x": -9.07,
            "y": -22.03
          },
          {
            "x": 16.05,
            "y": -11.98
          },
          {
            "x": 8.22,
            "y": -9.39
          },
          {
            "x": 15.87,
            "y": 11.04
          },
          {
            "x": 43.08,
            "y": -4.68
          },
          {
            "x": -5.34,
            "y": -15.25
          },
          {
            "x": 2.44,
            "y": -26.73
          },
          {
            "x": 2.36,
            "y": -13.83
          },
          {
            "x": 19.24,
            "y": -1.78
          },
          {
            "x": 3.03,
            "y": 5.02
          },
          {
            "x": 15.46,
            "y": -24.64
          }
        ],
        "awayPlayers": [
          {
            "x": 9.46,
            "y": -15.08
          },
          {
            "x": -12.04,
            "y": -18.17
          },
          {
            "x": -3.96,
            "y": -22.38
          },
          {
            "x": 13.11,
            "y": -16.55
          },
          {
            "x": -4.02,
            "y": -15.25
          },
          {
            "x": -6.24,
            "y": -13.43
          },
          {
            "x": -37.87,
            "y": -5.1
          },
          {
            "x": 2.5,
            "y": -7.64
          },
          {
            "x": -6.37,
            "y": 4.38
          },
          {
            "x": -3.56,
            "y": -33.06
          },
          {
            "x": 14.3,
            "y": 8.2
          }
        ],
        "time": 2.002
      },
      {
        "ball": {
          "x": -7.9,
          "y": -18.3,
          "z": 0.87
        },
        "homePlayers": [
          {
            "x": -11.32,
            "y": -22.71
          },
          {
            "x": 16.17,
            "y": -13.56
          },
          {
            "x": 7.31,
            "y": -9.38
          },
          {
            "x": 11.33,
            "y": 6.63
          },
          {
            "x": 42.76,
            "y": -4.76
          },
          {
            "x": -7.23,
            "y": -16.64
          },
          {
            "x": 1.02,
            "y": -27.04
          },
          {
            "x": 1.17,
            "y": -14.03
          },
          {
            "x": 17.82,
            "y": -1.75
          },
          {
            "x": 0.85,
            "y": 5.64
          },
          {
            "x": 14.59,
            "y": -24.76
          }
        ],
        "awayPlayers": [
          {
            "x": 8.23,
            "y": -15.32
          },
          {
            "x": -14.11,
            "y": -18.79
          },
          {
            "x": -6.23,
            "y": -21.99
          },
          {
            "x": 13.59,
            "y": -9.83
          },
          {
            "x": -6.19,
            "y": -16.4
          },
          {
            "x": -8.11,
            "y": -14.92
          },
          {
            "x": -38.49,
            "y": -5.08
          },
          {
            "x": 0.93,
            "y": -8.06
          },
          {
            "x": -8.11,
            "y": 3.85
          },
          {
            "x": 2.25,
            "y": -30.86
          },
          {
            "x": 12.93,
            "y": 8.6
          }
        ],
        "time": 2.336
      },
      {
        "ball": {
          "x": -10.34,
          "y": -18.91,
          "z": 0.48
        },
        "homePlayers": [
          {
            "x": -13.63,
            "y": -23.46
          },
          {
            "x": 16.16,
            "y": -15.0
          },
          {
            "x": 6.38,
            "y": -9.28
          },
          {
            "x": 7.66,
            "y": 4.0
          },
          {
            "x": 42.39,
            "y": -4.8
          },
          {
            "x": -8.95,
            "y": -17.99
          },
          {
            "x": -0.38,
            "y": -27.26
          },
          {
            "x": -0.05,
            "y": -14.19
          },
          {
            "x": 16.94,
            "y": -1.84
          },
          {
            "x": -1.37,
            "y": 6.24
          },
          {
            "x": 13.78,
            "y": -24.79
          }
        ],
        "awayPlayers": [
          {
            "x": 6.95,
            "y": -15.57
          },
          {
            "x": -16.22,
            "y": -19.24
          },
          {
            "x": -8.53,
            "y": -21.51
          },
          {
            "x": 13.78,
            "y": -2.73
          },
          {
            "x": -8.25,
            "y": -17.62
          },
          {
            "x": -9.97,
            "y": -16.11
          },
          {
            "x": -39.16,
            "y": -5.16
          },
          {
            "x": -0.7,
            "y": -8.38
          },
          {
            "x": -9.91,
            "y": 3.52
          },
          {
            "x": 2.17,
            "y": -30.89
          },
          {
            "x": 10.59,
            "y": 8.74
          }
        ],
        "time": 2.669
      },
      {
        "ball": {
          "x": -14.23,
          "y": -19.77,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -15.94,
            "y": -24.22
          },
          {
            "x": 15.18,
            "y": -15.27
          },
          {
            "x": 5.38,
            "y": -9.17
          },
          {
            "x": 3.85,
            "y": -0.72
          },
          {
            "x": 41.98,
            "y": -4.78
          },
          {
            "x": -10.63,
            "y": -19.14
          },
          {
            "x": -1.78,
            "y": -27.56
          },
          {
            "x": -1.3,
            "y": -14.25
          },
          {
            "x": 15.92,
            "y": -1.76
          },
          {
            "x": -3.63,
            "y": 6.91
          },
          {
            "x": 12.84,
            "y": -24.86
          }
        ],
        "awayPlayers": [
          {
            "x": 5.67,
            "y": -15.75
          },
          {
            "x": -18.4,
            "y": -19.65
          },
          {
            "x": -10.87,
            "y": -21.19
          },
          {
            "x": 12.93,
            "y": -1.57
          },
          {
            "x": -10.06,
            "y": -18.91
          },
          {
            "x": -11.74,
            "y": -17.19
          },
          {
            "x": -39.94,
            "y": -5.1
          },
          {
            "x": -2.37,
            "y": -8.64
          },
          {
            "x": -11.75,
            "y": 3.4
          },
          {
            "x": -0.27,
            "y": -31.78
          },
          {
            "x": 8.59,
            "y": 9.13
          }
        ],
        "time": 3.003
      },
      {
        "ball": {
          "x": -17.98,
          "y": -21.19,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -18.24,
            "y": -24.62
          },
          {
            "x": 14.28,
            "y": -15.41
          },
          {
            "x": 4.28,
            "y": -9.05
          },
          {
            "x": 3.81,
            "y": -0.36
          },
          {
            "x": 41.64,
            "y": -4.77
          },
          {
            "x": -12.44,
            "y": -19.66
          },
          {
            "x": -3.15,
            "y": -27.81
          },
          {
            "x": -2.59,
            "y": -14.32
          },
          {
            "x": 15.14,
            "y": -1.96
          },
          {
            "x": -5.86,
            "y": 7.55
          },
          {
            "x": 11.91,
            "y": -24.96
          }
        ],
        "awayPlayers": [
          {
            "x": 4.08,
            "y": -16.16
          },
          {
            "x": -20.54,
            "y": -20.26
          },
          {
            "x": -13.19,
            "y": -21.11
          },
          {
            "x": 12.34,
            "y": -1.74
          },
          {
            "x": -11.65,
            "y": -20.15
          },
          {
            "x": -13.42,
            "y": -18.33
          },
          {
            "x": -41.99,
            "y": -4.6
          },
          {
            "x": -4.06,
            "y": -8.92
          },
          {
            "x": -13.6,
            "y": 3.42
          },
          {
            "x": -6.15,
            "y": -33.95
          },
          {
            "x": 6.25,
            "y": 9.04
          }
        ],
        "time": 3.337
      },
      {
        "ball": {
          "x": -21.31,
          "y": -21.74,
          "z": 0.1
        },
        "homePlayers": [
          {
            "x": -20.48,
            "y": -24.4
          },
          {
            "x": 13.2,
            "y": -15.52
          },
          {
            "x": 3.67,
            "y": -9.2
          },
          {
            "x": 3.25,
            "y": -0.37
          },
          {
            "x": 41.12,
            "y": -4.7
          },
          {
            "x": -14.4,
            "y": -19.64
          },
          {
            "x": -4.48,
            "y": -28.13
          },
          {
            "x": -3.87,
            "y": -14.45
          },
          {
            "x": 14.17,
            "y": -1.89
          },
          {
            "x": -8.13,
            "y": 8.2
          },
          {
            "x": 10.76,
            "y": -25.03
          }
        ],
        "awayPlayers": [
          {
            "x": 3.18,
            "y": -16.48
          },
          {
            "x": -22.68,
            "y": -20.88
          },
          {
            "x": -15.49,
            "y": -21.12
          },
          {
            "x": 11.0,
            "y": -1.52
          },
          {
            "x": -13.23,
            "y": -21.21
          },
          {
            "x": -15.19,
            "y": -19.37
          },
          {
            "x": -43.83,
            "y": -4.01
          },
          {
            "x": -5.8,
            "y": -9.24
          },
          {
            "x": -15.5,
            "y": 3.46
          },
          {
            "x": -6.16,
            "y": -33.81
          },
          {
            "x": 4.75,
            "y": 9.07
          }
        ],
        "time": 3.67
      },
      {
        "ball": {
          "x": -24.64,
          "y": -20.44,
          "z": 0.23
        },
        "homePlayers": [
          {
            "x": -22.59,
            "y": -23.49
          },
          {
            "x": 12.3,
            "y": -15.94
          },
          {
            "x": 2.81,
            "y": -9.62
          },
          {
            "x": 1.76,
            "y": 0.26
          },
          {
            "x": 40.63,
            "y": -4.63
          },
          {
            "x": -16.49,
            "y": -19.1
          },
          {
            "x": -5.8,
            "y": -28.33
          },
          {
            "x": -5.13,
            "y": -14.7
          },
          {
            "x": 13.01,
            "y": -1.94
          },
          {
            "x": -10.41,
            "y": 8.88
          },
          {
            "x": 9.24,
            "y": -25.07
          }
        ],
        "awayPlayers": [
          {
            "x": 2.35,
            "y": -17.0
          },
          {
            "x": -24.79,
            "y": -21.4
          },
          {
            "x": -17.79,
            "y": -20.95
          },
          {
            "x": 10.44,
            "y": -1.6
          },
          {
            "x": -14.87,
            "y": -22.09
          },
          {
            "x": -17.24,
            "y": -19.77
          },
          {
            "x": -45.75,
            "y": -3.43
          },
          {
            "x": -7.57,
            "y": -9.4
          },
          {
            "x": -17.48,
            "y": 3.55
          },
          {
            "x": -6.25,
            "y": -33.03
          },
          {
            "x": 2.8,
            "y": 9.14
          }
        ],
        "time": 4.004
      },
      {
        "ball": {
          "x": -27.0,
          "y": -17.73,
          "z": 0.93
        },
        "homePlayers": [
          {
            "x": -24.46,
            "y": -22.14
          },
          {
            "x": 11.07,
            "y": -15.97
          },
          {
            "x": 1.96,
            "y": -9.92
          },
          {
            "x": 0.41,
            "y": 1.31
          },
          {
            "x": 40.12,
            "y": -4.41
          },
          {
            "x": -18.6,
            "y": -18.3
          },
          {
            "x": -7.12,
            "y": -28.5
          },
          {
            "x": -6.32,
            "y": -15.03
          },
          {
            "x": 11.7,
            "y": -1.81
          },
          {
            "x": -12.73,
            "y": 9.68
          },
          {
            "x": 7.75,
            "y": -24.98
          }
        ],
        "awayPlayers": [
          {
            "x": 1.54,
            "y": -17.41
          },
          {
            "x": -26.95,
            "y": -21.32
          },
          {
            "x": -20.07,
            "y": -20.56
          },
          {
            "x": 9.04,
            "y": -1.04
          },
          {
            "x": -16.54,
            "y": -22.73
          },
          {
            "x": -19.45,
            "y": -19.46
          },
          {
            "x": -46.22,
            "y": -3.3
          },
          {
            "x": -9.34,
            "y": -9.42
          },
          {
            "x": -19.51,
            "y": 3.54
          },
          {
            "x": -6.32,
            "y": -32.39
          },
          {
            "x": 0.92,
            "y": 9.05
          }
        ],
        "time": 4.338
      },
      {
        "ball": {
          "x": -28.07,
          "y": -16.46,
          "z": 1.37
        },
        "homePlayers": [
          {
            "x": -26.2,
            "y": -20.37
          },
          {
            "x": 9.87,
            "y": -15.91
          },
          {
            "x": 0.56,
            "y": -9.8
          },
          {
            "x": -0.97,
            "y": 0.27
          },
          {
            "x": 39.49,
            "y": -4.16
          },
          {
            "x": -20.7,
            "y": -17.11
          },
          {
            "x": -8.42,
            "y": -28.49
          },
          {
            "x": -7.53,
            "y": -15.34
          },
          {
            "x": 10.33,
            "y": -1.46
          },
          {
            "x": -15.01,
            "y": 10.32
          },
          {
            "x": 5.76,
            "y": -24.77
          }
        ],
        "awayPlayers": [
          {
            "x": 0.39,
            "y": -17.51
          },
          {
            "x": -29.01,
            "y": -20.6
          },
          {
            "x": -22.39,
            "y": -19.83
          },
          {
            "x": 7.97,
            "y": -0.76
          },
          {
            "x": -18.25,
            "y": -22.94
          },
          {
            "x": -21.74,
            "y": -18.61
          },
          {
            "x": -46.97,
            "y": -3.07
          },
          {
            "x": -11.07,
            "y": -9.36
          },
          {
            "x": -21.54,
            "y": 3.28
          },
          {
            "x": -2.92,
            "y": -30.19
          },
          {
            "x": -0.63,
            "y": 9.27
          }
        ],
        "time": 4.671
      },
      {
        "ball": {
          "x": -29.26,
          "y": -14.35,
          "z": 0.47
        },
        "homePlayers": [
          {
            "x": -27.87,
            "y": -18.27
          },
          {
            "x": 8.88,
            "y": -15.73
          },
          {
            "x": -0.62,
            "y": -9.3
          },
          {
            "x": -2.0,
            "y": 1.12
          },
          {
            "x": 38.95,
            "y": -3.81
          },
          {
            "x": -22.71,
            "y": -15.55
          },
          {
            "x": -9.69,
            "y": -28.32
          },
          {
            "x": -8.8,
            "y": -15.45
          },
          {
            "x": 9.2,
            "y": -1.07
          },
          {
            "x": -17.34,
            "y": 10.78
          },
          {
            "x": 4.1,
            "y": -24.6
          }
        ],
        "awayPlayers": [
          {
            "x": -1.0,
            "y": -17.29
          },
          {
            "x": -30.86,
            "y": -19.11
          },
          {
            "x": -24.68,
            "y": -18.85
          },
          {
            "x": 7.24,
            "y": -0.36
          },
          {
            "x": -19.93,
            "y": -22.43
          },
          {
            "x": -23.99,
            "y": -17.31
          },
          {
            "x": -47.56,
            "y": -2.76
          },
          {
            "x": -12.85,
            "y": -9.16
          },
          {
            "x": -23.61,
            "y": 2.89
          },
          {
            "x": 0.01,
            "y": -28.19
          },
          {
            "x": -2.63,
            "y": 9.4
          }
        ],
        "time": 5.005
      },
      {
        "ball": {
          "x": -30.59,
          "y": -12.01,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -29.46,
            "y": -15.87
          },
          {
            "x": 7.85,
            "y": -15.21
          },
          {
            "x": -1.92,
            "y": -8.54
          },
          {
            "x": -3.16,
            "y": 2.01
          },
          {
            "x": 38.37,
            "y": -3.37
          },
          {
            "x": -24.58,
            "y": -13.77
          },
          {
            "x": -10.98,
            "y": -27.76
          },
          {
            "x": -10.11,
            "y": -15.39
          },
          {
            "x": 8.06,
            "y": -0.51
          },
          {
            "x": -19.71,
            "y": 11.13
          },
          {
            "x": 2.36,
            "y": -24.2
          }
        ],
        "awayPlayers": [
          {
            "x": -2.33,
            "y": -16.84
          },
          {
            "x": -32.39,
            "y": -17.05
          },
          {
            "x": -26.91,
            "y": -17.62
          },
          {
            "x": 5.99,
            "y": 0.52
          },
          {
            "x": -21.4,
            "y": -21.35
          },
          {
            "x": -26.19,
            "y": -15.49
          },
          {
            "x": -48.26,
            "y": -2.33
          },
          {
            "x": -14.68,
            "y": -8.72
          },
          {
            "x": -25.73,
            "y": 2.38
          },
          {
            "x": 2.6,
            "y": -26.23
          },
          {
            "x": -4.13,
            "y": 9.67
          }
        ],
        "time": 5.339
      },
      {
        "ball": {
          "x": -32.4,
          "y": -9.25,
          "z": 0.05
        },
        "homePlayers": [
          {
            "x": -30.88,
            "y": -13.17
          },
          {
            "x": 6.87,
            "y": -14.86
          },
          {
            "x": -3.15,
            "y": -7.9
          },
          {
            "x": -4.23,
            "y": 2.02
          },
          {
            "x": 37.81,
            "y": -2.98
          },
          {
            "x": -26.27,
            "y": -11.87
          },
          {
            "x": -12.34,
            "y": -26.72
          },
          {
            "x": -11.37,
            "y": -15.15
          },
          {
            "x": 6.9,
            "y": 0.03
          },
          {
            "x": -22.09,
            "y": 11.52
          },
          {
            "x": 0.89,
            "y": -23.82
          }
        ],
        "awayPlayers": [
          {
            "x": -3.41,
            "y": -16.46
          },
          {
            "x": -33.55,
            "y": -14.71
          },
          {
            "x": -29.02,
            "y": -16.12
          },
          {
            "x": 4.93,
            "y": 1.08
          },
          {
            "x": -22.65,
            "y": -19.88
          },
          {
            "x": -28.25,
            "y": -13.47
          },
          {
            "x": -49.03,
            "y": -1.96
          },
          {
            "x": -16.58,
            "y": -7.99
          },
          {
            "x": -27.86,
            "y": 1.91
          },
          {
            "x": 1.3,
            "y": -25.71
          },
          {
            "x": -5.75,
            "y": 9.95
          }
        ],
        "time": 5.672
      },
      {
        "ball": {
          "x": -32.64,
          "y": -8.67,
          "z": 0.12
        },
        "homePlayers": [
          {
            "x": -31.9,
            "y": -10.72
          },
          {
            "x": 6.04,
            "y": -14.33
          },
          {
            "x": -4.28,
            "y": -7.17
          },
          {
            "x": -4.53,
            "y": 2.74
          },
          {
            "x": 37.36,
            "y": -2.56
          },
          {
            "x": -27.68,
            "y": -10.01
          },
          {
            "x": -13.76,
            "y": -25.38
          },
          {
            "x": -12.56,
            "y": -14.83
          },
          {
            "x": 6.02,
            "y": 0.49
          },
          {
            "x": -24.36,
            "y": 11.9
          },
          {
            "x": -0.6,
            "y": -23.51
          }
        ],
        "awayPlayers": [
          {
            "x": -4.33,
            "y": -16.16
          },
          {
            "x": -34.42,
            "y": -12.18
          },
          {
            "x": -30.9,
            "y": -14.45
          },
          {
            "x": 4.46,
            "y": 1.53
          },
          {
            "x": -23.66,
            "y": -18.29
          },
          {
            "x": -29.98,
            "y": -11.22
          },
          {
            "x": -49.45,
            "y": -1.88
          },
          {
            "x": -18.45,
            "y": -7.05
          },
          {
            "x": -29.96,
            "y": 1.58
          },
          {
            "x": 0.05,
            "y": -25.29
          },
          {
            "x": -7.38,
            "y": 10.05
          }
        ],
        "time": 6.006
      },
      {
        "ball": {
          "x": -33.68,
          "y": -4.93,
          "z": 0.21
        },
        "homePlayers": [
          {
            "x": -32.53,
            "y": -8.58
          },
          {
            "x": 5.14,
            "y": -13.71
          },
          {
            "x": -5.43,
            "y": -6.49
          },
          {
            "x": -4.9,
            "y": 3.17
          },
          {
            "x": 36.7,
            "y": -2.23
          },
          {
            "x": -28.86,
            "y": -8.22
          },
          {
            "x": -15.12,
            "y": -24.11
          },
          {
            "x": -13.67,
            "y": -14.42
          },
          {
            "x": 5.06,
            "y": 1.03
          },
          {
            "x": -26.57,
            "y": 12.24
          },
          {
            "x": -1.98,
            "y": -23.28
          }
        ],
        "awayPlayers": [
          {
            "x": -5.24,
            "y": -15.78
          },
          {
            "x": -35.15,
            "y": -9.35
          },
          {
            "x": -32.49,
            "y": -12.69
          },
          {
            "x": 3.48,
            "y": 2.22
          },
          {
            "x": -24.52,
            "y": -16.61
          },
          {
            "x": -31.4,
            "y": -8.77
          },
          {
            "x": -49.59,
            "y": -1.81
          },
          {
            "x": -20.28,
            "y": -5.98
          },
          {
            "x": -31.95,
            "y": 1.33
          },
          {
            "x": -1.19,
            "y": -24.82
          },
          {
            "x": -8.76,
            "y": 10.39
          }
        ],
        "time": 6.34
      },
      {
        "ball": {
          "x": -33.9,
          "y": 0.2,
          "z": 0.53
        },
        "homePlayers": [
          {
            "x": -33.25,
            "y": -6.31
          },
          {
            "x": 4.56,
            "y": -13.16
          },
          {
            "x": -6.39,
            "y": -5.75
          },
          {
            "x": -5.73,
            "y": 4.26
          },
          {
            "x": 36.19,
            "y": -1.88
          },
          {
            "x": -29.84,
            "y": -6.51
          },
          {
            "x": -16.49,
            "y": -22.93
          },
          {
            "x": -14.73,
            "y": -13.98
          },
          {
            "x": 4.34,
            "y": 1.54
          },
          {
            "x": -28.55,
            "y": 12.42
          },
          {
            "x": -3.1,
            "y": -23.09
          }
        ],
        "awayPlayers": [
          {
            "x": -5.99,
            "y": -15.44
          },
          {
            "x": -35.65,
            "y": -6.7
          },
          {
            "x": -33.74,
            "y": -10.93
          },
          {
            "x": 3.47,
            "y": 2.6
          },
          {
            "x": -25.22,
            "y": -15.02
          },
          {
            "x": -32.35,
            "y": -6.26
          },
          {
            "x": -49.57,
            "y": -1.63
          },
          {
            "x": -22.04,
            "y": -4.78
          },
          {
            "x": -33.77,
            "y": 1.54
          },
          {
            "x": -2.34,
            "y": -24.32
          },
          {
            "x": -10.24,
            "y": 10.75
          }
        ],
        "time": 6.673
      },
      {
        "ball": {
          "x": -33.67,
          "y": 4.46,
          "z": 0.14
        },
        "homePlayers": [
          {
            "x": -34.16,
            "y": -4.01
          },
          {
            "x": 3.8,
            "y": -12.41
          },
          {
            "x": -7.43,
            "y": -5.0
          },
          {
            "x": -6.8,
            "y": 5.29
          },
          {
            "x": 35.67,
            "y": -1.57
          },
          {
            "x": -30.61,
            "y": -4.85
          },
          {
            "x": -17.85,
            "y": -21.89
          },
          {
            "x": -15.75,
            "y": -13.46
          },
          {
            "x": 3.51,
            "y": 2.06
          },
          {
            "x": -30.11,
            "y": 12.6
          },
          {
            "x": -4.39,
            "y": -22.8
          }
        ],
        "awayPlayers": [
          {
            "x": -6.87,
            "y": -14.98
          },
          {
            "x": -36.17,
            "y": -4.1
          },
          {
            "x": -34.78,
            "y": -9.1
          },
          {
            "x": 2.43,
            "y": 3.43
          },
          {
            "x": -25.91,
            "y": -13.3
          },
          {
            "x": -32.97,
            "y": -3.69
          },
          {
            "x": -49.84,
            "y": -1.05
          },
          {
            "x": -23.76,
            "y": -3.4
          },
          {
            "x": -35.14,
            "y": 2.23
          },
          {
            "x": -3.46,
            "y": -23.79
          },
          {
            "x": -11.76,
            "y": 10.99
          }
        ],
        "time": 7.007
      },
      {
        "ball": {
          "x": -33.16,
          "y": 7.39,
          "z": 0.13
        },
        "homePlayers": [
          {
            "x": -35.18,
            "y": -1.68
          },
          {
            "x": 3.13,
            "y": -11.83
          },
          {
            "x": -8.46,
            "y": -4.29
          },
          {
            "x": -7.38,
            "y": 4.78
          },
          {
            "x": 35.09,
            "y": -1.31
          },
          {
            "x": -31.2,
            "y": -3.17
          },
          {
            "x": -19.14,
            "y": -21.17
          },
          {
            "x": -16.75,
            "y": -12.84
          },
          {
            "x": 2.76,
            "y": 2.56
          },
          {
            "x": -31.11,
            "y": 12.95
          },
          {
            "x": -5.89,
            "y": -22.48
          }
        ],
        "awayPlayers": [
          {
            "x": -7.82,
            "y": -14.62
          },
          {
            "x": -36.7,
            "y": -1.94
          },
          {
            "x": -35.62,
            "y": -7.42
          },
          {
            "x": 1.74,
            "y": 3.72
          },
          {
            "x": -26.6,
            "y": -11.57
          },
          {
            "x": -33.43,
            "y": -1.06
          },
          {
            "x": -50.15,
            "y": -0.39
          },
          {
            "x": -25.36,
            "y": -1.9
          },
          {
            "x": -36.01,
            "y": 3.45
          },
          {
            "x": -4.65,
            "y": -23.07
          },
          {
            "x": -13.1,
            "y": 11.34
          }
        ],
        "time": 7.341
      },
      {
        "ball": {
          "x": -33.09,
          "y": 10.33,
          "z": 0.39
        },
        "homePlayers": [
          {
            "x": -36.12,
            "y": 0.66
          },
          {
            "x": 2.52,
            "y": -11.38
          },
          {
            "x": -9.37,
            "y": -3.59
          },
          {
            "x": -8.33,
            "y": 5.92
          },
          {
            "x": 34.66,
            "y": -1.08
          },
          {
            "x": -31.88,
            "y": -1.84
          },
          {
            "x": -20.33,
            "y": -20.81
          },
          {
            "x": -17.64,
            "y": -12.3
          },
          {
            "x": 2.08,
            "y": 2.98
          },
          {
            "x": -31.6,
            "y": 13.4
          },
          {
            "x": -7.79,
            "y": -22.18
          }
        ],
        "awayPlayers": [
          {
            "x": -8.95,
            "y": -14.19
          },
          {
            "x": -37.39,
            "y": 0.09
          },
          {
            "x": -36.32,
            "y": -5.98
          },
          {
            "x": 1.23,
            "y": 3.98
          },
          {
            "x": -27.39,
            "y": -9.79
          },
          {
            "x": -33.78,
            "y": 1.39
          },
          {
            "x": -50.41,
            "y": 0.25
          },
          {
            "x": -26.84,
            "y": -0.36
          },
          {
            "x": -36.43,
            "y": 4.9
          },
          {
            "x": -5.97,
            "y": -22.51
          },
          {
            "x": -14.87,
            "y": 11.58
          }
        ],
        "time": 7.674
      },
      {
        "ball": {
          "x": -32.4,
          "y": 12.78,
          "z": 0.02
        },
        "homePlayers": [
          {
            "x": -36.88,
            "y": 2.96
          },
          {
            "x": 1.9,
            "y": -10.82
          },
          {
            "x": -10.35,
            "y": -2.88
          },
          {
            "x": -9.52,
            "y": 6.57
          },
          {
            "x": 34.23,
            "y": -0.84
          },
          {
            "x": -32.77,
            "y": -1.25
          },
          {
            "x": -21.52,
            "y": -20.57
          },
          {
            "x": -18.5,
            "y": -11.83
          },
          {
            "x": 1.37,
            "y": 3.26
          },
          {
            "x": -31.71,
            "y": 13.85
          },
          {
            "x": -9.87,
            "y": -21.6
          }
        ],
        "awayPlayers": [
          {
            "x": -9.92,
            "y": -13.74
          },
          {
            "x": -38.11,
            "y": 1.94
          },
          {
            "x": -36.85,
            "y": -4.95
          },
          {
            "x": 0.26,
            "y": 4.54
          },
          {
            "x": -28.27,
            "y": -8.19
          },
          {
            "x": -34.11,
            "y": 3.18
          },
          {
            "x": -50.46,
            "y": 0.52
          },
          {
            "x": -28.26,
            "y": 1.01
          },
          {
            "x": -36.59,
            "y": 6.79
          },
          {
            "x": -7.18,
            "y": -21.68
          },
          {
            "x": -16.32,
            "y": 11.87
          }
        ],
        "time": 8.008
      },
      {
        "ball": {
          "x": -32.49,
          "y": 15.58,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -37.5,
            "y": 5.18
          },
          {
            "x": 1.44,
            "y": -10.51
          },
          {
            "x": -11.21,
            "y": -2.37
          },
          {
            "x": -10.09,
            "y": 6.63
          },
          {
            "x": 33.86,
            "y": -0.66
          },
          {
            "x": -33.88,
            "y": -1.43
          },
          {
            "x": -22.81,
            "y": -20.18
          },
          {
            "x": -19.37,
            "y": -11.38
          },
          {
            "x": 0.78,
            "y": 3.62
          },
          {
            "x": -31.58,
            "y": 14.26
          },
          {
            "x": -11.67,
            "y": -20.91
          }
        ],
        "awayPlayers": [
          {
            "x": -10.82,
            "y": -13.27
          },
          {
            "x": -38.82,
            "y": 3.81
          },
          {
            "x": -37.34,
            "y": -3.96
          },
          {
            "x": -0.38,
            "y": 4.73
          },
          {
            "x": -29.29,
            "y": -6.69
          },
          {
            "x": -34.56,
            "y": 4.34
          },
          {
            "x": -50.34,
            "y": 0.55
          },
          {
            "x": -29.57,
            "y": 2.25
          },
          {
            "x": -36.36,
            "y": 8.74
          },
          {
            "x": -8.24,
            "y": -20.99
          },
          {
            "x": -17.51,
            "y": 12.16
          }
        ],
        "time": 8.342
      },
      {
        "ball": {
          "x": -32.65,
          "y": 15.81,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -38.07,
            "y": 7.47
          },
          {
            "x": 1.12,
            "y": -10.06
          },
          {
            "x": -11.97,
            "y": -1.85
          },
          {
            "x": -10.34,
            "y": 7.07
          },
          {
            "x": 33.6,
            "y": -0.46
          },
          {
            "x": -34.97,
            "y": -2.17
          },
          {
            "x": -24.25,
            "y": -19.7
          },
          {
            "x": -20.3,
            "y": -10.84
          },
          {
            "x": 0.38,
            "y": 3.91
          },
          {
            "x": -31.42,
            "y": 14.54
          },
          {
            "x": -12.85,
            "y": -20.82
          }
        ],
        "awayPlayers": [
          {
            "x": -11.52,
            "y": -13.01
          },
          {
            "x": -39.47,
            "y": 5.62
          },
          {
            "x": -37.83,
            "y": -3.33
          },
          {
            "x": -0.72,
            "y": 4.99
          },
          {
            "x": -30.46,
            "y": -5.29
          },
          {
            "x": -35.35,
            "y": 5.3
          },
          {
            "x": -50.2,
            "y": 0.48
          },
          {
            "x": -30.86,
            "y": 3.5
          },
          {
            "x": -35.75,
            "y": 10.65
          },
          {
            "x": -9.05,
            "y": -20.44
          },
          {
            "x": -18.67,
            "y": 12.38
          }
        ],
        "time": 8.675
      },
      {
        "ball": {
          "x": -32.34,
          "y": 14.68,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -38.52,
            "y": 9.8
          },
          {
            "x": 0.77,
            "y": -9.72
          },
          {
            "x": -12.72,
            "y": -1.38
          },
          {
            "x": -10.27,
            "y": 7.61
          },
          {
            "x": 33.12,
            "y": -0.3
          },
          {
            "x": -35.99,
            "y": -3.2
          },
          {
            "x": -25.64,
            "y": -19.37
          },
          {
            "x": -21.27,
            "y": -10.23
          },
          {
            "x": -0.08,
            "y": 4.32
          },
          {
            "x": -31.4,
            "y": 14.61
          },
          {
            "x": -13.13,
            "y": -20.8
          }
        ],
        "awayPlayers": [
          {
            "x": -12.41,
            "y": -12.53
          },
          {
            "x": -40.0,
            "y": 7.44
          },
          {
            "x": -38.52,
            "y": -3.07
          },
          {
            "x": -1.61,
            "y": 5.53
          },
          {
            "x": -31.63,
            "y": -3.83
          },
          {
            "x": -36.34,
            "y": 6.16
          },
          {
            "x": -50.13,
            "y": 0.48
          },
          {
            "x": -31.94,
            "y": 4.91
          },
          {
            "x": -34.81,
            "y": 12.03
          },
          {
            "x": -9.98,
            "y": -19.78
          },
          {
            "x": -19.37,
            "y": 12.74
          }
        ],
        "time": 9.009
      },
      {
        "ball": {
          "x": -32.23,
          "y": 14.52,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -38.78,
            "y": 11.98
          },
          {
            "x": 0.57,
            "y": -9.34
          },
          {
            "x": -13.45,
            "y": -0.87
          },
          {
            "x": -11.24,
            "y": 8.87
          },
          {
            "x": 32.84,
            "y": -0.13
          },
          {
            "x": -37.03,
            "y": -4.33
          },
          {
            "x": -26.93,
            "y": -19.27
          },
          {
            "x": -22.2,
            "y": -9.57
          },
          {
            "x": -0.42,
            "y": 4.69
          },
          {
            "x": -31.55,
            "y": 14.42
          },
          {
            "x": -13.27,
            "y": -21.01
          }
        ],
        "awayPlayers": [
          {
            "x": -13.22,
            "y": -12.06
          },
          {
            "x": -40.35,
            "y": 9.22
          },
          {
            "x": -39.27,
            "y": -3.31
          },
          {
            "x": -1.59,
            "y": 5.79
          },
          {
            "x": -32.57,
            "y": -2.42
          },
          {
            "x": -37.21,
            "y": 6.71
          },
          {
            "x": -50.11,
            "y": 0.53
          },
          {
            "x": -32.67,
            "y": 6.5
          },
          {
            "x": -33.87,
            "y": 13.03
          },
          {
            "x": -10.82,
            "y": -19.27
          },
          {
            "x": -20.32,
            "y": 13.14
          }
        ],
        "time": 9.343
      },
      {
        "ball": {
          "x": -32.01,
          "y": 14.33,
          "z": 0.01
        },
        "homePlayers": [
          {
            "x": -38.76,
            "y": 13.97
          },
          {
            "x": 0.19,
            "y": -9.06
          },
          {
            "x": -14.24,
            "y": -0.41
          },
          {
            "x": -12.48,
            "y": 9.63
          },
          {
            "x": 32.51,
            "y": 0.0
          },
          {
            "x": -38.05,
            "y": -5.39
          },
          {
            "x": -28.02,
            "y": -19.3
          },
          {
            "x": -23.09,
            "y": -8.92
          },
          {
            "x": -0.86,
            "y": 4.92
          },
          {
            "x": -31.73,
            "y": 14.36
          },
          {
            "x": -13.61,
            "y": -20.59
          }
        ],
        "awayPlayers": [
          {
            "x": -14.58,
            "y": -11.42
          },
          {
            "x": -40.58,
            "y": 11.18
          },
          {
            "x": -39.91,
            "y": -3.65
          },
          {
            "x": -2.42,
            "y": 6.27
          },
          {
            "x": -33.18,
            "y": -1.09
          },
          {
            "x": -37.9,
            "y": 6.86
          },
          {
            "x": -50.09,
            "y": 0.61
          },
          {
            "x": -32.92,
            "y": 8.08
          },
          {
            "x": -33.24,
            "y": 13.33
          },
          {
            "x": -11.7,
            "y": -18.76
          },
          {
            "x": -21.05,
            "y": 13.41
          }
        ],
        "time": 9.676
      },
      {
        "ball": {
          "x": -33.09,
          "y": 14.98,
          "z": 0.09
        },
        "homePlayers": [
          {
            "x": -38.58,
            "y": 15.86
          },
          {
            "x": -0.12,
            "y": -8.79
          },
          {
            "x": -14.94,
            "y": -0.01
          },
          {
            "x": -12.68,
            "y": 9.44
          },
          {
            "x": 32.11,
            "y": 0.13
          },
          {
            "x": -38.99,
            "y": -6.31
          },
          {
            "x": -29.0,
            "y": -19.46
          },
          {
            "x": -23.95,
            "y": -8.28
          },
          {
            "x": -1.31,
            "y": 5.31
          },
          {
            "x": -31.85,
            "y": 14.49
          },
          {
            "x": -14.33,
            "y": -20.29
          }
        ],
        "awayPlayers": [
          {
            "x": -16.22,
            "y": -10.83
          },
          {
            "x": -40.56,
            "y": 12.74
          },
          {
            "x": -40.2,
            "y": -3.98
          },
          {
            "x": -2.83,
            "y": 6.34
          },
          {
            "x": -33.57,
            "y": -0.08
          },
          {
            "x": -38.47,
            "y": 6.68
          },
          {
            "x": -50.16,
            "y": 0.75
          },
          {
            "x": -32.94,
            "y": 9.59
          },
          {
            "x": -33.09,
            "y": 13.51
          },
          {
            "x": -12.43,
            "y": -18.47
          },
          {
            "x": -21.71,
            "y": 13.86
          }
        ],
        "time": 10.01
      },
      {
        "ball": {
          "x": -34.95,
          "y": 16.42,
          "z": 0.13
        },
        "homePlayers": [
          {
            "x": -38.14,
            "y": 17.54
          },
          {
            "x": -0.42,
            "y": -8.52
          },
          {
            "x": -15.57,
            "y": 0.5
          },
          {
            "x": -13.44,
            "y": 10.47
          },
          {
            "x": 31.88,
            "y": 0.24
          },
          {
            "x": -39.7,
            "y": -6.84
          },
          {
            "x": -29.87,
            "y": -19.57
          },
          {
            "x": -24.78,
            "y": -7.66
          },
          {
            "x": -1.67,
            "y": 5.66
          },
          {
            "x": -31.77,
            "y": 14.88
          },
          {
            "x": -15.24,
            "y": -19.9
          }
        ],
        "awayPlayers": [
          {
            "x": -17.91,
            "y": -10.21
          },
          {
            "x": -40.34,
            "y": 14.26
          },
          {
            "x": -40.23,
            "y": -4.28
          },
          {
            "x": -3.29,
            "y": 6.69
          },
          {
            "x": -33.87,
            "y": 0.79
          },
          {
            "x": -39.14,
            "y": 6.57
          },
          {
            "x": -50.28,
            "y": 0.93
          },
          {
            "x": -33.05,
            "y": 11.11
          },
          {
            "x": -33.27,
            "y": 13.64
          },
          {
            "x": -14.42,
            "y": -16.88
          },
          {
            "x": -23.09,
            "y": 14.35
          }
        ],
        "time": 10.344
      },
      {
        "ball": {
          "x": -36.98,
          "y": 17.94,
          "z": 0.05
        },
        "homePlayers": [
          {
            "x": -37.84,
            "y": 18.39
          },
          {
            "x": -0.79,
            "y": -7.96
          },
          {
            "x": -16.15,
            "y": 0.95
          },
          {
            "x": -14.07,
            "y": 11.13
          },
          {
            "x": 31.63,
            "y": 0.32
          },
          {
            "x": -40.06,
            "y": -7.19
          },
          {
            "x": -30.81,
            "y": -19.45
          },
          {
            "x": -25.61,
            "y": -7.05
          },
          {
            "x": -2.19,
            "y": 6.0
          },
          {
            "x": -31.45,
            "y": 15.38
          },
          {
            "x": -15.82,
            "y": -19.43
          }
        ],
        "awayPlayers": [
          {
            "x": -19.14,
            "y": -9.48
          },
          {
            "x": -39.98,
            "y": 15.59
          },
          {
            "x": -40.31,
            "y": -4.68
          },
          {
            "x": -4.32,
            "y": 7.5
          },
          {
            "x": -34.22,
            "y": 1.43
          },
          {
            "x": -39.78,
            "y": 6.39
          },
          {
            "x": -50.48,
            "y": 1.19
          },
          {
            "x": -33.36,
            "y": 12.32
          },
          {
            "x": -33.89,
            "y": 13.99
          },
          {
            "x": -16.32,
            "y": -15.35
          },
          {
            "x": -24.64,
            "y": 15.32
          }
        ],
        "time": 10.677
      },
      {
        "ball": {
          "x": -37.37,
          "y": 18.22,
          "z": 0.14
        },
        "homePlayers": [
          {
            "x": -37.46,
            "y": 19.25
          },
          {
            "x": -1.06,
            "y": -7.58
          },
          {
            "x": -16.77,
            "y": 1.48
          },
          {
            "x": -14.35,
            "y": 11.44
          },
          {
            "x": 31.52,
            "y": 0.42
          },
          {
            "x": -40.21,
            "y": -7.2
          },
          {
            "x": -31.79,
            "y": -19.05
          },
          {
            "x": -26.5,
            "y": -6.49
          },
          {
            "x": -2.63,
            "y": 6.47
          },
          {
            "x": -30.91,
            "y": 16.12
          },
          {
            "x": -16.27,
            "y": -19.0
          }
        ],
        "awayPlayers": [
          {
            "x": -20.35,
            "y": -8.62
          },
          {
            "x": -39.55,
            "y": 16.88
          },
          {
            "x": -40.56,
            "y": -5.05
          },
          {
            "x": -4.73,
            "y": 7.78
          },
          {
            "x": -34.57,
            "y": 1.8
          },
          {
            "x": -40.34,
            "y": 6.14
          },
          {
            "x": -50.57,
            "y": 1.36
          },
          {
            "x": -33.82,
            "y": 13.15
          },
          {
            "x": -34.68,
            "y": 14.12
          },
          {
            "x": -18.19,
            "y": -14.17
          },
          {
            "x": -26.59,
            "y": 16.34
          }
        ],
        "time": 11.011
      },
      {
        "ball": {
          "x": -36.96,
          "y": 18.46,
          "z": 0.36
        },
        "homePlayers": [
          {
            "x": -36.93,
            "y": 19.76
          },
          {
            "x": -1.34,
            "y": -7.19
          },
          {
            "x": -17.67,
            "y": 2.39
          },
          {
            "x": -14.36,
            "y": 11.76
          },
          {
            "x": 31.39,
            "y": 0.48
          },
          {
            "x": -40.21,
            "y": -7.07
          },
          {
            "x": -32.67,
            "y": -18.63
          },
          {
            "x": -27.33,
            "y": -5.93
          },
          {
            "x": -2.92,
            "y": 6.79
          },
          {
            "x": -30.27,
            "y": 17.15
          },
          {
            "x": -16.63,
            "y": -18.56
          }
        ],
        "awayPlayers": [
          {
            "x": -21.49,
            "y": -7.79
          },
          {
            "x": -39.01,
            "y": 17.89
          },
          {
            "x": -40.92,
            "y": -5.26
          },
          {
            "x": -5.15,
            "y": 8.27
          },
          {
            "x": -34.96,
            "y": 2.1
          },
          {
            "x": -40.73,
            "y": 5.89
          },
          {
            "x": -50.62,
            "y": 1.49
          },
          {
            "x": -34.3,
            "y": 13.86
          },
          {
            "x": -35.61,
            "y": 14.68
          },
          {
            "x": -18.72,
            "y": -14.45
          },
          {
            "x": -28.02,
            "y": 17.34
          }
        ],
        "time": 11.345
      },
      {
        "ball": {
          "x": -36.35,
          "y": 19.26,
          "z": 0.15
        },
        "homePlayers": [
          {
            "x": -36.28,
            "y": 20.04
          },
          {
            "x": -1.59,
            "y": -6.86
          },
          {
            "x": -19.24,
            "y": 4.1
          },
          {
            "x": -14.09,
            "y": 12.23
          },
          {
            "x": 31.08,
            "y": 0.57
          },
          {
            "x": -40.13,
            "y": -6.72
          },
          {
            "x": -33.38,
            "y": -18.3
          },
          {
            "x": -28.11,
            "y": -5.34
          },
          {
            "x": -3.34,
            "y": 7.18
          },
          {
            "x": -29.83,
            "y": 18.49
          },
          {
            "x": -16.84,
            "y": -18.22
          }
        ],
        "awayPlayers": [
          {
            "x": -22.56,
            "y": -6.92
          },
          {
            "x": -38.3,
            "y": 18.61
          },
          {
            "x": -41.05,
            "y": -5.47
          },
          {
            "x": -5.89,
            "y": 8.76
          },
          {
            "x": -35.34,
            "y": 2.4
          },
          {
            "x": -40.96,
            "y": 5.9
          },
          {
            "x": -50.62,
            "y": 1.53
          },
          {
            "x": -34.6,
            "y": 14.44
          },
          {
            "x": -36.43,
            "y": 15.38
          },
          {
            "x": -19.69,
            "y": -14.62
          },
          {
            "x": -29.52,
            "y": 18.5
          }
        ],
        "time": 11.678
      },
      {
        "ball": {
          "x": -35.32,
          "y": 19.04,
          "z": 0.04
        },
        "homePlayers": [
          {
            "x": -35.68,
            "y": 19.97
          },
          {
            "x": -1.81,
            "y": -6.43
          },
          {
            "x": -20.64,
            "y": 5.8
          },
          {
            "x": -14.72,
            "y": 13.24
          },
          {
            "x": 30.94,
            "y": 0.65
          },
          {
            "x": -39.98,
            "y": -6.26
          },
          {
            "x": -33.89,
            "y": -18.08
          },
          {
            "x": -28.79,
            "y": -4.78
          },
          {
            "x": -3.53,
            "y": 7.52
          },
          {
            "x": -29.68,
            "y": 20.01
          },
          {
            "x": -16.92,
            "y": -17.53
          }
        ],
        "awayPlayers": [
          {
            "x": -23.52,
            "y": -6.04
          },
          {
            "x": -37.49,
            "y": 18.88
          },
          {
            "x": -41.01,
            "y": -5.67
          },
          {
            "x": -6.01,
            "y": 9.1
          },
          {
            "x": -35.58,
            "y": 2.61
          },
          {
            "x": -40.94,
            "y": 6.08
          },
          {
            "x": -50.59,
            "y": 1.51
          },
          {
            "x": -34.53,
            "y": 15.15
          },
          {
            "x": -37.24,
            "y": 16.13
          },
          {
            "x": -20.59,
            "y": -14.28
          },
          {
            "x": -30.83,
            "y": 19.25
          }
        ],
        "time": 12.012
      },
      {
        "ball": {
          "x": -32.96,
          "y": 17.07,
          "z": 0.03
        },
        "homePlayers": [
          {
            "x": -35.14,
            "y": 19.88
          },
          {
            "x": -2.04,
            "y": -6.04
          },
          {
            "x": -21.69,
            "y": 7.05
          },
          {
            "x": -15.41,
            "y": 13.68
          },
          {
            "x": 30.85,
            "y": 0.71
          },
          {
            "x": -39.77,
            "y": -5.65
          },
          {
            "x": -34.27,
            "y": -17.96
          },
          {
            "x": -29.48,
            "y": -4.27
          },
          {
            "x": -3.83,
            "y": 7.74
          },
          {
            "x": -29.86,
            "y": 21.44
          },
          {
            "x": -16.1,
            "y": -16.05
          }
        ],
        "awayPlayers": [
          {
            "x": -24.43,
            "y": -5.09
          },
          {
            "x": -36.71,
            "y": 18.56
          },
          {
            "x": -40.89,
            "y": -5.63
          },
          {
            "x": -6.84,
            "y": 9.69
          },
          {
            "x": -35.59,
            "y": 2.54
          },
          {
            "x": -40.7,
            "y": 6.29
          },
          {
            "x": -50.56,
            "y": 1.47
          },
          {
            "x": -34.0,
            "y": 15.61
          },
          {
            "x": -38.08,
            "y": 16.61
          },
          {
            "x": -21.55,
            "y": -13.6
          },
          {
            "x": -31.96,
            "y": 19.43
          }
        ],
        "time": 12.346
      },
      {
        "ball": {
          "x": -29.17,
          "y": 13.07,
          "z": 0.1
        },
        "homePlayers": [
          {
            "x": -34.94,
            "y": 19.77
          },
          {
            "x": -2.21,
            "y": -5.65
          },
          {
            "x": -22.0,
            "y": 7.51
          },
          {
            "x": -15.04,
            "y": 13.52
          },
          {
            "x": 30.66,
            "y": 0.79
          },
          {
            "x": -39.44,
            "y": -5.01
          },
          {
            "x": -34.48,
            "y": -18.02
          },
          {
            "x": -30.05,
            "y": -3.89
          },
          {
            "x": -3.97,
            "y": 8.22
          },
          {
            "x": -29.96,
            "y": 22.67
          },
          {
            "x": -15.61,
            "y": -14.56
          }
        ],
        "awayPlayers": [
          {
            "x": -25.22,
            "y": -4.14
          },
          {
            "x": -36.1,
            "y": 17.91
          },
          {
            "x": -40.67,
            "y": -5.2
          },
          {
            "x": -6.74,
            "y": 9.63
          },
          {
            "x": -35.25,
            "y": 2.48
          },
          {
            "x": -40.17,
            "y": 6.47
          },
          {
            "x": -50.51,
            "y": 1.25
          },
          {
            "x": -33.11,
            "y": 15.74
          },
          {
            "x": -38.62,
            "y": 16.52
          },
          {
            "x": -22.47,
            "y": -12.84
          },
          {
            "x": -32.8,
            "y": 19.63
          }
        ],
        "time": 12.679
      },
      {
        "ball": {
          "x": -26.64,
          "y": 10.74,
          "z": 0.01
        },
        "homePlayers": [
          {
            "x": -34.99,
            "y": 19.7
          },
          {
            "x": -2.33,
            "y": -5.29
          },
          {
            "x": -22.93,
            "y": 8.32
          },
          {
            "x": -15.29,
            "y": 14.09
          },
          {
            "x": 30.59,
            "y": 0.81
          },
          {
            "x": -39.01,
            "y": -4.25
          },
          {
            "x": -34.61,
            "y": -18.28
          },
          {
            "x": -30.59,
            "y": -3.61
          },
          {
            "x": -4.01,
            "y": 8.57
          },
          {
            "x": -29.91,
            "y": 23.72
          },
          {
            "x": -15.37,
            "y": -13.39
          }
        ],
        "awayPlayers": [
          {
            "x": -25.95,
            "y": -3.1
          },
          {
            "x": -35.71,
            "y": 17.15
          },
          {
            "x": -40.23,
            "y": -4.54
          },
          {
            "x": -7.05,
            "y": 10.19
          },
          {
            "x": -34.82,
            "y": 2.68
          },
          {
            "x": -39.45,
            "y": 6.6
          },
          {
            "x": -50.52,
            "y": 1.01
          },
          {
            "x": -32.15,
            "y": 15.39
          },
          {
            "x": -38.8,
            "y": 16.04
          },
          {
            "x": -23.32,
            "y": -12.08
          },
          {
            "x": -33.06,
            "y": 19.83
          }
        ],
        "time": 13.013
      },
      {
        "ball": {
          "x": -24.72,
          "y": 8.72,
          "z": 0.0
        },
        "homePlayers": [
          {
            "x": -35.07,
            "y": 19.15
          },
          {
            "x": -2.56,
            "y": -4.72
          },
          {
            "x": -23.54,
            "y": 8.57
          },
          {
            "x": -15.36,
            "y": 14.44
          },
          {
            "x": 30.48,
            "y": 0.82
          },
          {
            "x": -38.45,
            "y": -3.35
          },
          {
            "x": -34.66,
            "y": -18.67
          },
          {
            "x": -31.18,
            "y": -3.37
          },
          {
            "x": -4.23,
            "y": 8.79
          },
          {
            "x": -29.73,
            "y": 24.68
          },
          {
            "x": -15.84,
            "y": -13.12
          }
        ],
        "awayPlayers": [
          {
            "x": -26.64,
            "y": -2.07
          },
          {
            "x": -35.43,
            "y": 16.16
          },
          {
            "x": -39.47,
            "y": -3.97
          },
          {
            "x": -7.63,
            "y": 10.69
          },
          {
            "x": -34.16,
            "y": 2.46
          },
          {
            "x": -38.59,
            "y": 6.68
          },
          {
            "x": -50.51,
            "y": 0.62
          },
          {
            "x": -31.3,
            "y": 14.46
          },
          {
            "x": -38.59,
            "y": 15.25
          },
          {
            "x": -24.31,
            "y": -11.36
          },
          {
            "x": -32.86,
            "y": 20.11
          }
        ],
        "time": 13.347
      }
    ],
    "duration": 13.347,
    "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/0d77770d-6029-4fb0-b3b0-0ea38ac14337/3373.607"
  },
  "similarPlays": [
    {
      "id": "3842_101.0_subset3",
      "matchId": "3842",
      "sequenceId": "101.0_subset3",
      "dtwScore": 0.0988503451322609,
      "frames": [
        {
          "ball": {
            "x": 4.07,
            "y": 0.61,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.45,
              "y": 3.19
            },
            {
              "x": 11.03,
              "y": -10.04
            },
            {
              "x": 20.53,
              "y": -4.49
            },
            {
              "x": 33.4,
              "y": 0.94
            },
            {
              "x": 3.66,
              "y": 0.84
            },
            {
              "x": 30.96,
              "y": -8.75
            },
            {
              "x": 31.1,
              "y": -22.73
            },
            {
              "x": -25.0,
              "y": -0.56
            },
            {
              "x": 11.86,
              "y": 12.35
            },
            {
              "x": 24.65,
              "y": 13.89
            },
            {
              "x": 18.3,
              "y": 25.71
            }
          ],
          "awayPlayers": [
            {
              "x": 31.53,
              "y": -14.85
            },
            {
              "x": 24.28,
              "y": -3.22
            },
            {
              "x": 21.8,
              "y": -11.33
            },
            {
              "x": 30.79,
              "y": 4.01
            },
            {
              "x": 48.32,
              "y": -0.22
            },
            {
              "x": 31.84,
              "y": -4.39
            },
            {
              "x": 15.07,
              "y": 8.01
            },
            {
              "x": 16.18,
              "y": -2.14
            },
            {
              "x": 31.83,
              "y": 12.97
            },
            {
              "x": 24.36,
              "y": 7.09
            },
            {
              "x": 23.03,
              "y": 20.04
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": 4.4,
            "y": 0.44,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.26,
              "y": 2.36
            },
            {
              "x": 10.22,
              "y": -10.57
            },
            {
              "x": 20.07,
              "y": -4.54
            },
            {
              "x": 33.15,
              "y": 1.23
            },
            {
              "x": 3.51,
              "y": 0.66
            },
            {
              "x": 30.67,
              "y": -8.27
            },
            {
              "x": 30.86,
              "y": -23.57
            },
            {
              "x": -25.0,
              "y": -0.64
            },
            {
              "x": 11.2,
              "y": 12.74
            },
            {
              "x": 24.46,
              "y": 13.64
            },
            {
              "x": 18.08,
              "y": 26.07
            }
          ],
          "awayPlayers": [
            {
              "x": 31.25,
              "y": -15.61
            },
            {
              "x": 23.72,
              "y": -4.08
            },
            {
              "x": 20.82,
              "y": -11.91
            },
            {
              "x": 30.48,
              "y": 3.54
            },
            {
              "x": 48.21,
              "y": -0.29
            },
            {
              "x": 31.79,
              "y": -4.65
            },
            {
              "x": 14.98,
              "y": 7.15
            },
            {
              "x": 15.66,
              "y": -2.86
            },
            {
              "x": 31.53,
              "y": 12.64
            },
            {
              "x": 24.37,
              "y": 6.27
            },
            {
              "x": 22.64,
              "y": 19.98
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": 4.64,
            "y": 0.15,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.86,
              "y": 1.62
            },
            {
              "x": 9.36,
              "y": -10.97
            },
            {
              "x": 19.7,
              "y": -4.35
            },
            {
              "x": 32.89,
              "y": 1.73
            },
            {
              "x": 3.65,
              "y": 0.39
            },
            {
              "x": 30.34,
              "y": -7.62
            },
            {
              "x": 30.62,
              "y": -24.54
            },
            {
              "x": -25.0,
              "y": -0.55
            },
            {
              "x": 10.59,
              "y": 13.23
            },
            {
              "x": 24.19,
              "y": 13.43
            },
            {
              "x": 17.89,
              "y": 26.26
            }
          ],
          "awayPlayers": [
            {
              "x": 31.01,
              "y": -16.23
            },
            {
              "x": 23.11,
              "y": -4.74
            },
            {
              "x": 19.8,
              "y": -12.4
            },
            {
              "x": 30.19,
              "y": 3.13
            },
            {
              "x": 48.03,
              "y": -0.34
            },
            {
              "x": 31.46,
              "y": -5.11
            },
            {
              "x": 15.02,
              "y": 6.3
            },
            {
              "x": 15.06,
              "y": -3.2
            },
            {
              "x": 31.22,
              "y": 12.33
            },
            {
              "x": 24.28,
              "y": 5.48
            },
            {
              "x": 22.32,
              "y": 19.76
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": 4.78,
            "y": -0.02,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.28,
              "y": 1.08
            },
            {
              "x": 8.56,
              "y": -11.31
            },
            {
              "x": 19.35,
              "y": -4.32
            },
            {
              "x": 32.69,
              "y": 2.21
            },
            {
              "x": 4.02,
              "y": 0.26
            },
            {
              "x": 30.13,
              "y": -6.97
            },
            {
              "x": 30.48,
              "y": -25.04
            },
            {
              "x": -25.0,
              "y": -0.61
            },
            {
              "x": 10.02,
              "y": 13.64
            },
            {
              "x": 23.9,
              "y": 13.07
            },
            {
              "x": 17.65,
              "y": 26.24
            }
          ],
          "awayPlayers": [
            {
              "x": 30.83,
              "y": -16.81
            },
            {
              "x": 22.55,
              "y": -5.07
            },
            {
              "x": 18.8,
              "y": -12.82
            },
            {
              "x": 29.95,
              "y": 2.69
            },
            {
              "x": 48.02,
              "y": -0.36
            },
            {
              "x": 31.14,
              "y": -5.42
            },
            {
              "x": 15.05,
              "y": 5.36
            },
            {
              "x": 14.33,
              "y": -3.23
            },
            {
              "x": 30.88,
              "y": 11.9
            },
            {
              "x": 24.1,
              "y": 4.63
            },
            {
              "x": 22.08,
              "y": 19.38
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": 5.75,
            "y": 2.56,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.61,
              "y": 0.81
            },
            {
              "x": 7.89,
              "y": -11.6
            },
            {
              "x": 19.05,
              "y": -4.31
            },
            {
              "x": 32.53,
              "y": 2.71
            },
            {
              "x": 4.24,
              "y": 0.2
            },
            {
              "x": 29.92,
              "y": -6.46
            },
            {
              "x": 30.34,
              "y": -25.5
            },
            {
              "x": -25.0,
              "y": -0.59
            },
            {
              "x": 9.57,
              "y": 13.98
            },
            {
              "x": 23.61,
              "y": 12.91
            },
            {
              "x": 17.47,
              "y": 26.13
            }
          ],
          "awayPlayers": [
            {
              "x": 30.67,
              "y": -17.22
            },
            {
              "x": 22.01,
              "y": -5.17
            },
            {
              "x": 17.88,
              "y": -13.05
            },
            {
              "x": 29.79,
              "y": 2.5
            },
            {
              "x": 47.99,
              "y": -0.36
            },
            {
              "x": 30.71,
              "y": -5.87
            },
            {
              "x": 15.1,
              "y": 4.4
            },
            {
              "x": 13.68,
              "y": -3.02
            },
            {
              "x": 30.57,
              "y": 11.7
            },
            {
              "x": 23.85,
              "y": 3.88
            },
            {
              "x": 21.89,
              "y": 18.98
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": 7.24,
            "y": 6.5,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.21,
              "y": 0.64
            },
            {
              "x": 7.49,
              "y": -11.74
            },
            {
              "x": 18.75,
              "y": -4.39
            },
            {
              "x": 32.42,
              "y": 3.21
            },
            {
              "x": 4.19,
              "y": 0.19
            },
            {
              "x": 29.84,
              "y": -6.07
            },
            {
              "x": 30.22,
              "y": -25.85
            },
            {
              "x": -25.0,
              "y": -0.55
            },
            {
              "x": 9.3,
              "y": 14.25
            },
            {
              "x": 23.3,
              "y": 12.87
            },
            {
              "x": 17.49,
              "y": 26.25
            }
          ],
          "awayPlayers": [
            {
              "x": 30.83,
              "y": -17.8
            },
            {
              "x": 21.75,
              "y": -4.92
            },
            {
              "x": 17.15,
              "y": -13.01
            },
            {
              "x": 29.73,
              "y": 2.57
            },
            {
              "x": 47.99,
              "y": -0.35
            },
            {
              "x": 30.64,
              "y": -5.48
            },
            {
              "x": 15.16,
              "y": 3.75
            },
            {
              "x": 13.19,
              "y": -2.6
            },
            {
              "x": 30.22,
              "y": 11.67
            },
            {
              "x": 23.57,
              "y": 3.41
            },
            {
              "x": 21.77,
              "y": 18.82
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": 8.45,
            "y": 9.87,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.21,
              "y": 0.56
            },
            {
              "x": 7.25,
              "y": -11.84
            },
            {
              "x": 18.5,
              "y": -4.36
            },
            {
              "x": 32.35,
              "y": 3.51
            },
            {
              "x": 3.98,
              "y": 0.23
            },
            {
              "x": 29.8,
              "y": -6.07
            },
            {
              "x": 30.11,
              "y": -26.13
            },
            {
              "x": -25.0,
              "y": -0.54
            },
            {
              "x": 9.26,
              "y": 14.32
            },
            {
              "x": 23.04,
              "y": 13.04
            },
            {
              "x": 17.7,
              "y": 26.5
            }
          ],
          "awayPlayers": [
            {
              "x": 31.04,
              "y": -18.11
            },
            {
              "x": 21.7,
              "y": -4.59
            },
            {
              "x": 16.65,
              "y": -12.91
            },
            {
              "x": 29.71,
              "y": 2.76
            },
            {
              "x": 47.96,
              "y": -0.33
            },
            {
              "x": 30.66,
              "y": -5.05
            },
            {
              "x": 15.23,
              "y": 3.44
            },
            {
              "x": 13.01,
              "y": -2.26
            },
            {
              "x": 29.85,
              "y": 11.64
            },
            {
              "x": 23.33,
              "y": 3.4
            },
            {
              "x": 21.69,
              "y": 18.88
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": 9.45,
            "y": 12.58,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.54,
              "y": 0.58
            },
            {
              "x": 7.19,
              "y": -11.82
            },
            {
              "x": 18.22,
              "y": -4.36
            },
            {
              "x": 32.27,
              "y": 3.63
            },
            {
              "x": 3.72,
              "y": 0.3
            },
            {
              "x": 29.88,
              "y": -6.23
            },
            {
              "x": 30.07,
              "y": -26.52
            },
            {
              "x": -25.0,
              "y": -0.5
            },
            {
              "x": 9.36,
              "y": 14.23
            },
            {
              "x": 22.77,
              "y": 13.31
            },
            {
              "x": 18.13,
              "y": 27.01
            }
          ],
          "awayPlayers": [
            {
              "x": 31.24,
              "y": -18.34
            },
            {
              "x": 21.87,
              "y": -4.14
            },
            {
              "x": 16.31,
              "y": -12.68
            },
            {
              "x": 29.78,
              "y": 3.18
            },
            {
              "x": 47.91,
              "y": -0.32
            },
            {
              "x": 30.72,
              "y": -4.62
            },
            {
              "x": 15.34,
              "y": 3.72
            },
            {
              "x": 12.98,
              "y": -1.89
            },
            {
              "x": 29.46,
              "y": 11.8
            },
            {
              "x": 23.14,
              "y": 3.94
            },
            {
              "x": 21.65,
              "y": 19.07
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": 10.17,
            "y": 13.49,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.95,
              "y": 0.87
            },
            {
              "x": 7.3,
              "y": -11.74
            },
            {
              "x": 17.91,
              "y": -4.32
            },
            {
              "x": 32.2,
              "y": 3.59
            },
            {
              "x": 3.48,
              "y": 0.37
            },
            {
              "x": 29.94,
              "y": -6.59
            },
            {
              "x": 30.08,
              "y": -26.71
            },
            {
              "x": -25.0,
              "y": -0.48
            },
            {
              "x": 9.57,
              "y": 14.16
            },
            {
              "x": 22.47,
              "y": 13.67
            },
            {
              "x": 18.72,
              "y": 27.47
            }
          ],
          "awayPlayers": [
            {
              "x": 31.22,
              "y": -18.11
            },
            {
              "x": 22.16,
              "y": -3.77
            },
            {
              "x": 16.13,
              "y": -12.4
            },
            {
              "x": 29.9,
              "y": 3.61
            },
            {
              "x": 47.92,
              "y": -0.28
            },
            {
              "x": 30.84,
              "y": -4.24
            },
            {
              "x": 15.51,
              "y": 4.39
            },
            {
              "x": 13.08,
              "y": -1.5
            },
            {
              "x": 29.18,
              "y": 12.09
            },
            {
              "x": 23.05,
              "y": 4.92
            },
            {
              "x": 21.73,
              "y": 19.37
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": 10.71,
            "y": 13.3,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.26,
              "y": 1.31
            },
            {
              "x": 7.59,
              "y": -11.61
            },
            {
              "x": 17.66,
              "y": -4.19
            },
            {
              "x": 32.18,
              "y": 3.54
            },
            {
              "x": 3.25,
              "y": 0.49
            },
            {
              "x": 30.05,
              "y": -6.83
            },
            {
              "x": 30.15,
              "y": -26.88
            },
            {
              "x": -25.0,
              "y": -0.39
            },
            {
              "x": 9.84,
              "y": 14.21
            },
            {
              "x": 22.16,
              "y": 14.1
            },
            {
              "x": 19.45,
              "y": 28.09
            }
          ],
          "awayPlayers": [
            {
              "x": 31.19,
              "y": -17.45
            },
            {
              "x": 22.5,
              "y": -3.32
            },
            {
              "x": 16.17,
              "y": -12.04
            },
            {
              "x": 30.09,
              "y": 4.15
            },
            {
              "x": 47.91,
              "y": -0.23
            },
            {
              "x": 30.95,
              "y": -3.95
            },
            {
              "x": 15.73,
              "y": 5.36
            },
            {
              "x": 13.28,
              "y": -0.98
            },
            {
              "x": 29.04,
              "y": 12.59
            },
            {
              "x": 23.04,
              "y": 6.1
            },
            {
              "x": 22.08,
              "y": 19.95
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": 11.22,
            "y": 13.44,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.33,
              "y": 2.05
            },
            {
              "x": 7.91,
              "y": -11.48
            },
            {
              "x": 17.44,
              "y": -4.07
            },
            {
              "x": 32.22,
              "y": 3.5
            },
            {
              "x": 2.97,
              "y": 0.58
            },
            {
              "x": 30.19,
              "y": -6.97
            },
            {
              "x": 30.17,
              "y": -26.95
            },
            {
              "x": -25.0,
              "y": -0.25
            },
            {
              "x": 10.32,
              "y": 14.29
            },
            {
              "x": 21.8,
              "y": 14.67
            },
            {
              "x": 20.26,
              "y": 28.72
            }
          ],
          "awayPlayers": [
            {
              "x": 31.26,
              "y": -16.74
            },
            {
              "x": 22.84,
              "y": -2.8
            },
            {
              "x": 16.32,
              "y": -11.67
            },
            {
              "x": 30.27,
              "y": 4.63
            },
            {
              "x": 47.99,
              "y": -0.15
            },
            {
              "x": 31.09,
              "y": -3.69
            },
            {
              "x": 16.01,
              "y": 6.49
            },
            {
              "x": 13.49,
              "y": -0.52
            },
            {
              "x": 29.01,
              "y": 13.14
            },
            {
              "x": 23.03,
              "y": 7.16
            },
            {
              "x": 22.71,
              "y": 20.76
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": 12.06,
            "y": 13.57,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.11,
              "y": 2.92
            },
            {
              "x": 8.19,
              "y": -11.3
            },
            {
              "x": 17.3,
              "y": -3.98
            },
            {
              "x": 32.29,
              "y": 3.41
            },
            {
              "x": 2.89,
              "y": 0.6
            },
            {
              "x": 30.42,
              "y": -7.0
            },
            {
              "x": 30.26,
              "y": -26.94
            },
            {
              "x": -25.0,
              "y": -0.11
            },
            {
              "x": 10.89,
              "y": 14.24
            },
            {
              "x": 21.46,
              "y": 15.41
            },
            {
              "x": 21.11,
              "y": 29.38
            }
          ],
          "awayPlayers": [
            {
              "x": 31.41,
              "y": -16.1
            },
            {
              "x": 23.16,
              "y": -2.26
            },
            {
              "x": 16.57,
              "y": -11.36
            },
            {
              "x": 30.41,
              "y": 5.07
            },
            {
              "x": 48.11,
              "y": -0.08
            },
            {
              "x": 31.25,
              "y": -3.44
            },
            {
              "x": 16.33,
              "y": 7.71
            },
            {
              "x": 13.69,
              "y": -0.1
            },
            {
              "x": 29.08,
              "y": 13.76
            },
            {
              "x": 23.04,
              "y": 8.15
            },
            {
              "x": 23.51,
              "y": 21.46
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": 15.39,
            "y": 14.55,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 24.63,
              "y": 3.84
            },
            {
              "x": 8.39,
              "y": -11.09
            },
            {
              "x": 17.25,
              "y": -3.93
            },
            {
              "x": 32.39,
              "y": 3.29
            },
            {
              "x": 2.9,
              "y": 0.77
            },
            {
              "x": 30.71,
              "y": -6.95
            },
            {
              "x": 30.36,
              "y": -26.95
            },
            {
              "x": -25.0,
              "y": 0.07
            },
            {
              "x": 11.27,
              "y": 14.21
            },
            {
              "x": 21.14,
              "y": 16.07
            },
            {
              "x": 21.99,
              "y": 30.06
            }
          ],
          "awayPlayers": [
            {
              "x": 31.57,
              "y": -15.54
            },
            {
              "x": 23.47,
              "y": -1.67
            },
            {
              "x": 16.9,
              "y": -11.08
            },
            {
              "x": 30.55,
              "y": 5.51
            },
            {
              "x": 48.23,
              "y": 0.0
            },
            {
              "x": 31.41,
              "y": -3.21
            },
            {
              "x": 16.65,
              "y": 8.91
            },
            {
              "x": 13.89,
              "y": 0.35
            },
            {
              "x": 29.25,
              "y": 14.35
            },
            {
              "x": 23.08,
              "y": 9.18
            },
            {
              "x": 24.29,
              "y": 21.9
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": 19.1,
            "y": 15.53,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": 23.95,
              "y": 4.57
            },
            {
              "x": 8.65,
              "y": -10.93
            },
            {
              "x": 17.33,
              "y": -3.9
            },
            {
              "x": 32.49,
              "y": 3.18
            },
            {
              "x": 3.16,
              "y": 1.19
            },
            {
              "x": 31.04,
              "y": -6.94
            },
            {
              "x": 30.46,
              "y": -26.95
            },
            {
              "x": -25.0,
              "y": 0.24
            },
            {
              "x": 11.29,
              "y": 14.13
            },
            {
              "x": 20.98,
              "y": 16.41
            },
            {
              "x": 22.9,
              "y": 30.68
            }
          ],
          "awayPlayers": [
            {
              "x": 31.75,
              "y": -15.02
            },
            {
              "x": 23.76,
              "y": -1.02
            },
            {
              "x": 17.27,
              "y": -10.88
            },
            {
              "x": 30.66,
              "y": 5.88
            },
            {
              "x": 48.39,
              "y": 0.08
            },
            {
              "x": 31.57,
              "y": -2.88
            },
            {
              "x": 16.88,
              "y": 9.91
            },
            {
              "x": 14.06,
              "y": 0.73
            },
            {
              "x": 29.52,
              "y": 14.92
            },
            {
              "x": 23.17,
              "y": 10.37
            },
            {
              "x": 25.05,
              "y": 22.2
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": 20.77,
            "y": 15.7,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 23.29,
              "y": 5.41
            },
            {
              "x": 8.96,
              "y": -10.77
            },
            {
              "x": 17.57,
              "y": -3.9
            },
            {
              "x": 32.48,
              "y": 3.57
            },
            {
              "x": 3.38,
              "y": 1.66
            },
            {
              "x": 31.39,
              "y": -6.92
            },
            {
              "x": 30.58,
              "y": -26.86
            },
            {
              "x": -25.0,
              "y": 0.38
            },
            {
              "x": 11.13,
              "y": 14.1
            },
            {
              "x": 20.91,
              "y": 16.34
            },
            {
              "x": 23.83,
              "y": 31.12
            }
          ],
          "awayPlayers": [
            {
              "x": 31.91,
              "y": -14.57
            },
            {
              "x": 24.07,
              "y": -0.34
            },
            {
              "x": 17.66,
              "y": -10.7
            },
            {
              "x": 30.87,
              "y": 6.24
            },
            {
              "x": 48.55,
              "y": 0.16
            },
            {
              "x": 31.73,
              "y": -2.58
            },
            {
              "x": 16.96,
              "y": 10.85
            },
            {
              "x": 14.24,
              "y": 1.15
            },
            {
              "x": 29.79,
              "y": 15.31
            },
            {
              "x": 23.25,
              "y": 11.54
            },
            {
              "x": 25.83,
              "y": 22.54
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": 20.7,
            "y": 15.06,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.76,
              "y": 6.44
            },
            {
              "x": 9.34,
              "y": -10.63
            },
            {
              "x": 17.9,
              "y": -3.8
            },
            {
              "x": 32.28,
              "y": 4.4
            },
            {
              "x": 3.55,
              "y": 2.02
            },
            {
              "x": 31.7,
              "y": -6.89
            },
            {
              "x": 30.64,
              "y": -26.88
            },
            {
              "x": -25.0,
              "y": 0.55
            },
            {
              "x": 10.95,
              "y": 14.18
            },
            {
              "x": 20.87,
              "y": 16.18
            },
            {
              "x": 24.69,
              "y": 31.36
            }
          ],
          "awayPlayers": [
            {
              "x": 32.1,
              "y": -14.02
            },
            {
              "x": 24.38,
              "y": 0.46
            },
            {
              "x": 18.05,
              "y": -10.46
            },
            {
              "x": 31.17,
              "y": 6.51
            },
            {
              "x": 48.67,
              "y": 0.21
            },
            {
              "x": 31.95,
              "y": -2.26
            },
            {
              "x": 16.85,
              "y": 11.48
            },
            {
              "x": 14.38,
              "y": 1.49
            },
            {
              "x": 30.09,
              "y": 15.64
            },
            {
              "x": 23.19,
              "y": 12.37
            },
            {
              "x": 26.6,
              "y": 22.88
            }
          ],
          "time": 5.005
        },
        {
          "ball": {
            "x": 20.82,
            "y": 11.8,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": 22.28,
              "y": 7.42
            },
            {
              "x": 9.7,
              "y": -10.44
            },
            {
              "x": 18.29,
              "y": -3.66
            },
            {
              "x": 31.91,
              "y": 5.49
            },
            {
              "x": 3.6,
              "y": 2.35
            },
            {
              "x": 31.91,
              "y": -6.85
            },
            {
              "x": 30.76,
              "y": -26.73
            },
            {
              "x": -25.0,
              "y": 0.64
            },
            {
              "x": 10.72,
              "y": 14.39
            },
            {
              "x": 20.7,
              "y": 16.25
            },
            {
              "x": 25.48,
              "y": 31.47
            }
          ],
          "awayPlayers": [
            {
              "x": 32.23,
              "y": -13.34
            },
            {
              "x": 24.64,
              "y": 1.32
            },
            {
              "x": 18.45,
              "y": -10.3
            },
            {
              "x": 31.53,
              "y": 6.72
            },
            {
              "x": 48.86,
              "y": 0.25
            },
            {
              "x": 32.15,
              "y": -1.93
            },
            {
              "x": 16.61,
              "y": 12.05
            },
            {
              "x": 14.52,
              "y": 1.82
            },
            {
              "x": 30.34,
              "y": 15.69
            },
            {
              "x": 23.08,
              "y": 12.82
            },
            {
              "x": 27.34,
              "y": 23.27
            }
          ],
          "time": 5.339
        },
        {
          "ball": {
            "x": 21.21,
            "y": 8.74,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 21.79,
              "y": 7.98
            },
            {
              "x": 10.09,
              "y": -10.34
            },
            {
              "x": 18.78,
              "y": -3.34
            },
            {
              "x": 31.48,
              "y": 6.16
            },
            {
              "x": 3.74,
              "y": 2.57
            },
            {
              "x": 31.99,
              "y": -6.85
            },
            {
              "x": 30.86,
              "y": -26.71
            },
            {
              "x": -25.0,
              "y": 0.76
            },
            {
              "x": 10.52,
              "y": 14.67
            },
            {
              "x": 20.55,
              "y": 16.61
            },
            {
              "x": 26.23,
              "y": 31.47
            }
          ],
          "awayPlayers": [
            {
              "x": 32.4,
              "y": -12.4
            },
            {
              "x": 24.82,
              "y": 2.02
            },
            {
              "x": 18.96,
              "y": -10.01
            },
            {
              "x": 31.82,
              "y": 6.87
            },
            {
              "x": 48.96,
              "y": 0.29
            },
            {
              "x": 32.32,
              "y": -1.68
            },
            {
              "x": 16.36,
              "y": 12.27
            },
            {
              "x": 14.73,
              "y": 2.16
            },
            {
              "x": 30.55,
              "y": 15.62
            },
            {
              "x": 23.12,
              "y": 12.88
            },
            {
              "x": 28.04,
              "y": 23.66
            }
          ],
          "time": 5.672
        },
        {
          "ball": {
            "x": 22.5,
            "y": 7.41,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 21.51,
              "y": 7.96
            },
            {
              "x": 10.5,
              "y": -10.17
            },
            {
              "x": 19.34,
              "y": -3.03
            },
            {
              "x": 31.27,
              "y": 6.88
            },
            {
              "x": 3.89,
              "y": 2.87
            },
            {
              "x": 32.05,
              "y": -6.93
            },
            {
              "x": 30.99,
              "y": -26.62
            },
            {
              "x": -25.0,
              "y": 0.82
            },
            {
              "x": 10.52,
              "y": 14.94
            },
            {
              "x": 20.55,
              "y": 16.99
            },
            {
              "x": 26.88,
              "y": 31.23
            }
          ],
          "awayPlayers": [
            {
              "x": 32.54,
              "y": -11.56
            },
            {
              "x": 25.09,
              "y": 2.41
            },
            {
              "x": 19.56,
              "y": -9.66
            },
            {
              "x": 31.97,
              "y": 6.93
            },
            {
              "x": 49.13,
              "y": 0.33
            },
            {
              "x": 32.45,
              "y": -1.58
            },
            {
              "x": 16.27,
              "y": 12.31
            },
            {
              "x": 15.04,
              "y": 2.44
            },
            {
              "x": 30.68,
              "y": 15.44
            },
            {
              "x": 23.53,
              "y": 12.8
            },
            {
              "x": 28.71,
              "y": 23.81
            }
          ],
          "time": 6.006
        },
        {
          "ball": {
            "x": 22.91,
            "y": 7.23,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 21.83,
              "y": 7.79
            },
            {
              "x": 10.94,
              "y": -10.07
            },
            {
              "x": 19.97,
              "y": -2.69
            },
            {
              "x": 31.34,
              "y": 7.77
            },
            {
              "x": 3.91,
              "y": 2.99
            },
            {
              "x": 32.47,
              "y": -6.75
            },
            {
              "x": 31.13,
              "y": -26.62
            },
            {
              "x": -25.0,
              "y": 0.82
            },
            {
              "x": 10.76,
              "y": 14.97
            },
            {
              "x": 20.79,
              "y": 17.15
            },
            {
              "x": 27.43,
              "y": 30.76
            }
          ],
          "awayPlayers": [
            {
              "x": 32.84,
              "y": -11.08
            },
            {
              "x": 25.55,
              "y": 2.42
            },
            {
              "x": 20.37,
              "y": -9.06
            },
            {
              "x": 32.02,
              "y": 6.91
            },
            {
              "x": 49.29,
              "y": 0.36
            },
            {
              "x": 32.64,
              "y": -1.67
            },
            {
              "x": 16.44,
              "y": 12.14
            },
            {
              "x": 15.43,
              "y": 2.69
            },
            {
              "x": 30.88,
              "y": 15.03
            },
            {
              "x": 24.13,
              "y": 12.37
            },
            {
              "x": 29.35,
              "y": 23.82
            }
          ],
          "time": 6.34
        },
        {
          "ball": {
            "x": 23.33,
            "y": 7.01,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.66,
              "y": 7.53
            },
            {
              "x": 11.35,
              "y": -9.97
            },
            {
              "x": 20.63,
              "y": -2.58
            },
            {
              "x": 31.77,
              "y": 9.04
            },
            {
              "x": 4.07,
              "y": 3.1
            },
            {
              "x": 33.3,
              "y": -6.37
            },
            {
              "x": 31.29,
              "y": -26.41
            },
            {
              "x": -25.0,
              "y": 0.79
            },
            {
              "x": 11.17,
              "y": 14.79
            },
            {
              "x": 21.16,
              "y": 17.06
            },
            {
              "x": 27.83,
              "y": 30.39
            }
          ],
          "awayPlayers": [
            {
              "x": 33.22,
              "y": -10.98
            },
            {
              "x": 26.21,
              "y": 2.31
            },
            {
              "x": 21.2,
              "y": -8.3
            },
            {
              "x": 32.35,
              "y": 7.27
            },
            {
              "x": 49.44,
              "y": 0.36
            },
            {
              "x": 33.14,
              "y": -1.6
            },
            {
              "x": 16.78,
              "y": 11.98
            },
            {
              "x": 15.8,
              "y": 2.81
            },
            {
              "x": 31.29,
              "y": 14.46
            },
            {
              "x": 24.83,
              "y": 11.66
            },
            {
              "x": 29.91,
              "y": 23.8
            }
          ],
          "time": 6.673
        },
        {
          "ball": {
            "x": 24.2,
            "y": 6.19,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 23.58,
              "y": 6.98
            },
            {
              "x": 11.69,
              "y": -10.03
            },
            {
              "x": 21.23,
              "y": -2.6
            },
            {
              "x": 32.41,
              "y": 10.17
            },
            {
              "x": 4.27,
              "y": 3.18
            },
            {
              "x": 34.19,
              "y": -5.92
            },
            {
              "x": 31.45,
              "y": -26.08
            },
            {
              "x": -25.0,
              "y": 0.75
            },
            {
              "x": 11.72,
              "y": 14.4
            },
            {
              "x": 21.57,
              "y": 17.0
            },
            {
              "x": 28.04,
              "y": 29.85
            }
          ],
          "awayPlayers": [
            {
              "x": 33.64,
              "y": -10.9
            },
            {
              "x": 26.88,
              "y": 2.09
            },
            {
              "x": 22.08,
              "y": -7.42
            },
            {
              "x": 32.91,
              "y": 7.75
            },
            {
              "x": 49.75,
              "y": 0.3
            },
            {
              "x": 33.93,
              "y": -1.49
            },
            {
              "x": 17.12,
              "y": 11.8
            },
            {
              "x": 16.11,
              "y": 2.83
            },
            {
              "x": 31.98,
              "y": 13.76
            },
            {
              "x": 25.56,
              "y": 10.63
            },
            {
              "x": 30.38,
              "y": 23.72
            }
          ],
          "time": 7.007
        },
        {
          "ball": {
            "x": 24.56,
            "y": 4.56,
            "z": 0.19
          },
          "homePlayers": [
            {
              "x": 24.39,
              "y": 6.1
            },
            {
              "x": 12.05,
              "y": -10.04
            },
            {
              "x": 21.66,
              "y": -2.83
            },
            {
              "x": 33.3,
              "y": 11.0
            },
            {
              "x": 4.55,
              "y": 3.1
            },
            {
              "x": 34.73,
              "y": -5.71
            },
            {
              "x": 31.61,
              "y": -25.72
            },
            {
              "x": -25.0,
              "y": 0.66
            },
            {
              "x": 12.16,
              "y": 14.15
            },
            {
              "x": 22.0,
              "y": 16.98
            },
            {
              "x": 28.07,
              "y": 29.22
            }
          ],
          "awayPlayers": [
            {
              "x": 33.99,
              "y": -10.73
            },
            {
              "x": 27.65,
              "y": 2.12
            },
            {
              "x": 22.94,
              "y": -6.52
            },
            {
              "x": 33.71,
              "y": 8.4
            },
            {
              "x": 49.99,
              "y": 0.14
            },
            {
              "x": 34.95,
              "y": -1.31
            },
            {
              "x": 17.47,
              "y": 11.67
            },
            {
              "x": 16.36,
              "y": 2.79
            },
            {
              "x": 32.79,
              "y": 13.19
            },
            {
              "x": 26.2,
              "y": 9.23
            },
            {
              "x": 30.76,
              "y": 23.55
            }
          ],
          "time": 7.341
        },
        {
          "ball": {
            "x": 25.94,
            "y": -0.47,
            "z": 0.45
          },
          "homePlayers": [
            {
              "x": 25.03,
              "y": 5.31
            },
            {
              "x": 12.48,
              "y": -10.11
            },
            {
              "x": 21.92,
              "y": -2.96
            },
            {
              "x": 34.31,
              "y": 11.26
            },
            {
              "x": 4.75,
              "y": 3.02
            },
            {
              "x": 34.94,
              "y": -5.65
            },
            {
              "x": 31.67,
              "y": -25.58
            },
            {
              "x": -25.0,
              "y": 0.61
            },
            {
              "x": 12.54,
              "y": 13.84
            },
            {
              "x": 22.46,
              "y": 16.9
            },
            {
              "x": 27.95,
              "y": 28.33
            }
          ],
          "awayPlayers": [
            {
              "x": 34.36,
              "y": -10.74
            },
            {
              "x": 28.44,
              "y": 2.12
            },
            {
              "x": 23.98,
              "y": -5.8
            },
            {
              "x": 34.61,
              "y": 8.67
            },
            {
              "x": 50.26,
              "y": -0.09
            },
            {
              "x": 35.74,
              "y": -1.51
            },
            {
              "x": 17.9,
              "y": 11.47
            },
            {
              "x": 16.58,
              "y": 2.69
            },
            {
              "x": 33.52,
              "y": 12.44
            },
            {
              "x": 26.74,
              "y": 7.8
            },
            {
              "x": 31.09,
              "y": 23.28
            }
          ],
          "time": 7.674
        },
        {
          "ball": {
            "x": 28.1,
            "y": -6.69,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.52,
              "y": 4.63
            },
            {
              "x": 12.78,
              "y": -10.06
            },
            {
              "x": 22.08,
              "y": -3.02
            },
            {
              "x": 35.46,
              "y": 10.99
            },
            {
              "x": 4.87,
              "y": 2.9
            },
            {
              "x": 35.01,
              "y": -5.72
            },
            {
              "x": 31.63,
              "y": -25.46
            },
            {
              "x": -25.0,
              "y": 0.49
            },
            {
              "x": 12.88,
              "y": 13.58
            },
            {
              "x": 22.93,
              "y": 16.75
            },
            {
              "x": 27.75,
              "y": 27.4
            }
          ],
          "awayPlayers": [
            {
              "x": 34.64,
              "y": -11.19
            },
            {
              "x": 29.25,
              "y": 1.89
            },
            {
              "x": 25.2,
              "y": -5.48
            },
            {
              "x": 35.55,
              "y": 8.6
            },
            {
              "x": 50.38,
              "y": -0.32
            },
            {
              "x": 36.27,
              "y": -2.14
            },
            {
              "x": 18.16,
              "y": 11.37
            },
            {
              "x": 16.76,
              "y": 2.49
            },
            {
              "x": 34.11,
              "y": 11.64
            },
            {
              "x": 27.34,
              "y": 6.45
            },
            {
              "x": 31.41,
              "y": 23.01
            }
          ],
          "time": 8.008
        },
        {
          "ball": {
            "x": 28.81,
            "y": -12.78,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.1,
              "y": 4.0
            },
            {
              "x": 13.03,
              "y": -9.67
            },
            {
              "x": 22.12,
              "y": -3.25
            },
            {
              "x": 36.45,
              "y": 10.26
            },
            {
              "x": 5.0,
              "y": 2.61
            },
            {
              "x": 35.2,
              "y": -5.53
            },
            {
              "x": 31.2,
              "y": -25.27
            },
            {
              "x": -25.0,
              "y": 0.38
            },
            {
              "x": 13.19,
              "y": 13.17
            },
            {
              "x": 23.36,
              "y": 16.54
            },
            {
              "x": 27.42,
              "y": 26.4
            }
          ],
          "awayPlayers": [
            {
              "x": 34.86,
              "y": -12.13
            },
            {
              "x": 29.98,
              "y": 1.14
            },
            {
              "x": 26.54,
              "y": -5.83
            },
            {
              "x": 36.5,
              "y": 8.12
            },
            {
              "x": 50.55,
              "y": -0.58
            },
            {
              "x": 36.49,
              "y": -3.28
            },
            {
              "x": 18.32,
              "y": 10.85
            },
            {
              "x": 17.04,
              "y": 2.55
            },
            {
              "x": 34.72,
              "y": 10.82
            },
            {
              "x": 28.15,
              "y": 5.47
            },
            {
              "x": 31.66,
              "y": 22.69
            }
          ],
          "time": 8.342
        },
        {
          "ball": {
            "x": 29.12,
            "y": -18.03,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.91,
              "y": 3.25
            },
            {
              "x": 13.24,
              "y": -9.23
            },
            {
              "x": 21.95,
              "y": -4.03
            },
            {
              "x": 37.11,
              "y": 9.17
            },
            {
              "x": 5.15,
              "y": 2.35
            },
            {
              "x": 35.51,
              "y": -4.96
            },
            {
              "x": 30.54,
              "y": -24.9
            },
            {
              "x": -25.0,
              "y": 0.25
            },
            {
              "x": 13.61,
              "y": 12.66
            },
            {
              "x": 23.76,
              "y": 16.32
            },
            {
              "x": 27.03,
              "y": 25.53
            }
          ],
          "awayPlayers": [
            {
              "x": 34.88,
              "y": -13.48
            },
            {
              "x": 30.71,
              "y": 0.19
            },
            {
              "x": 27.7,
              "y": -6.83
            },
            {
              "x": 37.29,
              "y": 7.34
            },
            {
              "x": 50.73,
              "y": -0.85
            },
            {
              "x": 36.77,
              "y": -4.29
            },
            {
              "x": 18.21,
              "y": 9.99
            },
            {
              "x": 17.6,
              "y": 3.33
            },
            {
              "x": 35.32,
              "y": 10.05
            },
            {
              "x": 29.14,
              "y": 4.68
            },
            {
              "x": 31.87,
              "y": 22.31
            }
          ],
          "time": 8.675
        },
        {
          "ball": {
            "x": 29.36,
            "y": -22.12,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 28.08,
              "y": 2.57
            },
            {
              "x": 13.55,
              "y": -8.97
            },
            {
              "x": 21.67,
              "y": -5.25
            },
            {
              "x": 37.53,
              "y": 8.05
            },
            {
              "x": 5.17,
              "y": 1.95
            },
            {
              "x": 36.03,
              "y": -4.09
            },
            {
              "x": 30.04,
              "y": -24.57
            },
            {
              "x": -25.0,
              "y": 0.09
            },
            {
              "x": 14.03,
              "y": 12.09
            },
            {
              "x": 24.22,
              "y": 16.04
            },
            {
              "x": 26.62,
              "y": 24.48
            }
          ],
          "awayPlayers": [
            {
              "x": 34.75,
              "y": -15.02
            },
            {
              "x": 31.53,
              "y": -0.76
            },
            {
              "x": 28.67,
              "y": -8.21
            },
            {
              "x": 37.96,
              "y": 6.33
            },
            {
              "x": 50.82,
              "y": -1.1
            },
            {
              "x": 37.31,
              "y": -4.75
            },
            {
              "x": 18.12,
              "y": 8.88
            },
            {
              "x": 18.58,
              "y": 5.12
            },
            {
              "x": 35.96,
              "y": 9.27
            },
            {
              "x": 30.25,
              "y": 4.04
            },
            {
              "x": 32.21,
              "y": 21.79
            }
          ],
          "time": 9.009
        },
        {
          "ball": {
            "x": 29.64,
            "y": -23.86,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 29.47,
              "y": 1.9
            },
            {
              "x": 13.88,
              "y": -9.08
            },
            {
              "x": 21.44,
              "y": -6.75
            },
            {
              "x": 37.83,
              "y": 6.98
            },
            {
              "x": 5.38,
              "y": 1.63
            },
            {
              "x": 36.72,
              "y": -3.16
            },
            {
              "x": 29.75,
              "y": -24.35
            },
            {
              "x": -25.0,
              "y": -0.04
            },
            {
              "x": 14.46,
              "y": 11.43
            },
            {
              "x": 24.77,
              "y": 15.63
            },
            {
              "x": 26.31,
              "y": 23.23
            }
          ],
          "awayPlayers": [
            {
              "x": 34.35,
              "y": -16.6
            },
            {
              "x": 32.46,
              "y": -1.63
            },
            {
              "x": 29.5,
              "y": -9.78
            },
            {
              "x": 38.48,
              "y": 5.17
            },
            {
              "x": 50.8,
              "y": -1.42
            },
            {
              "x": 38.11,
              "y": -4.58
            },
            {
              "x": 18.08,
              "y": 8.07
            },
            {
              "x": 19.76,
              "y": 6.91
            },
            {
              "x": 36.65,
              "y": 8.45
            },
            {
              "x": 31.45,
              "y": 3.38
            },
            {
              "x": 32.75,
              "y": 21.11
            }
          ],
          "time": 9.343
        },
        {
          "ball": {
            "x": 29.7,
            "y": -23.85,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 31.02,
              "y": 1.19
            },
            {
              "x": 14.18,
              "y": -9.22
            },
            {
              "x": 21.34,
              "y": -8.31
            },
            {
              "x": 38.13,
              "y": 6.04
            },
            {
              "x": 5.54,
              "y": 1.29
            },
            {
              "x": 37.48,
              "y": -2.44
            },
            {
              "x": 29.68,
              "y": -24.29
            },
            {
              "x": -25.0,
              "y": -0.17
            },
            {
              "x": 14.89,
              "y": 10.78
            },
            {
              "x": 25.4,
              "y": 15.11
            },
            {
              "x": 25.99,
              "y": 21.7
            }
          ],
          "awayPlayers": [
            {
              "x": 33.78,
              "y": -18.07
            },
            {
              "x": 33.53,
              "y": -2.28
            },
            {
              "x": 30.24,
              "y": -11.39
            },
            {
              "x": 38.98,
              "y": 4.0
            },
            {
              "x": 50.76,
              "y": -1.66
            },
            {
              "x": 38.95,
              "y": -4.1
            },
            {
              "x": 18.15,
              "y": 7.27
            },
            {
              "x": 20.8,
              "y": 7.62
            },
            {
              "x": 37.41,
              "y": 7.67
            },
            {
              "x": 32.71,
              "y": 2.69
            },
            {
              "x": 33.38,
              "y": 20.2
            }
          ],
          "time": 9.676
        },
        {
          "ball": {
            "x": 30.03,
            "y": -23.32,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 32.53,
              "y": 0.44
            },
            {
              "x": 14.54,
              "y": -9.35
            },
            {
              "x": 21.37,
              "y": -9.95
            },
            {
              "x": 38.5,
              "y": 5.17
            },
            {
              "x": 5.79,
              "y": 0.78
            },
            {
              "x": 38.27,
              "y": -1.71
            },
            {
              "x": 29.8,
              "y": -24.14
            },
            {
              "x": -25.0,
              "y": -0.38
            },
            {
              "x": 15.03,
              "y": 10.14
            },
            {
              "x": 26.07,
              "y": 14.57
            },
            {
              "x": 25.74,
              "y": 20.35
            }
          ],
          "awayPlayers": [
            {
              "x": 33.31,
              "y": -19.2
            },
            {
              "x": 34.56,
              "y": -2.88
            },
            {
              "x": 30.86,
              "y": -12.99
            },
            {
              "x": 39.49,
              "y": 2.97
            },
            {
              "x": 50.73,
              "y": -1.71
            },
            {
              "x": 39.7,
              "y": -3.51
            },
            {
              "x": 18.47,
              "y": 6.47
            },
            {
              "x": 21.58,
              "y": 6.97
            },
            {
              "x": 38.23,
              "y": 6.88
            },
            {
              "x": 34.01,
              "y": 2.06
            },
            {
              "x": 33.95,
              "y": 19.24
            }
          ],
          "time": 10.01
        },
        {
          "ball": {
            "x": 30.4,
            "y": -22.91,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 33.84,
              "y": -0.57
            },
            {
              "x": 14.97,
              "y": -9.48
            },
            {
              "x": 21.59,
              "y": -11.5
            },
            {
              "x": 38.95,
              "y": 4.49
            },
            {
              "x": 5.88,
              "y": 0.3
            },
            {
              "x": 38.98,
              "y": -1.21
            },
            {
              "x": 30.12,
              "y": -23.81
            },
            {
              "x": -25.0,
              "y": -0.65
            },
            {
              "x": 15.34,
              "y": 9.51
            },
            {
              "x": 26.79,
              "y": 14.04
            },
            {
              "x": 25.49,
              "y": 19.09
            }
          ],
          "awayPlayers": [
            {
              "x": 33.06,
              "y": -19.83
            },
            {
              "x": 35.41,
              "y": -3.52
            },
            {
              "x": 31.4,
              "y": -14.48
            },
            {
              "x": 39.97,
              "y": 2.19
            },
            {
              "x": 50.68,
              "y": -1.68
            },
            {
              "x": 40.28,
              "y": -3.11
            },
            {
              "x": 18.96,
              "y": 5.54
            },
            {
              "x": 22.29,
              "y": 5.89
            },
            {
              "x": 39.18,
              "y": 6.32
            },
            {
              "x": 35.2,
              "y": 1.46
            },
            {
              "x": 34.41,
              "y": 18.29
            }
          ],
          "time": 10.344
        },
        {
          "ball": {
            "x": 30.67,
            "y": -22.61,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 34.94,
              "y": -1.54
            },
            {
              "x": 15.36,
              "y": -9.61
            },
            {
              "x": 22.09,
              "y": -12.82
            },
            {
              "x": 39.37,
              "y": 3.91
            },
            {
              "x": 5.86,
              "y": -0.18
            },
            {
              "x": 39.65,
              "y": -0.72
            },
            {
              "x": 30.52,
              "y": -23.3
            },
            {
              "x": -25.0,
              "y": -0.9
            },
            {
              "x": 15.44,
              "y": 9.01
            },
            {
              "x": 27.53,
              "y": 13.57
            },
            {
              "x": 25.27,
              "y": 17.86
            }
          ],
          "awayPlayers": [
            {
              "x": 33.04,
              "y": -20.11
            },
            {
              "x": 36.1,
              "y": -4.29
            },
            {
              "x": 31.76,
              "y": -15.87
            },
            {
              "x": 40.32,
              "y": 1.54
            },
            {
              "x": 50.67,
              "y": -1.63
            },
            {
              "x": 40.89,
              "y": -2.73
            },
            {
              "x": 19.43,
              "y": 4.79
            },
            {
              "x": 23.04,
              "y": 4.85
            },
            {
              "x": 40.11,
              "y": 5.67
            },
            {
              "x": 36.26,
              "y": 0.95
            },
            {
              "x": 34.72,
              "y": 17.3
            }
          ],
          "time": 10.677
        },
        {
          "ball": {
            "x": 30.29,
            "y": -22.08,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 35.77,
              "y": -2.46
            },
            {
              "x": 15.64,
              "y": -9.85
            },
            {
              "x": 22.72,
              "y": -13.92
            },
            {
              "x": 39.79,
              "y": 3.62
            },
            {
              "x": 5.87,
              "y": -0.51
            },
            {
              "x": 40.17,
              "y": -0.43
            },
            {
              "x": 30.7,
              "y": -22.74
            },
            {
              "x": -25.0,
              "y": -1.06
            },
            {
              "x": 15.78,
              "y": 8.5
            },
            {
              "x": 28.23,
              "y": 13.03
            },
            {
              "x": 25.05,
              "y": 16.69
            }
          ],
          "awayPlayers": [
            {
              "x": 32.92,
              "y": -20.21
            },
            {
              "x": 36.72,
              "y": -4.95
            },
            {
              "x": 31.95,
              "y": -16.97
            },
            {
              "x": 40.67,
              "y": 1.18
            },
            {
              "x": 50.67,
              "y": -1.64
            },
            {
              "x": 41.3,
              "y": -2.56
            },
            {
              "x": 19.55,
              "y": 3.96
            },
            {
              "x": 23.79,
              "y": 3.79
            },
            {
              "x": 40.82,
              "y": 4.99
            },
            {
              "x": 37.04,
              "y": 0.1
            },
            {
              "x": 34.92,
              "y": 16.27
            }
          ],
          "time": 11.011
        },
        {
          "ball": {
            "x": 29.7,
            "y": -21.62,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 36.32,
              "y": -2.95
            },
            {
              "x": 15.81,
              "y": -9.97
            },
            {
              "x": 23.27,
              "y": -14.69
            },
            {
              "x": 40.26,
              "y": 3.56
            },
            {
              "x": 5.9,
              "y": -0.79
            },
            {
              "x": 40.51,
              "y": -0.11
            },
            {
              "x": 30.44,
              "y": -22.06
            },
            {
              "x": -25.0,
              "y": -1.17
            },
            {
              "x": 16.11,
              "y": 8.04
            },
            {
              "x": 28.9,
              "y": 12.51
            },
            {
              "x": 24.86,
              "y": 15.54
            }
          ],
          "awayPlayers": [
            {
              "x": 32.64,
              "y": -20.2
            },
            {
              "x": 37.31,
              "y": -5.51
            },
            {
              "x": 31.76,
              "y": -17.65
            },
            {
              "x": 40.98,
              "y": 1.17
            },
            {
              "x": 50.65,
              "y": -1.58
            },
            {
              "x": 41.57,
              "y": -2.35
            },
            {
              "x": 19.41,
              "y": 3.16
            },
            {
              "x": 24.6,
              "y": 2.78
            },
            {
              "x": 41.2,
              "y": 4.17
            },
            {
              "x": 37.6,
              "y": -0.89
            },
            {
              "x": 35.07,
              "y": 15.21
            }
          ],
          "time": 11.345
        },
        {
          "ball": {
            "x": 28.86,
            "y": -20.69,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 36.6,
              "y": -3.16
            },
            {
              "x": 16.02,
              "y": -10.09
            },
            {
              "x": 23.54,
              "y": -15.18
            },
            {
              "x": 40.58,
              "y": 3.44
            },
            {
              "x": 5.99,
              "y": -1.04
            },
            {
              "x": 40.57,
              "y": 0.01
            },
            {
              "x": 30.0,
              "y": -21.45
            },
            {
              "x": -25.0,
              "y": -1.27
            },
            {
              "x": 16.54,
              "y": 7.54
            },
            {
              "x": 29.56,
              "y": 12.02
            },
            {
              "x": 24.7,
              "y": 14.49
            }
          ],
          "awayPlayers": [
            {
              "x": 32.31,
              "y": -19.93
            },
            {
              "x": 37.69,
              "y": -5.79
            },
            {
              "x": 31.29,
              "y": -17.89
            },
            {
              "x": 41.05,
              "y": 1.2
            },
            {
              "x": 50.53,
              "y": -1.47
            },
            {
              "x": 41.52,
              "y": -2.23
            },
            {
              "x": 19.27,
              "y": 2.27
            },
            {
              "x": 25.4,
              "y": 1.69
            },
            {
              "x": 41.43,
              "y": 3.85
            },
            {
              "x": 37.86,
              "y": -1.81
            },
            {
              "x": 35.17,
              "y": 14.14
            }
          ],
          "time": 11.678
        },
        {
          "ball": {
            "x": 26.82,
            "y": -18.08,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 36.73,
              "y": -3.09
            },
            {
              "x": 16.19,
              "y": -10.13
            },
            {
              "x": 23.81,
              "y": -15.19
            },
            {
              "x": 40.72,
              "y": 2.75
            },
            {
              "x": 6.1,
              "y": -1.24
            },
            {
              "x": 40.38,
              "y": 0.08
            },
            {
              "x": 29.73,
              "y": -21.12
            },
            {
              "x": -25.0,
              "y": -1.34
            },
            {
              "x": 16.91,
              "y": 7.15
            },
            {
              "x": 30.15,
              "y": 11.63
            },
            {
              "x": 24.57,
              "y": 13.54
            }
          ],
          "awayPlayers": [
            {
              "x": 32.06,
              "y": -19.63
            },
            {
              "x": 37.79,
              "y": -5.92
            },
            {
              "x": 30.63,
              "y": -17.64
            },
            {
              "x": 40.95,
              "y": 1.21
            },
            {
              "x": 50.44,
              "y": -1.28
            },
            {
              "x": 41.28,
              "y": -2.16
            },
            {
              "x": 19.19,
              "y": 1.49
            },
            {
              "x": 26.15,
              "y": 0.56
            },
            {
              "x": 41.52,
              "y": 4.0
            },
            {
              "x": 37.91,
              "y": -2.42
            },
            {
              "x": 35.19,
              "y": 13.18
            }
          ],
          "time": 12.012
        },
        {
          "ball": {
            "x": 25.11,
            "y": -15.75,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 36.74,
              "y": -3.01
            },
            {
              "x": 16.25,
              "y": -10.19
            },
            {
              "x": 24.01,
              "y": -14.99
            },
            {
              "x": 40.68,
              "y": 2.53
            },
            {
              "x": 6.36,
              "y": -1.44
            },
            {
              "x": 40.25,
              "y": 0.62
            },
            {
              "x": 29.76,
              "y": -21.31
            },
            {
              "x": -25.0,
              "y": -1.41
            },
            {
              "x": 17.07,
              "y": 6.88
            },
            {
              "x": 30.64,
              "y": 11.31
            },
            {
              "x": 24.45,
              "y": 12.71
            }
          ],
          "awayPlayers": [
            {
              "x": 32.04,
              "y": -19.48
            },
            {
              "x": 37.56,
              "y": -5.93
            },
            {
              "x": 29.99,
              "y": -16.95
            },
            {
              "x": 40.65,
              "y": 1.3
            },
            {
              "x": 50.39,
              "y": -1.18
            },
            {
              "x": 40.91,
              "y": -2.14
            },
            {
              "x": 19.04,
              "y": 0.86
            },
            {
              "x": 26.8,
              "y": -0.68
            },
            {
              "x": 41.16,
              "y": 4.24
            },
            {
              "x": 37.79,
              "y": -2.63
            },
            {
              "x": 35.11,
              "y": 12.29
            }
          ],
          "time": 12.346
        }
      ],
      "duration": 12.346,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/f5ce9c55-7c6f-42c4-83a3-1d6db1768711/1977.162"
    },
    {
      "id": "3833_133.0_subset0",
      "matchId": "3833",
      "sequenceId": "133.0_subset0",
      "dtwScore": 0.10170225888564707,
      "frames": [
        {
          "ball": {
            "x": 6.12,
            "y": 19.55,
            "z": 6.05
          },
          "homePlayers": [
            {
              "x": -5.94,
              "y": 6.73
            },
            {
              "x": 17.24,
              "y": -16.94
            },
            {
              "x": 27.57,
              "y": -5.67
            },
            {
              "x": 26.57,
              "y": 13.71
            },
            {
              "x": 8.5,
              "y": 4.6
            },
            {
              "x": 16.32,
              "y": 27.73
            },
            {
              "x": 4.95,
              "y": 20.84
            },
            {
              "x": -9.73,
              "y": 11.91
            },
            {
              "x": -2.87,
              "y": -20.64
            },
            {
              "x": 8.98,
              "y": 14.98
            },
            {
              "x": 41.97,
              "y": 1.05
            }
          ],
          "awayPlayers": [
            {
              "x": -35.3,
              "y": 2.16
            },
            {
              "x": -5.3,
              "y": -22.96
            },
            {
              "x": -9.1,
              "y": 15.44
            },
            {
              "x": 0.79,
              "y": 26.1
            },
            {
              "x": -10.39,
              "y": 3.06
            },
            {
              "x": 10.99,
              "y": 25.38
            },
            {
              "x": 5.24,
              "y": 4.1
            },
            {
              "x": 0.61,
              "y": 15.26
            },
            {
              "x": 9.2,
              "y": -19.49
            },
            {
              "x": 26.8,
              "y": 5.25
            },
            {
              "x": 17.27,
              "y": 13.68
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": 6.74,
            "y": 19.36,
            "z": 5.07
          },
          "homePlayers": [
            {
              "x": -6.49,
              "y": 7.16
            },
            {
              "x": 16.96,
              "y": -16.44
            },
            {
              "x": 26.85,
              "y": -5.12
            },
            {
              "x": 25.76,
              "y": 13.82
            },
            {
              "x": 7.85,
              "y": 5.46
            },
            {
              "x": 15.08,
              "y": 26.98
            },
            {
              "x": 5.16,
              "y": 20.72
            },
            {
              "x": -9.77,
              "y": 12.59
            },
            {
              "x": -2.98,
              "y": -19.94
            },
            {
              "x": 8.07,
              "y": 15.42
            },
            {
              "x": 41.75,
              "y": 1.06
            }
          ],
          "awayPlayers": [
            {
              "x": -35.49,
              "y": 2.22
            },
            {
              "x": -5.35,
              "y": -22.63
            },
            {
              "x": -9.41,
              "y": 15.67
            },
            {
              "x": 0.73,
              "y": 26.09
            },
            {
              "x": -10.78,
              "y": 3.23
            },
            {
              "x": 10.21,
              "y": 24.43
            },
            {
              "x": 4.39,
              "y": 4.65
            },
            {
              "x": 0.87,
              "y": 15.07
            },
            {
              "x": 8.46,
              "y": -18.67
            },
            {
              "x": 26.07,
              "y": 5.63
            },
            {
              "x": 16.36,
              "y": 14.51
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": 9.82,
            "y": 19.62,
            "z": 4.61
          },
          "homePlayers": [
            {
              "x": -6.7,
              "y": 7.57
            },
            {
              "x": 16.96,
              "y": -16.02
            },
            {
              "x": 26.64,
              "y": -4.55
            },
            {
              "x": 25.46,
              "y": 13.83
            },
            {
              "x": 7.39,
              "y": 6.26
            },
            {
              "x": 14.28,
              "y": 26.25
            },
            {
              "x": 5.66,
              "y": 20.43
            },
            {
              "x": -9.86,
              "y": 12.28
            },
            {
              "x": -2.87,
              "y": -19.71
            },
            {
              "x": 7.78,
              "y": 15.96
            },
            {
              "x": 41.78,
              "y": 1.11
            }
          ],
          "awayPlayers": [
            {
              "x": -35.5,
              "y": 2.26
            },
            {
              "x": -5.27,
              "y": -22.29
            },
            {
              "x": -9.41,
              "y": 15.76
            },
            {
              "x": 0.84,
              "y": 26.09
            },
            {
              "x": -10.81,
              "y": 3.44
            },
            {
              "x": 10.03,
              "y": 23.61
            },
            {
              "x": 3.66,
              "y": 5.14
            },
            {
              "x": 1.23,
              "y": 15.04
            },
            {
              "x": 7.82,
              "y": -18.07
            },
            {
              "x": 25.9,
              "y": 6.0
            },
            {
              "x": 15.91,
              "y": 15.69
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": 12.25,
            "y": 20.64,
            "z": 3.39
          },
          "homePlayers": [
            {
              "x": -5.91,
              "y": 7.88
            },
            {
              "x": 17.12,
              "y": -15.93
            },
            {
              "x": 26.83,
              "y": -4.29
            },
            {
              "x": 25.54,
              "y": 13.81
            },
            {
              "x": 7.19,
              "y": 7.02
            },
            {
              "x": 14.27,
              "y": 25.66
            },
            {
              "x": 5.87,
              "y": 20.26
            },
            {
              "x": -9.71,
              "y": 12.06
            },
            {
              "x": -2.19,
              "y": -19.93
            },
            {
              "x": 8.24,
              "y": 16.95
            },
            {
              "x": 42.04,
              "y": 1.16
            }
          ],
          "awayPlayers": [
            {
              "x": -35.3,
              "y": 2.25
            },
            {
              "x": -5.11,
              "y": -21.69
            },
            {
              "x": -9.24,
              "y": 15.79
            },
            {
              "x": 0.72,
              "y": 26.01
            },
            {
              "x": -10.6,
              "y": 3.51
            },
            {
              "x": 10.42,
              "y": 22.55
            },
            {
              "x": 3.24,
              "y": 5.62
            },
            {
              "x": 1.76,
              "y": 15.04
            },
            {
              "x": 7.44,
              "y": -17.38
            },
            {
              "x": 26.1,
              "y": 6.23
            },
            {
              "x": 15.68,
              "y": 17.04
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": 14.41,
            "y": 19.87,
            "z": 1.64
          },
          "homePlayers": [
            {
              "x": -4.0,
              "y": 8.24
            },
            {
              "x": 17.39,
              "y": -16.02
            },
            {
              "x": 27.19,
              "y": -3.98
            },
            {
              "x": 25.71,
              "y": 13.67
            },
            {
              "x": 7.36,
              "y": 7.73
            },
            {
              "x": 15.05,
              "y": 25.05
            },
            {
              "x": 5.81,
              "y": 20.2
            },
            {
              "x": -9.37,
              "y": 11.42
            },
            {
              "x": -1.25,
              "y": -20.4
            },
            {
              "x": 9.34,
              "y": 17.37
            },
            {
              "x": 42.41,
              "y": 1.26
            }
          ],
          "awayPlayers": [
            {
              "x": -34.99,
              "y": 2.23
            },
            {
              "x": -4.98,
              "y": -21.12
            },
            {
              "x": -8.85,
              "y": 15.65
            },
            {
              "x": 0.52,
              "y": 25.86
            },
            {
              "x": -10.13,
              "y": 3.63
            },
            {
              "x": 11.32,
              "y": 21.17
            },
            {
              "x": 3.15,
              "y": 5.96
            },
            {
              "x": 2.48,
              "y": 14.95
            },
            {
              "x": 7.42,
              "y": -16.95
            },
            {
              "x": 26.36,
              "y": 6.47
            },
            {
              "x": 15.44,
              "y": 18.23
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": 14.68,
            "y": 19.37,
            "z": 0.32
          },
          "homePlayers": [
            {
              "x": -1.65,
              "y": 8.42
            },
            {
              "x": 17.8,
              "y": -15.93
            },
            {
              "x": 27.65,
              "y": -3.64
            },
            {
              "x": 26.09,
              "y": 13.53
            },
            {
              "x": 7.76,
              "y": 8.4
            },
            {
              "x": 16.11,
              "y": 24.25
            },
            {
              "x": 6.13,
              "y": 20.07
            },
            {
              "x": -9.02,
              "y": 11.41
            },
            {
              "x": -0.88,
              "y": -20.21
            },
            {
              "x": 10.74,
              "y": 17.65
            },
            {
              "x": 42.77,
              "y": 1.32
            }
          ],
          "awayPlayers": [
            {
              "x": -34.71,
              "y": 2.21
            },
            {
              "x": -4.63,
              "y": -20.6
            },
            {
              "x": -8.47,
              "y": 15.69
            },
            {
              "x": 0.58,
              "y": 25.82
            },
            {
              "x": -9.72,
              "y": 3.71
            },
            {
              "x": 12.74,
              "y": 20.21
            },
            {
              "x": 3.29,
              "y": 6.33
            },
            {
              "x": 3.48,
              "y": 15.41
            },
            {
              "x": 7.92,
              "y": -15.91
            },
            {
              "x": 26.68,
              "y": 6.63
            },
            {
              "x": 14.98,
              "y": 19.51
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": 14.77,
            "y": 18.4,
            "z": 0.25
          },
          "homePlayers": [
            {
              "x": -0.05,
              "y": 8.6
            },
            {
              "x": 18.3,
              "y": -15.77
            },
            {
              "x": 27.89,
              "y": -3.22
            },
            {
              "x": 26.26,
              "y": 13.32
            },
            {
              "x": 8.38,
              "y": 9.08
            },
            {
              "x": 17.25,
              "y": 23.33
            },
            {
              "x": 6.54,
              "y": 20.01
            },
            {
              "x": -8.46,
              "y": 11.45
            },
            {
              "x": -0.17,
              "y": -19.65
            },
            {
              "x": 12.36,
              "y": 17.65
            },
            {
              "x": 43.12,
              "y": 1.32
            }
          ],
          "awayPlayers": [
            {
              "x": -34.51,
              "y": 2.19
            },
            {
              "x": -4.1,
              "y": -20.31
            },
            {
              "x": -8.04,
              "y": 15.78
            },
            {
              "x": 1.0,
              "y": 25.73
            },
            {
              "x": -9.35,
              "y": 3.83
            },
            {
              "x": 14.1,
              "y": 19.18
            },
            {
              "x": 3.55,
              "y": 6.74
            },
            {
              "x": 4.51,
              "y": 15.79
            },
            {
              "x": 8.7,
              "y": -15.27
            },
            {
              "x": 26.94,
              "y": 6.64
            },
            {
              "x": 14.76,
              "y": 20.53
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": 16.6,
            "y": 17.52,
            "z": 0.01
          },
          "homePlayers": [
            {
              "x": 1.08,
              "y": 8.5
            },
            {
              "x": 18.84,
              "y": -15.66
            },
            {
              "x": 27.98,
              "y": -3.08
            },
            {
              "x": 26.08,
              "y": 13.48
            },
            {
              "x": 9.32,
              "y": 9.69
            },
            {
              "x": 18.49,
              "y": 22.47
            },
            {
              "x": 7.26,
              "y": 19.69
            },
            {
              "x": -7.67,
              "y": 11.3
            },
            {
              "x": 0.7,
              "y": -19.2
            },
            {
              "x": 14.22,
              "y": 17.51
            },
            {
              "x": 43.34,
              "y": 1.27
            }
          ],
          "awayPlayers": [
            {
              "x": -34.26,
              "y": 2.09
            },
            {
              "x": -3.27,
              "y": -20.23
            },
            {
              "x": -7.3,
              "y": 15.65
            },
            {
              "x": 1.55,
              "y": 25.57
            },
            {
              "x": -8.68,
              "y": 3.76
            },
            {
              "x": 15.61,
              "y": 18.27
            },
            {
              "x": 3.96,
              "y": 6.95
            },
            {
              "x": 5.72,
              "y": 16.29
            },
            {
              "x": 9.78,
              "y": -14.82
            },
            {
              "x": 26.78,
              "y": 7.39
            },
            {
              "x": 14.85,
              "y": 21.47
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": 18.15,
            "y": 15.93,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 2.22,
              "y": 8.26
            },
            {
              "x": 19.56,
              "y": -15.41
            },
            {
              "x": 28.05,
              "y": -2.95
            },
            {
              "x": 25.79,
              "y": 13.48
            },
            {
              "x": 10.63,
              "y": 10.07
            },
            {
              "x": 19.87,
              "y": 21.49
            },
            {
              "x": 7.84,
              "y": 19.44
            },
            {
              "x": -6.92,
              "y": 11.3
            },
            {
              "x": 1.62,
              "y": -18.82
            },
            {
              "x": 16.16,
              "y": 16.79
            },
            {
              "x": 43.68,
              "y": 1.23
            }
          ],
          "awayPlayers": [
            {
              "x": -34.06,
              "y": 1.96
            },
            {
              "x": -2.3,
              "y": -19.93
            },
            {
              "x": -6.52,
              "y": 15.55
            },
            {
              "x": 2.41,
              "y": 25.43
            },
            {
              "x": -7.99,
              "y": 3.63
            },
            {
              "x": 16.95,
              "y": 16.66
            },
            {
              "x": 4.48,
              "y": 7.06
            },
            {
              "x": 6.97,
              "y": 16.19
            },
            {
              "x": 10.83,
              "y": -15.41
            },
            {
              "x": 26.75,
              "y": 8.49
            },
            {
              "x": 15.55,
              "y": 21.97
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": 19.36,
            "y": 14.46,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 3.39,
              "y": 7.71
            },
            {
              "x": 20.77,
              "y": -14.96
            },
            {
              "x": 27.78,
              "y": -0.36
            },
            {
              "x": 25.35,
              "y": 13.52
            },
            {
              "x": 12.16,
              "y": 9.99
            },
            {
              "x": 21.49,
              "y": 20.5
            },
            {
              "x": 8.05,
              "y": 18.65
            },
            {
              "x": -5.76,
              "y": 10.32
            },
            {
              "x": 3.16,
              "y": -18.05
            },
            {
              "x": 18.25,
              "y": 16.11
            },
            {
              "x": 43.83,
              "y": 1.29
            }
          ],
          "awayPlayers": [
            {
              "x": -33.86,
              "y": 1.74
            },
            {
              "x": -1.07,
              "y": -18.88
            },
            {
              "x": -5.48,
              "y": 15.4
            },
            {
              "x": 2.87,
              "y": 24.64
            },
            {
              "x": -7.05,
              "y": 2.73
            },
            {
              "x": 18.56,
              "y": 15.47
            },
            {
              "x": 5.01,
              "y": 6.74
            },
            {
              "x": 8.24,
              "y": 15.88
            },
            {
              "x": 12.12,
              "y": -16.07
            },
            {
              "x": 26.88,
              "y": 9.91
            },
            {
              "x": 16.36,
              "y": 22.2
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": 20.47,
            "y": 13.12,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 4.29,
              "y": 7.22
            },
            {
              "x": 21.91,
              "y": -14.43
            },
            {
              "x": 27.6,
              "y": 2.49
            },
            {
              "x": 25.3,
              "y": 13.11
            },
            {
              "x": 13.71,
              "y": 9.48
            },
            {
              "x": 23.05,
              "y": 19.3
            },
            {
              "x": 8.4,
              "y": 18.05
            },
            {
              "x": -4.86,
              "y": 9.8
            },
            {
              "x": 5.01,
              "y": -16.87
            },
            {
              "x": 20.12,
              "y": 14.89
            },
            {
              "x": 44.1,
              "y": 1.33
            }
          ],
          "awayPlayers": [
            {
              "x": -33.69,
              "y": 1.58
            },
            {
              "x": 0.24,
              "y": -17.68
            },
            {
              "x": -4.73,
              "y": 15.39
            },
            {
              "x": 3.68,
              "y": 23.91
            },
            {
              "x": -6.39,
              "y": 1.83
            },
            {
              "x": 19.73,
              "y": 13.91
            },
            {
              "x": 5.52,
              "y": 6.39
            },
            {
              "x": 9.39,
              "y": 15.14
            },
            {
              "x": 13.53,
              "y": -16.71
            },
            {
              "x": 27.65,
              "y": 10.63
            },
            {
              "x": 17.24,
              "y": 21.82
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": 20.47,
            "y": 10.81,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 5.23,
              "y": 6.58
            },
            {
              "x": 22.9,
              "y": -14.23
            },
            {
              "x": 27.27,
              "y": 5.2
            },
            {
              "x": 25.16,
              "y": 12.17
            },
            {
              "x": 15.28,
              "y": 8.73
            },
            {
              "x": 24.4,
              "y": 18.15
            },
            {
              "x": 8.5,
              "y": 17.16
            },
            {
              "x": -3.91,
              "y": 8.86
            },
            {
              "x": 6.94,
              "y": -16.04
            },
            {
              "x": 21.68,
              "y": 13.54
            },
            {
              "x": 44.34,
              "y": 1.38
            }
          ],
          "awayPlayers": [
            {
              "x": -33.5,
              "y": 1.39
            },
            {
              "x": 1.13,
              "y": -16.77
            },
            {
              "x": -4.04,
              "y": 15.09
            },
            {
              "x": 4.33,
              "y": 22.96
            },
            {
              "x": -5.79,
              "y": 0.9
            },
            {
              "x": 20.5,
              "y": 12.32
            },
            {
              "x": 6.55,
              "y": 5.67
            },
            {
              "x": 10.54,
              "y": 14.37
            },
            {
              "x": 15.18,
              "y": -16.16
            },
            {
              "x": 28.6,
              "y": 11.18
            },
            {
              "x": 17.91,
              "y": 20.89
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": 20.55,
            "y": 8.91,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 6.38,
              "y": 6.07
            },
            {
              "x": 23.37,
              "y": -14.53
            },
            {
              "x": 27.24,
              "y": 5.35
            },
            {
              "x": 24.97,
              "y": 10.83
            },
            {
              "x": 16.94,
              "y": 8.03
            },
            {
              "x": 25.45,
              "y": 17.0
            },
            {
              "x": 9.09,
              "y": 16.71
            },
            {
              "x": -3.35,
              "y": 8.54
            },
            {
              "x": 8.09,
              "y": -15.63
            },
            {
              "x": 22.72,
              "y": 11.73
            },
            {
              "x": 44.7,
              "y": 1.22
            }
          ],
          "awayPlayers": [
            {
              "x": -33.25,
              "y": 1.25
            },
            {
              "x": 2.1,
              "y": -16.83
            },
            {
              "x": -3.62,
              "y": 14.65
            },
            {
              "x": 5.19,
              "y": 22.57
            },
            {
              "x": -5.25,
              "y": 0.52
            },
            {
              "x": 20.96,
              "y": 10.37
            },
            {
              "x": 7.77,
              "y": 4.93
            },
            {
              "x": 11.76,
              "y": 13.61
            },
            {
              "x": 16.87,
              "y": -15.3
            },
            {
              "x": 29.01,
              "y": 11.54
            },
            {
              "x": 18.57,
              "y": 19.74
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": 20.93,
            "y": 6.99,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 7.46,
              "y": 5.3
            },
            {
              "x": 23.76,
              "y": -14.85
            },
            {
              "x": 27.53,
              "y": 5.15
            },
            {
              "x": 25.43,
              "y": 9.67
            },
            {
              "x": 18.69,
              "y": 7.08
            },
            {
              "x": 26.49,
              "y": 15.91
            },
            {
              "x": 9.58,
              "y": 16.15
            },
            {
              "x": -2.92,
              "y": 7.88
            },
            {
              "x": 8.98,
              "y": -15.62
            },
            {
              "x": 23.54,
              "y": 9.92
            },
            {
              "x": 44.95,
              "y": 1.09
            }
          ],
          "awayPlayers": [
            {
              "x": -33.09,
              "y": 1.09
            },
            {
              "x": 2.61,
              "y": -16.99
            },
            {
              "x": -3.22,
              "y": 14.01
            },
            {
              "x": 5.73,
              "y": 21.99
            },
            {
              "x": -4.73,
              "y": 0.17
            },
            {
              "x": 21.5,
              "y": 8.39
            },
            {
              "x": 8.82,
              "y": 4.11
            },
            {
              "x": 12.95,
              "y": 12.9
            },
            {
              "x": 18.75,
              "y": -14.54
            },
            {
              "x": 29.5,
              "y": 11.48
            },
            {
              "x": 19.37,
              "y": 18.74
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": 21.24,
            "y": 2.01,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 8.82,
              "y": 4.5
            },
            {
              "x": 24.84,
              "y": -14.73
            },
            {
              "x": 27.91,
              "y": 4.28
            },
            {
              "x": 26.29,
              "y": 8.63
            },
            {
              "x": 20.33,
              "y": 5.89
            },
            {
              "x": 27.41,
              "y": 14.8
            },
            {
              "x": 10.57,
              "y": 15.71
            },
            {
              "x": 8.64,
              "y": 2.05
            },
            {
              "x": 10.32,
              "y": -15.49
            },
            {
              "x": 24.14,
              "y": 8.05
            },
            {
              "x": 45.25,
              "y": 0.77
            }
          ],
          "awayPlayers": [
            {
              "x": -32.86,
              "y": 0.88
            },
            {
              "x": 4.03,
              "y": -17.55
            },
            {
              "x": -2.67,
              "y": 13.29
            },
            {
              "x": 7.02,
              "y": 21.46
            },
            {
              "x": -4.07,
              "y": -0.46
            },
            {
              "x": 22.14,
              "y": 6.55
            },
            {
              "x": 9.6,
              "y": 3.38
            },
            {
              "x": 13.92,
              "y": 12.21
            },
            {
              "x": 20.66,
              "y": -14.54
            },
            {
              "x": 30.06,
              "y": 11.04
            },
            {
              "x": 20.17,
              "y": 17.92
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": 21.37,
            "y": -4.2,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 10.0,
              "y": 3.74
            },
            {
              "x": 25.83,
              "y": -14.59
            },
            {
              "x": 28.34,
              "y": 3.08
            },
            {
              "x": 27.5,
              "y": 7.75
            },
            {
              "x": 21.91,
              "y": 4.37
            },
            {
              "x": 28.26,
              "y": 13.75
            },
            {
              "x": 11.54,
              "y": 15.24
            },
            {
              "x": 20.25,
              "y": -3.99
            },
            {
              "x": 11.93,
              "y": -15.35
            },
            {
              "x": 24.85,
              "y": 6.22
            },
            {
              "x": 45.57,
              "y": 0.52
            }
          ],
          "awayPlayers": [
            {
              "x": -32.66,
              "y": 0.72
            },
            {
              "x": 5.14,
              "y": -17.97
            },
            {
              "x": -2.13,
              "y": 12.58
            },
            {
              "x": 8.21,
              "y": 20.85
            },
            {
              "x": -3.46,
              "y": -1.1
            },
            {
              "x": 23.13,
              "y": 5.08
            },
            {
              "x": 10.36,
              "y": 2.56
            },
            {
              "x": 14.91,
              "y": 11.49
            },
            {
              "x": 22.28,
              "y": -15.25
            },
            {
              "x": 30.66,
              "y": 10.34
            },
            {
              "x": 20.99,
              "y": 17.01
            }
          ],
          "time": 5.005
        },
        {
          "ball": {
            "x": 21.65,
            "y": -9.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 11.36,
              "y": 2.89
            },
            {
              "x": 27.07,
              "y": -14.27
            },
            {
              "x": 28.91,
              "y": 1.96
            },
            {
              "x": 28.97,
              "y": 7.12
            },
            {
              "x": 23.41,
              "y": 2.75
            },
            {
              "x": 29.1,
              "y": 12.81
            },
            {
              "x": 13.26,
              "y": 14.48
            },
            {
              "x": 32.05,
              "y": -9.99
            },
            {
              "x": 12.78,
              "y": -14.79
            },
            {
              "x": 25.82,
              "y": 4.88
            },
            {
              "x": 45.89,
              "y": 0.21
            }
          ],
          "awayPlayers": [
            {
              "x": -32.45,
              "y": 0.54
            },
            {
              "x": 6.62,
              "y": -18.75
            },
            {
              "x": -1.54,
              "y": 11.88
            },
            {
              "x": 10.04,
              "y": 20.27
            },
            {
              "x": -2.87,
              "y": -1.68
            },
            {
              "x": 24.39,
              "y": 4.13
            },
            {
              "x": 11.11,
              "y": 1.8
            },
            {
              "x": 16.01,
              "y": 10.82
            },
            {
              "x": 23.24,
              "y": -16.18
            },
            {
              "x": 31.4,
              "y": 9.65
            },
            {
              "x": 21.87,
              "y": 15.94
            }
          ],
          "time": 5.339
        },
        {
          "ball": {
            "x": 22.0,
            "y": -13.65,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 12.48,
              "y": 2.19
            },
            {
              "x": 27.86,
              "y": -14.43
            },
            {
              "x": 29.79,
              "y": 0.9
            },
            {
              "x": 30.61,
              "y": 6.63
            },
            {
              "x": 24.8,
              "y": 1.13
            },
            {
              "x": 29.94,
              "y": 11.88
            },
            {
              "x": 14.42,
              "y": 13.87
            },
            {
              "x": 32.75,
              "y": -10.61
            },
            {
              "x": 13.42,
              "y": -14.01
            },
            {
              "x": 26.92,
              "y": 3.73
            },
            {
              "x": 46.16,
              "y": 0.07
            }
          ],
          "awayPlayers": [
            {
              "x": -32.26,
              "y": 0.4
            },
            {
              "x": 7.78,
              "y": -19.28
            },
            {
              "x": -1.07,
              "y": 11.23
            },
            {
              "x": 10.99,
              "y": 19.77
            },
            {
              "x": -2.38,
              "y": -2.25
            },
            {
              "x": 25.41,
              "y": 3.06
            },
            {
              "x": 11.88,
              "y": 1.14
            },
            {
              "x": 17.18,
              "y": 9.94
            },
            {
              "x": 23.44,
              "y": -17.05
            },
            {
              "x": 32.21,
              "y": 8.9
            },
            {
              "x": 22.76,
              "y": 14.73
            }
          ],
          "time": 5.672
        },
        {
          "ball": {
            "x": 22.3,
            "y": -16.89,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 13.57,
              "y": 1.42
            },
            {
              "x": 28.59,
              "y": -14.56
            },
            {
              "x": 30.8,
              "y": 0.13
            },
            {
              "x": 32.17,
              "y": 6.26
            },
            {
              "x": 25.81,
              "y": -0.57
            },
            {
              "x": 30.66,
              "y": 10.84
            },
            {
              "x": 15.69,
              "y": 13.29
            },
            {
              "x": 33.38,
              "y": -11.78
            },
            {
              "x": 14.29,
              "y": -13.57
            },
            {
              "x": 27.91,
              "y": 3.07
            },
            {
              "x": 46.34,
              "y": -0.14
            }
          ],
          "awayPlayers": [
            {
              "x": -32.02,
              "y": 0.25
            },
            {
              "x": 9.01,
              "y": -19.82
            },
            {
              "x": -0.63,
              "y": 10.61
            },
            {
              "x": 12.09,
              "y": 19.26
            },
            {
              "x": -1.98,
              "y": -2.65
            },
            {
              "x": 25.91,
              "y": 1.94
            },
            {
              "x": 12.52,
              "y": 0.39
            },
            {
              "x": 18.19,
              "y": 9.09
            },
            {
              "x": 23.24,
              "y": -17.85
            },
            {
              "x": 33.06,
              "y": 8.22
            },
            {
              "x": 23.47,
              "y": 13.49
            }
          ],
          "time": 6.006
        },
        {
          "ball": {
            "x": 23.05,
            "y": -18.24,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": 14.71,
              "y": 0.74
            },
            {
              "x": 29.34,
              "y": -14.63
            },
            {
              "x": 31.85,
              "y": -0.7
            },
            {
              "x": 33.59,
              "y": 5.7
            },
            {
              "x": 26.61,
              "y": -2.29
            },
            {
              "x": 31.38,
              "y": 9.77
            },
            {
              "x": 16.59,
              "y": 12.66
            },
            {
              "x": 33.23,
              "y": -12.81
            },
            {
              "x": 15.81,
              "y": -13.67
            },
            {
              "x": 28.55,
              "y": 2.05
            },
            {
              "x": 46.88,
              "y": -0.29
            }
          ],
          "awayPlayers": [
            {
              "x": -31.87,
              "y": 0.1
            },
            {
              "x": 10.1,
              "y": -20.17
            },
            {
              "x": -0.17,
              "y": 9.98
            },
            {
              "x": 12.94,
              "y": 18.83
            },
            {
              "x": -1.49,
              "y": -3.05
            },
            {
              "x": 25.85,
              "y": 0.55
            },
            {
              "x": 13.25,
              "y": -0.4
            },
            {
              "x": 19.08,
              "y": 8.08
            },
            {
              "x": 23.04,
              "y": -18.85
            },
            {
              "x": 33.8,
              "y": 7.3
            },
            {
              "x": 24.09,
              "y": 12.25
            }
          ],
          "time": 6.34
        },
        {
          "ball": {
            "x": 23.64,
            "y": -19.2,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": 15.57,
              "y": 0.23
            },
            {
              "x": 29.95,
              "y": -14.87
            },
            {
              "x": 32.93,
              "y": -1.23
            },
            {
              "x": 34.87,
              "y": 5.11
            },
            {
              "x": 27.34,
              "y": -4.0
            },
            {
              "x": 32.17,
              "y": 8.79
            },
            {
              "x": 17.48,
              "y": 12.2
            },
            {
              "x": 32.81,
              "y": -13.66
            },
            {
              "x": 18.7,
              "y": -14.2
            },
            {
              "x": 29.02,
              "y": 1.01
            },
            {
              "x": 47.89,
              "y": -0.41
            }
          ],
          "awayPlayers": [
            {
              "x": -31.71,
              "y": -0.03
            },
            {
              "x": 11.23,
              "y": -20.23
            },
            {
              "x": 0.32,
              "y": 9.45
            },
            {
              "x": 13.9,
              "y": 18.47
            },
            {
              "x": -0.98,
              "y": -3.51
            },
            {
              "x": 25.55,
              "y": -0.71
            },
            {
              "x": 13.99,
              "y": -1.13
            },
            {
              "x": 20.02,
              "y": 7.2
            },
            {
              "x": 23.33,
              "y": -19.67
            },
            {
              "x": 34.4,
              "y": 6.14
            },
            {
              "x": 25.25,
              "y": 10.76
            }
          ],
          "time": 6.673
        },
        {
          "ball": {
            "x": 24.8,
            "y": -19.86,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 16.61,
              "y": -0.45
            },
            {
              "x": 30.59,
              "y": -14.97
            },
            {
              "x": 34.04,
              "y": -1.58
            },
            {
              "x": 36.06,
              "y": 4.62
            },
            {
              "x": 28.21,
              "y": -5.41
            },
            {
              "x": 33.03,
              "y": 8.12
            },
            {
              "x": 18.54,
              "y": 11.58
            },
            {
              "x": 32.33,
              "y": -14.41
            },
            {
              "x": 21.17,
              "y": -14.97
            },
            {
              "x": 29.36,
              "y": -0.21
            },
            {
              "x": 48.91,
              "y": -0.41
            }
          ],
          "awayPlayers": [
            {
              "x": -31.64,
              "y": -0.17
            },
            {
              "x": 12.24,
              "y": -20.46
            },
            {
              "x": 0.85,
              "y": 8.81
            },
            {
              "x": 14.81,
              "y": 17.97
            },
            {
              "x": -0.48,
              "y": -3.88
            },
            {
              "x": 25.15,
              "y": -1.87
            },
            {
              "x": 14.57,
              "y": -1.89
            },
            {
              "x": 21.19,
              "y": 6.28
            },
            {
              "x": 24.05,
              "y": -20.3
            },
            {
              "x": 34.87,
              "y": 4.78
            },
            {
              "x": 25.96,
              "y": 10.2
            }
          ],
          "time": 7.007
        },
        {
          "ball": {
            "x": 26.69,
            "y": -20.12,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 17.73,
              "y": -1.06
            },
            {
              "x": 31.36,
              "y": -15.08
            },
            {
              "x": 35.21,
              "y": -1.57
            },
            {
              "x": 37.03,
              "y": 4.11
            },
            {
              "x": 29.22,
              "y": -6.61
            },
            {
              "x": 33.8,
              "y": 7.42
            },
            {
              "x": 19.53,
              "y": 11.04
            },
            {
              "x": 31.93,
              "y": -15.24
            },
            {
              "x": 23.55,
              "y": -15.82
            },
            {
              "x": 29.84,
              "y": -1.02
            },
            {
              "x": 49.6,
              "y": -0.44
            }
          ],
          "awayPlayers": [
            {
              "x": -31.47,
              "y": -0.35
            },
            {
              "x": 13.38,
              "y": -20.91
            },
            {
              "x": 1.37,
              "y": 8.15
            },
            {
              "x": 15.64,
              "y": 17.62
            },
            {
              "x": 0.07,
              "y": -4.41
            },
            {
              "x": 24.85,
              "y": -3.02
            },
            {
              "x": 15.41,
              "y": -2.68
            },
            {
              "x": 21.73,
              "y": 5.94
            },
            {
              "x": 25.35,
              "y": -20.56
            },
            {
              "x": 35.41,
              "y": 3.37
            },
            {
              "x": 27.06,
              "y": 9.33
            }
          ],
          "time": 7.341
        },
        {
          "ball": {
            "x": 28.27,
            "y": -20.47,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 18.68,
              "y": -1.75
            },
            {
              "x": 32.05,
              "y": -15.13
            },
            {
              "x": 36.37,
              "y": -1.58
            },
            {
              "x": 37.73,
              "y": 3.51
            },
            {
              "x": 30.29,
              "y": -7.66
            },
            {
              "x": 34.56,
              "y": 6.79
            },
            {
              "x": 20.47,
              "y": 10.48
            },
            {
              "x": 31.9,
              "y": -16.2
            },
            {
              "x": 25.86,
              "y": -16.66
            },
            {
              "x": 30.46,
              "y": -1.72
            },
            {
              "x": 49.71,
              "y": -0.49
            }
          ],
          "awayPlayers": [
            {
              "x": -31.25,
              "y": -0.52
            },
            {
              "x": 14.42,
              "y": -21.74
            },
            {
              "x": 1.88,
              "y": 7.49
            },
            {
              "x": 16.3,
              "y": 17.2
            },
            {
              "x": 0.56,
              "y": -4.97
            },
            {
              "x": 24.77,
              "y": -4.14
            },
            {
              "x": 16.12,
              "y": -3.6
            },
            {
              "x": 22.46,
              "y": 5.06
            },
            {
              "x": 26.93,
              "y": -20.8
            },
            {
              "x": 36.19,
              "y": 2.06
            },
            {
              "x": 28.28,
              "y": 8.44
            }
          ],
          "time": 7.674
        },
        {
          "ball": {
            "x": 29.63,
            "y": -20.88,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 19.7,
              "y": -2.35
            },
            {
              "x": 32.81,
              "y": -15.18
            },
            {
              "x": 37.6,
              "y": -1.49
            },
            {
              "x": 38.07,
              "y": 2.6
            },
            {
              "x": 31.36,
              "y": -8.64
            },
            {
              "x": 35.24,
              "y": 6.12
            },
            {
              "x": 21.47,
              "y": 9.83
            },
            {
              "x": 32.42,
              "y": -17.07
            },
            {
              "x": 28.13,
              "y": -17.34
            },
            {
              "x": 31.22,
              "y": -2.34
            },
            {
              "x": 49.96,
              "y": -0.76
            }
          ],
          "awayPlayers": [
            {
              "x": -31.0,
              "y": -0.74
            },
            {
              "x": 15.92,
              "y": -23.0
            },
            {
              "x": 2.39,
              "y": 6.76
            },
            {
              "x": 17.46,
              "y": 16.98
            },
            {
              "x": 1.16,
              "y": -5.59
            },
            {
              "x": 24.93,
              "y": -5.15
            },
            {
              "x": 17.04,
              "y": -4.32
            },
            {
              "x": 23.3,
              "y": 4.07
            },
            {
              "x": 28.83,
              "y": -20.93
            },
            {
              "x": 36.99,
              "y": 0.67
            },
            {
              "x": 29.5,
              "y": 7.58
            }
          ],
          "time": 8.008
        },
        {
          "ball": {
            "x": 30.63,
            "y": -21.31,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 20.5,
              "y": -2.97
            },
            {
              "x": 33.55,
              "y": -15.16
            },
            {
              "x": 38.76,
              "y": -1.52
            },
            {
              "x": 38.43,
              "y": 1.88
            },
            {
              "x": 32.26,
              "y": -9.47
            },
            {
              "x": 36.0,
              "y": 5.73
            },
            {
              "x": 22.14,
              "y": 9.46
            },
            {
              "x": 33.33,
              "y": -17.63
            },
            {
              "x": 30.07,
              "y": -17.78
            },
            {
              "x": 32.1,
              "y": -2.68
            },
            {
              "x": 50.15,
              "y": -0.92
            }
          ],
          "awayPlayers": [
            {
              "x": -30.77,
              "y": -0.91
            },
            {
              "x": 17.25,
              "y": -24.02
            },
            {
              "x": 2.92,
              "y": 6.18
            },
            {
              "x": 18.06,
              "y": 16.68
            },
            {
              "x": 1.72,
              "y": -6.22
            },
            {
              "x": 25.23,
              "y": -5.95
            },
            {
              "x": 17.82,
              "y": -5.01
            },
            {
              "x": 24.27,
              "y": 3.04
            },
            {
              "x": 30.37,
              "y": -21.0
            },
            {
              "x": 37.77,
              "y": -0.66
            },
            {
              "x": 30.68,
              "y": 6.85
            }
          ],
          "time": 8.342
        },
        {
          "ball": {
            "x": 31.45,
            "y": -21.11,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 21.56,
              "y": -3.62
            },
            {
              "x": 34.17,
              "y": -15.25
            },
            {
              "x": 40.05,
              "y": -1.77
            },
            {
              "x": 38.98,
              "y": 1.16
            },
            {
              "x": 33.14,
              "y": -10.22
            },
            {
              "x": 36.74,
              "y": 5.23
            },
            {
              "x": 22.97,
              "y": 8.95
            },
            {
              "x": 34.33,
              "y": -18.19
            },
            {
              "x": 31.81,
              "y": -18.27
            },
            {
              "x": 33.1,
              "y": -3.0
            },
            {
              "x": 50.39,
              "y": -0.99
            }
          ],
          "awayPlayers": [
            {
              "x": -30.56,
              "y": -1.1
            },
            {
              "x": 18.82,
              "y": -24.87
            },
            {
              "x": 3.45,
              "y": 5.66
            },
            {
              "x": 18.85,
              "y": 16.43
            },
            {
              "x": 2.23,
              "y": -6.7
            },
            {
              "x": 25.72,
              "y": -6.53
            },
            {
              "x": 18.61,
              "y": -5.74
            },
            {
              "x": 25.09,
              "y": 2.5
            },
            {
              "x": 31.65,
              "y": -21.12
            },
            {
              "x": 38.55,
              "y": -2.24
            },
            {
              "x": 31.5,
              "y": 6.37
            }
          ],
          "time": 8.675
        },
        {
          "ball": {
            "x": 31.64,
            "y": -20.7,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.62,
              "y": -4.32
            },
            {
              "x": 34.77,
              "y": -15.28
            },
            {
              "x": 41.05,
              "y": -2.51
            },
            {
              "x": 39.77,
              "y": 0.71
            },
            {
              "x": 33.62,
              "y": -10.73
            },
            {
              "x": 37.66,
              "y": 4.89
            },
            {
              "x": 23.58,
              "y": 8.54
            },
            {
              "x": 35.31,
              "y": -18.41
            },
            {
              "x": 32.84,
              "y": -18.56
            },
            {
              "x": 34.01,
              "y": -3.31
            },
            {
              "x": 50.55,
              "y": -1.07
            }
          ],
          "awayPlayers": [
            {
              "x": -30.42,
              "y": -1.27
            },
            {
              "x": 20.44,
              "y": -25.57
            },
            {
              "x": 3.91,
              "y": 5.18
            },
            {
              "x": 19.38,
              "y": 16.0
            },
            {
              "x": 2.71,
              "y": -7.13
            },
            {
              "x": 26.24,
              "y": -6.72
            },
            {
              "x": 19.25,
              "y": -6.44
            },
            {
              "x": 25.61,
              "y": 2.12
            },
            {
              "x": 32.21,
              "y": -20.96
            },
            {
              "x": 39.2,
              "y": -3.79
            },
            {
              "x": 33.4,
              "y": 5.38
            }
          ],
          "time": 9.009
        },
        {
          "ball": {
            "x": 31.48,
            "y": -20.28,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.31,
              "y": -5.16
            },
            {
              "x": 35.02,
              "y": -15.48
            },
            {
              "x": 41.6,
              "y": -3.52
            },
            {
              "x": 40.54,
              "y": 0.48
            },
            {
              "x": 33.51,
              "y": -11.13
            },
            {
              "x": 38.43,
              "y": 4.47
            },
            {
              "x": 24.02,
              "y": 8.03
            },
            {
              "x": 36.04,
              "y": -18.41
            },
            {
              "x": 32.91,
              "y": -18.79
            },
            {
              "x": 34.58,
              "y": -3.71
            },
            {
              "x": 50.7,
              "y": -1.17
            }
          ],
          "awayPlayers": [
            {
              "x": -30.22,
              "y": -1.42
            },
            {
              "x": 22.07,
              "y": -26.2
            },
            {
              "x": 4.4,
              "y": 4.85
            },
            {
              "x": 19.96,
              "y": 15.76
            },
            {
              "x": 3.17,
              "y": -7.54
            },
            {
              "x": 26.79,
              "y": -6.42
            },
            {
              "x": 20.02,
              "y": -7.38
            },
            {
              "x": 25.89,
              "y": 1.81
            },
            {
              "x": 32.24,
              "y": -20.61
            },
            {
              "x": 39.49,
              "y": -5.31
            },
            {
              "x": 34.71,
              "y": 4.6
            }
          ],
          "time": 9.343
        },
        {
          "ball": {
            "x": 29.03,
            "y": -17.95,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.84,
              "y": -6.02
            },
            {
              "x": 35.15,
              "y": -15.48
            },
            {
              "x": 41.6,
              "y": -4.62
            },
            {
              "x": 40.95,
              "y": 0.24
            },
            {
              "x": 32.9,
              "y": -11.21
            },
            {
              "x": 39.18,
              "y": 4.23
            },
            {
              "x": 24.62,
              "y": 7.38
            },
            {
              "x": 36.63,
              "y": -18.34
            },
            {
              "x": 32.48,
              "y": -18.62
            },
            {
              "x": 34.7,
              "y": -4.07
            },
            {
              "x": 50.77,
              "y": -1.3
            }
          ],
          "awayPlayers": [
            {
              "x": -30.11,
              "y": -1.57
            },
            {
              "x": 23.57,
              "y": -26.96
            },
            {
              "x": 4.84,
              "y": 4.37
            },
            {
              "x": 20.61,
              "y": 15.18
            },
            {
              "x": 3.59,
              "y": -7.98
            },
            {
              "x": 27.34,
              "y": -5.79
            },
            {
              "x": 21.08,
              "y": -8.42
            },
            {
              "x": 26.03,
              "y": 1.66
            },
            {
              "x": 31.95,
              "y": -20.23
            },
            {
              "x": 39.41,
              "y": -6.54
            },
            {
              "x": 35.8,
              "y": 3.78
            }
          ],
          "time": 9.676
        },
        {
          "ball": {
            "x": 25.65,
            "y": -14.54,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 27.11,
              "y": -6.88
            },
            {
              "x": 35.22,
              "y": -15.42
            },
            {
              "x": 41.15,
              "y": -5.57
            },
            {
              "x": 41.03,
              "y": 0.26
            },
            {
              "x": 32.17,
              "y": -11.07
            },
            {
              "x": 39.48,
              "y": 3.87
            },
            {
              "x": 24.89,
              "y": 6.98
            },
            {
              "x": 36.8,
              "y": -18.74
            },
            {
              "x": 31.84,
              "y": -18.43
            },
            {
              "x": 34.31,
              "y": -4.31
            },
            {
              "x": 50.76,
              "y": -1.32
            }
          ],
          "awayPlayers": [
            {
              "x": -30.02,
              "y": -1.67
            },
            {
              "x": 24.93,
              "y": -27.71
            },
            {
              "x": 5.27,
              "y": 4.16
            },
            {
              "x": 20.98,
              "y": 14.98
            },
            {
              "x": 3.97,
              "y": -8.29
            },
            {
              "x": 27.89,
              "y": -5.02
            },
            {
              "x": 22.09,
              "y": -9.49
            },
            {
              "x": 26.15,
              "y": 1.63
            },
            {
              "x": 32.02,
              "y": -19.5
            },
            {
              "x": 39.09,
              "y": -7.29
            },
            {
              "x": 36.62,
              "y": 3.1
            }
          ],
          "time": 10.01
        },
        {
          "ball": {
            "x": 23.27,
            "y": -11.64,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 27.37,
              "y": -7.38
            },
            {
              "x": 35.21,
              "y": -15.49
            },
            {
              "x": 40.52,
              "y": -6.23
            },
            {
              "x": 40.73,
              "y": 0.15
            },
            {
              "x": 31.51,
              "y": -10.77
            },
            {
              "x": 39.44,
              "y": 3.61
            },
            {
              "x": 25.24,
              "y": 6.65
            },
            {
              "x": 36.85,
              "y": -19.27
            },
            {
              "x": 31.41,
              "y": -18.16
            },
            {
              "x": 33.67,
              "y": -4.38
            },
            {
              "x": 50.74,
              "y": -1.19
            }
          ],
          "awayPlayers": [
            {
              "x": -30.0,
              "y": -1.72
            },
            {
              "x": 25.86,
              "y": -28.55
            },
            {
              "x": 5.37,
              "y": 3.88
            },
            {
              "x": 21.12,
              "y": 14.75
            },
            {
              "x": 4.03,
              "y": -8.63
            },
            {
              "x": 28.28,
              "y": -4.2
            },
            {
              "x": 22.7,
              "y": -10.22
            },
            {
              "x": 26.08,
              "y": 1.59
            },
            {
              "x": 32.41,
              "y": -18.49
            },
            {
              "x": 38.69,
              "y": -7.59
            },
            {
              "x": 37.07,
              "y": 2.49
            }
          ],
          "time": 10.344
        }
      ],
      "duration": 10.344,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/f24f462f-5cb4-443d-a83e-0ad87f9ddd3b/3528.629"
    },
    {
      "id": "3827_216.0_subset0",
      "matchId": "3827",
      "sequenceId": "216.0_subset0",
      "dtwScore": 0.10363977077429533,
      "frames": [
        {
          "ball": {
            "x": -16.44,
            "y": -20.37,
            "z": 0.08
          },
          "homePlayers": [
            {
              "x": -1.61,
              "y": -20.11
            },
            {
              "x": 6.65,
              "y": -13.45
            },
            {
              "x": -17.84,
              "y": 11.8
            },
            {
              "x": 35.17,
              "y": -6.83
            },
            {
              "x": 10.14,
              "y": -2.45
            },
            {
              "x": 4.44,
              "y": -33.09
            },
            {
              "x": 8.12,
              "y": 15.16
            },
            {
              "x": -4.71,
              "y": -13.85
            },
            {
              "x": -9.2,
              "y": -24.74
            },
            {
              "x": -16.71,
              "y": -21.16
            },
            {
              "x": -6.44,
              "y": -25.86
            }
          ],
          "awayPlayers": [
            {
              "x": -7.07,
              "y": -16.72
            },
            {
              "x": -17.71,
              "y": -22.08
            },
            {
              "x": -39.8,
              "y": -2.85
            },
            {
              "x": -4.86,
              "y": 6.88
            },
            {
              "x": -20.2,
              "y": 3.26
            },
            {
              "x": 2.85,
              "y": -14.68
            },
            {
              "x": -19.18,
              "y": -11.91
            },
            {
              "x": -10.37,
              "y": -18.84
            },
            {
              "x": 1.82,
              "y": 20.52
            },
            {
              "x": -6.7,
              "y": -26.9
            },
            {
              "x": 0.05,
              "y": -33.65
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": -16.89,
            "y": -19.59,
            "z": 0.13
          },
          "homePlayers": [
            {
              "x": -1.7,
              "y": -19.94
            },
            {
              "x": 7.11,
              "y": -14.22
            },
            {
              "x": -18.48,
              "y": 12.16
            },
            {
              "x": 34.97,
              "y": -6.91
            },
            {
              "x": 10.4,
              "y": -3.15
            },
            {
              "x": 4.2,
              "y": -32.81
            },
            {
              "x": 8.0,
              "y": 15.26
            },
            {
              "x": -5.89,
              "y": -13.23
            },
            {
              "x": -10.74,
              "y": -24.87
            },
            {
              "x": -16.97,
              "y": -20.12
            },
            {
              "x": -6.71,
              "y": -25.72
            }
          ],
          "awayPlayers": [
            {
              "x": -7.77,
              "y": -16.27
            },
            {
              "x": -17.8,
              "y": -20.9
            },
            {
              "x": -40.12,
              "y": -2.76
            },
            {
              "x": -4.49,
              "y": 6.98
            },
            {
              "x": -20.67,
              "y": 3.49
            },
            {
              "x": 2.84,
              "y": -14.43
            },
            {
              "x": -19.73,
              "y": -11.91
            },
            {
              "x": -11.26,
              "y": -18.66
            },
            {
              "x": 1.79,
              "y": 21.06
            },
            {
              "x": -6.66,
              "y": -27.08
            },
            {
              "x": -0.01,
              "y": -33.5
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": -16.8,
            "y": -18.57,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": -1.89,
              "y": -19.66
            },
            {
              "x": 7.32,
              "y": -14.87
            },
            {
              "x": -19.46,
              "y": 12.7
            },
            {
              "x": 34.94,
              "y": -6.74
            },
            {
              "x": 10.39,
              "y": -3.71
            },
            {
              "x": 2.93,
              "y": -32.44
            },
            {
              "x": 7.77,
              "y": 15.16
            },
            {
              "x": -7.28,
              "y": -12.2
            },
            {
              "x": -12.53,
              "y": -24.7
            },
            {
              "x": -17.18,
              "y": -18.83
            },
            {
              "x": -7.21,
              "y": -25.6
            }
          ],
          "awayPlayers": [
            {
              "x": -8.64,
              "y": -15.58
            },
            {
              "x": -18.0,
              "y": -19.32
            },
            {
              "x": -40.59,
              "y": -2.68
            },
            {
              "x": -4.19,
              "y": 7.07
            },
            {
              "x": -21.52,
              "y": 3.71
            },
            {
              "x": 2.69,
              "y": -14.05
            },
            {
              "x": -20.56,
              "y": -11.67
            },
            {
              "x": -12.48,
              "y": -18.11
            },
            {
              "x": 1.7,
              "y": 21.6
            },
            {
              "x": -6.57,
              "y": -26.96
            },
            {
              "x": 1.3,
              "y": -26.65
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": -16.74,
            "y": -17.3,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -2.16,
              "y": -19.39
            },
            {
              "x": 7.41,
              "y": -15.55
            },
            {
              "x": -20.5,
              "y": 13.08
            },
            {
              "x": 34.72,
              "y": -6.73
            },
            {
              "x": 9.92,
              "y": -3.92
            },
            {
              "x": 2.19,
              "y": -32.25
            },
            {
              "x": 7.31,
              "y": 14.9
            },
            {
              "x": -8.8,
              "y": -11.02
            },
            {
              "x": -14.43,
              "y": -24.22
            },
            {
              "x": -17.52,
              "y": -17.73
            },
            {
              "x": -8.04,
              "y": -25.18
            }
          ],
          "awayPlayers": [
            {
              "x": -9.64,
              "y": -14.89
            },
            {
              "x": -17.96,
              "y": -17.7
            },
            {
              "x": -41.91,
              "y": -2.6
            },
            {
              "x": -3.85,
              "y": 7.17
            },
            {
              "x": -22.63,
              "y": 3.72
            },
            {
              "x": 2.49,
              "y": -13.73
            },
            {
              "x": -21.44,
              "y": -11.38
            },
            {
              "x": -13.95,
              "y": -17.77
            },
            {
              "x": 1.32,
              "y": 22.04
            },
            {
              "x": -6.66,
              "y": -26.89
            },
            {
              "x": 3.51,
              "y": -15.62
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": -16.87,
            "y": -15.34,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": -2.41,
              "y": -19.17
            },
            {
              "x": 7.02,
              "y": -15.5
            },
            {
              "x": -21.3,
              "y": 13.45
            },
            {
              "x": 34.53,
              "y": -6.62
            },
            {
              "x": 9.38,
              "y": -3.79
            },
            {
              "x": 2.17,
              "y": -31.24
            },
            {
              "x": 6.88,
              "y": 14.7
            },
            {
              "x": -10.08,
              "y": -9.93
            },
            {
              "x": -15.97,
              "y": -23.72
            },
            {
              "x": -17.62,
              "y": -16.91
            },
            {
              "x": -8.88,
              "y": -24.83
            }
          ],
          "awayPlayers": [
            {
              "x": -10.55,
              "y": -14.19
            },
            {
              "x": -17.88,
              "y": -16.57
            },
            {
              "x": -42.9,
              "y": -2.56
            },
            {
              "x": -3.54,
              "y": 7.28
            },
            {
              "x": -23.69,
              "y": 3.63
            },
            {
              "x": 2.27,
              "y": -13.15
            },
            {
              "x": -22.2,
              "y": -11.07
            },
            {
              "x": -15.24,
              "y": -17.77
            },
            {
              "x": 1.09,
              "y": 22.09
            },
            {
              "x": -6.78,
              "y": -26.8
            },
            {
              "x": 5.07,
              "y": -6.77
            }
          ],
          "time": 1.235
        },
        {
          "ball": {
            "x": -16.87,
            "y": -15.34,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": -2.41,
              "y": -19.17
            },
            {
              "x": 7.02,
              "y": -15.5
            },
            {
              "x": -21.3,
              "y": 13.45
            },
            {
              "x": 34.53,
              "y": -6.62
            },
            {
              "x": 9.38,
              "y": -3.79
            },
            {
              "x": 2.17,
              "y": -31.24
            },
            {
              "x": 6.88,
              "y": 14.7
            },
            {
              "x": -10.08,
              "y": -9.93
            },
            {
              "x": -15.97,
              "y": -23.72
            },
            {
              "x": -17.62,
              "y": -16.91
            },
            {
              "x": -8.88,
              "y": -24.83
            }
          ],
          "awayPlayers": [
            {
              "x": -10.55,
              "y": -14.19
            },
            {
              "x": -17.88,
              "y": -16.57
            },
            {
              "x": -42.9,
              "y": -2.56
            },
            {
              "x": -3.54,
              "y": 7.28
            },
            {
              "x": -23.69,
              "y": 3.63
            },
            {
              "x": 2.27,
              "y": -13.15
            },
            {
              "x": -22.2,
              "y": -11.07
            },
            {
              "x": -15.24,
              "y": -17.77
            },
            {
              "x": 1.09,
              "y": 22.09
            },
            {
              "x": -6.78,
              "y": -26.8
            },
            {
              "x": 5.07,
              "y": -6.77
            }
          ],
          "time": 1.235
        },
        {
          "ball": {
            "x": -16.81,
            "y": -12.68,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -2.69,
              "y": -18.93
            },
            {
              "x": 6.69,
              "y": -15.49
            },
            {
              "x": -22.0,
              "y": 13.88
            },
            {
              "x": 34.38,
              "y": -6.5
            },
            {
              "x": 8.9,
              "y": -3.85
            },
            {
              "x": 2.5,
              "y": -29.87
            },
            {
              "x": 6.41,
              "y": 14.67
            },
            {
              "x": -11.47,
              "y": -8.84
            },
            {
              "x": -17.51,
              "y": -23.21
            },
            {
              "x": -17.84,
              "y": -16.28
            },
            {
              "x": -9.84,
              "y": -24.45
            }
          ],
          "awayPlayers": [
            {
              "x": -11.5,
              "y": -13.47
            },
            {
              "x": -17.99,
              "y": -15.72
            },
            {
              "x": -43.92,
              "y": -2.53
            },
            {
              "x": -3.42,
              "y": 7.33
            },
            {
              "x": -24.8,
              "y": 3.51
            },
            {
              "x": 2.12,
              "y": -12.65
            },
            {
              "x": -22.9,
              "y": -10.82
            },
            {
              "x": -16.6,
              "y": -18.18
            },
            {
              "x": 0.88,
              "y": 22.11
            },
            {
              "x": -6.87,
              "y": -26.66
            },
            {
              "x": 6.31,
              "y": -0.3
            }
          ],
          "time": 1.502
        },
        {
          "ball": {
            "x": -16.83,
            "y": -9.66,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.01,
              "y": -18.54
            },
            {
              "x": 6.11,
              "y": -15.34
            },
            {
              "x": -22.95,
              "y": 14.72
            },
            {
              "x": 34.19,
              "y": -6.26
            },
            {
              "x": 8.11,
              "y": -3.67
            },
            {
              "x": 2.97,
              "y": -28.1
            },
            {
              "x": 5.61,
              "y": 14.5
            },
            {
              "x": -13.4,
              "y": -7.52
            },
            {
              "x": -19.51,
              "y": -22.48
            },
            {
              "x": -18.32,
              "y": -15.71
            },
            {
              "x": -11.16,
              "y": -24.16
            }
          ],
          "awayPlayers": [
            {
              "x": -12.8,
              "y": -12.45
            },
            {
              "x": -18.45,
              "y": -15.02
            },
            {
              "x": -44.42,
              "y": -2.51
            },
            {
              "x": -3.29,
              "y": 7.28
            },
            {
              "x": -26.28,
              "y": 3.42
            },
            {
              "x": 1.77,
              "y": -12.04
            },
            {
              "x": -23.77,
              "y": -10.35
            },
            {
              "x": -18.41,
              "y": -18.71
            },
            {
              "x": 0.65,
              "y": 22.06
            },
            {
              "x": -6.92,
              "y": -26.5
            },
            {
              "x": 5.49,
              "y": -0.24
            }
          ],
          "time": 1.835
        },
        {
          "ball": {
            "x": -17.03,
            "y": -7.13,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.1,
              "y": -18.32
            },
            {
              "x": 5.6,
              "y": -15.09
            },
            {
              "x": -24.05,
              "y": 15.56
            },
            {
              "x": 33.93,
              "y": -5.97
            },
            {
              "x": 7.37,
              "y": -3.31
            },
            {
              "x": 3.11,
              "y": -26.67
            },
            {
              "x": 4.55,
              "y": 14.4
            },
            {
              "x": -15.48,
              "y": -6.38
            },
            {
              "x": -21.59,
              "y": -21.6
            },
            {
              "x": -18.73,
              "y": -15.46
            },
            {
              "x": -12.57,
              "y": -23.89
            }
          ],
          "awayPlayers": [
            {
              "x": -14.18,
              "y": -11.32
            },
            {
              "x": -19.42,
              "y": -14.27
            },
            {
              "x": -44.91,
              "y": -2.44
            },
            {
              "x": -3.38,
              "y": 7.26
            },
            {
              "x": -27.71,
              "y": 3.11
            },
            {
              "x": 1.44,
              "y": -11.77
            },
            {
              "x": -24.59,
              "y": -9.75
            },
            {
              "x": -20.43,
              "y": -18.87
            },
            {
              "x": 0.42,
              "y": 22.02
            },
            {
              "x": -6.93,
              "y": -26.41
            },
            {
              "x": 4.76,
              "y": -0.06
            }
          ],
          "time": 2.169
        },
        {
          "ball": {
            "x": -18.08,
            "y": -5.82,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.21,
              "y": -18.05
            },
            {
              "x": 4.97,
              "y": -14.78
            },
            {
              "x": -25.37,
              "y": 16.26
            },
            {
              "x": 33.67,
              "y": -5.76
            },
            {
              "x": 6.56,
              "y": -2.83
            },
            {
              "x": 2.53,
              "y": -26.23
            },
            {
              "x": 3.49,
              "y": 14.43
            },
            {
              "x": -17.53,
              "y": -5.46
            },
            {
              "x": -23.79,
              "y": -20.48
            },
            {
              "x": -19.74,
              "y": -14.99
            },
            {
              "x": -14.07,
              "y": -23.57
            }
          ],
          "awayPlayers": [
            {
              "x": -15.63,
              "y": -10.12
            },
            {
              "x": -20.7,
              "y": -13.21
            },
            {
              "x": -45.38,
              "y": -2.22
            },
            {
              "x": -3.58,
              "y": 7.17
            },
            {
              "x": -29.04,
              "y": 2.6
            },
            {
              "x": 0.91,
              "y": -11.44
            },
            {
              "x": -25.35,
              "y": -8.83
            },
            {
              "x": -22.59,
              "y": -18.38
            },
            {
              "x": -0.39,
              "y": 21.96
            },
            {
              "x": -6.97,
              "y": -26.36
            },
            {
              "x": 3.92,
              "y": 0.01
            }
          ],
          "time": 2.503
        },
        {
          "ball": {
            "x": -19.77,
            "y": -5.23,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.44,
              "y": -17.75
            },
            {
              "x": 4.52,
              "y": -14.38
            },
            {
              "x": -26.77,
              "y": 16.62
            },
            {
              "x": 33.42,
              "y": -5.34
            },
            {
              "x": 5.85,
              "y": -2.08
            },
            {
              "x": 2.22,
              "y": -25.68
            },
            {
              "x": 2.4,
              "y": 14.55
            },
            {
              "x": -19.36,
              "y": -4.8
            },
            {
              "x": -25.99,
              "y": -19.29
            },
            {
              "x": -20.83,
              "y": -14.17
            },
            {
              "x": -15.6,
              "y": -23.17
            }
          ],
          "awayPlayers": [
            {
              "x": -17.11,
              "y": -9.03
            },
            {
              "x": -22.28,
              "y": -12.06
            },
            {
              "x": -45.88,
              "y": -1.9
            },
            {
              "x": -4.03,
              "y": 7.27
            },
            {
              "x": -30.28,
              "y": 2.04
            },
            {
              "x": 0.29,
              "y": -11.1
            },
            {
              "x": -26.1,
              "y": -7.54
            },
            {
              "x": -24.8,
              "y": -17.39
            },
            {
              "x": -1.72,
              "y": 21.82
            },
            {
              "x": -7.11,
              "y": -26.23
            },
            {
              "x": 3.13,
              "y": 0.49
            }
          ],
          "time": 2.836
        },
        {
          "ball": {
            "x": -21.69,
            "y": -4.42,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.94,
              "y": -17.12
            },
            {
              "x": 3.95,
              "y": -13.86
            },
            {
              "x": -28.24,
              "y": 16.81
            },
            {
              "x": 33.14,
              "y": -4.81
            },
            {
              "x": 5.11,
              "y": -1.12
            },
            {
              "x": 1.58,
              "y": -25.23
            },
            {
              "x": 1.26,
              "y": 14.99
            },
            {
              "x": -21.14,
              "y": -4.13
            },
            {
              "x": -28.18,
              "y": -17.93
            },
            {
              "x": -21.91,
              "y": -13.15
            },
            {
              "x": -17.16,
              "y": -22.65
            }
          ],
          "awayPlayers": [
            {
              "x": -18.66,
              "y": -7.91
            },
            {
              "x": -24.05,
              "y": -10.89
            },
            {
              "x": -46.47,
              "y": -1.43
            },
            {
              "x": -4.41,
              "y": 7.46
            },
            {
              "x": -31.51,
              "y": 2.17
            },
            {
              "x": -0.46,
              "y": -10.65
            },
            {
              "x": -26.85,
              "y": -6.0
            },
            {
              "x": -26.94,
              "y": -16.13
            },
            {
              "x": -3.41,
              "y": 21.66
            },
            {
              "x": -7.17,
              "y": -26.11
            },
            {
              "x": 2.31,
              "y": 0.64
            }
          ],
          "time": 3.17
        },
        {
          "ball": {
            "x": -23.51,
            "y": -3.46,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -4.47,
              "y": -16.53
            },
            {
              "x": 3.36,
              "y": -13.18
            },
            {
              "x": -29.72,
              "y": 16.8
            },
            {
              "x": 32.72,
              "y": -4.01
            },
            {
              "x": 4.43,
              "y": -0.77
            },
            {
              "x": 0.91,
              "y": -24.64
            },
            {
              "x": 0.02,
              "y": 15.34
            },
            {
              "x": -22.86,
              "y": -3.46
            },
            {
              "x": -30.24,
              "y": -16.48
            },
            {
              "x": -23.01,
              "y": -12.25
            },
            {
              "x": -18.7,
              "y": -22.14
            }
          ],
          "awayPlayers": [
            {
              "x": -20.2,
              "y": -7.0
            },
            {
              "x": -25.76,
              "y": -9.95
            },
            {
              "x": -46.89,
              "y": -1.12
            },
            {
              "x": -4.82,
              "y": 7.63
            },
            {
              "x": -32.7,
              "y": 2.88
            },
            {
              "x": -1.65,
              "y": -9.77
            },
            {
              "x": -27.64,
              "y": -4.59
            },
            {
              "x": -29.05,
              "y": -14.71
            },
            {
              "x": -4.71,
              "y": 21.41
            },
            {
              "x": -7.06,
              "y": -25.66
            },
            {
              "x": 1.41,
              "y": 1.0
            }
          ],
          "time": 3.504
        },
        {
          "ball": {
            "x": -26.66,
            "y": -0.2,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -5.16,
              "y": -15.8
            },
            {
              "x": 2.73,
              "y": -12.48
            },
            {
              "x": -31.25,
              "y": 16.72
            },
            {
              "x": 32.28,
              "y": -3.38
            },
            {
              "x": 3.76,
              "y": -0.38
            },
            {
              "x": -0.04,
              "y": -24.4
            },
            {
              "x": -1.06,
              "y": 15.79
            },
            {
              "x": -24.55,
              "y": -2.92
            },
            {
              "x": -32.22,
              "y": -14.94
            },
            {
              "x": -24.09,
              "y": -11.56
            },
            {
              "x": -20.27,
              "y": -21.59
            }
          ],
          "awayPlayers": [
            {
              "x": -21.82,
              "y": -6.01
            },
            {
              "x": -27.38,
              "y": -9.04
            },
            {
              "x": -47.32,
              "y": -0.66
            },
            {
              "x": -5.27,
              "y": 7.7
            },
            {
              "x": -33.8,
              "y": 4.22
            },
            {
              "x": -2.92,
              "y": -8.78
            },
            {
              "x": -28.55,
              "y": -3.33
            },
            {
              "x": -31.1,
              "y": -13.22
            },
            {
              "x": -6.18,
              "y": 21.12
            },
            {
              "x": -7.08,
              "y": -25.11
            },
            {
              "x": 0.63,
              "y": 1.15
            }
          ],
          "time": 3.837
        },
        {
          "ball": {
            "x": -30.33,
            "y": 4.49,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -5.81,
              "y": -15.26
            },
            {
              "x": 2.26,
              "y": -11.94
            },
            {
              "x": -32.87,
              "y": 16.51
            },
            {
              "x": 31.87,
              "y": -3.01
            },
            {
              "x": 3.2,
              "y": -0.51
            },
            {
              "x": -0.79,
              "y": -24.03
            },
            {
              "x": -2.09,
              "y": 15.95
            },
            {
              "x": -26.14,
              "y": -2.83
            },
            {
              "x": -34.12,
              "y": -13.46
            },
            {
              "x": -25.21,
              "y": -11.03
            },
            {
              "x": -21.83,
              "y": -21.04
            }
          ],
          "awayPlayers": [
            {
              "x": -23.36,
              "y": -5.25
            },
            {
              "x": -28.81,
              "y": -8.27
            },
            {
              "x": -47.65,
              "y": -0.17
            },
            {
              "x": -5.72,
              "y": 7.6
            },
            {
              "x": -34.7,
              "y": 5.87
            },
            {
              "x": -4.23,
              "y": -7.73
            },
            {
              "x": -29.72,
              "y": -2.19
            },
            {
              "x": -33.05,
              "y": -11.77
            },
            {
              "x": -7.66,
              "y": 20.69
            },
            {
              "x": -7.39,
              "y": -24.38
            },
            {
              "x": -0.24,
              "y": 1.38
            }
          ],
          "time": 4.171
        },
        {
          "ball": {
            "x": -33.12,
            "y": 8.14,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -6.76,
              "y": -14.45
            },
            {
              "x": 1.88,
              "y": -11.34
            },
            {
              "x": -34.48,
              "y": 16.15
            },
            {
              "x": 31.66,
              "y": -2.72
            },
            {
              "x": 2.62,
              "y": 0.14
            },
            {
              "x": -1.47,
              "y": -23.77
            },
            {
              "x": -3.06,
              "y": 16.03
            },
            {
              "x": -27.73,
              "y": -3.0
            },
            {
              "x": -35.92,
              "y": -12.13
            },
            {
              "x": -26.33,
              "y": -10.5
            },
            {
              "x": -23.43,
              "y": -20.43
            }
          ],
          "awayPlayers": [
            {
              "x": -24.91,
              "y": -4.44
            },
            {
              "x": -30.18,
              "y": -7.55
            },
            {
              "x": -48.17,
              "y": 0.66
            },
            {
              "x": -6.11,
              "y": 7.56
            },
            {
              "x": -35.49,
              "y": 7.66
            },
            {
              "x": -5.39,
              "y": -6.9
            },
            {
              "x": -31.04,
              "y": -1.34
            },
            {
              "x": -34.93,
              "y": -10.41
            },
            {
              "x": -9.54,
              "y": 20.45
            },
            {
              "x": -8.22,
              "y": -23.67
            },
            {
              "x": -1.2,
              "y": 1.77
            }
          ],
          "time": 4.505
        },
        {
          "ball": {
            "x": -35.27,
            "y": 10.93,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -7.62,
              "y": -13.71
            },
            {
              "x": 1.53,
              "y": -10.71
            },
            {
              "x": -36.0,
              "y": 15.93
            },
            {
              "x": 31.55,
              "y": -2.4
            },
            {
              "x": 2.07,
              "y": 0.66
            },
            {
              "x": -2.01,
              "y": -23.28
            },
            {
              "x": -4.0,
              "y": 16.28
            },
            {
              "x": -29.31,
              "y": -2.83
            },
            {
              "x": -37.53,
              "y": -11.01
            },
            {
              "x": -27.41,
              "y": -9.81
            },
            {
              "x": -25.01,
              "y": -19.79
            }
          ],
          "awayPlayers": [
            {
              "x": -26.35,
              "y": -3.65
            },
            {
              "x": -31.44,
              "y": -6.87
            },
            {
              "x": -48.58,
              "y": 1.3
            },
            {
              "x": -6.42,
              "y": 7.64
            },
            {
              "x": -36.46,
              "y": 9.45
            },
            {
              "x": -6.57,
              "y": -5.91
            },
            {
              "x": -32.51,
              "y": -0.68
            },
            {
              "x": -36.76,
              "y": -9.07
            },
            {
              "x": -11.38,
              "y": 20.28
            },
            {
              "x": -8.93,
              "y": -23.19
            },
            {
              "x": -2.24,
              "y": 2.27
            }
          ],
          "time": 4.838
        },
        {
          "ball": {
            "x": -37.03,
            "y": 13.38,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -8.6,
              "y": -12.97
            },
            {
              "x": 1.15,
              "y": -10.15
            },
            {
              "x": -37.36,
              "y": 16.12
            },
            {
              "x": 31.32,
              "y": -2.16
            },
            {
              "x": 1.57,
              "y": 1.25
            },
            {
              "x": -2.61,
              "y": -22.95
            },
            {
              "x": -4.86,
              "y": 16.52
            },
            {
              "x": -30.9,
              "y": -2.19
            },
            {
              "x": -38.95,
              "y": -9.89
            },
            {
              "x": -28.36,
              "y": -8.99
            },
            {
              "x": -26.61,
              "y": -19.09
            }
          ],
          "awayPlayers": [
            {
              "x": -27.81,
              "y": -2.59
            },
            {
              "x": -32.7,
              "y": -6.2
            },
            {
              "x": -49.04,
              "y": 1.94
            },
            {
              "x": -6.73,
              "y": 7.76
            },
            {
              "x": -37.72,
              "y": 11.1
            },
            {
              "x": -7.93,
              "y": -4.98
            },
            {
              "x": -34.07,
              "y": 0.06
            },
            {
              "x": -38.47,
              "y": -7.79
            },
            {
              "x": -13.29,
              "y": 20.17
            },
            {
              "x": -10.2,
              "y": -22.27
            },
            {
              "x": -3.27,
              "y": 2.77
            }
          ],
          "time": 5.172
        },
        {
          "ball": {
            "x": -38.61,
            "y": 15.53,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -9.64,
              "y": -12.31
            },
            {
              "x": 0.75,
              "y": -9.66
            },
            {
              "x": -38.45,
              "y": 16.41
            },
            {
              "x": 30.88,
              "y": -1.96
            },
            {
              "x": 0.99,
              "y": 1.79
            },
            {
              "x": -3.35,
              "y": -22.61
            },
            {
              "x": -5.84,
              "y": 16.79
            },
            {
              "x": -32.57,
              "y": -1.25
            },
            {
              "x": -40.16,
              "y": -8.84
            },
            {
              "x": -29.21,
              "y": -7.88
            },
            {
              "x": -28.29,
              "y": -18.36
            }
          ],
          "awayPlayers": [
            {
              "x": -29.22,
              "y": -1.54
            },
            {
              "x": -33.86,
              "y": -5.66
            },
            {
              "x": -49.34,
              "y": 2.29
            },
            {
              "x": -7.08,
              "y": 8.05
            },
            {
              "x": -38.99,
              "y": 12.51
            },
            {
              "x": -9.29,
              "y": -4.14
            },
            {
              "x": -35.73,
              "y": 1.09
            },
            {
              "x": -40.08,
              "y": -6.47
            },
            {
              "x": -15.3,
              "y": 20.07
            },
            {
              "x": -12.44,
              "y": -20.49
            },
            {
              "x": -4.27,
              "y": 3.09
            }
          ],
          "time": 5.506
        },
        {
          "ball": {
            "x": -39.49,
            "y": 15.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -10.65,
              "y": -11.75
            },
            {
              "x": 0.41,
              "y": -9.26
            },
            {
              "x": -39.36,
              "y": 16.54
            },
            {
              "x": 30.49,
              "y": -1.78
            },
            {
              "x": 0.49,
              "y": 2.17
            },
            {
              "x": -3.93,
              "y": -22.2
            },
            {
              "x": -6.95,
              "y": 16.94
            },
            {
              "x": -34.33,
              "y": -0.24
            },
            {
              "x": -41.23,
              "y": -7.83
            },
            {
              "x": -29.83,
              "y": -6.59
            },
            {
              "x": -30.01,
              "y": -17.52
            }
          ],
          "awayPlayers": [
            {
              "x": -30.72,
              "y": -0.36
            },
            {
              "x": -35.02,
              "y": -5.12
            },
            {
              "x": -49.59,
              "y": 2.52
            },
            {
              "x": -7.61,
              "y": 8.23
            },
            {
              "x": -40.07,
              "y": 13.49
            },
            {
              "x": -10.68,
              "y": -3.44
            },
            {
              "x": -37.33,
              "y": 2.38
            },
            {
              "x": -41.42,
              "y": -5.33
            },
            {
              "x": -17.24,
              "y": 19.91
            },
            {
              "x": -14.91,
              "y": -18.61
            },
            {
              "x": -5.13,
              "y": 3.39
            }
          ],
          "time": 5.839
        },
        {
          "ball": {
            "x": -40.17,
            "y": 15.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -11.71,
              "y": -11.07
            },
            {
              "x": 0.08,
              "y": -8.83
            },
            {
              "x": -40.06,
              "y": 16.36
            },
            {
              "x": 30.11,
              "y": -1.6
            },
            {
              "x": 0.01,
              "y": 2.6
            },
            {
              "x": -4.72,
              "y": -21.85
            },
            {
              "x": -8.04,
              "y": 17.05
            },
            {
              "x": -36.1,
              "y": 0.7
            },
            {
              "x": -42.16,
              "y": -6.97
            },
            {
              "x": -30.27,
              "y": -5.05
            },
            {
              "x": -31.75,
              "y": -16.59
            }
          ],
          "awayPlayers": [
            {
              "x": -32.29,
              "y": 0.92
            },
            {
              "x": -36.09,
              "y": -4.54
            },
            {
              "x": -49.84,
              "y": 2.7
            },
            {
              "x": -7.86,
              "y": 8.46
            },
            {
              "x": -41.08,
              "y": 13.93
            },
            {
              "x": -12.04,
              "y": -2.76
            },
            {
              "x": -38.9,
              "y": 3.71
            },
            {
              "x": -42.67,
              "y": -4.15
            },
            {
              "x": -19.03,
              "y": 19.74
            },
            {
              "x": -16.95,
              "y": -17.35
            },
            {
              "x": -6.04,
              "y": 3.45
            }
          ],
          "time": 6.173
        },
        {
          "ball": {
            "x": -40.5,
            "y": 14.85,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -12.57,
              "y": -10.67
            },
            {
              "x": -0.17,
              "y": -8.44
            },
            {
              "x": -40.51,
              "y": 15.65
            },
            {
              "x": 29.82,
              "y": -1.47
            },
            {
              "x": -0.38,
              "y": 3.06
            },
            {
              "x": -5.22,
              "y": -21.55
            },
            {
              "x": -8.91,
              "y": 17.22
            },
            {
              "x": -37.82,
              "y": 1.46
            },
            {
              "x": -43.03,
              "y": -6.2
            },
            {
              "x": -30.5,
              "y": -3.42
            },
            {
              "x": -33.43,
              "y": -15.63
            }
          ],
          "awayPlayers": [
            {
              "x": -33.74,
              "y": 1.94
            },
            {
              "x": -37.01,
              "y": -3.85
            },
            {
              "x": -50.01,
              "y": 2.81
            },
            {
              "x": -7.99,
              "y": 8.75
            },
            {
              "x": -41.78,
              "y": 13.81
            },
            {
              "x": -13.15,
              "y": -2.25
            },
            {
              "x": -40.3,
              "y": 4.95
            },
            {
              "x": -43.76,
              "y": -3.2
            },
            {
              "x": -20.36,
              "y": 19.46
            },
            {
              "x": -17.71,
              "y": -17.28
            },
            {
              "x": -6.91,
              "y": 3.74
            }
          ],
          "time": 6.507
        },
        {
          "ball": {
            "x": -40.55,
            "y": 13.49,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -13.56,
              "y": -10.19
            },
            {
              "x": -0.45,
              "y": -8.24
            },
            {
              "x": -40.62,
              "y": 14.6
            },
            {
              "x": 29.69,
              "y": -1.32
            },
            {
              "x": -0.66,
              "y": 3.26
            },
            {
              "x": -5.83,
              "y": -21.26
            },
            {
              "x": -9.66,
              "y": 17.16
            },
            {
              "x": -39.49,
              "y": 2.11
            },
            {
              "x": -43.81,
              "y": -5.58
            },
            {
              "x": -30.65,
              "y": -1.76
            },
            {
              "x": -35.1,
              "y": -14.72
            }
          ],
          "awayPlayers": [
            {
              "x": -35.04,
              "y": 2.71
            },
            {
              "x": -37.75,
              "y": -3.03
            },
            {
              "x": -50.09,
              "y": 2.76
            },
            {
              "x": -7.99,
              "y": 8.87
            },
            {
              "x": -41.93,
              "y": 13.27
            },
            {
              "x": -14.29,
              "y": -1.75
            },
            {
              "x": -41.38,
              "y": 5.96
            },
            {
              "x": -44.81,
              "y": -2.25
            },
            {
              "x": -21.48,
              "y": 19.15
            },
            {
              "x": -19.18,
              "y": -17.54
            },
            {
              "x": -7.75,
              "y": 3.82
            }
          ],
          "time": 6.84
        },
        {
          "ball": {
            "x": -40.34,
            "y": 12.92,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -14.56,
              "y": -9.89
            },
            {
              "x": -0.67,
              "y": -7.96
            },
            {
              "x": -40.45,
              "y": 13.2
            },
            {
              "x": 29.48,
              "y": -1.22
            },
            {
              "x": -0.93,
              "y": 3.55
            },
            {
              "x": -6.38,
              "y": -21.02
            },
            {
              "x": -10.43,
              "y": 17.1
            },
            {
              "x": -40.88,
              "y": 2.4
            },
            {
              "x": -44.46,
              "y": -5.19
            },
            {
              "x": -30.86,
              "y": -0.09
            },
            {
              "x": -36.76,
              "y": -13.91
            }
          ],
          "awayPlayers": [
            {
              "x": -36.22,
              "y": 3.35
            },
            {
              "x": -38.31,
              "y": -2.14
            },
            {
              "x": -50.07,
              "y": 2.54
            },
            {
              "x": -7.92,
              "y": 9.14
            },
            {
              "x": -41.64,
              "y": 12.45
            },
            {
              "x": -15.21,
              "y": -1.44
            },
            {
              "x": -41.96,
              "y": 6.67
            },
            {
              "x": -45.61,
              "y": -1.68
            },
            {
              "x": -22.42,
              "y": 18.89
            },
            {
              "x": -20.26,
              "y": -17.92
            },
            {
              "x": -8.58,
              "y": 3.98
            }
          ],
          "time": 7.174
        },
        {
          "ball": {
            "x": -39.7,
            "y": 12.24,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -15.98,
              "y": -9.29
            },
            {
              "x": -0.9,
              "y": -7.67
            },
            {
              "x": -40.04,
              "y": 12.12
            },
            {
              "x": 29.42,
              "y": -1.07
            },
            {
              "x": -1.09,
              "y": 3.75
            },
            {
              "x": -6.81,
              "y": -20.66
            },
            {
              "x": -11.12,
              "y": 17.06
            },
            {
              "x": -41.68,
              "y": 2.45
            },
            {
              "x": -44.85,
              "y": -5.16
            },
            {
              "x": -31.1,
              "y": 1.48
            },
            {
              "x": -38.26,
              "y": -13.28
            }
          ],
          "awayPlayers": [
            {
              "x": -37.14,
              "y": 4.11
            },
            {
              "x": -38.69,
              "y": -1.39
            },
            {
              "x": -50.2,
              "y": 2.44
            },
            {
              "x": -7.86,
              "y": 9.24
            },
            {
              "x": -41.27,
              "y": 11.76
            },
            {
              "x": -16.26,
              "y": -1.07
            },
            {
              "x": -42.05,
              "y": 7.11
            },
            {
              "x": -46.07,
              "y": -1.38
            },
            {
              "x": -23.29,
              "y": 18.59
            },
            {
              "x": -21.34,
              "y": -18.28
            },
            {
              "x": -9.43,
              "y": 4.09
            }
          ],
          "time": 7.508
        },
        {
          "ball": {
            "x": -39.24,
            "y": 11.57,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -18.11,
              "y": -8.35
            },
            {
              "x": -1.07,
              "y": -7.37
            },
            {
              "x": -39.35,
              "y": 11.51
            },
            {
              "x": 29.25,
              "y": -0.98
            },
            {
              "x": -1.29,
              "y": 4.08
            },
            {
              "x": -7.33,
              "y": -20.34
            },
            {
              "x": -11.62,
              "y": 17.11
            },
            {
              "x": -41.8,
              "y": 2.24
            },
            {
              "x": -44.95,
              "y": -5.38
            },
            {
              "x": -31.37,
              "y": 2.93
            },
            {
              "x": -39.42,
              "y": -12.84
            }
          ],
          "awayPlayers": [
            {
              "x": -37.62,
              "y": 5.12
            },
            {
              "x": -38.98,
              "y": -0.64
            },
            {
              "x": -50.33,
              "y": 2.31
            },
            {
              "x": -7.42,
              "y": 9.43
            },
            {
              "x": -40.95,
              "y": 11.6
            },
            {
              "x": -17.06,
              "y": -0.84
            },
            {
              "x": -41.71,
              "y": 7.3
            },
            {
              "x": -46.17,
              "y": -1.38
            },
            {
              "x": -23.93,
              "y": 18.45
            },
            {
              "x": -22.51,
              "y": -18.35
            },
            {
              "x": -10.3,
              "y": 4.14
            }
          ],
          "time": 7.841
        },
        {
          "ball": {
            "x": -38.36,
            "y": 11.79,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -20.26,
              "y": -7.33
            },
            {
              "x": -1.36,
              "y": -6.95
            },
            {
              "x": -38.53,
              "y": 11.75
            },
            {
              "x": 28.88,
              "y": -0.86
            },
            {
              "x": -1.6,
              "y": 4.48
            },
            {
              "x": -7.89,
              "y": -19.89
            },
            {
              "x": -12.27,
              "y": 17.33
            },
            {
              "x": -41.46,
              "y": 2.31
            },
            {
              "x": -44.88,
              "y": -5.54
            },
            {
              "x": -31.35,
              "y": 4.17
            },
            {
              "x": -40.18,
              "y": -12.41
            }
          ],
          "awayPlayers": [
            {
              "x": -37.66,
              "y": 6.51
            },
            {
              "x": -39.21,
              "y": 0.07
            },
            {
              "x": -50.4,
              "y": 2.11
            },
            {
              "x": -6.92,
              "y": 9.73
            },
            {
              "x": -40.26,
              "y": 11.59
            },
            {
              "x": -18.32,
              "y": -0.76
            },
            {
              "x": -41.26,
              "y": 7.5
            },
            {
              "x": -46.06,
              "y": -1.34
            },
            {
              "x": -24.82,
              "y": 18.85
            },
            {
              "x": -23.82,
              "y": -17.95
            },
            {
              "x": -11.53,
              "y": 4.12
            }
          ],
          "time": 8.175
        },
        {
          "ball": {
            "x": -36.92,
            "y": 11.97,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -22.11,
              "y": -6.45
            },
            {
              "x": -1.66,
              "y": -6.56
            },
            {
              "x": -37.62,
              "y": 11.97
            },
            {
              "x": 28.49,
              "y": -0.72
            },
            {
              "x": -1.95,
              "y": 4.81
            },
            {
              "x": -8.33,
              "y": -19.34
            },
            {
              "x": -12.97,
              "y": 17.46
            },
            {
              "x": -40.79,
              "y": 2.44
            },
            {
              "x": -44.64,
              "y": -5.63
            },
            {
              "x": -31.1,
              "y": 4.9
            },
            {
              "x": -40.49,
              "y": -12.07
            }
          ],
          "awayPlayers": [
            {
              "x": -37.22,
              "y": 7.82
            },
            {
              "x": -39.41,
              "y": 0.87
            },
            {
              "x": -50.4,
              "y": 1.87
            },
            {
              "x": -6.69,
              "y": 9.84
            },
            {
              "x": -39.22,
              "y": 11.75
            },
            {
              "x": -19.5,
              "y": -0.78
            },
            {
              "x": -40.71,
              "y": 7.31
            },
            {
              "x": -45.78,
              "y": -1.34
            },
            {
              "x": -25.8,
              "y": 19.33
            },
            {
              "x": -25.29,
              "y": -17.14
            },
            {
              "x": -13.61,
              "y": 3.96
            }
          ],
          "time": 8.509
        },
        {
          "ball": {
            "x": -34.71,
            "y": 9.04,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -22.91,
              "y": -6.07
            },
            {
              "x": -1.96,
              "y": -6.07
            },
            {
              "x": -36.94,
              "y": 12.27
            },
            {
              "x": 28.08,
              "y": -0.57
            },
            {
              "x": -2.36,
              "y": 5.18
            },
            {
              "x": -8.94,
              "y": -18.9
            },
            {
              "x": -13.74,
              "y": 17.65
            },
            {
              "x": -40.06,
              "y": 2.65
            },
            {
              "x": -44.36,
              "y": -5.59
            },
            {
              "x": -30.97,
              "y": 5.14
            },
            {
              "x": -40.39,
              "y": -11.84
            }
          ],
          "awayPlayers": [
            {
              "x": -36.5,
              "y": 8.64
            },
            {
              "x": -39.43,
              "y": 1.48
            },
            {
              "x": -50.42,
              "y": 1.75
            },
            {
              "x": -6.43,
              "y": 10.0
            },
            {
              "x": -38.16,
              "y": 11.7
            },
            {
              "x": -20.87,
              "y": -0.71
            },
            {
              "x": -40.3,
              "y": 7.14
            },
            {
              "x": -45.34,
              "y": -1.38
            },
            {
              "x": -26.84,
              "y": 19.75
            },
            {
              "x": -26.66,
              "y": -16.27
            },
            {
              "x": -16.52,
              "y": 3.72
            }
          ],
          "time": 8.842
        },
        {
          "ball": {
            "x": -32.48,
            "y": 5.39,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -24.9,
              "y": -5.39
            },
            {
              "x": -2.21,
              "y": -5.74
            },
            {
              "x": -36.43,
              "y": 12.69
            },
            {
              "x": 27.73,
              "y": -0.52
            },
            {
              "x": -2.75,
              "y": 5.42
            },
            {
              "x": -9.48,
              "y": -18.48
            },
            {
              "x": -14.41,
              "y": 17.76
            },
            {
              "x": -39.28,
              "y": 2.87
            },
            {
              "x": -43.92,
              "y": -5.63
            },
            {
              "x": -31.08,
              "y": 4.8
            },
            {
              "x": -39.88,
              "y": -11.76
            }
          ],
          "awayPlayers": [
            {
              "x": -35.48,
              "y": 8.7
            },
            {
              "x": -39.22,
              "y": 1.98
            },
            {
              "x": -50.34,
              "y": 1.47
            },
            {
              "x": -6.49,
              "y": 10.08
            },
            {
              "x": -37.37,
              "y": 11.76
            },
            {
              "x": -21.9,
              "y": -0.41
            },
            {
              "x": -39.76,
              "y": 6.6
            },
            {
              "x": -44.67,
              "y": -1.67
            },
            {
              "x": -27.52,
              "y": 19.53
            },
            {
              "x": -28.19,
              "y": -15.36
            },
            {
              "x": -19.03,
              "y": 3.65
            }
          ],
          "time": 9.176
        }
      ],
      "duration": 9.176,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/d8cab85d-4f7d-4b69-b3c3-6e9eaf99986f/5106.64"
    },
    {
      "id": "3855_108.0_subset1",
      "matchId": "3855",
      "sequenceId": "108.0_subset1",
      "dtwScore": 0.10670779477298198,
      "frames": [
        {
          "ball": {
            "x": -15.21,
            "y": -17.29,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -31.16,
              "y": 0.8
            },
            {
              "x": -31.55,
              "y": 7.46
            },
            {
              "x": -28.5,
              "y": -29.48
            },
            {
              "x": -21.9,
              "y": -14.59
            },
            {
              "x": -27.97,
              "y": 5.74
            },
            {
              "x": -26.47,
              "y": -2.91
            },
            {
              "x": -18.72,
              "y": -24.85
            },
            {
              "x": -31.43,
              "y": -7.95
            },
            {
              "x": -10.04,
              "y": -12.27
            },
            {
              "x": -48.03,
              "y": -1.69
            },
            {
              "x": -29.62,
              "y": -15.51
            }
          ],
          "awayPlayers": [
            {
              "x": -15.11,
              "y": -17.02
            },
            {
              "x": -28.5,
              "y": -12.37
            },
            {
              "x": 25.0,
              "y": -3.53
            },
            {
              "x": -10.91,
              "y": 1.49
            },
            {
              "x": -23.22,
              "y": 8.72
            },
            {
              "x": -29.44,
              "y": 2.95
            },
            {
              "x": -28.55,
              "y": -7.87
            },
            {
              "x": -18.24,
              "y": -26.09
            },
            {
              "x": -33.04,
              "y": 7.96
            },
            {
              "x": -25.47,
              "y": -33.8
            },
            {
              "x": -5.84,
              "y": -13.98
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": -14.77,
            "y": -16.82,
            "z": 0.25
          },
          "homePlayers": [
            {
              "x": -30.73,
              "y": 0.85
            },
            {
              "x": -31.16,
              "y": 7.97
            },
            {
              "x": -28.53,
              "y": -28.89
            },
            {
              "x": -21.26,
              "y": -15.16
            },
            {
              "x": -27.52,
              "y": 6.02
            },
            {
              "x": -25.75,
              "y": -3.1
            },
            {
              "x": -19.23,
              "y": -24.05
            },
            {
              "x": -31.08,
              "y": -7.68
            },
            {
              "x": -10.81,
              "y": -12.87
            },
            {
              "x": -47.94,
              "y": -1.54
            },
            {
              "x": -29.31,
              "y": -15.1
            }
          ],
          "awayPlayers": [
            {
              "x": -14.77,
              "y": -17.39
            },
            {
              "x": -28.18,
              "y": -11.99
            },
            {
              "x": 25.0,
              "y": -3.47
            },
            {
              "x": -11.09,
              "y": 1.54
            },
            {
              "x": -23.0,
              "y": 9.2
            },
            {
              "x": -29.07,
              "y": 2.71
            },
            {
              "x": -28.05,
              "y": -7.8
            },
            {
              "x": -19.27,
              "y": -25.35
            },
            {
              "x": -32.36,
              "y": 9.04
            },
            {
              "x": -24.65,
              "y": -33.85
            },
            {
              "x": -5.98,
              "y": -14.08
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": -14.53,
            "y": -16.93,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -30.46,
              "y": 0.98
            },
            {
              "x": -31.01,
              "y": 8.37
            },
            {
              "x": -28.55,
              "y": -28.38
            },
            {
              "x": -20.95,
              "y": -15.47
            },
            {
              "x": -27.1,
              "y": 6.28
            },
            {
              "x": -25.08,
              "y": -3.47
            },
            {
              "x": -19.87,
              "y": -23.43
            },
            {
              "x": -30.84,
              "y": -7.42
            },
            {
              "x": -11.4,
              "y": -13.81
            },
            {
              "x": -47.98,
              "y": -1.42
            },
            {
              "x": -29.04,
              "y": -14.72
            }
          ],
          "awayPlayers": [
            {
              "x": -14.57,
              "y": -17.45
            },
            {
              "x": -27.82,
              "y": -11.68
            },
            {
              "x": 25.0,
              "y": -3.42
            },
            {
              "x": -11.38,
              "y": 1.66
            },
            {
              "x": -22.84,
              "y": 9.66
            },
            {
              "x": -28.77,
              "y": 2.52
            },
            {
              "x": -27.46,
              "y": -7.81
            },
            {
              "x": -20.35,
              "y": -24.7
            },
            {
              "x": -31.57,
              "y": 9.74
            },
            {
              "x": -24.37,
              "y": -33.78
            },
            {
              "x": -5.97,
              "y": -14.05
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": -14.29,
            "y": -15.05,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -30.24,
              "y": 1.05
            },
            {
              "x": -31.05,
              "y": 8.74
            },
            {
              "x": -28.55,
              "y": -27.95
            },
            {
              "x": -20.91,
              "y": -15.44
            },
            {
              "x": -26.69,
              "y": 6.47
            },
            {
              "x": -24.41,
              "y": -4.01
            },
            {
              "x": -20.56,
              "y": -22.84
            },
            {
              "x": -30.73,
              "y": -7.2
            },
            {
              "x": -11.95,
              "y": -14.75
            },
            {
              "x": -47.95,
              "y": -1.32
            },
            {
              "x": -28.79,
              "y": -14.42
            }
          ],
          "awayPlayers": [
            {
              "x": -14.48,
              "y": -17.46
            },
            {
              "x": -27.47,
              "y": -11.44
            },
            {
              "x": 25.0,
              "y": -3.38
            },
            {
              "x": -11.4,
              "y": 1.59
            },
            {
              "x": -22.74,
              "y": 10.07
            },
            {
              "x": -28.48,
              "y": 2.23
            },
            {
              "x": -26.82,
              "y": -7.89
            },
            {
              "x": -21.39,
              "y": -24.09
            },
            {
              "x": -30.9,
              "y": 10.44
            },
            {
              "x": -23.72,
              "y": -33.65
            },
            {
              "x": -6.0,
              "y": -14.09
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": -14.25,
            "y": -10.34,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -30.05,
              "y": 1.2
            },
            {
              "x": -30.99,
              "y": 8.89
            },
            {
              "x": -28.74,
              "y": -27.22
            },
            {
              "x": -20.97,
              "y": -15.04
            },
            {
              "x": -26.33,
              "y": 6.66
            },
            {
              "x": -23.76,
              "y": -4.3
            },
            {
              "x": -21.31,
              "y": -22.23
            },
            {
              "x": -30.64,
              "y": -6.94
            },
            {
              "x": -12.52,
              "y": -15.45
            },
            {
              "x": -47.53,
              "y": -1.01
            },
            {
              "x": -28.57,
              "y": -14.04
            }
          ],
          "awayPlayers": [
            {
              "x": -14.48,
              "y": -17.33
            },
            {
              "x": -27.23,
              "y": -11.04
            },
            {
              "x": 25.0,
              "y": -3.29
            },
            {
              "x": -11.68,
              "y": 1.6
            },
            {
              "x": -22.73,
              "y": 10.7
            },
            {
              "x": -28.25,
              "y": 1.97
            },
            {
              "x": -26.28,
              "y": -7.8
            },
            {
              "x": -22.52,
              "y": -23.3
            },
            {
              "x": -30.37,
              "y": 10.92
            },
            {
              "x": -23.32,
              "y": -33.5
            },
            {
              "x": -5.89,
              "y": -14.04
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": -14.46,
            "y": -5.9,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.88,
              "y": 1.45
            },
            {
              "x": -30.87,
              "y": 9.22
            },
            {
              "x": -29.09,
              "y": -26.09
            },
            {
              "x": -21.21,
              "y": -14.2
            },
            {
              "x": -26.05,
              "y": 6.96
            },
            {
              "x": -23.11,
              "y": -4.06
            },
            {
              "x": -22.04,
              "y": -21.57
            },
            {
              "x": -30.53,
              "y": -6.56
            },
            {
              "x": -13.06,
              "y": -15.68
            },
            {
              "x": -47.08,
              "y": -0.71
            },
            {
              "x": -28.52,
              "y": -13.39
            }
          ],
          "awayPlayers": [
            {
              "x": -14.66,
              "y": -17.09
            },
            {
              "x": -27.12,
              "y": -10.33
            },
            {
              "x": 25.0,
              "y": -3.08
            },
            {
              "x": -12.37,
              "y": 1.61
            },
            {
              "x": -22.83,
              "y": 11.53
            },
            {
              "x": -28.09,
              "y": 1.72
            },
            {
              "x": -25.84,
              "y": -7.58
            },
            {
              "x": -23.73,
              "y": -22.27
            },
            {
              "x": -30.23,
              "y": 12.01
            },
            {
              "x": -23.14,
              "y": -33.18
            },
            {
              "x": -5.72,
              "y": -13.89
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": -14.67,
            "y": -2.2,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.7,
              "y": 1.79
            },
            {
              "x": -30.72,
              "y": 9.8
            },
            {
              "x": -29.64,
              "y": -24.56
            },
            {
              "x": -21.62,
              "y": -12.99
            },
            {
              "x": -25.8,
              "y": 7.42
            },
            {
              "x": -22.59,
              "y": -3.17
            },
            {
              "x": -22.77,
              "y": -20.81
            },
            {
              "x": -30.39,
              "y": -5.98
            },
            {
              "x": -13.51,
              "y": -15.74
            },
            {
              "x": -46.71,
              "y": -0.36
            },
            {
              "x": -28.67,
              "y": -12.47
            }
          ],
          "awayPlayers": [
            {
              "x": -15.0,
              "y": -16.47
            },
            {
              "x": -27.16,
              "y": -9.33
            },
            {
              "x": 25.0,
              "y": -2.9
            },
            {
              "x": -13.33,
              "y": 1.86
            },
            {
              "x": -22.96,
              "y": 12.51
            },
            {
              "x": -27.97,
              "y": 1.5
            },
            {
              "x": -25.51,
              "y": -7.24
            },
            {
              "x": -24.98,
              "y": -21.05
            },
            {
              "x": -30.22,
              "y": 13.2
            },
            {
              "x": -23.09,
              "y": -32.8
            },
            {
              "x": -5.62,
              "y": -13.71
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": -14.81,
            "y": 0.74,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.53,
              "y": 2.14
            },
            {
              "x": -30.58,
              "y": 10.4
            },
            {
              "x": -30.24,
              "y": -22.93
            },
            {
              "x": -22.09,
              "y": -11.69
            },
            {
              "x": -25.59,
              "y": 7.9
            },
            {
              "x": -22.2,
              "y": -2.11
            },
            {
              "x": -23.41,
              "y": -20.07
            },
            {
              "x": -30.29,
              "y": -5.27
            },
            {
              "x": -13.81,
              "y": -15.68
            },
            {
              "x": -46.73,
              "y": -0.22
            },
            {
              "x": -28.98,
              "y": -11.48
            }
          ],
          "awayPlayers": [
            {
              "x": -15.42,
              "y": -15.54
            },
            {
              "x": -27.29,
              "y": -8.21
            },
            {
              "x": 25.0,
              "y": -2.68
            },
            {
              "x": -14.08,
              "y": 2.15
            },
            {
              "x": -23.12,
              "y": 13.59
            },
            {
              "x": -27.94,
              "y": 1.37
            },
            {
              "x": -25.25,
              "y": -6.89
            },
            {
              "x": -26.11,
              "y": -19.9
            },
            {
              "x": -30.24,
              "y": 14.41
            },
            {
              "x": -23.25,
              "y": -32.41
            },
            {
              "x": -5.64,
              "y": -13.34
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": -15.02,
            "y": 2.47,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.42,
              "y": 2.44
            },
            {
              "x": -30.61,
              "y": 11.18
            },
            {
              "x": -30.84,
              "y": -21.18
            },
            {
              "x": -22.58,
              "y": -10.32
            },
            {
              "x": -25.57,
              "y": 8.53
            },
            {
              "x": -21.99,
              "y": -0.91
            },
            {
              "x": -24.03,
              "y": -19.24
            },
            {
              "x": -30.3,
              "y": -4.46
            },
            {
              "x": -14.1,
              "y": -15.6
            },
            {
              "x": -46.74,
              "y": -0.06
            },
            {
              "x": -29.37,
              "y": -10.57
            }
          ],
          "awayPlayers": [
            {
              "x": -15.81,
              "y": -14.4
            },
            {
              "x": -27.51,
              "y": -7.05
            },
            {
              "x": 25.0,
              "y": -2.44
            },
            {
              "x": -14.51,
              "y": 2.6
            },
            {
              "x": -23.28,
              "y": 14.76
            },
            {
              "x": -28.07,
              "y": 1.27
            },
            {
              "x": -25.15,
              "y": -6.64
            },
            {
              "x": -27.15,
              "y": -18.83
            },
            {
              "x": -30.2,
              "y": 15.65
            },
            {
              "x": -23.64,
              "y": -32.0
            },
            {
              "x": -5.67,
              "y": -12.99
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": -15.4,
            "y": 3.19,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.58,
              "y": 2.98
            },
            {
              "x": -30.77,
              "y": 12.01
            },
            {
              "x": -31.36,
              "y": -19.45
            },
            {
              "x": -23.07,
              "y": -8.94
            },
            {
              "x": -25.76,
              "y": 9.21
            },
            {
              "x": -21.83,
              "y": 0.28
            },
            {
              "x": -24.6,
              "y": -18.29
            },
            {
              "x": -30.48,
              "y": -3.59
            },
            {
              "x": -14.36,
              "y": -15.43
            },
            {
              "x": -46.78,
              "y": 0.08
            },
            {
              "x": -29.89,
              "y": -9.63
            }
          ],
          "awayPlayers": [
            {
              "x": -16.16,
              "y": -13.12
            },
            {
              "x": -27.75,
              "y": -5.81
            },
            {
              "x": 25.0,
              "y": -2.18
            },
            {
              "x": -14.81,
              "y": 3.06
            },
            {
              "x": -23.48,
              "y": 15.96
            },
            {
              "x": -28.33,
              "y": 1.21
            },
            {
              "x": -25.34,
              "y": -6.21
            },
            {
              "x": -28.08,
              "y": -17.83
            },
            {
              "x": -30.14,
              "y": 16.93
            },
            {
              "x": -23.89,
              "y": -31.74
            },
            {
              "x": -5.84,
              "y": -12.63
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": -15.79,
            "y": 4.13,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.97,
              "y": 3.63
            },
            {
              "x": -31.04,
              "y": 12.79
            },
            {
              "x": -31.78,
              "y": -17.91
            },
            {
              "x": -23.56,
              "y": -7.61
            },
            {
              "x": -26.17,
              "y": 10.02
            },
            {
              "x": -21.59,
              "y": 1.44
            },
            {
              "x": -25.11,
              "y": -17.29
            },
            {
              "x": -30.75,
              "y": -2.81
            },
            {
              "x": -14.54,
              "y": -15.32
            },
            {
              "x": -46.77,
              "y": 0.2
            },
            {
              "x": -30.51,
              "y": -8.83
            }
          ],
          "awayPlayers": [
            {
              "x": -16.38,
              "y": -11.82
            },
            {
              "x": -27.94,
              "y": -4.63
            },
            {
              "x": 25.0,
              "y": -1.94
            },
            {
              "x": -15.14,
              "y": 3.64
            },
            {
              "x": -23.71,
              "y": 17.17
            },
            {
              "x": -28.65,
              "y": 1.02
            },
            {
              "x": -25.67,
              "y": -5.95
            },
            {
              "x": -28.96,
              "y": -16.91
            },
            {
              "x": -30.03,
              "y": 18.15
            },
            {
              "x": -24.57,
              "y": -31.03
            },
            {
              "x": -5.78,
              "y": -12.2
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": -15.79,
            "y": 5.13,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": -30.71,
              "y": 4.68
            },
            {
              "x": -31.36,
              "y": 13.55
            },
            {
              "x": -32.2,
              "y": -16.59
            },
            {
              "x": -24.04,
              "y": -6.49
            },
            {
              "x": -26.62,
              "y": 10.63
            },
            {
              "x": -21.25,
              "y": 2.49
            },
            {
              "x": -25.52,
              "y": -16.3
            },
            {
              "x": -31.07,
              "y": -2.04
            },
            {
              "x": -14.64,
              "y": -15.07
            },
            {
              "x": -46.82,
              "y": 0.35
            },
            {
              "x": -31.29,
              "y": -8.23
            }
          ],
          "awayPlayers": [
            {
              "x": -16.5,
              "y": -10.6
            },
            {
              "x": -28.1,
              "y": -3.19
            },
            {
              "x": 25.0,
              "y": -1.72
            },
            {
              "x": -15.6,
              "y": 4.43
            },
            {
              "x": -23.99,
              "y": 18.35
            },
            {
              "x": -29.09,
              "y": 1.22
            },
            {
              "x": -26.06,
              "y": -5.77
            },
            {
              "x": -29.7,
              "y": -16.09
            },
            {
              "x": -30.0,
              "y": 19.53
            },
            {
              "x": -25.19,
              "y": -30.46
            },
            {
              "x": -5.87,
              "y": -11.79
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": -15.23,
            "y": 5.42,
            "z": 0.24
          },
          "homePlayers": [
            {
              "x": -31.12,
              "y": 5.28
            },
            {
              "x": -31.77,
              "y": 14.43
            },
            {
              "x": -32.59,
              "y": -15.38
            },
            {
              "x": -24.53,
              "y": -5.47
            },
            {
              "x": -27.14,
              "y": 11.43
            },
            {
              "x": -20.95,
              "y": 3.6
            },
            {
              "x": -25.87,
              "y": -15.34
            },
            {
              "x": -31.43,
              "y": -1.27
            },
            {
              "x": -14.7,
              "y": -14.87
            },
            {
              "x": -46.85,
              "y": 0.48
            },
            {
              "x": -32.08,
              "y": -7.83
            }
          ],
          "awayPlayers": [
            {
              "x": -16.55,
              "y": -9.38
            },
            {
              "x": -28.16,
              "y": -1.74
            },
            {
              "x": 25.0,
              "y": -1.52
            },
            {
              "x": -16.12,
              "y": 5.62
            },
            {
              "x": -24.32,
              "y": 19.55
            },
            {
              "x": -29.46,
              "y": 1.27
            },
            {
              "x": -26.36,
              "y": -5.81
            },
            {
              "x": -30.39,
              "y": -15.34
            },
            {
              "x": -29.97,
              "y": 20.78
            },
            {
              "x": -25.69,
              "y": -29.83
            },
            {
              "x": -5.99,
              "y": -11.35
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": -16.53,
            "y": 7.39,
            "z": 0.06
          },
          "homePlayers": [
            {
              "x": -31.57,
              "y": 6.08
            },
            {
              "x": -32.19,
              "y": 15.47
            },
            {
              "x": -32.92,
              "y": -14.35
            },
            {
              "x": -25.01,
              "y": -4.62
            },
            {
              "x": -27.58,
              "y": 12.19
            },
            {
              "x": -20.84,
              "y": 4.8
            },
            {
              "x": -26.18,
              "y": -14.45
            },
            {
              "x": -31.82,
              "y": -0.58
            },
            {
              "x": -14.73,
              "y": -14.58
            },
            {
              "x": -46.93,
              "y": 0.67
            },
            {
              "x": -32.81,
              "y": -7.45
            }
          ],
          "awayPlayers": [
            {
              "x": -16.56,
              "y": -8.24
            },
            {
              "x": -28.13,
              "y": -0.4
            },
            {
              "x": 25.0,
              "y": -1.25
            },
            {
              "x": -16.63,
              "y": 6.92
            },
            {
              "x": -24.72,
              "y": 20.71
            },
            {
              "x": -29.91,
              "y": 1.61
            },
            {
              "x": -26.73,
              "y": -5.81
            },
            {
              "x": -30.98,
              "y": -14.73
            },
            {
              "x": -30.02,
              "y": 22.08
            },
            {
              "x": -25.79,
              "y": -29.52
            },
            {
              "x": -6.07,
              "y": -10.6
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": -19.77,
            "y": 11.94,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -31.94,
              "y": 6.73
            },
            {
              "x": -32.56,
              "y": 16.61
            },
            {
              "x": -33.16,
              "y": -13.51
            },
            {
              "x": -25.44,
              "y": -3.78
            },
            {
              "x": -28.0,
              "y": 13.23
            },
            {
              "x": -20.95,
              "y": 6.08
            },
            {
              "x": -26.49,
              "y": -13.53
            },
            {
              "x": -32.26,
              "y": 0.11
            },
            {
              "x": -14.71,
              "y": -14.3
            },
            {
              "x": -47.01,
              "y": 0.82
            },
            {
              "x": -33.42,
              "y": -6.86
            }
          ],
          "awayPlayers": [
            {
              "x": -16.59,
              "y": -7.07
            },
            {
              "x": -28.05,
              "y": 0.82
            },
            {
              "x": 25.0,
              "y": -0.94
            },
            {
              "x": -17.14,
              "y": 8.01
            },
            {
              "x": -25.12,
              "y": 21.79
            },
            {
              "x": -30.22,
              "y": 1.59
            },
            {
              "x": -27.17,
              "y": -5.63
            },
            {
              "x": -31.53,
              "y": -14.2
            },
            {
              "x": -30.05,
              "y": 23.17
            },
            {
              "x": -25.84,
              "y": -29.05
            },
            {
              "x": -6.24,
              "y": -9.7
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": -24.12,
            "y": 17.17,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.25,
              "y": 7.27
            },
            {
              "x": -32.87,
              "y": 17.77
            },
            {
              "x": -33.53,
              "y": -12.81
            },
            {
              "x": -25.96,
              "y": -2.69
            },
            {
              "x": -28.33,
              "y": 14.46
            },
            {
              "x": -21.26,
              "y": 7.31
            },
            {
              "x": -26.81,
              "y": -12.63
            },
            {
              "x": -32.71,
              "y": 0.67
            },
            {
              "x": -14.67,
              "y": -13.9
            },
            {
              "x": -47.1,
              "y": 0.98
            },
            {
              "x": -33.9,
              "y": -6.17
            }
          ],
          "awayPlayers": [
            {
              "x": -16.61,
              "y": -6.12
            },
            {
              "x": -28.22,
              "y": 2.62
            },
            {
              "x": 25.0,
              "y": -0.64
            },
            {
              "x": -17.49,
              "y": 8.62
            },
            {
              "x": -25.54,
              "y": 22.87
            },
            {
              "x": -30.56,
              "y": 1.65
            },
            {
              "x": -27.69,
              "y": -5.37
            },
            {
              "x": -31.95,
              "y": -13.78
            },
            {
              "x": -30.22,
              "y": 24.13
            },
            {
              "x": -25.93,
              "y": -28.6
            },
            {
              "x": -6.23,
              "y": -8.7
            }
          ],
          "time": 5.005
        },
        {
          "ball": {
            "x": -27.96,
            "y": 21.45,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.62,
              "y": 7.83
            },
            {
              "x": -33.18,
              "y": 18.89
            },
            {
              "x": -34.34,
              "y": -12.21
            },
            {
              "x": -26.4,
              "y": -1.82
            },
            {
              "x": -28.69,
              "y": 15.74
            },
            {
              "x": -21.78,
              "y": 8.4
            },
            {
              "x": -27.15,
              "y": -11.73
            },
            {
              "x": -33.15,
              "y": 1.04
            },
            {
              "x": -14.62,
              "y": -13.65
            },
            {
              "x": -47.26,
              "y": 1.08
            },
            {
              "x": -34.32,
              "y": -5.36
            }
          ],
          "awayPlayers": [
            {
              "x": -16.71,
              "y": -5.24
            },
            {
              "x": -28.34,
              "y": 3.98
            },
            {
              "x": 25.0,
              "y": -0.37
            },
            {
              "x": -17.59,
              "y": 9.03
            },
            {
              "x": -26.04,
              "y": 23.85
            },
            {
              "x": -30.86,
              "y": 1.4
            },
            {
              "x": -28.43,
              "y": -4.88
            },
            {
              "x": -32.26,
              "y": -13.45
            },
            {
              "x": -30.5,
              "y": 24.74
            },
            {
              "x": -25.99,
              "y": -28.16
            },
            {
              "x": -6.54,
              "y": -8.15
            }
          ],
          "time": 5.339
        },
        {
          "ball": {
            "x": -30.66,
            "y": 24.02,
            "z": 0.05
          },
          "homePlayers": [
            {
              "x": -32.9,
              "y": 8.29
            },
            {
              "x": -33.5,
              "y": 19.97
            },
            {
              "x": -34.79,
              "y": -11.99
            },
            {
              "x": -26.82,
              "y": -1.31
            },
            {
              "x": -29.21,
              "y": 16.93
            },
            {
              "x": -22.5,
              "y": 9.33
            },
            {
              "x": -27.51,
              "y": -11.0
            },
            {
              "x": -33.61,
              "y": 1.06
            },
            {
              "x": -14.61,
              "y": -13.4
            },
            {
              "x": -47.39,
              "y": 1.17
            },
            {
              "x": -34.66,
              "y": -4.62
            }
          ],
          "awayPlayers": [
            {
              "x": -16.84,
              "y": -4.66
            },
            {
              "x": -28.48,
              "y": 4.99
            },
            {
              "x": 25.0,
              "y": -0.2
            },
            {
              "x": -17.49,
              "y": 9.34
            },
            {
              "x": -26.82,
              "y": 24.85
            },
            {
              "x": -31.31,
              "y": 1.26
            },
            {
              "x": -29.34,
              "y": -4.31
            },
            {
              "x": -32.54,
              "y": -13.3
            },
            {
              "x": -30.78,
              "y": 24.94
            },
            {
              "x": -26.19,
              "y": -27.83
            },
            {
              "x": -6.7,
              "y": -7.9
            }
          ],
          "time": 5.672
        },
        {
          "ball": {
            "x": -30.89,
            "y": 24.34,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -33.7,
              "y": 9.4
            },
            {
              "x": -33.75,
              "y": 20.9
            },
            {
              "x": -34.76,
              "y": -11.47
            },
            {
              "x": -27.05,
              "y": -1.36
            },
            {
              "x": -29.95,
              "y": 18.02
            },
            {
              "x": -23.38,
              "y": 10.09
            },
            {
              "x": -27.8,
              "y": -10.42
            },
            {
              "x": -34.11,
              "y": 0.88
            },
            {
              "x": -14.58,
              "y": -13.21
            },
            {
              "x": -47.54,
              "y": 1.21
            },
            {
              "x": -35.06,
              "y": -4.0
            }
          ],
          "awayPlayers": [
            {
              "x": -16.98,
              "y": -4.13
            },
            {
              "x": -28.73,
              "y": 5.9
            },
            {
              "x": 25.0,
              "y": -0.07
            },
            {
              "x": -17.32,
              "y": 9.72
            },
            {
              "x": -27.93,
              "y": 25.94
            },
            {
              "x": -31.74,
              "y": 1.08
            },
            {
              "x": -30.41,
              "y": -3.62
            },
            {
              "x": -32.82,
              "y": -13.34
            },
            {
              "x": -30.86,
              "y": 25.01
            },
            {
              "x": -26.63,
              "y": -27.39
            },
            {
              "x": -6.97,
              "y": -7.7
            }
          ],
          "time": 6.006
        },
        {
          "ball": {
            "x": -30.57,
            "y": 24.18,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -34.34,
              "y": 10.12
            },
            {
              "x": -34.17,
              "y": 21.76
            },
            {
              "x": -34.55,
              "y": -10.96
            },
            {
              "x": -27.47,
              "y": -1.01
            },
            {
              "x": -30.8,
              "y": 19.05
            },
            {
              "x": -24.39,
              "y": 10.8
            },
            {
              "x": -28.1,
              "y": -9.94
            },
            {
              "x": -34.64,
              "y": 0.63
            },
            {
              "x": -14.57,
              "y": -12.87
            },
            {
              "x": -47.64,
              "y": 1.25
            },
            {
              "x": -35.54,
              "y": -3.65
            }
          ],
          "awayPlayers": [
            {
              "x": -17.12,
              "y": -3.61
            },
            {
              "x": -29.13,
              "y": 7.02
            },
            {
              "x": 25.0,
              "y": 0.04
            },
            {
              "x": -17.18,
              "y": 10.2
            },
            {
              "x": -29.3,
              "y": 26.94
            },
            {
              "x": -32.21,
              "y": 0.94
            },
            {
              "x": -31.36,
              "y": -3.21
            },
            {
              "x": -33.08,
              "y": -13.6
            },
            {
              "x": -30.76,
              "y": 24.94
            },
            {
              "x": -27.06,
              "y": -27.0
            },
            {
              "x": -7.09,
              "y": -7.52
            }
          ],
          "time": 6.34
        },
        {
          "ball": {
            "x": -30.7,
            "y": 24.13,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -34.99,
              "y": 10.7
            },
            {
              "x": -34.77,
              "y": 22.29
            },
            {
              "x": -34.28,
              "y": -10.42
            },
            {
              "x": -27.87,
              "y": -0.72
            },
            {
              "x": -31.54,
              "y": 19.98
            },
            {
              "x": -25.43,
              "y": 11.39
            },
            {
              "x": -28.36,
              "y": -9.57
            },
            {
              "x": -35.17,
              "y": 0.53
            },
            {
              "x": -14.59,
              "y": -12.64
            },
            {
              "x": -47.74,
              "y": 1.29
            },
            {
              "x": -36.08,
              "y": -3.45
            }
          ],
          "awayPlayers": [
            {
              "x": -17.3,
              "y": -3.09
            },
            {
              "x": -29.59,
              "y": 7.97
            },
            {
              "x": 25.0,
              "y": 0.15
            },
            {
              "x": -17.11,
              "y": 10.72
            },
            {
              "x": -30.87,
              "y": 27.93
            },
            {
              "x": -32.66,
              "y": 0.85
            },
            {
              "x": -32.28,
              "y": -2.89
            },
            {
              "x": -33.35,
              "y": -13.92
            },
            {
              "x": -30.67,
              "y": 24.85
            },
            {
              "x": -27.65,
              "y": -26.55
            },
            {
              "x": -7.3,
              "y": -7.24
            }
          ],
          "time": 6.673
        },
        {
          "ball": {
            "x": -30.84,
            "y": 24.08,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.43,
              "y": 11.08
            },
            {
              "x": -35.51,
              "y": 22.5
            },
            {
              "x": -34.48,
              "y": -10.13
            },
            {
              "x": -28.29,
              "y": -0.35
            },
            {
              "x": -32.09,
              "y": 20.62
            },
            {
              "x": -26.52,
              "y": 11.95
            },
            {
              "x": -28.66,
              "y": -9.16
            },
            {
              "x": -35.68,
              "y": 0.58
            },
            {
              "x": -14.67,
              "y": -12.35
            },
            {
              "x": -47.86,
              "y": 1.34
            },
            {
              "x": -36.64,
              "y": -3.29
            }
          ],
          "awayPlayers": [
            {
              "x": -17.52,
              "y": -2.57
            },
            {
              "x": -30.12,
              "y": 8.82
            },
            {
              "x": 25.0,
              "y": 0.22
            },
            {
              "x": -17.16,
              "y": 11.27
            },
            {
              "x": -32.38,
              "y": 28.48
            },
            {
              "x": -33.16,
              "y": 0.75
            },
            {
              "x": -33.15,
              "y": -2.52
            },
            {
              "x": -33.61,
              "y": -14.32
            },
            {
              "x": -30.68,
              "y": 24.64
            },
            {
              "x": -28.03,
              "y": -26.28
            },
            {
              "x": -7.48,
              "y": -6.98
            }
          ],
          "time": 7.007
        },
        {
          "ball": {
            "x": -30.79,
            "y": 23.78,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.47,
              "y": 11.3
            },
            {
              "x": -36.2,
              "y": 22.59
            },
            {
              "x": -34.8,
              "y": -9.92
            },
            {
              "x": -28.63,
              "y": -0.04
            },
            {
              "x": -32.48,
              "y": 21.05
            },
            {
              "x": -27.55,
              "y": 12.45
            },
            {
              "x": -28.99,
              "y": -8.75
            },
            {
              "x": -36.12,
              "y": 0.7
            },
            {
              "x": -14.74,
              "y": -12.1
            },
            {
              "x": -47.97,
              "y": 1.39
            },
            {
              "x": -37.22,
              "y": -2.94
            }
          ],
          "awayPlayers": [
            {
              "x": -17.75,
              "y": -2.09
            },
            {
              "x": -30.72,
              "y": 9.47
            },
            {
              "x": 25.0,
              "y": 0.36
            },
            {
              "x": -17.33,
              "y": 11.76
            },
            {
              "x": -33.79,
              "y": 28.9
            },
            {
              "x": -33.62,
              "y": 0.66
            },
            {
              "x": -34.0,
              "y": -1.99
            },
            {
              "x": -33.71,
              "y": -14.49
            },
            {
              "x": -30.69,
              "y": 24.42
            },
            {
              "x": -28.52,
              "y": -26.02
            },
            {
              "x": -7.81,
              "y": -6.81
            }
          ],
          "time": 7.341
        },
        {
          "ball": {
            "x": -30.6,
            "y": 23.38,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.32,
              "y": 11.56
            },
            {
              "x": -36.74,
              "y": 22.69
            },
            {
              "x": -35.05,
              "y": -9.66
            },
            {
              "x": -28.93,
              "y": 0.32
            },
            {
              "x": -32.55,
              "y": 21.32
            },
            {
              "x": -28.5,
              "y": 12.96
            },
            {
              "x": -29.32,
              "y": -8.41
            },
            {
              "x": -36.51,
              "y": 0.88
            },
            {
              "x": -14.84,
              "y": -11.77
            },
            {
              "x": -48.04,
              "y": 1.44
            },
            {
              "x": -37.68,
              "y": -2.53
            }
          ],
          "awayPlayers": [
            {
              "x": -18.01,
              "y": -1.63
            },
            {
              "x": -31.35,
              "y": 10.06
            },
            {
              "x": 25.0,
              "y": 0.37
            },
            {
              "x": -17.63,
              "y": 12.29
            },
            {
              "x": -34.9,
              "y": 29.16
            },
            {
              "x": -34.07,
              "y": 0.54
            },
            {
              "x": -34.83,
              "y": -1.26
            },
            {
              "x": -33.57,
              "y": -14.53
            },
            {
              "x": -30.64,
              "y": 24.09
            },
            {
              "x": -29.07,
              "y": -25.77
            },
            {
              "x": -8.0,
              "y": -6.59
            }
          ],
          "time": 7.674
        },
        {
          "ball": {
            "x": -30.03,
            "y": 22.56,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.19,
              "y": 11.83
            },
            {
              "x": -37.19,
              "y": 23.13
            },
            {
              "x": -35.32,
              "y": -9.55
            },
            {
              "x": -29.16,
              "y": 0.72
            },
            {
              "x": -32.34,
              "y": 21.61
            },
            {
              "x": -29.27,
              "y": 13.6
            },
            {
              "x": -29.66,
              "y": -8.09
            },
            {
              "x": -36.65,
              "y": 0.89
            },
            {
              "x": -14.96,
              "y": -11.54
            },
            {
              "x": -48.16,
              "y": 1.48
            },
            {
              "x": -38.04,
              "y": -1.88
            }
          ],
          "awayPlayers": [
            {
              "x": -18.23,
              "y": -1.17
            },
            {
              "x": -32.02,
              "y": 10.37
            },
            {
              "x": 25.0,
              "y": 0.45
            },
            {
              "x": -18.02,
              "y": 12.72
            },
            {
              "x": -35.8,
              "y": 29.59
            },
            {
              "x": -34.51,
              "y": 0.42
            },
            {
              "x": -35.51,
              "y": -0.29
            },
            {
              "x": -33.35,
              "y": -14.44
            },
            {
              "x": -30.55,
              "y": 23.76
            },
            {
              "x": -29.61,
              "y": -25.37
            },
            {
              "x": -8.21,
              "y": -6.35
            }
          ],
          "time": 8.008
        },
        {
          "ball": {
            "x": -27.52,
            "y": 19.43,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.17,
              "y": 11.9
            },
            {
              "x": -37.35,
              "y": 23.5
            },
            {
              "x": -35.47,
              "y": -9.39
            },
            {
              "x": -29.25,
              "y": 1.07
            },
            {
              "x": -31.95,
              "y": 21.73
            },
            {
              "x": -29.7,
              "y": 14.15
            },
            {
              "x": -30.0,
              "y": -7.79
            },
            {
              "x": -36.57,
              "y": 0.9
            },
            {
              "x": -15.12,
              "y": -11.28
            },
            {
              "x": -48.24,
              "y": 1.55
            },
            {
              "x": -38.12,
              "y": -1.31
            }
          ],
          "awayPlayers": [
            {
              "x": -18.39,
              "y": -0.71
            },
            {
              "x": -32.7,
              "y": 10.53
            },
            {
              "x": 25.0,
              "y": 0.46
            },
            {
              "x": -18.53,
              "y": 13.07
            },
            {
              "x": -36.44,
              "y": 29.86
            },
            {
              "x": -34.86,
              "y": 0.18
            },
            {
              "x": -35.95,
              "y": 1.16
            },
            {
              "x": -33.15,
              "y": -14.24
            },
            {
              "x": -30.57,
              "y": 23.48
            },
            {
              "x": -30.25,
              "y": -25.02
            },
            {
              "x": -8.29,
              "y": -6.18
            }
          ],
          "time": 8.342
        },
        {
          "ball": {
            "x": -24.72,
            "y": 15.96,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.13,
              "y": 11.67
            },
            {
              "x": -37.31,
              "y": 23.64
            },
            {
              "x": -35.56,
              "y": -9.37
            },
            {
              "x": -29.21,
              "y": 1.31
            },
            {
              "x": -31.63,
              "y": 21.59
            },
            {
              "x": -29.68,
              "y": 14.4
            },
            {
              "x": -30.28,
              "y": -7.6
            },
            {
              "x": -36.4,
              "y": 1.16
            },
            {
              "x": -15.27,
              "y": -11.04
            },
            {
              "x": -48.33,
              "y": 1.59
            },
            {
              "x": -37.97,
              "y": -0.89
            }
          ],
          "awayPlayers": [
            {
              "x": -18.52,
              "y": -0.35
            },
            {
              "x": -33.28,
              "y": 10.52
            },
            {
              "x": 25.0,
              "y": 0.51
            },
            {
              "x": -19.17,
              "y": 13.09
            },
            {
              "x": -36.84,
              "y": 30.04
            },
            {
              "x": -35.04,
              "y": -0.17
            },
            {
              "x": -35.82,
              "y": 2.29
            },
            {
              "x": -33.12,
              "y": -14.17
            },
            {
              "x": -30.85,
              "y": 23.25
            },
            {
              "x": -30.63,
              "y": -24.66
            },
            {
              "x": -8.55,
              "y": -6.05
            }
          ],
          "time": 8.675
        },
        {
          "ball": {
            "x": -22.27,
            "y": 13.19,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.12,
              "y": 11.23
            },
            {
              "x": -37.1,
              "y": 23.47
            },
            {
              "x": -35.61,
              "y": -9.33
            },
            {
              "x": -29.19,
              "y": 1.55
            },
            {
              "x": -31.47,
              "y": 21.2
            },
            {
              "x": -29.21,
              "y": 14.08
            },
            {
              "x": -30.62,
              "y": -7.44
            },
            {
              "x": -36.33,
              "y": 1.94
            },
            {
              "x": -15.47,
              "y": -10.64
            },
            {
              "x": -48.34,
              "y": 1.57
            },
            {
              "x": -37.55,
              "y": -0.82
            }
          ],
          "awayPlayers": [
            {
              "x": -18.62,
              "y": -0.06
            },
            {
              "x": -33.63,
              "y": 10.58
            },
            {
              "x": 25.0,
              "y": 0.56
            },
            {
              "x": -19.88,
              "y": 12.71
            },
            {
              "x": -36.95,
              "y": 29.9
            },
            {
              "x": -35.0,
              "y": -0.59
            },
            {
              "x": -35.24,
              "y": 3.27
            },
            {
              "x": -33.09,
              "y": -14.23
            },
            {
              "x": -31.42,
              "y": 23.3
            },
            {
              "x": -31.15,
              "y": -24.34
            },
            {
              "x": -9.19,
              "y": -6.7
            }
          ],
          "time": 9.009
        },
        {
          "ball": {
            "x": -21.09,
            "y": 11.72,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.08,
              "y": 10.75
            },
            {
              "x": -36.91,
              "y": 23.03
            },
            {
              "x": -35.55,
              "y": -9.41
            },
            {
              "x": -29.25,
              "y": 1.72
            },
            {
              "x": -31.43,
              "y": 20.71
            },
            {
              "x": -28.54,
              "y": 13.35
            },
            {
              "x": -30.89,
              "y": -7.41
            },
            {
              "x": -36.19,
              "y": 2.74
            },
            {
              "x": -15.7,
              "y": -10.3
            },
            {
              "x": -48.35,
              "y": 1.53
            },
            {
              "x": -37.11,
              "y": -0.94
            }
          ],
          "awayPlayers": [
            {
              "x": -18.71,
              "y": 0.16
            },
            {
              "x": -33.74,
              "y": 10.57
            },
            {
              "x": 25.0,
              "y": 0.6
            },
            {
              "x": -20.49,
              "y": 12.1
            },
            {
              "x": -36.85,
              "y": 29.65
            },
            {
              "x": -34.81,
              "y": -1.08
            },
            {
              "x": -34.39,
              "y": 3.83
            },
            {
              "x": -32.98,
              "y": -14.39
            },
            {
              "x": -32.02,
              "y": 22.86
            },
            {
              "x": -31.65,
              "y": -24.18
            },
            {
              "x": -10.01,
              "y": -7.45
            }
          ],
          "time": 9.343
        },
        {
          "ball": {
            "x": -21.37,
            "y": 11.01,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -35.04,
              "y": 10.56
            },
            {
              "x": -36.72,
              "y": 22.33
            },
            {
              "x": -35.52,
              "y": -9.47
            },
            {
              "x": -29.43,
              "y": 1.98
            },
            {
              "x": -31.4,
              "y": 19.99
            },
            {
              "x": -27.77,
              "y": 12.37
            },
            {
              "x": -31.14,
              "y": -7.43
            },
            {
              "x": -35.88,
              "y": 3.27
            },
            {
              "x": -16.01,
              "y": -9.85
            },
            {
              "x": -48.38,
              "y": 1.5
            },
            {
              "x": -36.71,
              "y": -1.09
            }
          ],
          "awayPlayers": [
            {
              "x": -18.77,
              "y": 0.28
            },
            {
              "x": -33.7,
              "y": 10.63
            },
            {
              "x": 25.0,
              "y": 0.61
            },
            {
              "x": -20.91,
              "y": 11.49
            },
            {
              "x": -36.64,
              "y": 29.41
            },
            {
              "x": -34.58,
              "y": -1.38
            },
            {
              "x": -33.42,
              "y": 4.44
            },
            {
              "x": -32.87,
              "y": -14.53
            },
            {
              "x": -32.58,
              "y": 22.29
            },
            {
              "x": -32.06,
              "y": -23.85
            },
            {
              "x": -10.73,
              "y": -8.26
            }
          ],
          "time": 9.676
        },
        {
          "ball": {
            "x": -21.75,
            "y": 10.43,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -34.81,
              "y": 10.18
            },
            {
              "x": -36.55,
              "y": 21.45
            },
            {
              "x": -35.46,
              "y": -9.54
            },
            {
              "x": -29.63,
              "y": 2.11
            },
            {
              "x": -31.48,
              "y": 19.48
            },
            {
              "x": -27.01,
              "y": 11.5
            },
            {
              "x": -31.21,
              "y": -7.54
            },
            {
              "x": -35.41,
              "y": 3.56
            },
            {
              "x": -16.32,
              "y": -9.45
            },
            {
              "x": -48.4,
              "y": 1.53
            },
            {
              "x": -36.36,
              "y": -1.19
            }
          ],
          "awayPlayers": [
            {
              "x": -18.82,
              "y": 0.33
            },
            {
              "x": -33.74,
              "y": 10.98
            },
            {
              "x": 25.0,
              "y": 0.65
            },
            {
              "x": -21.33,
              "y": 11.12
            },
            {
              "x": -36.36,
              "y": 29.16
            },
            {
              "x": -34.32,
              "y": -1.56
            },
            {
              "x": -32.48,
              "y": 5.07
            },
            {
              "x": -32.77,
              "y": -14.57
            },
            {
              "x": -32.99,
              "y": 21.18
            },
            {
              "x": -32.38,
              "y": -23.72
            },
            {
              "x": -11.03,
              "y": -8.44
            }
          ],
          "time": 10.01
        },
        {
          "ball": {
            "x": -22.32,
            "y": 9.93,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -34.59,
              "y": 10.05
            },
            {
              "x": -36.38,
              "y": 20.52
            },
            {
              "x": -35.44,
              "y": -9.51
            },
            {
              "x": -29.89,
              "y": 2.45
            },
            {
              "x": -31.59,
              "y": 18.84
            },
            {
              "x": -26.29,
              "y": 10.58
            },
            {
              "x": -31.21,
              "y": -7.64
            },
            {
              "x": -34.94,
              "y": 3.82
            },
            {
              "x": -16.7,
              "y": -8.79
            },
            {
              "x": -48.4,
              "y": 1.57
            },
            {
              "x": -35.96,
              "y": -1.29
            }
          ],
          "awayPlayers": [
            {
              "x": -18.86,
              "y": 0.43
            },
            {
              "x": -33.76,
              "y": 11.19
            },
            {
              "x": 25.0,
              "y": 0.59
            },
            {
              "x": -21.89,
              "y": 10.74
            },
            {
              "x": -36.02,
              "y": 28.96
            },
            {
              "x": -34.03,
              "y": -1.56
            },
            {
              "x": -31.43,
              "y": 5.46
            },
            {
              "x": -32.66,
              "y": -14.51
            },
            {
              "x": -33.46,
              "y": 20.35
            },
            {
              "x": -32.58,
              "y": -23.26
            },
            {
              "x": -11.33,
              "y": -8.48
            }
          ],
          "time": 10.344
        },
        {
          "ball": {
            "x": -24.5,
            "y": 8.44,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -34.39,
              "y": 9.8
            },
            {
              "x": -36.31,
              "y": 19.7
            },
            {
              "x": -35.4,
              "y": -9.61
            },
            {
              "x": -30.11,
              "y": 2.89
            },
            {
              "x": -31.71,
              "y": 18.13
            },
            {
              "x": -25.69,
              "y": 9.64
            },
            {
              "x": -31.1,
              "y": -7.86
            },
            {
              "x": -34.68,
              "y": 4.09
            },
            {
              "x": -17.16,
              "y": -7.95
            },
            {
              "x": -48.44,
              "y": 1.58
            },
            {
              "x": -35.62,
              "y": -1.31
            }
          ],
          "awayPlayers": [
            {
              "x": -18.95,
              "y": 0.63
            },
            {
              "x": -33.83,
              "y": 11.41
            },
            {
              "x": 25.0,
              "y": 0.61
            },
            {
              "x": -22.65,
              "y": 10.43
            },
            {
              "x": -35.62,
              "y": 28.7
            },
            {
              "x": -33.56,
              "y": -1.92
            },
            {
              "x": -30.49,
              "y": 5.76
            },
            {
              "x": -32.54,
              "y": -14.98
            },
            {
              "x": -33.88,
              "y": 19.32
            },
            {
              "x": -32.63,
              "y": -22.97
            },
            {
              "x": -11.65,
              "y": -8.5
            }
          ],
          "time": 10.677
        },
        {
          "ball": {
            "x": -27.39,
            "y": 6.53,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": -34.36,
              "y": 9.92
            },
            {
              "x": -36.07,
              "y": 18.09
            },
            {
              "x": -35.4,
              "y": -9.57
            },
            {
              "x": -30.18,
              "y": 3.54
            },
            {
              "x": -31.81,
              "y": 17.34
            },
            {
              "x": -25.48,
              "y": 9.0
            },
            {
              "x": -31.07,
              "y": -8.03
            },
            {
              "x": -34.62,
              "y": 4.37
            },
            {
              "x": -17.66,
              "y": -6.92
            },
            {
              "x": -48.48,
              "y": 1.63
            },
            {
              "x": -35.34,
              "y": -1.26
            }
          ],
          "awayPlayers": [
            {
              "x": -19.12,
              "y": 0.93
            },
            {
              "x": -33.63,
              "y": 11.13
            },
            {
              "x": 25.0,
              "y": 0.63
            },
            {
              "x": -23.7,
              "y": 10.47
            },
            {
              "x": -35.25,
              "y": 28.5
            },
            {
              "x": -33.06,
              "y": -2.19
            },
            {
              "x": -29.49,
              "y": 5.61
            },
            {
              "x": -32.23,
              "y": -16.12
            },
            {
              "x": -34.29,
              "y": 18.27
            },
            {
              "x": -32.66,
              "y": -22.68
            },
            {
              "x": -12.01,
              "y": -8.49
            }
          ],
          "time": 11.011
        }
      ],
      "duration": 11.011,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/d23fd2e0-cfbe-4cb4-a196-55238e848623/2372.706"
    },
    {
      "id": "3852_197.0_subset0",
      "matchId": "3852",
      "sequenceId": "197.0_subset0",
      "dtwScore": 0.10708191457825687,
      "frames": [
        {
          "ball": {
            "x": 15.43,
            "y": 31.17,
            "z": 0.31
          },
          "homePlayers": [
            {
              "x": 24.81,
              "y": 8.84
            },
            {
              "x": 47.53,
              "y": 2.0
            },
            {
              "x": 33.15,
              "y": 24.86
            },
            {
              "x": 23.74,
              "y": 12.18
            },
            {
              "x": 34.91,
              "y": 8.12
            },
            {
              "x": 35.74,
              "y": 10.2
            },
            {
              "x": 32.09,
              "y": -2.03
            },
            {
              "x": 23.36,
              "y": 10.89
            },
            {
              "x": 30.69,
              "y": -4.49
            },
            {
              "x": 17.41,
              "y": 12.36
            },
            {
              "x": 11.03,
              "y": 14.04
            }
          ],
          "awayPlayers": [
            {
              "x": -26.46,
              "y": 5.17
            },
            {
              "x": 16.44,
              "y": 25.28
            },
            {
              "x": 25.82,
              "y": 21.11
            },
            {
              "x": 8.82,
              "y": -6.65
            },
            {
              "x": 12.71,
              "y": 20.31
            },
            {
              "x": 0.1,
              "y": 11.38
            },
            {
              "x": 8.47,
              "y": 22.89
            },
            {
              "x": 37.34,
              "y": 4.47
            },
            {
              "x": 32.16,
              "y": 18.3
            },
            {
              "x": 23.02,
              "y": 30.92
            },
            {
              "x": 13.81,
              "y": 8.34
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": 14.8,
            "y": 30.22,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 24.27,
              "y": 9.02
            },
            {
              "x": 47.37,
              "y": 1.95
            },
            {
              "x": 32.55,
              "y": 25.05
            },
            {
              "x": 23.15,
              "y": 12.52
            },
            {
              "x": 34.34,
              "y": 8.31
            },
            {
              "x": 35.19,
              "y": 10.43
            },
            {
              "x": 31.5,
              "y": -2.0
            },
            {
              "x": 22.76,
              "y": 11.14
            },
            {
              "x": 30.09,
              "y": -4.48
            },
            {
              "x": 17.22,
              "y": 12.78
            },
            {
              "x": 10.44,
              "y": 14.36
            }
          ],
          "awayPlayers": [
            {
              "x": -26.72,
              "y": 5.27
            },
            {
              "x": 15.63,
              "y": 25.48
            },
            {
              "x": 25.64,
              "y": 21.4
            },
            {
              "x": 7.76,
              "y": -6.72
            },
            {
              "x": 11.26,
              "y": 20.88
            },
            {
              "x": -0.81,
              "y": 11.98
            },
            {
              "x": 5.06,
              "y": 21.53
            },
            {
              "x": 36.99,
              "y": 4.69
            },
            {
              "x": 31.63,
              "y": 18.06
            },
            {
              "x": 22.6,
              "y": 31.14
            },
            {
              "x": 13.08,
              "y": 9.08
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": 14.46,
            "y": 30.55,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 23.55,
              "y": 9.13
            },
            {
              "x": 47.25,
              "y": 2.01
            },
            {
              "x": 31.72,
              "y": 25.26
            },
            {
              "x": 22.29,
              "y": 12.8
            },
            {
              "x": 33.62,
              "y": 8.56
            },
            {
              "x": 34.47,
              "y": 10.71
            },
            {
              "x": 30.7,
              "y": -2.13
            },
            {
              "x": 21.94,
              "y": 11.31
            },
            {
              "x": 29.23,
              "y": -4.59
            },
            {
              "x": 16.45,
              "y": 13.12
            },
            {
              "x": 9.84,
              "y": 14.69
            }
          ],
          "awayPlayers": [
            {
              "x": -27.04,
              "y": 5.53
            },
            {
              "x": 14.92,
              "y": 25.85
            },
            {
              "x": 25.36,
              "y": 21.75
            },
            {
              "x": 6.75,
              "y": -6.68
            },
            {
              "x": 9.92,
              "y": 21.67
            },
            {
              "x": -2.14,
              "y": 12.95
            },
            {
              "x": 4.2,
              "y": 21.68
            },
            {
              "x": 36.69,
              "y": 5.18
            },
            {
              "x": 31.27,
              "y": 17.99
            },
            {
              "x": 22.18,
              "y": 31.44
            },
            {
              "x": 12.26,
              "y": 9.73
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": 14.09,
            "y": 30.58,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.8,
              "y": 9.14
            },
            {
              "x": 47.08,
              "y": 2.01
            },
            {
              "x": 30.89,
              "y": 25.31
            },
            {
              "x": 21.32,
              "y": 12.96
            },
            {
              "x": 32.83,
              "y": 8.68
            },
            {
              "x": 33.67,
              "y": 10.82
            },
            {
              "x": 29.85,
              "y": -2.18
            },
            {
              "x": 21.02,
              "y": 11.41
            },
            {
              "x": 28.47,
              "y": -4.68
            },
            {
              "x": 15.95,
              "y": 13.44
            },
            {
              "x": 9.33,
              "y": 14.85
            }
          ],
          "awayPlayers": [
            {
              "x": -27.27,
              "y": 5.73
            },
            {
              "x": 14.44,
              "y": 26.01
            },
            {
              "x": 24.86,
              "y": 21.83
            },
            {
              "x": 5.78,
              "y": -6.66
            },
            {
              "x": 8.78,
              "y": 22.19
            },
            {
              "x": -3.34,
              "y": 13.9
            },
            {
              "x": 4.1,
              "y": 22.07
            },
            {
              "x": 36.13,
              "y": 5.63
            },
            {
              "x": 30.66,
              "y": 18.0
            },
            {
              "x": 21.69,
              "y": 31.46
            },
            {
              "x": 11.46,
              "y": 10.21
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": 13.81,
            "y": 31.18,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 22.22,
              "y": 9.33
            },
            {
              "x": 47.05,
              "y": 2.04
            },
            {
              "x": 30.38,
              "y": 25.36
            },
            {
              "x": 20.83,
              "y": 13.17
            },
            {
              "x": 32.21,
              "y": 8.84
            },
            {
              "x": 33.05,
              "y": 10.97
            },
            {
              "x": 29.27,
              "y": -2.17
            },
            {
              "x": 20.34,
              "y": 11.66
            },
            {
              "x": 27.91,
              "y": -4.78
            },
            {
              "x": 15.47,
              "y": 13.59
            },
            {
              "x": 8.84,
              "y": 15.04
            }
          ],
          "awayPlayers": [
            {
              "x": -27.44,
              "y": 5.87
            },
            {
              "x": 13.64,
              "y": 26.32
            },
            {
              "x": 24.37,
              "y": 21.98
            },
            {
              "x": 5.01,
              "y": -6.62
            },
            {
              "x": 7.97,
              "y": 22.75
            },
            {
              "x": -3.92,
              "y": 14.38
            },
            {
              "x": 3.88,
              "y": 22.31
            },
            {
              "x": 35.59,
              "y": 5.87
            },
            {
              "x": 29.75,
              "y": 17.49
            },
            {
              "x": 21.27,
              "y": 31.61
            },
            {
              "x": 10.87,
              "y": 10.53
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": 13.66,
            "y": 32.01,
            "z": 0.14
          },
          "homePlayers": [
            {
              "x": 21.74,
              "y": 9.6
            },
            {
              "x": 47.04,
              "y": 2.08
            },
            {
              "x": 30.02,
              "y": 25.5
            },
            {
              "x": 20.41,
              "y": 13.44
            },
            {
              "x": 31.79,
              "y": 9.07
            },
            {
              "x": 32.64,
              "y": 11.33
            },
            {
              "x": 28.86,
              "y": -1.92
            },
            {
              "x": 19.79,
              "y": 12.02
            },
            {
              "x": 27.51,
              "y": -4.55
            },
            {
              "x": 15.27,
              "y": 13.87
            },
            {
              "x": 8.5,
              "y": 15.29
            }
          ],
          "awayPlayers": [
            {
              "x": -27.61,
              "y": 5.9
            },
            {
              "x": 12.91,
              "y": 26.56
            },
            {
              "x": 23.84,
              "y": 22.12
            },
            {
              "x": 4.41,
              "y": -6.58
            },
            {
              "x": 7.47,
              "y": 23.11
            },
            {
              "x": -4.12,
              "y": 14.53
            },
            {
              "x": 3.71,
              "y": 22.5
            },
            {
              "x": 35.03,
              "y": 6.08
            },
            {
              "x": 28.61,
              "y": 16.85
            },
            {
              "x": 20.88,
              "y": 31.75
            },
            {
              "x": 10.44,
              "y": 10.67
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": 14.2,
            "y": 32.08,
            "z": 0.16
          },
          "homePlayers": [
            {
              "x": 21.3,
              "y": 9.82
            },
            {
              "x": 47.01,
              "y": 2.03
            },
            {
              "x": 29.71,
              "y": 25.61
            },
            {
              "x": 20.19,
              "y": 13.67
            },
            {
              "x": 31.39,
              "y": 9.21
            },
            {
              "x": 32.18,
              "y": 11.61
            },
            {
              "x": 28.44,
              "y": -1.88
            },
            {
              "x": 19.37,
              "y": 12.2
            },
            {
              "x": 27.17,
              "y": -4.57
            },
            {
              "x": 15.2,
              "y": 14.18
            },
            {
              "x": 8.21,
              "y": 15.49
            }
          ],
          "awayPlayers": [
            {
              "x": -27.76,
              "y": 5.93
            },
            {
              "x": 12.13,
              "y": 26.82
            },
            {
              "x": 23.35,
              "y": 22.31
            },
            {
              "x": 4.0,
              "y": -6.61
            },
            {
              "x": 7.19,
              "y": 23.38
            },
            {
              "x": -4.16,
              "y": 14.51
            },
            {
              "x": 3.72,
              "y": 22.74
            },
            {
              "x": 34.43,
              "y": 6.24
            },
            {
              "x": 27.87,
              "y": 15.95
            },
            {
              "x": 20.57,
              "y": 31.83
            },
            {
              "x": 10.2,
              "y": 10.67
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": 15.15,
            "y": 31.54,
            "z": 0.17
          },
          "homePlayers": [
            {
              "x": 21.06,
              "y": 10.1
            },
            {
              "x": 47.04,
              "y": 2.05
            },
            {
              "x": 29.4,
              "y": 25.73
            },
            {
              "x": 19.9,
              "y": 13.98
            },
            {
              "x": 31.09,
              "y": 9.42
            },
            {
              "x": 31.9,
              "y": 11.88
            },
            {
              "x": 28.18,
              "y": -1.71
            },
            {
              "x": 19.11,
              "y": 12.6
            },
            {
              "x": 26.95,
              "y": -4.35
            },
            {
              "x": 14.91,
              "y": 14.35
            },
            {
              "x": 8.04,
              "y": 15.76
            }
          ],
          "awayPlayers": [
            {
              "x": -28.0,
              "y": 5.96
            },
            {
              "x": 11.76,
              "y": 26.96
            },
            {
              "x": 23.03,
              "y": 22.34
            },
            {
              "x": 3.73,
              "y": -6.72
            },
            {
              "x": 7.07,
              "y": 23.49
            },
            {
              "x": -4.0,
              "y": 14.4
            },
            {
              "x": 3.66,
              "y": 22.95
            },
            {
              "x": 34.12,
              "y": 6.43
            },
            {
              "x": 27.51,
              "y": 15.6
            },
            {
              "x": 20.38,
              "y": 31.89
            },
            {
              "x": 10.06,
              "y": 10.57
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": 17.69,
            "y": 28.68,
            "z": 0.09
          },
          "homePlayers": [
            {
              "x": 21.01,
              "y": 9.96
            },
            {
              "x": 47.0,
              "y": 1.96
            },
            {
              "x": 29.26,
              "y": 25.81
            },
            {
              "x": 19.79,
              "y": 14.06
            },
            {
              "x": 30.79,
              "y": 9.59
            },
            {
              "x": 31.58,
              "y": 12.03
            },
            {
              "x": 27.97,
              "y": -1.71
            },
            {
              "x": 19.02,
              "y": 12.59
            },
            {
              "x": 26.83,
              "y": -4.47
            },
            {
              "x": 15.14,
              "y": 14.52
            },
            {
              "x": 8.04,
              "y": 15.85
            }
          ],
          "awayPlayers": [
            {
              "x": -28.15,
              "y": 5.91
            },
            {
              "x": 12.02,
              "y": 27.49
            },
            {
              "x": 23.02,
              "y": 22.34
            },
            {
              "x": 3.63,
              "y": -6.91
            },
            {
              "x": 6.99,
              "y": 23.55
            },
            {
              "x": -3.88,
              "y": 14.39
            },
            {
              "x": 5.96,
              "y": 24.47
            },
            {
              "x": 33.87,
              "y": 6.66
            },
            {
              "x": 27.35,
              "y": 15.32
            },
            {
              "x": 20.36,
              "y": 32.06
            },
            {
              "x": 10.11,
              "y": 10.44
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": 20.81,
            "y": 25.79,
            "z": 0.18
          },
          "homePlayers": [
            {
              "x": 20.93,
              "y": 10.0
            },
            {
              "x": 47.07,
              "y": 1.89
            },
            {
              "x": 29.22,
              "y": 25.79
            },
            {
              "x": 19.84,
              "y": 14.17
            },
            {
              "x": 30.72,
              "y": 9.64
            },
            {
              "x": 31.49,
              "y": 12.12
            },
            {
              "x": 27.99,
              "y": -1.66
            },
            {
              "x": 18.96,
              "y": 12.66
            },
            {
              "x": 26.79,
              "y": -4.48
            },
            {
              "x": 15.31,
              "y": 14.45
            },
            {
              "x": 8.12,
              "y": 15.83
            }
          ],
          "awayPlayers": [
            {
              "x": -28.13,
              "y": 5.79
            },
            {
              "x": 13.42,
              "y": 27.92
            },
            {
              "x": 23.26,
              "y": 22.26
            },
            {
              "x": 3.71,
              "y": -6.99
            },
            {
              "x": 6.94,
              "y": 23.47
            },
            {
              "x": -3.42,
              "y": 14.12
            },
            {
              "x": 8.11,
              "y": 25.85
            },
            {
              "x": 33.68,
              "y": 6.66
            },
            {
              "x": 27.28,
              "y": 14.97
            },
            {
              "x": 20.45,
              "y": 32.23
            },
            {
              "x": 10.35,
              "y": 10.11
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": 23.22,
            "y": 23.39,
            "z": 0.1
          },
          "homePlayers": [
            {
              "x": 20.93,
              "y": 9.95
            },
            {
              "x": 47.23,
              "y": 1.82
            },
            {
              "x": 29.33,
              "y": 25.79
            },
            {
              "x": 20.03,
              "y": 14.12
            },
            {
              "x": 30.88,
              "y": 9.6
            },
            {
              "x": 31.61,
              "y": 12.14
            },
            {
              "x": 28.18,
              "y": -1.7
            },
            {
              "x": 18.92,
              "y": 12.63
            },
            {
              "x": 26.94,
              "y": -4.43
            },
            {
              "x": 15.1,
              "y": 14.11
            },
            {
              "x": 8.28,
              "y": 15.76
            }
          ],
          "awayPlayers": [
            {
              "x": -28.13,
              "y": 5.6
            },
            {
              "x": 15.15,
              "y": 28.1
            },
            {
              "x": 23.71,
              "y": 22.17
            },
            {
              "x": 3.92,
              "y": -7.06
            },
            {
              "x": 7.02,
              "y": 23.35
            },
            {
              "x": -2.84,
              "y": 13.6
            },
            {
              "x": 10.26,
              "y": 27.22
            },
            {
              "x": 33.7,
              "y": 6.64
            },
            {
              "x": 27.32,
              "y": 14.4
            },
            {
              "x": 20.64,
              "y": 32.2
            },
            {
              "x": 11.02,
              "y": 9.63
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": 24.79,
            "y": 21.85,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": 20.69,
              "y": 9.91
            },
            {
              "x": 47.35,
              "y": 1.68
            },
            {
              "x": 29.37,
              "y": 25.66
            },
            {
              "x": 19.88,
              "y": 13.73
            },
            {
              "x": 31.14,
              "y": 9.31
            },
            {
              "x": 31.88,
              "y": 11.95
            },
            {
              "x": 28.48,
              "y": -1.88
            },
            {
              "x": 18.52,
              "y": 12.43
            },
            {
              "x": 27.11,
              "y": -4.56
            },
            {
              "x": 14.52,
              "y": 13.84
            },
            {
              "x": 8.23,
              "y": 15.37
            }
          ],
          "awayPlayers": [
            {
              "x": -28.15,
              "y": 5.33
            },
            {
              "x": 16.42,
              "y": 27.6
            },
            {
              "x": 24.36,
              "y": 21.83
            },
            {
              "x": 4.25,
              "y": -7.28
            },
            {
              "x": 7.17,
              "y": 22.94
            },
            {
              "x": -2.19,
              "y": 12.97
            },
            {
              "x": 10.1,
              "y": 27.12
            },
            {
              "x": 33.62,
              "y": 6.44
            },
            {
              "x": 27.69,
              "y": 13.46
            },
            {
              "x": 20.95,
              "y": 31.89
            },
            {
              "x": 12.1,
              "y": 8.86
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": 25.82,
            "y": 20.91,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": 21.06,
              "y": 9.67
            },
            {
              "x": 47.49,
              "y": 1.55
            },
            {
              "x": 29.75,
              "y": 25.42
            },
            {
              "x": 20.33,
              "y": 13.44
            },
            {
              "x": 31.52,
              "y": 9.09
            },
            {
              "x": 32.25,
              "y": 11.65
            },
            {
              "x": 29.0,
              "y": -2.12
            },
            {
              "x": 18.76,
              "y": 12.23
            },
            {
              "x": 27.56,
              "y": -4.83
            },
            {
              "x": 14.53,
              "y": 13.47
            },
            {
              "x": 8.41,
              "y": 15.11
            }
          ],
          "awayPlayers": [
            {
              "x": -28.13,
              "y": 5.06
            },
            {
              "x": 16.78,
              "y": 26.98
            },
            {
              "x": 25.26,
              "y": 21.55
            },
            {
              "x": 4.71,
              "y": -7.61
            },
            {
              "x": 7.52,
              "y": 22.5
            },
            {
              "x": -1.69,
              "y": 12.35
            },
            {
              "x": 9.85,
              "y": 27.0
            },
            {
              "x": 33.96,
              "y": 6.22
            },
            {
              "x": 28.38,
              "y": 12.48
            },
            {
              "x": 21.44,
              "y": 31.62
            },
            {
              "x": 13.5,
              "y": 8.3
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": 26.85,
            "y": 20.38,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 21.43,
              "y": 9.16
            },
            {
              "x": 47.7,
              "y": 1.39
            },
            {
              "x": 30.18,
              "y": 24.96
            },
            {
              "x": 20.62,
              "y": 12.96
            },
            {
              "x": 31.8,
              "y": 8.8
            },
            {
              "x": 32.6,
              "y": 11.27
            },
            {
              "x": 29.48,
              "y": -2.53
            },
            {
              "x": 18.94,
              "y": 11.82
            },
            {
              "x": 28.01,
              "y": -5.21
            },
            {
              "x": 14.91,
              "y": 13.34
            },
            {
              "x": 8.72,
              "y": 14.67
            }
          ],
          "awayPlayers": [
            {
              "x": -28.05,
              "y": 4.72
            },
            {
              "x": 17.0,
              "y": 26.19
            },
            {
              "x": 26.5,
              "y": 21.1
            },
            {
              "x": 5.01,
              "y": -7.75
            },
            {
              "x": 7.81,
              "y": 22.26
            },
            {
              "x": -1.28,
              "y": 11.76
            },
            {
              "x": 9.82,
              "y": 27.1
            },
            {
              "x": 34.3,
              "y": 5.96
            },
            {
              "x": 29.45,
              "y": 11.27
            },
            {
              "x": 22.18,
              "y": 31.38
            },
            {
              "x": 15.29,
              "y": 7.59
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": 27.83,
            "y": 19.33,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 21.95,
              "y": 8.87
            },
            {
              "x": 47.98,
              "y": 1.14
            },
            {
              "x": 30.77,
              "y": 24.33
            },
            {
              "x": 21.5,
              "y": 12.57
            },
            {
              "x": 32.19,
              "y": 8.31
            },
            {
              "x": 33.15,
              "y": 10.6
            },
            {
              "x": 30.26,
              "y": -2.6
            },
            {
              "x": 19.29,
              "y": 11.42
            },
            {
              "x": 28.93,
              "y": -5.54
            },
            {
              "x": 15.59,
              "y": 13.04
            },
            {
              "x": 9.46,
              "y": 14.14
            }
          ],
          "awayPlayers": [
            {
              "x": -27.82,
              "y": 4.35
            },
            {
              "x": 16.98,
              "y": 25.68
            },
            {
              "x": 27.78,
              "y": 20.41
            },
            {
              "x": 5.53,
              "y": -7.89
            },
            {
              "x": 8.44,
              "y": 21.52
            },
            {
              "x": -0.87,
              "y": 10.72
            },
            {
              "x": 8.39,
              "y": 25.21
            },
            {
              "x": 34.92,
              "y": 5.82
            },
            {
              "x": 30.33,
              "y": 9.93
            },
            {
              "x": 23.04,
              "y": 31.07
            },
            {
              "x": 17.27,
              "y": 6.99
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": 29.17,
            "y": 15.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.62,
              "y": 8.5
            },
            {
              "x": 48.37,
              "y": 0.89
            },
            {
              "x": 31.38,
              "y": 23.61
            },
            {
              "x": 22.33,
              "y": 12.06
            },
            {
              "x": 32.7,
              "y": 7.72
            },
            {
              "x": 33.81,
              "y": 9.75
            },
            {
              "x": 31.17,
              "y": -2.56
            },
            {
              "x": 19.81,
              "y": 10.91
            },
            {
              "x": 30.04,
              "y": -5.82
            },
            {
              "x": 16.28,
              "y": 12.57
            },
            {
              "x": 10.36,
              "y": 13.56
            }
          ],
          "awayPlayers": [
            {
              "x": -27.57,
              "y": 4.02
            },
            {
              "x": 16.88,
              "y": 25.37
            },
            {
              "x": 28.83,
              "y": 19.48
            },
            {
              "x": 6.22,
              "y": -7.91
            },
            {
              "x": 9.11,
              "y": 20.75
            },
            {
              "x": -0.26,
              "y": 9.77
            },
            {
              "x": 6.78,
              "y": 22.73
            },
            {
              "x": 35.57,
              "y": 5.72
            },
            {
              "x": 31.01,
              "y": 8.4
            },
            {
              "x": 23.84,
              "y": 30.57
            },
            {
              "x": 19.29,
              "y": 6.31
            }
          ],
          "time": 5.005
        },
        {
          "ball": {
            "x": 30.65,
            "y": 11.12,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 23.52,
              "y": 8.27
            },
            {
              "x": 48.7,
              "y": 0.55
            },
            {
              "x": 32.23,
              "y": 23.13
            },
            {
              "x": 23.39,
              "y": 11.64
            },
            {
              "x": 33.71,
              "y": 7.26
            },
            {
              "x": 34.84,
              "y": 9.11
            },
            {
              "x": 32.45,
              "y": -2.19
            },
            {
              "x": 20.48,
              "y": 10.43
            },
            {
              "x": 31.31,
              "y": -5.89
            },
            {
              "x": 16.99,
              "y": 12.18
            },
            {
              "x": 11.22,
              "y": 13.07
            }
          ],
          "awayPlayers": [
            {
              "x": -27.37,
              "y": 3.73
            },
            {
              "x": 15.77,
              "y": 24.88
            },
            {
              "x": 29.59,
              "y": 18.45
            },
            {
              "x": 7.1,
              "y": -7.97
            },
            {
              "x": 9.89,
              "y": 19.5
            },
            {
              "x": 0.29,
              "y": 8.91
            },
            {
              "x": 5.28,
              "y": 19.96
            },
            {
              "x": 36.18,
              "y": 5.69
            },
            {
              "x": 31.64,
              "y": 7.07
            },
            {
              "x": 24.54,
              "y": 30.0
            },
            {
              "x": 21.2,
              "y": 5.51
            }
          ],
          "time": 5.339
        },
        {
          "ball": {
            "x": 32.0,
            "y": 7.27,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 24.43,
              "y": 7.87
            },
            {
              "x": 49.53,
              "y": 0.39
            },
            {
              "x": 33.04,
              "y": 22.85
            },
            {
              "x": 24.41,
              "y": 11.31
            },
            {
              "x": 34.96,
              "y": 7.0
            },
            {
              "x": 35.96,
              "y": 8.85
            },
            {
              "x": 33.76,
              "y": -2.04
            },
            {
              "x": 21.38,
              "y": 9.79
            },
            {
              "x": 32.56,
              "y": -6.17
            },
            {
              "x": 17.61,
              "y": 11.71
            },
            {
              "x": 11.7,
              "y": 12.61
            }
          ],
          "awayPlayers": [
            {
              "x": -27.21,
              "y": 3.52
            },
            {
              "x": 14.7,
              "y": 24.02
            },
            {
              "x": 30.02,
              "y": 17.12
            },
            {
              "x": 8.2,
              "y": -8.03
            },
            {
              "x": 10.69,
              "y": 18.43
            },
            {
              "x": 1.06,
              "y": 8.18
            },
            {
              "x": 5.57,
              "y": 19.01
            },
            {
              "x": 36.56,
              "y": 5.63
            },
            {
              "x": 32.39,
              "y": 6.11
            },
            {
              "x": 25.19,
              "y": 29.55
            },
            {
              "x": 23.05,
              "y": 4.69
            }
          ],
          "time": 5.672
        },
        {
          "ball": {
            "x": 32.97,
            "y": 4.99,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.34,
              "y": 7.42
            },
            {
              "x": 50.21,
              "y": 0.25
            },
            {
              "x": 33.89,
              "y": 22.43
            },
            {
              "x": 25.33,
              "y": 10.89
            },
            {
              "x": 36.15,
              "y": 6.59
            },
            {
              "x": 37.04,
              "y": 8.44
            },
            {
              "x": 34.91,
              "y": -1.94
            },
            {
              "x": 22.22,
              "y": 9.26
            },
            {
              "x": 33.63,
              "y": -6.19
            },
            {
              "x": 17.64,
              "y": 11.19
            },
            {
              "x": 11.95,
              "y": 12.15
            }
          ],
          "awayPlayers": [
            {
              "x": -27.13,
              "y": 3.33
            },
            {
              "x": 13.72,
              "y": 23.27
            },
            {
              "x": 30.16,
              "y": 15.44
            },
            {
              "x": 9.16,
              "y": -8.14
            },
            {
              "x": 11.27,
              "y": 17.35
            },
            {
              "x": 1.39,
              "y": 7.45
            },
            {
              "x": 5.86,
              "y": 18.4
            },
            {
              "x": 37.17,
              "y": 5.45
            },
            {
              "x": 33.13,
              "y": 5.24
            },
            {
              "x": 25.58,
              "y": 28.91
            },
            {
              "x": 24.76,
              "y": 3.61
            }
          ],
          "time": 6.006
        },
        {
          "ball": {
            "x": 33.28,
            "y": 2.86,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.8,
              "y": 6.87
            },
            {
              "x": 50.74,
              "y": 0.14
            },
            {
              "x": 34.36,
              "y": 21.55
            },
            {
              "x": 25.95,
              "y": 10.17
            },
            {
              "x": 36.86,
              "y": 5.73
            },
            {
              "x": 37.68,
              "y": 7.59
            },
            {
              "x": 35.75,
              "y": -2.0
            },
            {
              "x": 22.82,
              "y": 8.36
            },
            {
              "x": 34.46,
              "y": -6.48
            },
            {
              "x": 17.97,
              "y": 10.57
            },
            {
              "x": 12.11,
              "y": 11.38
            }
          ],
          "awayPlayers": [
            {
              "x": -26.99,
              "y": 3.1
            },
            {
              "x": 13.66,
              "y": 22.28
            },
            {
              "x": 30.16,
              "y": 13.63
            },
            {
              "x": 10.02,
              "y": -8.19
            },
            {
              "x": 11.95,
              "y": 16.11
            },
            {
              "x": 1.66,
              "y": 6.43
            },
            {
              "x": 5.97,
              "y": 17.61
            },
            {
              "x": 37.32,
              "y": 5.34
            },
            {
              "x": 33.57,
              "y": 4.05
            },
            {
              "x": 25.76,
              "y": 27.82
            },
            {
              "x": 26.21,
              "y": 2.37
            }
          ],
          "time": 6.34
        },
        {
          "ball": {
            "x": 33.5,
            "y": 1.15,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.3,
              "y": 6.21
            },
            {
              "x": 50.72,
              "y": 0.02
            },
            {
              "x": 34.79,
              "y": 20.35
            },
            {
              "x": 26.54,
              "y": 9.5
            },
            {
              "x": 37.14,
              "y": 4.84
            },
            {
              "x": 37.94,
              "y": 6.53
            },
            {
              "x": 36.2,
              "y": -2.29
            },
            {
              "x": 23.47,
              "y": 7.66
            },
            {
              "x": 34.88,
              "y": -6.6
            },
            {
              "x": 18.38,
              "y": 9.96
            },
            {
              "x": 12.25,
              "y": 10.78
            }
          ],
          "awayPlayers": [
            {
              "x": -26.84,
              "y": 2.88
            },
            {
              "x": 13.77,
              "y": 21.61
            },
            {
              "x": 30.08,
              "y": 11.88
            },
            {
              "x": 10.67,
              "y": -8.43
            },
            {
              "x": 12.24,
              "y": 14.95
            },
            {
              "x": 1.68,
              "y": 5.56
            },
            {
              "x": 5.8,
              "y": 16.77
            },
            {
              "x": 37.35,
              "y": 5.26
            },
            {
              "x": 33.73,
              "y": 2.54
            },
            {
              "x": 25.97,
              "y": 26.75
            },
            {
              "x": 27.31,
              "y": 1.01
            }
          ],
          "time": 6.673
        },
        {
          "ball": {
            "x": 33.56,
            "y": -0.27,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.54,
              "y": 5.67
            },
            {
              "x": 50.75,
              "y": -0.22
            },
            {
              "x": 35.08,
              "y": 19.35
            },
            {
              "x": 26.86,
              "y": 8.96
            },
            {
              "x": 37.26,
              "y": 4.16
            },
            {
              "x": 38.17,
              "y": 5.78
            },
            {
              "x": 36.55,
              "y": -2.58
            },
            {
              "x": 23.85,
              "y": 6.99
            },
            {
              "x": 35.1,
              "y": -6.86
            },
            {
              "x": 18.98,
              "y": 9.43
            },
            {
              "x": 12.31,
              "y": 10.12
            }
          ],
          "awayPlayers": [
            {
              "x": -26.78,
              "y": 2.62
            },
            {
              "x": 13.87,
              "y": 20.95
            },
            {
              "x": 29.93,
              "y": 9.98
            },
            {
              "x": 11.05,
              "y": -8.65
            },
            {
              "x": 12.63,
              "y": 13.81
            },
            {
              "x": 1.66,
              "y": 4.65
            },
            {
              "x": 5.67,
              "y": 16.1
            },
            {
              "x": 37.4,
              "y": 5.1
            },
            {
              "x": 33.51,
              "y": 0.98
            },
            {
              "x": 26.1,
              "y": 26.12
            },
            {
              "x": 28.06,
              "y": -0.44
            }
          ],
          "time": 7.007
        },
        {
          "ball": {
            "x": 33.02,
            "y": -2.18,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.68,
              "y": 4.78
            },
            {
              "x": 50.76,
              "y": -0.41
            },
            {
              "x": 35.38,
              "y": 18.04
            },
            {
              "x": 27.28,
              "y": 8.16
            },
            {
              "x": 37.16,
              "y": 3.37
            },
            {
              "x": 38.26,
              "y": 4.91
            },
            {
              "x": 36.8,
              "y": -3.34
            },
            {
              "x": 24.22,
              "y": 6.08
            },
            {
              "x": 35.35,
              "y": -7.42
            },
            {
              "x": 19.57,
              "y": 8.58
            },
            {
              "x": 12.59,
              "y": 9.23
            }
          ],
          "awayPlayers": [
            {
              "x": -26.65,
              "y": 2.21
            },
            {
              "x": 13.86,
              "y": 20.34
            },
            {
              "x": 29.72,
              "y": 8.07
            },
            {
              "x": 11.62,
              "y": -9.02
            },
            {
              "x": 13.05,
              "y": 12.58
            },
            {
              "x": 1.84,
              "y": 3.56
            },
            {
              "x": 5.64,
              "y": 15.29
            },
            {
              "x": 37.53,
              "y": 4.82
            },
            {
              "x": 33.13,
              "y": -0.32
            },
            {
              "x": 26.44,
              "y": 25.68
            },
            {
              "x": 28.81,
              "y": -1.76
            }
          ],
          "time": 7.341
        },
        {
          "ball": {
            "x": 32.47,
            "y": -4.06,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.85,
              "y": 3.97
            },
            {
              "x": 50.79,
              "y": -0.56
            },
            {
              "x": 35.51,
              "y": 17.13
            },
            {
              "x": 27.34,
              "y": 7.44
            },
            {
              "x": 37.09,
              "y": 2.68
            },
            {
              "x": 38.34,
              "y": 4.23
            },
            {
              "x": 36.97,
              "y": -3.82
            },
            {
              "x": 24.47,
              "y": 5.33
            },
            {
              "x": 35.52,
              "y": -8.03
            },
            {
              "x": 19.7,
              "y": 7.73
            },
            {
              "x": 12.62,
              "y": 8.47
            }
          ],
          "awayPlayers": [
            {
              "x": -26.66,
              "y": 1.89
            },
            {
              "x": 13.43,
              "y": 20.02
            },
            {
              "x": 29.5,
              "y": 6.25
            },
            {
              "x": 11.87,
              "y": -9.21
            },
            {
              "x": 13.25,
              "y": 11.72
            },
            {
              "x": 1.8,
              "y": 2.75
            },
            {
              "x": 5.37,
              "y": 14.71
            },
            {
              "x": 37.55,
              "y": 4.41
            },
            {
              "x": 32.32,
              "y": -1.85
            },
            {
              "x": 26.56,
              "y": 25.44
            },
            {
              "x": 29.57,
              "y": -3.24
            }
          ],
          "time": 7.674
        },
        {
          "ball": {
            "x": 31.99,
            "y": -5.72,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.93,
              "y": 2.94
            },
            {
              "x": 50.8,
              "y": -0.82
            },
            {
              "x": 35.65,
              "y": 15.96
            },
            {
              "x": 27.62,
              "y": 6.49
            },
            {
              "x": 36.99,
              "y": 1.9
            },
            {
              "x": 38.38,
              "y": 3.37
            },
            {
              "x": 37.2,
              "y": -4.68
            },
            {
              "x": 24.67,
              "y": 4.37
            },
            {
              "x": 35.7,
              "y": -8.68
            },
            {
              "x": 20.4,
              "y": 6.85
            },
            {
              "x": 12.89,
              "y": 7.51
            }
          ],
          "awayPlayers": [
            {
              "x": -26.54,
              "y": 1.5
            },
            {
              "x": 12.96,
              "y": 19.54
            },
            {
              "x": 29.3,
              "y": 4.61
            },
            {
              "x": 12.18,
              "y": -9.61
            },
            {
              "x": 13.64,
              "y": 10.6
            },
            {
              "x": 1.92,
              "y": 1.81
            },
            {
              "x": 5.14,
              "y": 13.88
            },
            {
              "x": 37.6,
              "y": 3.97
            },
            {
              "x": 31.56,
              "y": -3.32
            },
            {
              "x": 26.67,
              "y": 25.03
            },
            {
              "x": 30.61,
              "y": -4.65
            }
          ],
          "time": 8.008
        },
        {
          "ball": {
            "x": 31.8,
            "y": -7.11,
            "z": 0.06
          },
          "homePlayers": [
            {
              "x": 27.0,
              "y": 2.23
            },
            {
              "x": 50.84,
              "y": -1.03
            },
            {
              "x": 35.6,
              "y": 15.54
            },
            {
              "x": 27.44,
              "y": 5.71
            },
            {
              "x": 37.18,
              "y": 1.84
            },
            {
              "x": 38.45,
              "y": 3.41
            },
            {
              "x": 37.31,
              "y": -5.08
            },
            {
              "x": 24.7,
              "y": 3.45
            },
            {
              "x": 36.03,
              "y": -9.16
            },
            {
              "x": 20.41,
              "y": 6.44
            },
            {
              "x": 12.89,
              "y": 6.6
            }
          ],
          "awayPlayers": [
            {
              "x": -26.43,
              "y": 1.29
            },
            {
              "x": 12.7,
              "y": 19.39
            },
            {
              "x": 29.05,
              "y": 3.04
            },
            {
              "x": 12.32,
              "y": -9.84
            },
            {
              "x": 13.66,
              "y": 10.07
            },
            {
              "x": 1.87,
              "y": 1.15
            },
            {
              "x": 4.99,
              "y": 13.48
            },
            {
              "x": 37.64,
              "y": 3.52
            },
            {
              "x": 30.69,
              "y": -5.14
            },
            {
              "x": 26.7,
              "y": 24.57
            },
            {
              "x": 31.54,
              "y": -6.28
            }
          ],
          "time": 8.342
        },
        {
          "ball": {
            "x": 32.07,
            "y": -8.82,
            "z": 0.01
          },
          "homePlayers": [
            {
              "x": 26.82,
              "y": 1.86
            },
            {
              "x": 50.86,
              "y": -1.28
            },
            {
              "x": 35.58,
              "y": 15.04
            },
            {
              "x": 27.2,
              "y": 4.62
            },
            {
              "x": 37.59,
              "y": 2.02
            },
            {
              "x": 38.68,
              "y": 3.72
            },
            {
              "x": 37.7,
              "y": -5.65
            },
            {
              "x": 24.73,
              "y": 2.57
            },
            {
              "x": 36.9,
              "y": -9.04
            },
            {
              "x": 21.7,
              "y": 6.43
            },
            {
              "x": 13.47,
              "y": 5.05
            }
          ],
          "awayPlayers": [
            {
              "x": -26.15,
              "y": 1.05
            },
            {
              "x": 13.16,
              "y": 19.0
            },
            {
              "x": 28.79,
              "y": 1.55
            },
            {
              "x": 12.65,
              "y": -10.25
            },
            {
              "x": 13.96,
              "y": 9.57
            },
            {
              "x": 2.12,
              "y": 0.06
            },
            {
              "x": 5.05,
              "y": 12.92
            },
            {
              "x": 37.81,
              "y": 3.15
            },
            {
              "x": 30.01,
              "y": -6.98
            },
            {
              "x": 26.65,
              "y": 23.72
            },
            {
              "x": 32.36,
              "y": -8.03
            }
          ],
          "time": 8.675
        },
        {
          "ball": {
            "x": 32.01,
            "y": -10.93,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.7,
              "y": 1.43
            },
            {
              "x": 50.87,
              "y": -1.46
            },
            {
              "x": 35.52,
              "y": 14.81
            },
            {
              "x": 26.8,
              "y": 3.47
            },
            {
              "x": 38.13,
              "y": 2.51
            },
            {
              "x": 38.89,
              "y": 4.38
            },
            {
              "x": 38.05,
              "y": -6.32
            },
            {
              "x": 24.61,
              "y": 1.56
            },
            {
              "x": 37.69,
              "y": -9.29
            },
            {
              "x": 22.33,
              "y": 6.3
            },
            {
              "x": 13.75,
              "y": 3.57
            }
          ],
          "awayPlayers": [
            {
              "x": -25.91,
              "y": 0.85
            },
            {
              "x": 13.35,
              "y": 18.76
            },
            {
              "x": 28.58,
              "y": 0.11
            },
            {
              "x": 12.86,
              "y": -10.61
            },
            {
              "x": 14.1,
              "y": 9.13
            },
            {
              "x": 2.12,
              "y": -0.86
            },
            {
              "x": 4.95,
              "y": 12.39
            },
            {
              "x": 38.0,
              "y": 2.85
            },
            {
              "x": 29.54,
              "y": -8.9
            },
            {
              "x": 26.8,
              "y": 22.85
            },
            {
              "x": 32.84,
              "y": -9.83
            }
          ],
          "time": 9.009
        },
        {
          "ball": {
            "x": 31.81,
            "y": -12.61,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.61,
              "y": 0.74
            },
            {
              "x": 50.85,
              "y": -1.55
            },
            {
              "x": 35.34,
              "y": 14.44
            },
            {
              "x": 26.54,
              "y": 2.26
            },
            {
              "x": 38.53,
              "y": 2.49
            },
            {
              "x": 39.09,
              "y": 4.43
            },
            {
              "x": 38.3,
              "y": -7.27
            },
            {
              "x": 24.56,
              "y": 0.75
            },
            {
              "x": 38.14,
              "y": -9.55
            },
            {
              "x": 23.18,
              "y": 5.91
            },
            {
              "x": 14.07,
              "y": 2.4
            }
          ],
          "awayPlayers": [
            {
              "x": -25.8,
              "y": 0.63
            },
            {
              "x": 13.37,
              "y": 18.45
            },
            {
              "x": 28.47,
              "y": -1.21
            },
            {
              "x": 13.04,
              "y": -11.11
            },
            {
              "x": 14.52,
              "y": 8.52
            },
            {
              "x": 2.12,
              "y": -1.66
            },
            {
              "x": 4.87,
              "y": 11.68
            },
            {
              "x": 38.12,
              "y": 2.56
            },
            {
              "x": 29.13,
              "y": -10.36
            },
            {
              "x": 26.82,
              "y": 22.05
            },
            {
              "x": 32.85,
              "y": -11.69
            }
          ],
          "time": 9.343
        },
        {
          "ball": {
            "x": 30.82,
            "y": -13.05,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 26.65,
              "y": -0.55
            },
            {
              "x": 50.82,
              "y": -1.54
            },
            {
              "x": 35.34,
              "y": 13.85
            },
            {
              "x": 26.62,
              "y": 0.98
            },
            {
              "x": 38.59,
              "y": 2.0
            },
            {
              "x": 39.06,
              "y": 3.94
            },
            {
              "x": 38.37,
              "y": -8.39
            },
            {
              "x": 24.53,
              "y": -0.55
            },
            {
              "x": 38.17,
              "y": -10.55
            },
            {
              "x": 23.05,
              "y": 4.72
            },
            {
              "x": 14.12,
              "y": 1.36
            }
          ],
          "awayPlayers": [
            {
              "x": -25.67,
              "y": 0.39
            },
            {
              "x": 12.79,
              "y": 18.13
            },
            {
              "x": 28.36,
              "y": -2.45
            },
            {
              "x": 12.93,
              "y": -11.77
            },
            {
              "x": 14.75,
              "y": 7.31
            },
            {
              "x": 1.9,
              "y": -2.5
            },
            {
              "x": 4.53,
              "y": 10.62
            },
            {
              "x": 38.13,
              "y": 2.39
            },
            {
              "x": 28.5,
              "y": -11.5
            },
            {
              "x": 27.0,
              "y": 21.61
            },
            {
              "x": 32.52,
              "y": -13.24
            }
          ],
          "time": 9.676
        },
        {
          "ball": {
            "x": 28.33,
            "y": -12.48,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": 26.27,
              "y": -1.63
            },
            {
              "x": 50.8,
              "y": -1.54
            },
            {
              "x": 34.95,
              "y": 13.88
            },
            {
              "x": 26.19,
              "y": -0.11
            },
            {
              "x": 38.4,
              "y": 1.7
            },
            {
              "x": 38.77,
              "y": 3.66
            },
            {
              "x": 38.11,
              "y": -9.45
            },
            {
              "x": 24.09,
              "y": -1.57
            },
            {
              "x": 37.84,
              "y": -11.45
            },
            {
              "x": 22.45,
              "y": 3.65
            },
            {
              "x": 13.87,
              "y": 0.53
            }
          ],
          "awayPlayers": [
            {
              "x": -25.78,
              "y": 0.21
            },
            {
              "x": 11.93,
              "y": 17.9
            },
            {
              "x": 28.21,
              "y": -3.62
            },
            {
              "x": 12.74,
              "y": -12.22
            },
            {
              "x": 15.05,
              "y": 6.22
            },
            {
              "x": 1.84,
              "y": -3.21
            },
            {
              "x": 4.2,
              "y": 9.71
            },
            {
              "x": 38.0,
              "y": 2.16
            },
            {
              "x": 27.78,
              "y": -12.18
            },
            {
              "x": 27.79,
              "y": 21.35
            },
            {
              "x": 32.17,
              "y": -14.52
            }
          ],
          "time": 10.01
        }
      ],
      "duration": 10.01,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/5cce040b-a08c-488b-8b95-a3b342df349b/5027.194"
    },
    {
      "id": "3844_59.0_subset0",
      "matchId": "3844",
      "sequenceId": "59.0_subset0",
      "dtwScore": 0.11186349355643893,
      "frames": [
        {
          "ball": {
            "x": 10.11,
            "y": 16.96,
            "z": 1.09
          },
          "homePlayers": [
            {
              "x": -7.74,
              "y": 3.92
            },
            {
              "x": -5.82,
              "y": 22.13
            },
            {
              "x": 39.8,
              "y": 3.6
            },
            {
              "x": 13.74,
              "y": 19.77
            },
            {
              "x": 12.14,
              "y": -3.24
            },
            {
              "x": 5.95,
              "y": 10.6
            },
            {
              "x": -13.34,
              "y": 13.38
            },
            {
              "x": 14.22,
              "y": 12.29
            },
            {
              "x": 8.47,
              "y": 17.16
            },
            {
              "x": 15.09,
              "y": 6.22
            },
            {
              "x": 0.53,
              "y": 22.5
            }
          ],
          "awayPlayers": [
            {
              "x": -4.13,
              "y": 9.2
            },
            {
              "x": -9.75,
              "y": -7.78
            },
            {
              "x": -37.95,
              "y": 2.36
            },
            {
              "x": 8.04,
              "y": -2.56
            },
            {
              "x": -13.03,
              "y": 19.5
            },
            {
              "x": 9.13,
              "y": 14.99
            },
            {
              "x": -5.31,
              "y": 24.77
            },
            {
              "x": 0.5,
              "y": 18.38
            },
            {
              "x": 10.55,
              "y": 20.05
            },
            {
              "x": 9.9,
              "y": 10.96
            },
            {
              "x": -13.94,
              "y": 4.27
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": 11.08,
            "y": 16.88,
            "z": 0.83
          },
          "homePlayers": [
            {
              "x": -7.63,
              "y": 3.75
            },
            {
              "x": -5.4,
              "y": 22.04
            },
            {
              "x": 40.19,
              "y": 3.52
            },
            {
              "x": 13.76,
              "y": 19.47
            },
            {
              "x": 12.53,
              "y": -3.33
            },
            {
              "x": 7.23,
              "y": 10.88
            },
            {
              "x": -12.8,
              "y": 12.95
            },
            {
              "x": 15.07,
              "y": 12.43
            },
            {
              "x": 9.44,
              "y": 18.2
            },
            {
              "x": 15.8,
              "y": 6.48
            },
            {
              "x": 1.08,
              "y": 21.71
            }
          ],
          "awayPlayers": [
            {
              "x": -3.67,
              "y": 9.35
            },
            {
              "x": -9.04,
              "y": -7.81
            },
            {
              "x": -37.59,
              "y": 2.34
            },
            {
              "x": 8.04,
              "y": -3.03
            },
            {
              "x": -12.48,
              "y": 19.25
            },
            {
              "x": 11.07,
              "y": 15.89
            },
            {
              "x": -4.11,
              "y": 24.78
            },
            {
              "x": 1.29,
              "y": 18.45
            },
            {
              "x": 10.81,
              "y": 20.26
            },
            {
              "x": 9.96,
              "y": 10.65
            },
            {
              "x": -13.41,
              "y": 4.25
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": 11.61,
            "y": 15.75,
            "z": 0.21
          },
          "homePlayers": [
            {
              "x": -7.38,
              "y": 3.58
            },
            {
              "x": -5.14,
              "y": 22.01
            },
            {
              "x": 40.61,
              "y": 3.44
            },
            {
              "x": 14.32,
              "y": 19.43
            },
            {
              "x": 12.97,
              "y": -3.32
            },
            {
              "x": 8.82,
              "y": 11.32
            },
            {
              "x": -12.13,
              "y": 12.43
            },
            {
              "x": 15.52,
              "y": 12.59
            },
            {
              "x": 10.49,
              "y": 18.33
            },
            {
              "x": 16.48,
              "y": 6.72
            },
            {
              "x": 2.11,
              "y": 20.92
            }
          ],
          "awayPlayers": [
            {
              "x": -3.16,
              "y": 9.41
            },
            {
              "x": -8.11,
              "y": -7.89
            },
            {
              "x": -37.13,
              "y": 2.29
            },
            {
              "x": 8.34,
              "y": -3.51
            },
            {
              "x": -11.74,
              "y": 19.03
            },
            {
              "x": 13.05,
              "y": 16.59
            },
            {
              "x": -2.87,
              "y": 24.92
            },
            {
              "x": 2.03,
              "y": 18.32
            },
            {
              "x": 11.59,
              "y": 20.7
            },
            {
              "x": 10.7,
              "y": 11.02
            },
            {
              "x": -12.7,
              "y": 4.14
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": 12.44,
            "y": 14.44,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -7.08,
              "y": 3.24
            },
            {
              "x": -5.04,
              "y": 21.49
            },
            {
              "x": 41.14,
              "y": 3.27
            },
            {
              "x": 15.24,
              "y": 19.27
            },
            {
              "x": 13.47,
              "y": -3.3
            },
            {
              "x": 10.7,
              "y": 11.76
            },
            {
              "x": -11.43,
              "y": 11.88
            },
            {
              "x": 15.3,
              "y": 12.64
            },
            {
              "x": 11.56,
              "y": 17.9
            },
            {
              "x": 17.11,
              "y": 6.9
            },
            {
              "x": 3.25,
              "y": 20.14
            }
          ],
          "awayPlayers": [
            {
              "x": -2.79,
              "y": 9.44
            },
            {
              "x": -7.0,
              "y": -8.06
            },
            {
              "x": -36.65,
              "y": 2.18
            },
            {
              "x": 8.87,
              "y": -4.02
            },
            {
              "x": -10.95,
              "y": 18.56
            },
            {
              "x": 14.96,
              "y": 16.91
            },
            {
              "x": -1.61,
              "y": 24.93
            },
            {
              "x": 2.76,
              "y": 18.07
            },
            {
              "x": 12.69,
              "y": 21.12
            },
            {
              "x": 11.43,
              "y": 11.44
            },
            {
              "x": -11.94,
              "y": 3.92
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": 13.08,
            "y": 11.77,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -6.48,
              "y": 2.96
            },
            {
              "x": -5.08,
              "y": 20.91
            },
            {
              "x": 41.58,
              "y": 3.15
            },
            {
              "x": 16.37,
              "y": 18.95
            },
            {
              "x": 13.98,
              "y": -3.27
            },
            {
              "x": 12.42,
              "y": 11.91
            },
            {
              "x": -10.88,
              "y": 11.13
            },
            {
              "x": 14.56,
              "y": 12.13
            },
            {
              "x": 12.51,
              "y": 17.0
            },
            {
              "x": 17.54,
              "y": 6.83
            },
            {
              "x": 4.42,
              "y": 19.31
            }
          ],
          "awayPlayers": [
            {
              "x": -2.48,
              "y": 9.89
            },
            {
              "x": -6.03,
              "y": -8.28
            },
            {
              "x": -36.31,
              "y": 2.03
            },
            {
              "x": 9.5,
              "y": -4.38
            },
            {
              "x": -10.38,
              "y": 17.98
            },
            {
              "x": 16.91,
              "y": 16.83
            },
            {
              "x": -0.42,
              "y": 24.72
            },
            {
              "x": 3.56,
              "y": 17.77
            },
            {
              "x": 13.76,
              "y": 21.39
            },
            {
              "x": 12.38,
              "y": 11.14
            },
            {
              "x": -11.37,
              "y": 3.68
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": 13.65,
            "y": 10.28,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -5.78,
              "y": 2.4
            },
            {
              "x": -4.91,
              "y": 20.26
            },
            {
              "x": 42.1,
              "y": 2.98
            },
            {
              "x": 17.7,
              "y": 18.26
            },
            {
              "x": 14.45,
              "y": -3.36
            },
            {
              "x": 13.8,
              "y": 12.11
            },
            {
              "x": -10.32,
              "y": 10.43
            },
            {
              "x": 14.14,
              "y": 11.34
            },
            {
              "x": 13.28,
              "y": 16.02
            },
            {
              "x": 17.81,
              "y": 6.77
            },
            {
              "x": 5.51,
              "y": 18.66
            }
          ],
          "awayPlayers": [
            {
              "x": -1.89,
              "y": 10.15
            },
            {
              "x": -5.03,
              "y": -8.64
            },
            {
              "x": -35.93,
              "y": 1.89
            },
            {
              "x": 10.33,
              "y": -4.59
            },
            {
              "x": -9.74,
              "y": 17.34
            },
            {
              "x": 18.79,
              "y": 16.36
            },
            {
              "x": 0.87,
              "y": 24.25
            },
            {
              "x": 4.56,
              "y": 17.32
            },
            {
              "x": 14.9,
              "y": 21.66
            },
            {
              "x": 13.44,
              "y": 10.83
            },
            {
              "x": -10.73,
              "y": 3.35
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": 14.17,
            "y": 9.23,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -5.15,
              "y": 2.04
            },
            {
              "x": -4.48,
              "y": 20.04
            },
            {
              "x": 42.54,
              "y": 2.85
            },
            {
              "x": 19.1,
              "y": 17.34
            },
            {
              "x": 15.01,
              "y": -3.53
            },
            {
              "x": 14.91,
              "y": 12.12
            },
            {
              "x": -9.77,
              "y": 9.89
            },
            {
              "x": 14.14,
              "y": 10.21
            },
            {
              "x": 13.87,
              "y": 14.85
            },
            {
              "x": 18.2,
              "y": 6.86
            },
            {
              "x": 6.5,
              "y": 17.88
            }
          ],
          "awayPlayers": [
            {
              "x": -1.26,
              "y": 10.32
            },
            {
              "x": -3.86,
              "y": -9.22
            },
            {
              "x": -35.66,
              "y": 1.78
            },
            {
              "x": 11.37,
              "y": -4.76
            },
            {
              "x": -9.1,
              "y": 16.84
            },
            {
              "x": 20.48,
              "y": 15.49
            },
            {
              "x": 1.42,
              "y": 23.95
            },
            {
              "x": 5.03,
              "y": 17.09
            },
            {
              "x": 16.07,
              "y": 21.89
            },
            {
              "x": 14.26,
              "y": 9.95
            },
            {
              "x": -10.2,
              "y": 3.08
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": 14.66,
            "y": 8.38,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -4.49,
              "y": 1.41
            },
            {
              "x": -4.12,
              "y": 19.64
            },
            {
              "x": 42.9,
              "y": 2.67
            },
            {
              "x": 20.34,
              "y": 15.93
            },
            {
              "x": 15.9,
              "y": -3.72
            },
            {
              "x": 16.09,
              "y": 11.75
            },
            {
              "x": -9.27,
              "y": 9.07
            },
            {
              "x": 14.42,
              "y": 9.58
            },
            {
              "x": 14.46,
              "y": 13.68
            },
            {
              "x": 18.95,
              "y": 6.94
            },
            {
              "x": 7.44,
              "y": 17.14
            }
          ],
          "awayPlayers": [
            {
              "x": -0.52,
              "y": 9.73
            },
            {
              "x": -2.92,
              "y": -9.77
            },
            {
              "x": -35.4,
              "y": 1.6
            },
            {
              "x": 12.8,
              "y": -5.03
            },
            {
              "x": -8.52,
              "y": 16.24
            },
            {
              "x": 21.78,
              "y": 14.13
            },
            {
              "x": 1.1,
              "y": 22.99
            },
            {
              "x": 4.78,
              "y": 16.29
            },
            {
              "x": 17.47,
              "y": 21.96
            },
            {
              "x": 14.9,
              "y": 9.32
            },
            {
              "x": -9.75,
              "y": 2.62
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": 15.17,
            "y": 7.15,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.81,
              "y": 0.81
            },
            {
              "x": -3.76,
              "y": 19.23
            },
            {
              "x": 43.27,
              "y": 2.53
            },
            {
              "x": 21.45,
              "y": 14.18
            },
            {
              "x": 17.29,
              "y": -4.03
            },
            {
              "x": 17.39,
              "y": 10.64
            },
            {
              "x": -8.69,
              "y": 8.22
            },
            {
              "x": 14.73,
              "y": 9.31
            },
            {
              "x": 15.23,
              "y": 12.29
            },
            {
              "x": 20.09,
              "y": 6.63
            },
            {
              "x": 8.36,
              "y": 16.32
            }
          ],
          "awayPlayers": [
            {
              "x": 0.24,
              "y": 9.1
            },
            {
              "x": -1.66,
              "y": -10.38
            },
            {
              "x": -35.13,
              "y": 1.45
            },
            {
              "x": 14.62,
              "y": -5.39
            },
            {
              "x": -7.84,
              "y": 15.52
            },
            {
              "x": 22.62,
              "y": 12.3
            },
            {
              "x": 0.74,
              "y": 21.96
            },
            {
              "x": 5.41,
              "y": 15.72
            },
            {
              "x": 19.06,
              "y": 21.76
            },
            {
              "x": 15.15,
              "y": 8.46
            },
            {
              "x": -9.16,
              "y": 2.1
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": 15.77,
            "y": 5.06,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -3.1,
              "y": 0.14
            },
            {
              "x": -3.36,
              "y": 18.72
            },
            {
              "x": 43.74,
              "y": 2.33
            },
            {
              "x": 22.76,
              "y": 12.63
            },
            {
              "x": 19.1,
              "y": -4.36
            },
            {
              "x": 18.59,
              "y": 9.21
            },
            {
              "x": -8.1,
              "y": 7.2
            },
            {
              "x": 15.27,
              "y": 9.26
            },
            {
              "x": 16.27,
              "y": 10.97
            },
            {
              "x": 21.31,
              "y": 5.78
            },
            {
              "x": 9.43,
              "y": 15.65
            }
          ],
          "awayPlayers": [
            {
              "x": 1.0,
              "y": 8.44
            },
            {
              "x": -0.65,
              "y": -10.85
            },
            {
              "x": -34.86,
              "y": 1.27
            },
            {
              "x": 16.77,
              "y": -5.43
            },
            {
              "x": -7.21,
              "y": 14.75
            },
            {
              "x": 23.12,
              "y": 10.36
            },
            {
              "x": 0.36,
              "y": 20.98
            },
            {
              "x": 6.73,
              "y": 15.24
            },
            {
              "x": 20.8,
              "y": 21.09
            },
            {
              "x": 15.77,
              "y": 6.34
            },
            {
              "x": -8.59,
              "y": 1.56
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": 16.34,
            "y": 3.38,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -2.03,
              "y": -0.46
            },
            {
              "x": -2.66,
              "y": 18.37
            },
            {
              "x": 44.31,
              "y": 2.07
            },
            {
              "x": 24.27,
              "y": 10.93
            },
            {
              "x": 21.11,
              "y": -4.87
            },
            {
              "x": 19.56,
              "y": 7.36
            },
            {
              "x": -7.33,
              "y": 6.34
            },
            {
              "x": 16.27,
              "y": 9.2
            },
            {
              "x": 17.35,
              "y": 9.07
            },
            {
              "x": 22.38,
              "y": 4.37
            },
            {
              "x": 10.71,
              "y": 15.04
            }
          ],
          "awayPlayers": [
            {
              "x": 2.02,
              "y": 7.89
            },
            {
              "x": 0.99,
              "y": -11.53
            },
            {
              "x": -34.52,
              "y": 1.1
            },
            {
              "x": 19.12,
              "y": -5.05
            },
            {
              "x": -6.35,
              "y": 14.08
            },
            {
              "x": 23.6,
              "y": 8.32
            },
            {
              "x": 0.91,
              "y": 20.45
            },
            {
              "x": 7.49,
              "y": 14.97
            },
            {
              "x": 22.57,
              "y": 20.3
            },
            {
              "x": 16.34,
              "y": 4.42
            },
            {
              "x": -7.77,
              "y": 1.03
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": 17.01,
            "y": 1.85,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -1.06,
              "y": -1.06
            },
            {
              "x": -2.11,
              "y": 17.96
            },
            {
              "x": 44.82,
              "y": 1.77
            },
            {
              "x": 25.97,
              "y": 9.45
            },
            {
              "x": 23.2,
              "y": -5.17
            },
            {
              "x": 20.22,
              "y": 5.32
            },
            {
              "x": -6.72,
              "y": 5.55
            },
            {
              "x": 17.62,
              "y": 9.0
            },
            {
              "x": 18.43,
              "y": 7.04
            },
            {
              "x": 23.29,
              "y": 2.65
            },
            {
              "x": 12.27,
              "y": 14.56
            }
          ],
          "awayPlayers": [
            {
              "x": 2.9,
              "y": 7.3
            },
            {
              "x": 2.66,
              "y": -12.29
            },
            {
              "x": -34.29,
              "y": 0.93
            },
            {
              "x": 21.54,
              "y": -4.28
            },
            {
              "x": -5.72,
              "y": 13.5
            },
            {
              "x": 24.68,
              "y": 5.91
            },
            {
              "x": 1.52,
              "y": 20.05
            },
            {
              "x": 8.06,
              "y": 14.34
            },
            {
              "x": 24.32,
              "y": 19.32
            },
            {
              "x": 17.02,
              "y": 2.43
            },
            {
              "x": -7.13,
              "y": 0.42
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": 17.9,
            "y": 0.14,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -0.21,
              "y": -1.65
            },
            {
              "x": -1.62,
              "y": 17.64
            },
            {
              "x": 45.3,
              "y": 1.53
            },
            {
              "x": 27.61,
              "y": 7.82
            },
            {
              "x": 25.27,
              "y": -5.19
            },
            {
              "x": 20.68,
              "y": 2.98
            },
            {
              "x": -6.25,
              "y": 4.67
            },
            {
              "x": 19.02,
              "y": 8.55
            },
            {
              "x": 19.38,
              "y": 4.78
            },
            {
              "x": 24.36,
              "y": 0.97
            },
            {
              "x": 13.79,
              "y": 14.1
            }
          ],
          "awayPlayers": [
            {
              "x": 3.76,
              "y": 6.61
            },
            {
              "x": 4.31,
              "y": -13.11
            },
            {
              "x": -34.1,
              "y": 0.75
            },
            {
              "x": 23.94,
              "y": -3.5
            },
            {
              "x": -5.25,
              "y": 12.68
            },
            {
              "x": 25.37,
              "y": 4.71
            },
            {
              "x": 1.91,
              "y": 19.57
            },
            {
              "x": 7.98,
              "y": 13.0
            },
            {
              "x": 25.94,
              "y": 18.45
            },
            {
              "x": 17.74,
              "y": 0.55
            },
            {
              "x": -6.54,
              "y": -0.28
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": 18.37,
            "y": -1.48,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 0.84,
              "y": -1.91
            },
            {
              "x": -1.1,
              "y": 17.37
            },
            {
              "x": 45.7,
              "y": 1.28
            },
            {
              "x": 29.4,
              "y": 6.73
            },
            {
              "x": 27.32,
              "y": -4.72
            },
            {
              "x": 21.01,
              "y": 0.63
            },
            {
              "x": -5.91,
              "y": 3.91
            },
            {
              "x": 20.59,
              "y": 8.1
            },
            {
              "x": 20.32,
              "y": 2.83
            },
            {
              "x": 25.78,
              "y": -0.08
            },
            {
              "x": 15.49,
              "y": 13.68
            }
          ],
          "awayPlayers": [
            {
              "x": 4.54,
              "y": 6.04
            },
            {
              "x": 5.75,
              "y": -13.91
            },
            {
              "x": -33.93,
              "y": 0.58
            },
            {
              "x": 26.41,
              "y": -2.65
            },
            {
              "x": -4.94,
              "y": 11.92
            },
            {
              "x": 25.18,
              "y": 3.94
            },
            {
              "x": 2.19,
              "y": 19.16
            },
            {
              "x": 8.13,
              "y": 11.69
            },
            {
              "x": 27.57,
              "y": 17.57
            },
            {
              "x": 18.57,
              "y": -1.08
            },
            {
              "x": -6.02,
              "y": -0.96
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": 18.96,
            "y": -3.32,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 1.57,
              "y": -2.43
            },
            {
              "x": -0.58,
              "y": 17.26
            },
            {
              "x": 46.1,
              "y": 1.07
            },
            {
              "x": 31.14,
              "y": 5.68
            },
            {
              "x": 29.2,
              "y": -4.34
            },
            {
              "x": 21.33,
              "y": -1.7
            },
            {
              "x": -5.63,
              "y": 3.21
            },
            {
              "x": 22.21,
              "y": 7.48
            },
            {
              "x": 21.13,
              "y": 0.89
            },
            {
              "x": 27.29,
              "y": -0.79
            },
            {
              "x": 17.34,
              "y": 13.3
            }
          ],
          "awayPlayers": [
            {
              "x": 5.25,
              "y": 5.64
            },
            {
              "x": 7.12,
              "y": -14.59
            },
            {
              "x": -33.76,
              "y": 0.41
            },
            {
              "x": 28.81,
              "y": -2.07
            },
            {
              "x": -4.69,
              "y": 11.18
            },
            {
              "x": 24.67,
              "y": 3.58
            },
            {
              "x": 2.37,
              "y": 18.84
            },
            {
              "x": 8.71,
              "y": 10.65
            },
            {
              "x": 29.21,
              "y": 16.89
            },
            {
              "x": 19.39,
              "y": -2.37
            },
            {
              "x": -5.63,
              "y": -1.62
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": 19.06,
            "y": -7.13,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 2.41,
              "y": -3.09
            },
            {
              "x": -0.04,
              "y": 17.02
            },
            {
              "x": 46.44,
              "y": 0.74
            },
            {
              "x": 32.8,
              "y": 4.97
            },
            {
              "x": 30.7,
              "y": -4.47
            },
            {
              "x": 21.75,
              "y": -3.9
            },
            {
              "x": -5.24,
              "y": 2.28
            },
            {
              "x": 23.95,
              "y": 6.84
            },
            {
              "x": 21.94,
              "y": -0.81
            },
            {
              "x": 28.68,
              "y": -1.54
            },
            {
              "x": 19.39,
              "y": 12.95
            }
          ],
          "awayPlayers": [
            {
              "x": 6.12,
              "y": 5.2
            },
            {
              "x": 9.17,
              "y": -15.5
            },
            {
              "x": -33.44,
              "y": 0.24
            },
            {
              "x": 31.08,
              "y": -1.9
            },
            {
              "x": -4.35,
              "y": 10.53
            },
            {
              "x": 25.51,
              "y": 2.45
            },
            {
              "x": 2.88,
              "y": 18.5
            },
            {
              "x": 9.75,
              "y": 10.18
            },
            {
              "x": 30.85,
              "y": 16.21
            },
            {
              "x": 20.31,
              "y": -3.25
            },
            {
              "x": -5.24,
              "y": -2.2
            }
          ],
          "time": 5.005
        },
        {
          "ball": {
            "x": 18.98,
            "y": -11.04,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 3.1,
              "y": -4.12
            },
            {
              "x": 0.37,
              "y": 16.8
            },
            {
              "x": 46.8,
              "y": 0.39
            },
            {
              "x": 34.19,
              "y": 4.67
            },
            {
              "x": 31.73,
              "y": -5.41
            },
            {
              "x": 22.22,
              "y": -6.15
            },
            {
              "x": -4.84,
              "y": 1.44
            },
            {
              "x": 25.55,
              "y": 6.06
            },
            {
              "x": 22.8,
              "y": -2.38
            },
            {
              "x": 29.85,
              "y": -2.65
            },
            {
              "x": 21.34,
              "y": 12.57
            }
          ],
          "awayPlayers": [
            {
              "x": 7.02,
              "y": 4.59
            },
            {
              "x": 11.13,
              "y": -16.47
            },
            {
              "x": -33.08,
              "y": 0.08
            },
            {
              "x": 32.95,
              "y": -2.19
            },
            {
              "x": -3.98,
              "y": 9.9
            },
            {
              "x": 28.06,
              "y": 0.42
            },
            {
              "x": 3.56,
              "y": 18.3
            },
            {
              "x": 11.0,
              "y": 9.5
            },
            {
              "x": 32.27,
              "y": 15.55
            },
            {
              "x": 21.36,
              "y": -3.63
            },
            {
              "x": -4.75,
              "y": -2.85
            }
          ],
          "time": 5.339
        },
        {
          "ball": {
            "x": 18.89,
            "y": -14.44,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 4.02,
              "y": -5.05
            },
            {
              "x": 0.93,
              "y": 16.46
            },
            {
              "x": 47.15,
              "y": 0.07
            },
            {
              "x": 35.27,
              "y": 4.74
            },
            {
              "x": 32.39,
              "y": -6.71
            },
            {
              "x": 22.77,
              "y": -8.43
            },
            {
              "x": -4.33,
              "y": 0.54
            },
            {
              "x": 27.13,
              "y": 5.33
            },
            {
              "x": 23.87,
              "y": -3.71
            },
            {
              "x": 31.01,
              "y": -3.79
            },
            {
              "x": 23.23,
              "y": 12.16
            }
          ],
          "awayPlayers": [
            {
              "x": 7.97,
              "y": 4.0
            },
            {
              "x": 13.09,
              "y": -17.73
            },
            {
              "x": -32.7,
              "y": -0.08
            },
            {
              "x": 34.43,
              "y": -2.32
            },
            {
              "x": -3.56,
              "y": 9.23
            },
            {
              "x": 30.83,
              "y": -1.64
            },
            {
              "x": 4.36,
              "y": 18.03
            },
            {
              "x": 12.13,
              "y": 8.92
            },
            {
              "x": 33.56,
              "y": 14.87
            },
            {
              "x": 22.61,
              "y": -3.67
            },
            {
              "x": -4.21,
              "y": -3.4
            }
          ],
          "time": 5.672
        },
        {
          "ball": {
            "x": 18.88,
            "y": -17.26,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 5.01,
              "y": -5.89
            },
            {
              "x": 1.58,
              "y": 16.32
            },
            {
              "x": 47.4,
              "y": -0.23
            },
            {
              "x": 35.86,
              "y": 4.96
            },
            {
              "x": 32.84,
              "y": -8.04
            },
            {
              "x": 23.37,
              "y": -10.63
            },
            {
              "x": -3.82,
              "y": -0.21
            },
            {
              "x": 28.6,
              "y": 4.61
            },
            {
              "x": 25.02,
              "y": -4.99
            },
            {
              "x": 32.26,
              "y": -4.57
            },
            {
              "x": 25.02,
              "y": 11.53
            }
          ],
          "awayPlayers": [
            {
              "x": 8.9,
              "y": 3.39
            },
            {
              "x": 14.2,
              "y": -18.68
            },
            {
              "x": -32.25,
              "y": -0.26
            },
            {
              "x": 35.44,
              "y": -2.08
            },
            {
              "x": -3.14,
              "y": 8.53
            },
            {
              "x": 32.13,
              "y": -2.77
            },
            {
              "x": 4.88,
              "y": 17.77
            },
            {
              "x": 13.19,
              "y": 8.15
            },
            {
              "x": 34.7,
              "y": 14.15
            },
            {
              "x": 24.01,
              "y": -3.64
            },
            {
              "x": -3.58,
              "y": -3.96
            }
          ],
          "time": 6.006
        },
        {
          "ball": {
            "x": 18.89,
            "y": -19.69,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 5.99,
              "y": -6.67
            },
            {
              "x": 2.25,
              "y": 16.19
            },
            {
              "x": 47.6,
              "y": -0.41
            },
            {
              "x": 36.0,
              "y": 4.91
            },
            {
              "x": 33.14,
              "y": -9.28
            },
            {
              "x": 23.91,
              "y": -12.75
            },
            {
              "x": -3.31,
              "y": -0.79
            },
            {
              "x": 30.0,
              "y": 3.96
            },
            {
              "x": 26.19,
              "y": -6.12
            },
            {
              "x": 33.49,
              "y": -4.73
            },
            {
              "x": 26.74,
              "y": 10.95
            }
          ],
          "awayPlayers": [
            {
              "x": 9.83,
              "y": 2.98
            },
            {
              "x": 16.34,
              "y": -20.6
            },
            {
              "x": -31.94,
              "y": -0.39
            },
            {
              "x": 36.12,
              "y": -1.44
            },
            {
              "x": -2.76,
              "y": 8.08
            },
            {
              "x": 32.84,
              "y": -3.7
            },
            {
              "x": 5.54,
              "y": 17.52
            },
            {
              "x": 14.09,
              "y": 7.59
            },
            {
              "x": 35.76,
              "y": 13.49
            },
            {
              "x": 25.37,
              "y": -3.89
            },
            {
              "x": -3.08,
              "y": -4.41
            }
          ],
          "time": 6.34
        },
        {
          "ball": {
            "x": 18.94,
            "y": -21.79,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 6.69,
              "y": -7.32
            },
            {
              "x": 2.87,
              "y": 16.07
            },
            {
              "x": 47.8,
              "y": -0.59
            },
            {
              "x": 36.16,
              "y": 4.97
            },
            {
              "x": 33.38,
              "y": -10.35
            },
            {
              "x": 24.33,
              "y": -14.88
            },
            {
              "x": -2.87,
              "y": -1.57
            },
            {
              "x": 31.29,
              "y": 3.33
            },
            {
              "x": 27.39,
              "y": -7.11
            },
            {
              "x": 34.56,
              "y": -4.53
            },
            {
              "x": 28.29,
              "y": 10.15
            }
          ],
          "awayPlayers": [
            {
              "x": 10.75,
              "y": 2.4
            },
            {
              "x": 17.91,
              "y": -21.9
            },
            {
              "x": -31.62,
              "y": -0.53
            },
            {
              "x": 36.52,
              "y": -0.88
            },
            {
              "x": -2.43,
              "y": 7.49
            },
            {
              "x": 33.36,
              "y": -4.63
            },
            {
              "x": 6.05,
              "y": 17.21
            },
            {
              "x": 14.99,
              "y": 6.8
            },
            {
              "x": 36.58,
              "y": 12.84
            },
            {
              "x": 26.43,
              "y": -4.71
            },
            {
              "x": -2.56,
              "y": -4.9
            }
          ],
          "time": 6.673
        },
        {
          "ball": {
            "x": 19.58,
            "y": -22.86,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 7.63,
              "y": -7.93
            },
            {
              "x": 3.68,
              "y": 15.92
            },
            {
              "x": 48.91,
              "y": -0.33
            },
            {
              "x": 36.54,
              "y": 5.01
            },
            {
              "x": 33.61,
              "y": -11.32
            },
            {
              "x": 24.72,
              "y": -16.78
            },
            {
              "x": -2.36,
              "y": -2.16
            },
            {
              "x": 32.52,
              "y": 2.77
            },
            {
              "x": 28.6,
              "y": -7.84
            },
            {
              "x": 35.44,
              "y": -4.4
            },
            {
              "x": 29.66,
              "y": 9.23
            }
          ],
          "awayPlayers": [
            {
              "x": 11.81,
              "y": 1.93
            },
            {
              "x": 19.41,
              "y": -22.92
            },
            {
              "x": -31.44,
              "y": -0.64
            },
            {
              "x": 36.86,
              "y": -0.24
            },
            {
              "x": -2.12,
              "y": 7.09
            },
            {
              "x": 33.69,
              "y": -5.65
            },
            {
              "x": 6.68,
              "y": 16.95
            },
            {
              "x": 15.83,
              "y": 6.3
            },
            {
              "x": 37.12,
              "y": 12.22
            },
            {
              "x": 27.05,
              "y": -5.93
            },
            {
              "x": -2.04,
              "y": -5.33
            }
          ],
          "time": 7.007
        },
        {
          "ball": {
            "x": 20.36,
            "y": -23.24,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 8.34,
              "y": -8.58
            },
            {
              "x": 4.42,
              "y": 15.72
            },
            {
              "x": 49.93,
              "y": -0.05
            },
            {
              "x": 36.96,
              "y": 5.13
            },
            {
              "x": 33.72,
              "y": -12.16
            },
            {
              "x": 25.15,
              "y": -18.43
            },
            {
              "x": -1.96,
              "y": -2.86
            },
            {
              "x": 33.59,
              "y": 2.16
            },
            {
              "x": 29.64,
              "y": -8.6
            },
            {
              "x": 36.08,
              "y": -4.6
            },
            {
              "x": 30.77,
              "y": 8.08
            }
          ],
          "awayPlayers": [
            {
              "x": 12.78,
              "y": 1.31
            },
            {
              "x": 20.57,
              "y": -23.73
            },
            {
              "x": -31.29,
              "y": -0.77
            },
            {
              "x": 37.1,
              "y": 0.29
            },
            {
              "x": -1.85,
              "y": 6.52
            },
            {
              "x": 33.96,
              "y": -6.67
            },
            {
              "x": 7.19,
              "y": 16.64
            },
            {
              "x": 16.6,
              "y": 5.75
            },
            {
              "x": 37.38,
              "y": 11.7
            },
            {
              "x": 27.31,
              "y": -7.34
            },
            {
              "x": -1.66,
              "y": -5.91
            }
          ],
          "time": 7.341
        },
        {
          "ball": {
            "x": 21.21,
            "y": -23.47,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 9.12,
              "y": -9.12
            },
            {
              "x": 5.22,
              "y": 15.43
            },
            {
              "x": 50.78,
              "y": 0.23
            },
            {
              "x": 37.23,
              "y": 5.23
            },
            {
              "x": 33.77,
              "y": -12.86
            },
            {
              "x": 25.41,
              "y": -19.76
            },
            {
              "x": -1.32,
              "y": -3.57
            },
            {
              "x": 34.47,
              "y": 1.61
            },
            {
              "x": 30.24,
              "y": -9.47
            },
            {
              "x": 36.47,
              "y": -5.1
            },
            {
              "x": 31.5,
              "y": 6.85
            }
          ],
          "awayPlayers": [
            {
              "x": 13.66,
              "y": 0.75
            },
            {
              "x": 21.38,
              "y": -24.31
            },
            {
              "x": -31.11,
              "y": -0.89
            },
            {
              "x": 37.28,
              "y": 0.74
            },
            {
              "x": -1.44,
              "y": 5.95
            },
            {
              "x": 34.19,
              "y": -7.67
            },
            {
              "x": 7.72,
              "y": 16.25
            },
            {
              "x": 18.09,
              "y": 5.09
            },
            {
              "x": 37.47,
              "y": 11.28
            },
            {
              "x": 27.35,
              "y": -8.85
            },
            {
              "x": -1.21,
              "y": -6.43
            }
          ],
          "time": 7.674
        },
        {
          "ball": {
            "x": 22.01,
            "y": -23.7,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": 9.08,
              "y": -9.93
            },
            {
              "x": 6.23,
              "y": 15.59
            },
            {
              "x": 50.66,
              "y": 0.18
            },
            {
              "x": 37.47,
              "y": 5.46
            },
            {
              "x": 33.71,
              "y": -13.43
            },
            {
              "x": 25.35,
              "y": -20.91
            },
            {
              "x": -0.63,
              "y": -4.52
            },
            {
              "x": 35.15,
              "y": 1.26
            },
            {
              "x": 30.29,
              "y": -10.62
            },
            {
              "x": 36.64,
              "y": -5.77
            },
            {
              "x": 31.8,
              "y": 5.53
            }
          ],
          "awayPlayers": [
            {
              "x": 14.24,
              "y": -0.2
            },
            {
              "x": 21.98,
              "y": -24.35
            },
            {
              "x": -30.95,
              "y": -1.05
            },
            {
              "x": 37.44,
              "y": 1.09
            },
            {
              "x": -1.18,
              "y": 4.99
            },
            {
              "x": 34.39,
              "y": -8.62
            },
            {
              "x": 8.64,
              "y": 15.72
            },
            {
              "x": 19.43,
              "y": 4.35
            },
            {
              "x": 37.5,
              "y": 11.04
            },
            {
              "x": 27.51,
              "y": -10.43
            },
            {
              "x": -0.84,
              "y": -7.51
            }
          ],
          "time": 8.008
        },
        {
          "ball": {
            "x": 22.92,
            "y": -24.09,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 9.16,
              "y": -10.61
            },
            {
              "x": 7.23,
              "y": 15.86
            },
            {
              "x": 50.37,
              "y": 0.14
            },
            {
              "x": 37.73,
              "y": 5.81
            },
            {
              "x": 33.67,
              "y": -13.94
            },
            {
              "x": 25.14,
              "y": -21.82
            },
            {
              "x": 0.09,
              "y": -5.3
            },
            {
              "x": 35.68,
              "y": 1.07
            },
            {
              "x": 29.89,
              "y": -11.69
            },
            {
              "x": 36.69,
              "y": -6.42
            },
            {
              "x": 31.71,
              "y": 4.29
            }
          ],
          "awayPlayers": [
            {
              "x": 14.8,
              "y": -1.1
            },
            {
              "x": 22.61,
              "y": -24.18
            },
            {
              "x": -30.76,
              "y": -1.16
            },
            {
              "x": 37.55,
              "y": 1.36
            },
            {
              "x": -0.94,
              "y": 4.15
            },
            {
              "x": 34.44,
              "y": -9.56
            },
            {
              "x": 9.37,
              "y": 15.27
            },
            {
              "x": 20.63,
              "y": 3.55
            },
            {
              "x": 37.48,
              "y": 10.95
            },
            {
              "x": 28.0,
              "y": -12.07
            },
            {
              "x": -0.39,
              "y": -8.38
            }
          ],
          "time": 8.342
        },
        {
          "ball": {
            "x": 23.52,
            "y": -24.31,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 8.96,
              "y": -11.43
            },
            {
              "x": 8.13,
              "y": 16.12
            },
            {
              "x": 50.15,
              "y": -0.02
            },
            {
              "x": 37.85,
              "y": 6.08
            },
            {
              "x": 33.79,
              "y": -14.59
            },
            {
              "x": 25.0,
              "y": -22.58
            },
            {
              "x": 0.52,
              "y": -6.14
            },
            {
              "x": 36.07,
              "y": 0.89
            },
            {
              "x": 29.35,
              "y": -12.71
            },
            {
              "x": 36.72,
              "y": -7.13
            },
            {
              "x": 31.42,
              "y": 3.22
            }
          ],
          "awayPlayers": [
            {
              "x": 15.19,
              "y": -2.01
            },
            {
              "x": 23.17,
              "y": -23.98
            },
            {
              "x": -30.65,
              "y": -1.32
            },
            {
              "x": 37.63,
              "y": 1.57
            },
            {
              "x": -0.77,
              "y": 3.22
            },
            {
              "x": 34.37,
              "y": -10.38
            },
            {
              "x": 10.04,
              "y": 14.78
            },
            {
              "x": 20.94,
              "y": 3.06
            },
            {
              "x": 37.41,
              "y": 10.95
            },
            {
              "x": 28.89,
              "y": -13.73
            },
            {
              "x": -0.04,
              "y": -9.5
            }
          ],
          "time": 8.675
        },
        {
          "ball": {
            "x": 23.74,
            "y": -24.52,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 9.53,
              "y": -11.93
            },
            {
              "x": 8.37,
              "y": 16.01
            },
            {
              "x": 50.02,
              "y": -0.14
            },
            {
              "x": 37.85,
              "y": 6.24
            },
            {
              "x": 34.27,
              "y": -15.5
            },
            {
              "x": 24.75,
              "y": -23.29
            },
            {
              "x": 0.8,
              "y": -6.66
            },
            {
              "x": 36.32,
              "y": 0.57
            },
            {
              "x": 28.97,
              "y": -13.35
            },
            {
              "x": 36.8,
              "y": -7.74
            },
            {
              "x": 31.09,
              "y": 2.3
            }
          ],
          "awayPlayers": [
            {
              "x": 15.78,
              "y": -2.68
            },
            {
              "x": 23.51,
              "y": -24.11
            },
            {
              "x": -30.53,
              "y": -1.42
            },
            {
              "x": 37.76,
              "y": 1.71
            },
            {
              "x": -0.55,
              "y": 2.78
            },
            {
              "x": 34.21,
              "y": -11.0
            },
            {
              "x": 10.08,
              "y": 14.5
            },
            {
              "x": 21.47,
              "y": 2.24
            },
            {
              "x": 37.34,
              "y": 10.97
            },
            {
              "x": 30.03,
              "y": -15.39
            },
            {
              "x": 0.17,
              "y": -10.03
            }
          ],
          "time": 9.009
        },
        {
          "ball": {
            "x": 24.74,
            "y": -24.97,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 9.93,
              "y": -12.63
            },
            {
              "x": 8.82,
              "y": 15.68
            },
            {
              "x": 49.98,
              "y": -0.22
            },
            {
              "x": 37.81,
              "y": 6.24
            },
            {
              "x": 35.0,
              "y": -16.83
            },
            {
              "x": 24.4,
              "y": -24.04
            },
            {
              "x": 1.2,
              "y": -7.65
            },
            {
              "x": 36.55,
              "y": 0.24
            },
            {
              "x": 28.91,
              "y": -13.82
            },
            {
              "x": 36.93,
              "y": -8.44
            },
            {
              "x": 30.79,
              "y": 1.46
            }
          ],
          "awayPlayers": [
            {
              "x": 16.74,
              "y": -3.3
            },
            {
              "x": 23.68,
              "y": -24.27
            },
            {
              "x": -30.46,
              "y": -1.57
            },
            {
              "x": 37.93,
              "y": 1.77
            },
            {
              "x": -0.22,
              "y": 2.09
            },
            {
              "x": 34.07,
              "y": -11.49
            },
            {
              "x": 10.35,
              "y": 14.03
            },
            {
              "x": 21.84,
              "y": 1.63
            },
            {
              "x": 37.29,
              "y": 10.91
            },
            {
              "x": 31.23,
              "y": -17.11
            },
            {
              "x": 0.52,
              "y": -10.9
            }
          ],
          "time": 9.343
        },
        {
          "ball": {
            "x": 27.12,
            "y": -25.49,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 10.46,
              "y": -13.06
            },
            {
              "x": 9.16,
              "y": 15.46
            },
            {
              "x": 50.03,
              "y": -0.16
            },
            {
              "x": 37.89,
              "y": 6.21
            },
            {
              "x": 35.62,
              "y": -18.58
            },
            {
              "x": 24.21,
              "y": -24.8
            },
            {
              "x": 1.56,
              "y": -8.39
            },
            {
              "x": 36.94,
              "y": 0.04
            },
            {
              "x": 29.15,
              "y": -14.17
            },
            {
              "x": 37.12,
              "y": -9.16
            },
            {
              "x": 30.62,
              "y": 0.78
            }
          ],
          "awayPlayers": [
            {
              "x": 17.4,
              "y": -3.94
            },
            {
              "x": 24.0,
              "y": -24.22
            },
            {
              "x": -30.3,
              "y": -1.67
            },
            {
              "x": 38.13,
              "y": 1.77
            },
            {
              "x": 0.05,
              "y": 1.62
            },
            {
              "x": 33.95,
              "y": -11.91
            },
            {
              "x": 10.55,
              "y": 13.71
            },
            {
              "x": 22.14,
              "y": 1.11
            },
            {
              "x": 37.29,
              "y": 10.82
            },
            {
              "x": 32.25,
              "y": -18.98
            },
            {
              "x": 0.84,
              "y": -11.52
            }
          ],
          "time": 9.676
        },
        {
          "ball": {
            "x": 28.96,
            "y": -25.96,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 10.99,
              "y": -13.64
            },
            {
              "x": 9.78,
              "y": 15.24
            },
            {
              "x": 50.04,
              "y": -0.12
            },
            {
              "x": 38.03,
              "y": 5.96
            },
            {
              "x": 35.78,
              "y": -20.67
            },
            {
              "x": 24.57,
              "y": -25.24
            },
            {
              "x": 1.9,
              "y": -9.29
            },
            {
              "x": 37.39,
              "y": -0.14
            },
            {
              "x": 29.65,
              "y": -14.61
            },
            {
              "x": 37.27,
              "y": -10.08
            },
            {
              "x": 30.55,
              "y": 0.18
            }
          ],
          "awayPlayers": [
            {
              "x": 17.81,
              "y": -4.58
            },
            {
              "x": 24.79,
              "y": -23.95
            },
            {
              "x": -30.15,
              "y": -1.81
            },
            {
              "x": 38.29,
              "y": 1.68
            },
            {
              "x": 0.25,
              "y": 1.11
            },
            {
              "x": 33.97,
              "y": -12.39
            },
            {
              "x": 10.88,
              "y": 13.45
            },
            {
              "x": 22.38,
              "y": 0.66
            },
            {
              "x": 37.28,
              "y": 10.62
            },
            {
              "x": 32.81,
              "y": -20.99
            },
            {
              "x": 1.16,
              "y": -12.2
            }
          ],
          "time": 10.01
        },
        {
          "ball": {
            "x": 30.33,
            "y": -26.32,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 11.31,
              "y": -13.95
            },
            {
              "x": 10.23,
              "y": 15.05
            },
            {
              "x": 50.04,
              "y": -0.1
            },
            {
              "x": 38.17,
              "y": 5.63
            },
            {
              "x": 35.26,
              "y": -22.82
            },
            {
              "x": 25.39,
              "y": -25.41
            },
            {
              "x": 2.05,
              "y": -9.87
            },
            {
              "x": 37.92,
              "y": -0.28
            },
            {
              "x": 30.36,
              "y": -15.16
            },
            {
              "x": 37.28,
              "y": -11.11
            },
            {
              "x": 30.61,
              "y": -0.32
            }
          ],
          "awayPlayers": [
            {
              "x": 17.7,
              "y": -5.16
            },
            {
              "x": 26.14,
              "y": -23.49
            },
            {
              "x": -29.96,
              "y": -1.94
            },
            {
              "x": 38.43,
              "y": 1.52
            },
            {
              "x": 0.41,
              "y": 0.72
            },
            {
              "x": 34.16,
              "y": -12.75
            },
            {
              "x": 11.11,
              "y": 13.23
            },
            {
              "x": 22.71,
              "y": 0.26
            },
            {
              "x": 37.28,
              "y": 10.34
            },
            {
              "x": 32.95,
              "y": -23.08
            },
            {
              "x": 1.32,
              "y": -12.68
            }
          ],
          "time": 10.344
        },
        {
          "ball": {
            "x": 31.51,
            "y": -26.61,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 12.09,
              "y": -14.42
            },
            {
              "x": 10.9,
              "y": 14.79
            },
            {
              "x": 50.0,
              "y": -0.14
            },
            {
              "x": 38.26,
              "y": 5.29
            },
            {
              "x": 34.35,
              "y": -24.9
            },
            {
              "x": 26.75,
              "y": -25.22
            },
            {
              "x": 2.49,
              "y": -10.75
            },
            {
              "x": 38.31,
              "y": -0.48
            },
            {
              "x": 31.34,
              "y": -15.71
            },
            {
              "x": 37.18,
              "y": -12.14
            },
            {
              "x": 30.71,
              "y": -0.77
            }
          ],
          "awayPlayers": [
            {
              "x": 18.04,
              "y": -5.81
            },
            {
              "x": 27.88,
              "y": -23.17
            },
            {
              "x": -29.74,
              "y": -2.07
            },
            {
              "x": 38.46,
              "y": 1.27
            },
            {
              "x": 0.55,
              "y": 0.29
            },
            {
              "x": 34.42,
              "y": -13.04
            },
            {
              "x": 11.41,
              "y": 12.97
            },
            {
              "x": 23.08,
              "y": -0.04
            },
            {
              "x": 37.3,
              "y": 10.11
            },
            {
              "x": 32.92,
              "y": -25.02
            },
            {
              "x": 1.47,
              "y": -13.19
            }
          ],
          "time": 10.677
        },
        {
          "ball": {
            "x": 32.31,
            "y": -27.0,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 12.92,
              "y": -14.69
            },
            {
              "x": 11.49,
              "y": 14.45
            },
            {
              "x": 50.02,
              "y": -0.16
            },
            {
              "x": 38.38,
              "y": 4.97
            },
            {
              "x": 33.45,
              "y": -26.58
            },
            {
              "x": 28.41,
              "y": -24.96
            },
            {
              "x": 2.86,
              "y": -11.35
            },
            {
              "x": 38.6,
              "y": -0.75
            },
            {
              "x": 32.49,
              "y": -16.39
            },
            {
              "x": 37.2,
              "y": -13.08
            },
            {
              "x": 30.89,
              "y": -1.2
            }
          ],
          "awayPlayers": [
            {
              "x": 18.55,
              "y": -6.34
            },
            {
              "x": 29.68,
              "y": -23.18
            },
            {
              "x": -29.57,
              "y": -2.18
            },
            {
              "x": 38.49,
              "y": 1.04
            },
            {
              "x": 0.81,
              "y": -0.07
            },
            {
              "x": 34.65,
              "y": -13.22
            },
            {
              "x": 11.75,
              "y": 12.7
            },
            {
              "x": 23.37,
              "y": -0.35
            },
            {
              "x": 37.37,
              "y": 9.99
            },
            {
              "x": 32.68,
              "y": -26.61
            },
            {
              "x": 1.8,
              "y": -13.7
            }
          ],
          "time": 11.011
        },
        {
          "ball": {
            "x": 31.9,
            "y": -27.78,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 13.53,
              "y": -15.13
            },
            {
              "x": 12.03,
              "y": 14.14
            },
            {
              "x": 50.05,
              "y": -0.18
            },
            {
              "x": 38.46,
              "y": 4.63
            },
            {
              "x": 32.77,
              "y": -27.89
            },
            {
              "x": 30.11,
              "y": -24.89
            },
            {
              "x": 3.19,
              "y": -12.18
            },
            {
              "x": 38.76,
              "y": -1.08
            },
            {
              "x": 33.7,
              "y": -17.17
            },
            {
              "x": 37.38,
              "y": -13.85
            },
            {
              "x": 31.13,
              "y": -1.57
            }
          ],
          "awayPlayers": [
            {
              "x": 19.2,
              "y": -7.38
            },
            {
              "x": 31.45,
              "y": -23.39
            },
            {
              "x": -29.42,
              "y": -2.3
            },
            {
              "x": 38.52,
              "y": 0.77
            },
            {
              "x": 1.08,
              "y": -0.56
            },
            {
              "x": 34.72,
              "y": -13.46
            },
            {
              "x": 12.1,
              "y": 12.34
            },
            {
              "x": 23.58,
              "y": -0.53
            },
            {
              "x": 37.46,
              "y": 9.93
            },
            {
              "x": 32.16,
              "y": -27.65
            },
            {
              "x": 2.03,
              "y": -14.27
            }
          ],
          "time": 11.345
        },
        {
          "ball": {
            "x": 30.77,
            "y": -27.84,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 15.22,
              "y": -15.49
            },
            {
              "x": 12.47,
              "y": 13.76
            },
            {
              "x": 50.07,
              "y": -0.22
            },
            {
              "x": 38.48,
              "y": 4.26
            },
            {
              "x": 32.08,
              "y": -28.66
            },
            {
              "x": 31.5,
              "y": -25.05
            },
            {
              "x": 3.48,
              "y": -12.83
            },
            {
              "x": 38.82,
              "y": -1.55
            },
            {
              "x": 34.72,
              "y": -18.05
            },
            {
              "x": 37.51,
              "y": -14.4
            },
            {
              "x": 31.28,
              "y": -1.92
            }
          ],
          "awayPlayers": [
            {
              "x": 19.91,
              "y": -8.62
            },
            {
              "x": 33.04,
              "y": -23.79
            },
            {
              "x": -29.32,
              "y": -2.41
            },
            {
              "x": 38.51,
              "y": 0.45
            },
            {
              "x": 1.3,
              "y": -1.01
            },
            {
              "x": 34.66,
              "y": -13.74
            },
            {
              "x": 12.29,
              "y": 11.99
            },
            {
              "x": 23.74,
              "y": -0.77
            },
            {
              "x": 37.48,
              "y": 9.82
            },
            {
              "x": 31.2,
              "y": -28.09
            },
            {
              "x": 2.21,
              "y": -14.8
            }
          ],
          "time": 11.678
        },
        {
          "ball": {
            "x": 29.86,
            "y": -27.19,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 16.79,
              "y": -15.86
            },
            {
              "x": 12.94,
              "y": 13.31
            },
            {
              "x": 50.04,
              "y": -0.29
            },
            {
              "x": 38.37,
              "y": 3.98
            },
            {
              "x": 31.17,
              "y": -28.79
            },
            {
              "x": 32.34,
              "y": -25.34
            },
            {
              "x": 3.74,
              "y": -13.75
            },
            {
              "x": 38.74,
              "y": -2.08
            },
            {
              "x": 35.39,
              "y": -18.56
            },
            {
              "x": 37.32,
              "y": -14.65
            },
            {
              "x": 31.25,
              "y": -2.22
            }
          ],
          "awayPlayers": [
            {
              "x": 20.43,
              "y": -9.87
            },
            {
              "x": 34.19,
              "y": -24.41
            },
            {
              "x": -29.27,
              "y": -2.52
            },
            {
              "x": 38.38,
              "y": 0.05
            },
            {
              "x": 1.53,
              "y": -1.58
            },
            {
              "x": 34.45,
              "y": -14.02
            },
            {
              "x": 12.51,
              "y": 11.5
            },
            {
              "x": 23.84,
              "y": -1.07
            },
            {
              "x": 37.33,
              "y": 9.65
            },
            {
              "x": 30.16,
              "y": -27.92
            },
            {
              "x": 2.34,
              "y": -15.52
            }
          ],
          "time": 12.012
        },
        {
          "ball": {
            "x": 29.22,
            "y": -26.47,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 18.86,
              "y": -16.07
            },
            {
              "x": 13.34,
              "y": 12.9
            },
            {
              "x": 50.04,
              "y": -0.34
            },
            {
              "x": 38.16,
              "y": 3.79
            },
            {
              "x": 30.25,
              "y": -28.02
            },
            {
              "x": 32.81,
              "y": -25.51
            },
            {
              "x": 4.09,
              "y": -14.44
            },
            {
              "x": 38.45,
              "y": -2.54
            },
            {
              "x": 35.63,
              "y": -18.62
            },
            {
              "x": 36.81,
              "y": -14.67
            },
            {
              "x": 31.08,
              "y": -2.57
            }
          ],
          "awayPlayers": [
            {
              "x": 20.84,
              "y": -10.67
            },
            {
              "x": 34.91,
              "y": -24.82
            },
            {
              "x": -29.18,
              "y": -2.61
            },
            {
              "x": 38.19,
              "y": -0.32
            },
            {
              "x": 1.7,
              "y": -2.03
            },
            {
              "x": 34.16,
              "y": -14.17
            },
            {
              "x": 12.63,
              "y": 11.11
            },
            {
              "x": 23.84,
              "y": -1.41
            },
            {
              "x": 37.1,
              "y": 9.53
            },
            {
              "x": 29.25,
              "y": -27.13
            },
            {
              "x": 2.54,
              "y": -16.03
            }
          ],
          "time": 12.346
        },
        {
          "ball": {
            "x": 28.81,
            "y": -25.05,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 19.72,
              "y": -16.12
            },
            {
              "x": 13.7,
              "y": 12.74
            },
            {
              "x": 50.05,
              "y": -0.42
            },
            {
              "x": 37.87,
              "y": 3.63
            },
            {
              "x": 29.66,
              "y": -26.52
            },
            {
              "x": 33.22,
              "y": -25.29
            },
            {
              "x": 4.32,
              "y": -14.86
            },
            {
              "x": 37.92,
              "y": -2.91
            },
            {
              "x": 35.44,
              "y": -18.25
            },
            {
              "x": 36.14,
              "y": -14.5
            },
            {
              "x": 30.9,
              "y": -2.84
            }
          ],
          "awayPlayers": [
            {
              "x": 21.18,
              "y": -11.14
            },
            {
              "x": 35.35,
              "y": -24.61
            },
            {
              "x": -29.11,
              "y": -2.68
            },
            {
              "x": 37.93,
              "y": -0.66
            },
            {
              "x": 1.91,
              "y": -2.34
            },
            {
              "x": 33.87,
              "y": -14.11
            },
            {
              "x": 12.73,
              "y": 10.84
            },
            {
              "x": 23.79,
              "y": -1.69
            },
            {
              "x": 36.9,
              "y": 9.58
            },
            {
              "x": 28.8,
              "y": -25.71
            },
            {
              "x": 2.76,
              "y": -16.32
            }
          ],
          "time": 12.679
        },
        {
          "ball": {
            "x": 28.58,
            "y": -22.88,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 20.61,
              "y": -15.98
            },
            {
              "x": 13.82,
              "y": 12.65
            },
            {
              "x": 50.19,
              "y": -0.48
            },
            {
              "x": 37.58,
              "y": 3.51
            },
            {
              "x": 29.45,
              "y": -24.53
            },
            {
              "x": 33.65,
              "y": -24.69
            },
            {
              "x": 4.42,
              "y": -15.0
            },
            {
              "x": 37.27,
              "y": -3.25
            },
            {
              "x": 35.29,
              "y": -17.65
            },
            {
              "x": 35.5,
              "y": -14.17
            },
            {
              "x": 30.75,
              "y": -3.04
            }
          ],
          "awayPlayers": [
            {
              "x": 21.55,
              "y": -11.36
            },
            {
              "x": 35.62,
              "y": -23.68
            },
            {
              "x": -29.08,
              "y": -2.71
            },
            {
              "x": 37.62,
              "y": -0.94
            },
            {
              "x": 2.04,
              "y": -2.52
            },
            {
              "x": 33.67,
              "y": -13.86
            },
            {
              "x": 12.7,
              "y": 10.66
            },
            {
              "x": 23.74,
              "y": -1.77
            },
            {
              "x": 36.68,
              "y": 9.84
            },
            {
              "x": 28.79,
              "y": -23.74
            },
            {
              "x": 2.91,
              "y": -16.39
            }
          ],
          "time": 13.013
        },
        {
          "ball": {
            "x": 28.36,
            "y": -21.13,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 21.43,
              "y": -15.6
            },
            {
              "x": 14.02,
              "y": 12.59
            },
            {
              "x": 50.31,
              "y": -0.68
            },
            {
              "x": 37.22,
              "y": 3.25
            },
            {
              "x": 29.41,
              "y": -22.23
            },
            {
              "x": 34.1,
              "y": -23.59
            },
            {
              "x": 4.62,
              "y": -15.07
            },
            {
              "x": 36.54,
              "y": -3.78
            },
            {
              "x": 35.33,
              "y": -16.98
            },
            {
              "x": 35.05,
              "y": -13.63
            },
            {
              "x": 30.63,
              "y": -3.15
            }
          ],
          "awayPlayers": [
            {
              "x": 21.89,
              "y": -11.44
            },
            {
              "x": 35.76,
              "y": -22.36
            },
            {
              "x": -29.0,
              "y": -2.69
            },
            {
              "x": 37.26,
              "y": -1.11
            },
            {
              "x": 2.11,
              "y": -2.53
            },
            {
              "x": 33.55,
              "y": -13.52
            },
            {
              "x": 12.66,
              "y": 10.53
            },
            {
              "x": 23.62,
              "y": -1.82
            },
            {
              "x": 36.45,
              "y": 10.21
            },
            {
              "x": 28.78,
              "y": -21.7
            },
            {
              "x": 2.96,
              "y": -16.32
            }
          ],
          "time": 13.347
        },
        {
          "ball": {
            "x": 28.1,
            "y": -19.83,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.23,
              "y": -15.06
            },
            {
              "x": 14.22,
              "y": 12.56
            },
            {
              "x": 50.48,
              "y": -0.79
            },
            {
              "x": 36.84,
              "y": 3.04
            },
            {
              "x": 29.25,
              "y": -20.24
            },
            {
              "x": 34.31,
              "y": -22.46
            },
            {
              "x": 4.77,
              "y": -15.12
            },
            {
              "x": 35.94,
              "y": -4.12
            },
            {
              "x": 35.68,
              "y": -16.26
            },
            {
              "x": 34.77,
              "y": -12.99
            },
            {
              "x": 30.5,
              "y": -3.08
            }
          ],
          "awayPlayers": [
            {
              "x": 22.13,
              "y": -11.4
            },
            {
              "x": 35.61,
              "y": -21.18
            },
            {
              "x": -28.97,
              "y": -2.66
            },
            {
              "x": 36.86,
              "y": -1.25
            },
            {
              "x": 2.19,
              "y": -2.54
            },
            {
              "x": 33.51,
              "y": -13.1
            },
            {
              "x": 12.63,
              "y": 10.44
            },
            {
              "x": 23.41,
              "y": -1.7
            },
            {
              "x": 36.28,
              "y": 10.8
            },
            {
              "x": 28.42,
              "y": -19.56
            },
            {
              "x": 3.13,
              "y": -16.32
            }
          ],
          "time": 13.68
        },
        {
          "ball": {
            "x": 27.89,
            "y": -18.89,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 22.93,
              "y": -14.74
            },
            {
              "x": 14.35,
              "y": 12.58
            },
            {
              "x": 50.51,
              "y": -0.86
            },
            {
              "x": 36.45,
              "y": 2.9
            },
            {
              "x": 28.77,
              "y": -19.06
            },
            {
              "x": 34.24,
              "y": -21.37
            },
            {
              "x": 4.87,
              "y": -15.11
            },
            {
              "x": 35.52,
              "y": -4.22
            },
            {
              "x": 35.84,
              "y": -15.63
            },
            {
              "x": 34.49,
              "y": -12.5
            },
            {
              "x": 30.19,
              "y": -2.99
            }
          ],
          "awayPlayers": [
            {
              "x": 22.18,
              "y": -11.31
            },
            {
              "x": 35.37,
              "y": -20.33
            },
            {
              "x": -28.91,
              "y": -2.62
            },
            {
              "x": 36.42,
              "y": -1.44
            },
            {
              "x": 2.28,
              "y": -2.52
            },
            {
              "x": 33.49,
              "y": -12.72
            },
            {
              "x": 12.7,
              "y": 10.41
            },
            {
              "x": 23.11,
              "y": -1.54
            },
            {
              "x": 36.16,
              "y": 11.34
            },
            {
              "x": 28.14,
              "y": -19.06
            },
            {
              "x": 3.2,
              "y": -16.25
            }
          ],
          "time": 14.014
        },
        {
          "ball": {
            "x": 27.41,
            "y": -18.68,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": 23.51,
              "y": -14.93
            },
            {
              "x": 14.27,
              "y": 12.7
            },
            {
              "x": 50.55,
              "y": -0.85
            },
            {
              "x": 36.14,
              "y": 2.85
            },
            {
              "x": 28.05,
              "y": -18.64
            },
            {
              "x": 33.86,
              "y": -20.77
            },
            {
              "x": 4.8,
              "y": -15.19
            },
            {
              "x": 35.29,
              "y": -4.09
            },
            {
              "x": 35.84,
              "y": -15.11
            },
            {
              "x": 34.23,
              "y": -12.17
            },
            {
              "x": 29.78,
              "y": -2.85
            }
          ],
          "awayPlayers": [
            {
              "x": 22.07,
              "y": -11.18
            },
            {
              "x": 35.01,
              "y": -20.02
            },
            {
              "x": -28.89,
              "y": -2.61
            },
            {
              "x": 35.96,
              "y": -1.69
            },
            {
              "x": 2.18,
              "y": -2.49
            },
            {
              "x": 33.46,
              "y": -12.38
            },
            {
              "x": 12.46,
              "y": 10.51
            },
            {
              "x": 22.7,
              "y": -1.33
            },
            {
              "x": 36.06,
              "y": 11.84
            },
            {
              "x": 27.91,
              "y": -19.05
            },
            {
              "x": 3.15,
              "y": -16.17
            }
          ],
          "time": 14.348
        },
        {
          "ball": {
            "x": 27.01,
            "y": -17.95,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": 23.91,
              "y": -15.61
            },
            {
              "x": 14.06,
              "y": 12.82
            },
            {
              "x": 50.56,
              "y": -0.86
            },
            {
              "x": 35.89,
              "y": 2.83
            },
            {
              "x": 27.27,
              "y": -18.41
            },
            {
              "x": 33.41,
              "y": -20.46
            },
            {
              "x": 4.65,
              "y": -15.43
            },
            {
              "x": 35.09,
              "y": -4.04
            },
            {
              "x": 35.55,
              "y": -14.73
            },
            {
              "x": 33.99,
              "y": -11.89
            },
            {
              "x": 29.37,
              "y": -2.83
            }
          ],
          "awayPlayers": [
            {
              "x": 21.91,
              "y": -11.05
            },
            {
              "x": 34.69,
              "y": -19.9
            },
            {
              "x": -28.92,
              "y": -2.57
            },
            {
              "x": 35.51,
              "y": -1.95
            },
            {
              "x": 2.06,
              "y": -2.46
            },
            {
              "x": 33.32,
              "y": -12.16
            },
            {
              "x": 12.25,
              "y": 10.58
            },
            {
              "x": 22.25,
              "y": -1.26
            },
            {
              "x": 35.93,
              "y": 12.19
            },
            {
              "x": 27.95,
              "y": -19.66
            },
            {
              "x": 3.04,
              "y": -16.19
            }
          ],
          "time": 14.681
        },
        {
          "ball": {
            "x": 26.74,
            "y": -17.22,
            "z": 0.17
          },
          "homePlayers": [
            {
              "x": 24.27,
              "y": -16.26
            },
            {
              "x": 13.97,
              "y": 12.96
            },
            {
              "x": 50.6,
              "y": -0.83
            },
            {
              "x": 35.62,
              "y": 2.8
            },
            {
              "x": 26.63,
              "y": -18.14
            },
            {
              "x": 33.04,
              "y": -20.31
            },
            {
              "x": 4.61,
              "y": -15.7
            },
            {
              "x": 34.84,
              "y": -4.08
            },
            {
              "x": 35.13,
              "y": -14.46
            },
            {
              "x": 33.75,
              "y": -11.61
            },
            {
              "x": 29.05,
              "y": -2.7
            }
          ],
          "awayPlayers": [
            {
              "x": 21.81,
              "y": -10.98
            },
            {
              "x": 34.38,
              "y": -19.72
            },
            {
              "x": -28.93,
              "y": -2.53
            },
            {
              "x": 35.1,
              "y": -2.2
            },
            {
              "x": 1.9,
              "y": -2.43
            },
            {
              "x": 33.1,
              "y": -11.97
            },
            {
              "x": 11.95,
              "y": 10.69
            },
            {
              "x": 21.82,
              "y": -1.19
            },
            {
              "x": 35.79,
              "y": 12.57
            },
            {
              "x": 27.88,
              "y": -20.17
            },
            {
              "x": 2.95,
              "y": -16.16
            }
          ],
          "time": 15.015
        },
        {
          "ball": {
            "x": 26.38,
            "y": -16.33,
            "z": 0.36
          },
          "homePlayers": [
            {
              "x": 24.79,
              "y": -16.29
            },
            {
              "x": 14.33,
              "y": 13.0
            },
            {
              "x": 50.65,
              "y": -0.77
            },
            {
              "x": 35.35,
              "y": 2.81
            },
            {
              "x": 26.11,
              "y": -17.91
            },
            {
              "x": 32.66,
              "y": -20.08
            },
            {
              "x": 4.81,
              "y": -15.97
            },
            {
              "x": 34.59,
              "y": -4.08
            },
            {
              "x": 34.65,
              "y": -14.17
            },
            {
              "x": 33.49,
              "y": -11.25
            },
            {
              "x": 28.78,
              "y": -2.57
            }
          ],
          "awayPlayers": [
            {
              "x": 21.79,
              "y": -10.93
            },
            {
              "x": 34.04,
              "y": -19.37
            },
            {
              "x": -28.91,
              "y": -2.5
            },
            {
              "x": 34.66,
              "y": -2.44
            },
            {
              "x": 1.97,
              "y": -2.33
            },
            {
              "x": 32.8,
              "y": -11.79
            },
            {
              "x": 12.08,
              "y": 10.79
            },
            {
              "x": 21.39,
              "y": -1.17
            },
            {
              "x": 35.61,
              "y": 12.89
            },
            {
              "x": 27.23,
              "y": -19.64
            },
            {
              "x": 3.06,
              "y": -16.14
            }
          ],
          "time": 15.349
        },
        {
          "ball": {
            "x": 25.88,
            "y": -13.88,
            "z": 0.18
          },
          "homePlayers": [
            {
              "x": 25.28,
              "y": -16.05
            },
            {
              "x": 14.72,
              "y": 12.94
            },
            {
              "x": 50.69,
              "y": -0.62
            },
            {
              "x": 35.07,
              "y": 2.84
            },
            {
              "x": 25.93,
              "y": -17.55
            },
            {
              "x": 32.14,
              "y": -20.07
            },
            {
              "x": 5.1,
              "y": -16.23
            },
            {
              "x": 34.36,
              "y": -4.07
            },
            {
              "x": 34.16,
              "y": -13.88
            },
            {
              "x": 33.16,
              "y": -11.06
            },
            {
              "x": 28.54,
              "y": -2.41
            }
          ],
          "awayPlayers": [
            {
              "x": 21.91,
              "y": -10.82
            },
            {
              "x": 33.55,
              "y": -18.96
            },
            {
              "x": -28.93,
              "y": -2.48
            },
            {
              "x": 34.23,
              "y": -2.67
            },
            {
              "x": 2.03,
              "y": -2.27
            },
            {
              "x": 32.45,
              "y": -11.63
            },
            {
              "x": 12.2,
              "y": 10.89
            },
            {
              "x": 21.0,
              "y": -1.16
            },
            {
              "x": 35.38,
              "y": 13.2
            },
            {
              "x": 26.29,
              "y": -18.57
            },
            {
              "x": 3.11,
              "y": -16.1
            }
          ],
          "time": 15.682
        },
        {
          "ball": {
            "x": 24.42,
            "y": -11.68,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.57,
              "y": -15.63
            },
            {
              "x": 15.23,
              "y": 12.86
            },
            {
              "x": 50.69,
              "y": -0.47
            },
            {
              "x": 34.79,
              "y": 2.84
            },
            {
              "x": 25.9,
              "y": -17.31
            },
            {
              "x": 31.45,
              "y": -20.36
            },
            {
              "x": 5.36,
              "y": -16.61
            },
            {
              "x": 34.11,
              "y": -4.01
            },
            {
              "x": 33.66,
              "y": -13.72
            },
            {
              "x": 32.78,
              "y": -11.01
            },
            {
              "x": 28.26,
              "y": -2.35
            }
          ],
          "awayPlayers": [
            {
              "x": 22.09,
              "y": -10.63
            },
            {
              "x": 32.98,
              "y": -18.6
            },
            {
              "x": -28.9,
              "y": -2.44
            },
            {
              "x": 33.81,
              "y": -2.9
            },
            {
              "x": 2.04,
              "y": -2.12
            },
            {
              "x": 32.01,
              "y": -11.59
            },
            {
              "x": 12.32,
              "y": 11.02
            },
            {
              "x": 20.55,
              "y": -1.3
            },
            {
              "x": 35.08,
              "y": 13.43
            },
            {
              "x": 25.61,
              "y": -17.73
            },
            {
              "x": 3.06,
              "y": -16.02
            }
          ],
          "time": 16.016
        },
        {
          "ball": {
            "x": 23.15,
            "y": -9.64,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": 25.6,
              "y": -14.93
            },
            {
              "x": 15.7,
              "y": 12.75
            },
            {
              "x": 49.94,
              "y": -0.64
            },
            {
              "x": 34.37,
              "y": 2.84
            },
            {
              "x": 26.01,
              "y": -17.18
            },
            {
              "x": 30.7,
              "y": -20.81
            },
            {
              "x": 5.6,
              "y": -17.22
            },
            {
              "x": 33.85,
              "y": -4.02
            },
            {
              "x": 33.17,
              "y": -13.6
            },
            {
              "x": 32.41,
              "y": -10.74
            },
            {
              "x": 27.84,
              "y": -2.47
            }
          ],
          "awayPlayers": [
            {
              "x": 22.25,
              "y": -10.28
            },
            {
              "x": 32.58,
              "y": -18.35
            },
            {
              "x": -28.93,
              "y": -2.39
            },
            {
              "x": 33.39,
              "y": -3.2
            },
            {
              "x": 1.93,
              "y": -2.08
            },
            {
              "x": 31.6,
              "y": -11.57
            },
            {
              "x": 12.03,
              "y": 11.07
            },
            {
              "x": 20.12,
              "y": -1.51
            },
            {
              "x": 34.61,
              "y": 13.73
            },
            {
              "x": 25.49,
              "y": -17.48
            },
            {
              "x": 3.02,
              "y": -16.03
            }
          ],
          "time": 16.35
        }
      ],
      "duration": 16.35,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/ad591583-5d76-4979-9ff7-718646818cd3/1417.885"
    },
    {
      "id": "3855_18.0_subset1",
      "matchId": "3855",
      "sequenceId": "18.0_subset1",
      "dtwScore": 0.11592649986139468,
      "frames": [
        {
          "ball": {
            "x": -13.93,
            "y": -0.22,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.44,
              "y": 19.23
            },
            {
              "x": -28.04,
              "y": 15.1
            },
            {
              "x": -30.75,
              "y": 8.36
            },
            {
              "x": -24.23,
              "y": 5.28
            },
            {
              "x": -15.7,
              "y": 6.93
            },
            {
              "x": -25.47,
              "y": 23.29
            },
            {
              "x": -28.71,
              "y": -0.47
            },
            {
              "x": -20.03,
              "y": 12.82
            },
            {
              "x": -21.95,
              "y": -13.55
            },
            {
              "x": -46.62,
              "y": 0.42
            },
            {
              "x": -29.15,
              "y": -4.62
            }
          ],
          "awayPlayers": [
            {
              "x": -14.56,
              "y": -0.01
            },
            {
              "x": -16.86,
              "y": 11.28
            },
            {
              "x": 25.0,
              "y": 2.0
            },
            {
              "x": -11.16,
              "y": 17.61
            },
            {
              "x": -28.78,
              "y": 24.77
            },
            {
              "x": -25.29,
              "y": 19.78
            },
            {
              "x": -25.38,
              "y": -6.51
            },
            {
              "x": -29.05,
              "y": -27.68
            },
            {
              "x": -30.13,
              "y": 12.2
            },
            {
              "x": -15.03,
              "y": -20.76
            },
            {
              "x": -6.9,
              "y": -3.23
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": -13.72,
            "y": -1.67,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.17,
              "y": 18.7
            },
            {
              "x": -28.62,
              "y": 14.02
            },
            {
              "x": -30.91,
              "y": 7.45
            },
            {
              "x": -24.1,
              "y": 3.99
            },
            {
              "x": -15.54,
              "y": 5.46
            },
            {
              "x": -25.15,
              "y": 22.11
            },
            {
              "x": -28.6,
              "y": -2.13
            },
            {
              "x": -20.82,
              "y": 11.67
            },
            {
              "x": -22.16,
              "y": -13.99
            },
            {
              "x": -46.73,
              "y": 0.26
            },
            {
              "x": -28.89,
              "y": -5.52
            }
          ],
          "awayPlayers": [
            {
              "x": -14.06,
              "y": -0.66
            },
            {
              "x": -17.94,
              "y": 9.57
            },
            {
              "x": 25.0,
              "y": 1.67
            },
            {
              "x": -11.42,
              "y": 17.24
            },
            {
              "x": -28.71,
              "y": 23.81
            },
            {
              "x": -25.54,
              "y": 19.2
            },
            {
              "x": -25.21,
              "y": -7.24
            },
            {
              "x": -29.21,
              "y": -28.03
            },
            {
              "x": -30.55,
              "y": 11.51
            },
            {
              "x": -15.4,
              "y": -21.37
            },
            {
              "x": -7.02,
              "y": -3.62
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": -13.55,
            "y": -2.83,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.08,
              "y": 18.2
            },
            {
              "x": -29.32,
              "y": 12.98
            },
            {
              "x": -31.06,
              "y": 6.35
            },
            {
              "x": -24.06,
              "y": 2.58
            },
            {
              "x": -15.42,
              "y": 3.81
            },
            {
              "x": -24.93,
              "y": 21.1
            },
            {
              "x": -28.57,
              "y": -3.63
            },
            {
              "x": -21.7,
              "y": 10.44
            },
            {
              "x": -22.51,
              "y": -14.48
            },
            {
              "x": -46.84,
              "y": 0.11
            },
            {
              "x": -28.63,
              "y": -6.54
            }
          ],
          "awayPlayers": [
            {
              "x": -13.69,
              "y": -1.78
            },
            {
              "x": -19.2,
              "y": 7.82
            },
            {
              "x": 25.0,
              "y": 1.27
            },
            {
              "x": -11.72,
              "y": 16.91
            },
            {
              "x": -28.59,
              "y": 22.83
            },
            {
              "x": -25.77,
              "y": 18.49
            },
            {
              "x": -24.96,
              "y": -8.04
            },
            {
              "x": -29.42,
              "y": -28.33
            },
            {
              "x": -30.94,
              "y": 10.6
            },
            {
              "x": -15.82,
              "y": -22.03
            },
            {
              "x": -7.15,
              "y": -4.02
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": -14.0,
            "y": -3.93,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.15,
              "y": 17.66
            },
            {
              "x": -30.09,
              "y": 11.93
            },
            {
              "x": -31.2,
              "y": 5.15
            },
            {
              "x": -24.11,
              "y": 1.01
            },
            {
              "x": -15.41,
              "y": 1.96
            },
            {
              "x": -24.77,
              "y": 20.0
            },
            {
              "x": -28.38,
              "y": -5.13
            },
            {
              "x": -22.61,
              "y": 9.17
            },
            {
              "x": -23.02,
              "y": -14.88
            },
            {
              "x": -47.01,
              "y": -0.08
            },
            {
              "x": -28.19,
              "y": -7.54
            }
          ],
          "awayPlayers": [
            {
              "x": -13.57,
              "y": -3.22
            },
            {
              "x": -20.6,
              "y": 6.1
            },
            {
              "x": 25.0,
              "y": 0.82
            },
            {
              "x": -12.07,
              "y": 16.54
            },
            {
              "x": -28.38,
              "y": 21.85
            },
            {
              "x": -25.9,
              "y": 17.71
            },
            {
              "x": -24.57,
              "y": -8.98
            },
            {
              "x": -29.63,
              "y": -28.68
            },
            {
              "x": -31.22,
              "y": 9.57
            },
            {
              "x": -16.22,
              "y": -22.81
            },
            {
              "x": -7.34,
              "y": -4.41
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": -15.05,
            "y": -5.08,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.29,
              "y": 17.05
            },
            {
              "x": -30.84,
              "y": 10.87
            },
            {
              "x": -31.31,
              "y": 3.9
            },
            {
              "x": -24.19,
              "y": -0.65
            },
            {
              "x": -15.68,
              "y": 0.46
            },
            {
              "x": -24.66,
              "y": 18.77
            },
            {
              "x": -28.19,
              "y": -6.73
            },
            {
              "x": -23.53,
              "y": 7.98
            },
            {
              "x": -23.56,
              "y": -14.8
            },
            {
              "x": -47.09,
              "y": -0.22
            },
            {
              "x": -27.67,
              "y": -8.23
            }
          ],
          "awayPlayers": [
            {
              "x": -13.98,
              "y": -4.52
            },
            {
              "x": -22.12,
              "y": 4.34
            },
            {
              "x": 25.0,
              "y": 0.41
            },
            {
              "x": -12.47,
              "y": 16.16
            },
            {
              "x": -28.05,
              "y": 20.82
            },
            {
              "x": -25.8,
              "y": 16.82
            },
            {
              "x": -24.05,
              "y": -9.68
            },
            {
              "x": -29.71,
              "y": -28.81
            },
            {
              "x": -31.39,
              "y": 8.38
            },
            {
              "x": -16.61,
              "y": -23.51
            },
            {
              "x": -7.64,
              "y": -4.72
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": -15.85,
            "y": -5.97,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.46,
              "y": 16.27
            },
            {
              "x": -31.49,
              "y": 9.88
            },
            {
              "x": -31.45,
              "y": 2.55
            },
            {
              "x": -24.42,
              "y": -1.93
            },
            {
              "x": -16.16,
              "y": -1.0
            },
            {
              "x": -24.64,
              "y": 17.49
            },
            {
              "x": -27.85,
              "y": -8.3
            },
            {
              "x": -24.35,
              "y": 6.55
            },
            {
              "x": -23.91,
              "y": -14.4
            },
            {
              "x": -47.16,
              "y": -0.34
            },
            {
              "x": -27.08,
              "y": -8.54
            }
          ],
          "awayPlayers": [
            {
              "x": -14.94,
              "y": -5.53
            },
            {
              "x": -23.9,
              "y": 2.69
            },
            {
              "x": 25.0,
              "y": -0.02
            },
            {
              "x": -12.88,
              "y": 15.73
            },
            {
              "x": -27.61,
              "y": 19.74
            },
            {
              "x": -25.4,
              "y": 15.82
            },
            {
              "x": -23.51,
              "y": -10.16
            },
            {
              "x": -29.79,
              "y": -29.05
            },
            {
              "x": -31.48,
              "y": 7.19
            },
            {
              "x": -17.02,
              "y": -24.16
            },
            {
              "x": -7.97,
              "y": -5.02
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": -17.01,
            "y": -6.84,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -32.75,
              "y": 15.74
            },
            {
              "x": -32.0,
              "y": 8.86
            },
            {
              "x": -31.76,
              "y": 1.04
            },
            {
              "x": -24.83,
              "y": -2.91
            },
            {
              "x": -16.87,
              "y": -2.69
            },
            {
              "x": -24.74,
              "y": 16.25
            },
            {
              "x": -28.6,
              "y": -12.07
            },
            {
              "x": -25.22,
              "y": 5.07
            },
            {
              "x": -24.01,
              "y": -13.68
            },
            {
              "x": -47.23,
              "y": -0.4
            },
            {
              "x": -26.59,
              "y": -8.85
            }
          ],
          "awayPlayers": [
            {
              "x": -16.21,
              "y": -6.43
            },
            {
              "x": -25.87,
              "y": 0.86
            },
            {
              "x": 25.0,
              "y": -0.27
            },
            {
              "x": -13.29,
              "y": 15.31
            },
            {
              "x": -27.18,
              "y": 18.69
            },
            {
              "x": -24.84,
              "y": 14.86
            },
            {
              "x": -23.19,
              "y": -10.37
            },
            {
              "x": -29.95,
              "y": -29.05
            },
            {
              "x": -31.58,
              "y": 5.97
            },
            {
              "x": -17.54,
              "y": -24.84
            },
            {
              "x": -8.36,
              "y": -5.41
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": -18.81,
            "y": -7.85,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -33.06,
              "y": 15.21
            },
            {
              "x": -32.4,
              "y": 7.62
            },
            {
              "x": -32.32,
              "y": -0.77
            },
            {
              "x": -25.42,
              "y": -3.82
            },
            {
              "x": -17.82,
              "y": -4.52
            },
            {
              "x": -25.01,
              "y": 15.02
            },
            {
              "x": -29.64,
              "y": -15.76
            },
            {
              "x": -26.29,
              "y": 3.79
            },
            {
              "x": -24.0,
              "y": -12.98
            },
            {
              "x": -47.31,
              "y": -0.48
            },
            {
              "x": -26.45,
              "y": -9.16
            }
          ],
          "awayPlayers": [
            {
              "x": -17.75,
              "y": -7.24
            },
            {
              "x": -27.94,
              "y": -1.13
            },
            {
              "x": 25.0,
              "y": -0.56
            },
            {
              "x": -13.78,
              "y": 14.78
            },
            {
              "x": -26.89,
              "y": 17.67
            },
            {
              "x": -24.22,
              "y": 13.83
            },
            {
              "x": -23.27,
              "y": -10.66
            },
            {
              "x": -30.18,
              "y": -29.06
            },
            {
              "x": -31.88,
              "y": 4.85
            },
            {
              "x": -18.3,
              "y": -25.36
            },
            {
              "x": -8.53,
              "y": -5.61
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": -20.32,
            "y": -8.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -33.29,
              "y": 14.6
            },
            {
              "x": -32.83,
              "y": 6.24
            },
            {
              "x": -33.05,
              "y": -2.69
            },
            {
              "x": -26.04,
              "y": -5.0
            },
            {
              "x": -19.11,
              "y": -6.18
            },
            {
              "x": -25.34,
              "y": 13.74
            },
            {
              "x": -30.81,
              "y": -19.43
            },
            {
              "x": -27.45,
              "y": 2.49
            },
            {
              "x": -23.98,
              "y": -12.35
            },
            {
              "x": -47.45,
              "y": -0.52
            },
            {
              "x": -26.8,
              "y": -9.42
            }
          ],
          "awayPlayers": [
            {
              "x": -19.38,
              "y": -8.12
            },
            {
              "x": -29.82,
              "y": -3.57
            },
            {
              "x": 25.0,
              "y": -0.78
            },
            {
              "x": -14.31,
              "y": 14.18
            },
            {
              "x": -26.85,
              "y": 16.97
            },
            {
              "x": -23.62,
              "y": 12.78
            },
            {
              "x": -23.79,
              "y": -11.08
            },
            {
              "x": -29.94,
              "y": -29.28
            },
            {
              "x": -32.32,
              "y": 3.48
            },
            {
              "x": -19.21,
              "y": -25.84
            },
            {
              "x": -8.47,
              "y": -5.97
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": -22.07,
            "y": -9.14,
            "z": 0.13
          },
          "homePlayers": [
            {
              "x": -33.49,
              "y": 14.04
            },
            {
              "x": -33.55,
              "y": 4.95
            },
            {
              "x": -33.92,
              "y": -4.63
            },
            {
              "x": -26.47,
              "y": -6.09
            },
            {
              "x": -20.63,
              "y": -7.32
            },
            {
              "x": -25.76,
              "y": 12.51
            },
            {
              "x": -31.22,
              "y": -20.24
            },
            {
              "x": -28.78,
              "y": 1.24
            },
            {
              "x": -23.98,
              "y": -11.8
            },
            {
              "x": -47.75,
              "y": -0.62
            },
            {
              "x": -27.48,
              "y": -9.66
            }
          ],
          "awayPlayers": [
            {
              "x": -20.97,
              "y": -8.78
            },
            {
              "x": -31.55,
              "y": -5.98
            },
            {
              "x": 25.0,
              "y": -1.05
            },
            {
              "x": -14.57,
              "y": 13.7
            },
            {
              "x": -26.87,
              "y": 16.05
            },
            {
              "x": -23.15,
              "y": 11.71
            },
            {
              "x": -24.69,
              "y": -11.69
            },
            {
              "x": -29.4,
              "y": -29.92
            },
            {
              "x": -32.93,
              "y": 1.96
            },
            {
              "x": -20.38,
              "y": -25.91
            },
            {
              "x": -8.38,
              "y": -6.74
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": -24.76,
            "y": -10.19,
            "z": 1.25
          },
          "homePlayers": [
            {
              "x": -33.73,
              "y": 13.55
            },
            {
              "x": -34.4,
              "y": 3.59
            },
            {
              "x": -34.9,
              "y": -6.25
            },
            {
              "x": -26.7,
              "y": -6.66
            },
            {
              "x": -22.1,
              "y": -8.12
            },
            {
              "x": -26.26,
              "y": 11.36
            },
            {
              "x": -31.67,
              "y": -20.37
            },
            {
              "x": -30.09,
              "y": -0.04
            },
            {
              "x": -23.86,
              "y": -11.64
            },
            {
              "x": -48.41,
              "y": -0.83
            },
            {
              "x": -28.15,
              "y": -10.15
            }
          ],
          "awayPlayers": [
            {
              "x": -22.09,
              "y": -9.61
            },
            {
              "x": -33.2,
              "y": -8.22
            },
            {
              "x": 25.0,
              "y": -1.29
            },
            {
              "x": -14.57,
              "y": 12.87
            },
            {
              "x": -27.11,
              "y": 15.19
            },
            {
              "x": -22.87,
              "y": 10.7
            },
            {
              "x": -25.69,
              "y": -12.19
            },
            {
              "x": -29.0,
              "y": -30.68
            },
            {
              "x": -33.51,
              "y": 0.48
            },
            {
              "x": -21.6,
              "y": -25.74
            },
            {
              "x": -8.22,
              "y": -7.72
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": -25.94,
            "y": -11.26,
            "z": 2.41
          },
          "homePlayers": [
            {
              "x": -34.06,
              "y": 13.07
            },
            {
              "x": -35.11,
              "y": 1.99
            },
            {
              "x": -35.84,
              "y": -7.63
            },
            {
              "x": -26.86,
              "y": -6.83
            },
            {
              "x": -23.05,
              "y": -8.72
            },
            {
              "x": -26.85,
              "y": 10.27
            },
            {
              "x": -32.12,
              "y": -20.26
            },
            {
              "x": -31.36,
              "y": -1.13
            },
            {
              "x": -23.66,
              "y": -11.7
            },
            {
              "x": -48.99,
              "y": -1.01
            },
            {
              "x": -28.88,
              "y": -10.5
            }
          ],
          "awayPlayers": [
            {
              "x": -22.63,
              "y": -10.3
            },
            {
              "x": -35.08,
              "y": -9.87
            },
            {
              "x": 25.0,
              "y": -1.51
            },
            {
              "x": -14.44,
              "y": 11.93
            },
            {
              "x": -27.51,
              "y": 14.25
            },
            {
              "x": -22.76,
              "y": 9.67
            },
            {
              "x": -26.74,
              "y": -12.63
            },
            {
              "x": -28.97,
              "y": -31.16
            },
            {
              "x": -33.78,
              "y": -0.79
            },
            {
              "x": -22.77,
              "y": -25.24
            },
            {
              "x": -8.36,
              "y": -8.79
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": -24.35,
            "y": -11.67,
            "z": 3.19
          },
          "homePlayers": [
            {
              "x": -34.32,
              "y": 12.7
            },
            {
              "x": -35.51,
              "y": 0.85
            },
            {
              "x": -36.59,
              "y": -8.51
            },
            {
              "x": -27.03,
              "y": -6.55
            },
            {
              "x": -23.44,
              "y": -9.15
            },
            {
              "x": -27.4,
              "y": 9.17
            },
            {
              "x": -32.48,
              "y": -20.12
            },
            {
              "x": -32.51,
              "y": -2.21
            },
            {
              "x": -23.36,
              "y": -12.04
            },
            {
              "x": -49.46,
              "y": -1.06
            },
            {
              "x": -29.74,
              "y": -10.62
            }
          ],
          "awayPlayers": [
            {
              "x": -22.75,
              "y": -10.59
            },
            {
              "x": -37.11,
              "y": -10.79
            },
            {
              "x": 25.0,
              "y": -1.7
            },
            {
              "x": -14.44,
              "y": 11.1
            },
            {
              "x": -27.86,
              "y": 13.5
            },
            {
              "x": -22.66,
              "y": 8.56
            },
            {
              "x": -27.77,
              "y": -12.62
            },
            {
              "x": -29.42,
              "y": -31.31
            },
            {
              "x": -33.43,
              "y": -1.61
            },
            {
              "x": -23.57,
              "y": -24.52
            },
            {
              "x": -8.48,
              "y": -9.52
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": -21.45,
            "y": -12.57,
            "z": 3.31
          },
          "homePlayers": [
            {
              "x": -34.46,
              "y": 12.44
            },
            {
              "x": -35.6,
              "y": 0.14
            },
            {
              "x": -37.09,
              "y": -8.85
            },
            {
              "x": -27.04,
              "y": -6.12
            },
            {
              "x": -23.45,
              "y": -8.93
            },
            {
              "x": -27.77,
              "y": 8.1
            },
            {
              "x": -32.71,
              "y": -19.9
            },
            {
              "x": -33.71,
              "y": -3.12
            },
            {
              "x": -22.95,
              "y": -12.33
            },
            {
              "x": -49.66,
              "y": -0.96
            },
            {
              "x": -30.68,
              "y": -10.56
            }
          ],
          "awayPlayers": [
            {
              "x": -22.76,
              "y": -10.24
            },
            {
              "x": -39.43,
              "y": -11.05
            },
            {
              "x": 25.0,
              "y": -1.87
            },
            {
              "x": -14.39,
              "y": 10.63
            },
            {
              "x": -27.91,
              "y": 12.73
            },
            {
              "x": -22.57,
              "y": 7.52
            },
            {
              "x": -28.55,
              "y": -12.54
            },
            {
              "x": -29.5,
              "y": -31.17
            },
            {
              "x": -32.55,
              "y": -2.53
            },
            {
              "x": -23.86,
              "y": -23.55
            },
            {
              "x": -8.48,
              "y": -9.97
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": -18.27,
            "y": -14.07,
            "z": 3.1
          },
          "homePlayers": [
            {
              "x": -34.4,
              "y": 12.47
            },
            {
              "x": -35.34,
              "y": 0.02
            },
            {
              "x": -37.15,
              "y": -8.73
            },
            {
              "x": -26.75,
              "y": -5.67
            },
            {
              "x": -23.07,
              "y": -8.63
            },
            {
              "x": -27.76,
              "y": 7.09
            },
            {
              "x": -32.59,
              "y": -20.06
            },
            {
              "x": -34.76,
              "y": -3.72
            },
            {
              "x": -22.33,
              "y": -12.72
            },
            {
              "x": -49.69,
              "y": -0.9
            },
            {
              "x": -31.35,
              "y": -10.56
            }
          ],
          "awayPlayers": [
            {
              "x": -22.61,
              "y": -9.82
            },
            {
              "x": -40.06,
              "y": -10.78
            },
            {
              "x": 25.0,
              "y": -1.99
            },
            {
              "x": -14.51,
              "y": 10.27
            },
            {
              "x": -27.68,
              "y": 12.19
            },
            {
              "x": -22.4,
              "y": 6.45
            },
            {
              "x": -29.01,
              "y": -12.53
            },
            {
              "x": -29.38,
              "y": -31.09
            },
            {
              "x": -31.5,
              "y": -3.37
            },
            {
              "x": -23.48,
              "y": -22.8
            },
            {
              "x": -8.37,
              "y": -10.46
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": -15.42,
            "y": -15.53,
            "z": 1.96
          },
          "homePlayers": [
            {
              "x": -34.13,
              "y": 12.5
            },
            {
              "x": -34.69,
              "y": -0.1
            },
            {
              "x": -36.55,
              "y": -8.38
            },
            {
              "x": -26.26,
              "y": -5.52
            },
            {
              "x": -22.32,
              "y": -8.57
            },
            {
              "x": -27.37,
              "y": 6.3
            },
            {
              "x": -32.41,
              "y": -20.28
            },
            {
              "x": -35.45,
              "y": -3.71
            },
            {
              "x": -21.66,
              "y": -13.17
            },
            {
              "x": -49.1,
              "y": -0.85
            },
            {
              "x": -31.7,
              "y": -10.54
            }
          ],
          "awayPlayers": [
            {
              "x": -22.34,
              "y": -9.48
            },
            {
              "x": -39.26,
              "y": -9.03
            },
            {
              "x": 25.0,
              "y": -2.17
            },
            {
              "x": -14.79,
              "y": 10.23
            },
            {
              "x": -27.36,
              "y": 11.8
            },
            {
              "x": -22.16,
              "y": 5.45
            },
            {
              "x": -29.12,
              "y": -12.83
            },
            {
              "x": -30.0,
              "y": -30.08
            },
            {
              "x": -30.56,
              "y": -4.22
            },
            {
              "x": -22.64,
              "y": -22.62
            },
            {
              "x": -7.81,
              "y": -10.67
            }
          ],
          "time": 5.005
        },
        {
          "ball": {
            "x": -12.19,
            "y": -17.13,
            "z": 0.59
          },
          "homePlayers": [
            {
              "x": -33.69,
              "y": 12.61
            },
            {
              "x": -33.79,
              "y": 0.03
            },
            {
              "x": -36.06,
              "y": -8.19
            },
            {
              "x": -25.64,
              "y": -5.73
            },
            {
              "x": -21.22,
              "y": -8.87
            },
            {
              "x": -26.67,
              "y": 5.81
            },
            {
              "x": -30.58,
              "y": -16.14
            },
            {
              "x": -35.57,
              "y": -3.13
            },
            {
              "x": -20.99,
              "y": -13.96
            },
            {
              "x": -48.45,
              "y": -0.91
            },
            {
              "x": -31.58,
              "y": -10.52
            }
          ],
          "awayPlayers": [
            {
              "x": -22.04,
              "y": -9.16
            },
            {
              "x": -36.91,
              "y": -6.28
            },
            {
              "x": 25.0,
              "y": -2.39
            },
            {
              "x": -15.2,
              "y": 10.23
            },
            {
              "x": -26.96,
              "y": 11.68
            },
            {
              "x": -21.77,
              "y": 4.54
            },
            {
              "x": -28.92,
              "y": -13.39
            },
            {
              "x": -30.55,
              "y": -29.07
            },
            {
              "x": -29.73,
              "y": -4.84
            },
            {
              "x": -21.61,
              "y": -23.08
            },
            {
              "x": -7.18,
              "y": -11.09
            }
          ],
          "time": 5.339
        },
        {
          "ball": {
            "x": -9.29,
            "y": -18.67,
            "z": 1.19
          },
          "homePlayers": [
            {
              "x": -33.16,
              "y": 12.58
            },
            {
              "x": -32.77,
              "y": 0.1
            },
            {
              "x": -34.64,
              "y": -8.77
            },
            {
              "x": -24.95,
              "y": -6.21
            },
            {
              "x": -20.19,
              "y": -8.95
            },
            {
              "x": -25.8,
              "y": 5.57
            },
            {
              "x": -28.62,
              "y": -11.4
            },
            {
              "x": -35.39,
              "y": -2.78
            },
            {
              "x": -20.4,
              "y": -14.83
            },
            {
              "x": -47.77,
              "y": -0.99
            },
            {
              "x": -31.4,
              "y": -10.3
            }
          ],
          "awayPlayers": [
            {
              "x": -21.71,
              "y": -8.89
            },
            {
              "x": -34.16,
              "y": -3.65
            },
            {
              "x": 25.0,
              "y": -2.62
            },
            {
              "x": -15.26,
              "y": 10.38
            },
            {
              "x": -26.57,
              "y": 11.88
            },
            {
              "x": -21.34,
              "y": 3.85
            },
            {
              "x": -28.74,
              "y": -13.7
            },
            {
              "x": -30.81,
              "y": -27.82
            },
            {
              "x": -29.04,
              "y": -5.31
            },
            {
              "x": -20.68,
              "y": -23.92
            },
            {
              "x": -6.33,
              "y": -11.48
            }
          ],
          "time": 5.672
        },
        {
          "ball": {
            "x": -6.7,
            "y": -19.08,
            "z": 0.85
          },
          "homePlayers": [
            {
              "x": -32.65,
              "y": 12.7
            },
            {
              "x": -31.81,
              "y": 0.46
            },
            {
              "x": -33.02,
              "y": -9.76
            },
            {
              "x": -24.32,
              "y": -6.73
            },
            {
              "x": -19.12,
              "y": -8.9
            },
            {
              "x": -24.89,
              "y": 5.56
            },
            {
              "x": -26.68,
              "y": -6.25
            },
            {
              "x": -33.99,
              "y": -3.52
            },
            {
              "x": -19.89,
              "y": -15.74
            },
            {
              "x": -47.74,
              "y": -1.09
            },
            {
              "x": -31.17,
              "y": -9.25
            }
          ],
          "awayPlayers": [
            {
              "x": -21.39,
              "y": -8.51
            },
            {
              "x": -32.56,
              "y": -2.48
            },
            {
              "x": 25.0,
              "y": -2.92
            },
            {
              "x": -14.99,
              "y": 10.29
            },
            {
              "x": -26.26,
              "y": 12.5
            },
            {
              "x": -20.98,
              "y": 3.46
            },
            {
              "x": -28.12,
              "y": -14.28
            },
            {
              "x": -30.09,
              "y": -27.58
            },
            {
              "x": -28.32,
              "y": -5.59
            },
            {
              "x": -19.91,
              "y": -24.84
            },
            {
              "x": -5.42,
              "y": -12.41
            }
          ],
          "time": 6.006
        },
        {
          "ball": {
            "x": -4.27,
            "y": -19.83,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": -31.97,
              "y": 13.0
            },
            {
              "x": -30.78,
              "y": 1.1
            },
            {
              "x": -31.54,
              "y": -11.12
            },
            {
              "x": -23.73,
              "y": -7.19
            },
            {
              "x": -18.03,
              "y": -8.76
            },
            {
              "x": -23.61,
              "y": 5.68
            },
            {
              "x": -26.19,
              "y": -5.32
            },
            {
              "x": -32.53,
              "y": -4.57
            },
            {
              "x": -19.48,
              "y": -16.51
            },
            {
              "x": -47.62,
              "y": -1.13
            },
            {
              "x": -30.9,
              "y": -8.16
            }
          ],
          "awayPlayers": [
            {
              "x": -20.99,
              "y": -8.01
            },
            {
              "x": -31.83,
              "y": -2.24
            },
            {
              "x": 25.0,
              "y": -3.13
            },
            {
              "x": -14.32,
              "y": 10.27
            },
            {
              "x": -25.95,
              "y": 13.2
            },
            {
              "x": -20.66,
              "y": 3.28
            },
            {
              "x": -27.39,
              "y": -15.03
            },
            {
              "x": -29.35,
              "y": -27.35
            },
            {
              "x": -28.02,
              "y": -5.56
            },
            {
              "x": -19.14,
              "y": -25.86
            },
            {
              "x": -4.57,
              "y": -13.18
            }
          ],
          "time": 6.34
        },
        {
          "ball": {
            "x": -2.11,
            "y": -19.8,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -31.7,
              "y": 13.2
            },
            {
              "x": -30.12,
              "y": 1.32
            },
            {
              "x": -30.74,
              "y": -11.97
            },
            {
              "x": -23.16,
              "y": -7.73
            },
            {
              "x": -17.01,
              "y": -8.54
            },
            {
              "x": -23.12,
              "y": 5.78
            },
            {
              "x": -25.59,
              "y": -4.19
            },
            {
              "x": -30.94,
              "y": -5.92
            },
            {
              "x": -19.12,
              "y": -17.5
            },
            {
              "x": -47.55,
              "y": -1.15
            },
            {
              "x": -30.46,
              "y": -7.35
            }
          ],
          "awayPlayers": [
            {
              "x": -20.6,
              "y": -7.61
            },
            {
              "x": -31.09,
              "y": -1.94
            },
            {
              "x": 25.0,
              "y": -3.35
            },
            {
              "x": -13.7,
              "y": 10.4
            },
            {
              "x": -25.63,
              "y": 13.89
            },
            {
              "x": -20.4,
              "y": 3.19
            },
            {
              "x": -26.48,
              "y": -15.87
            },
            {
              "x": -28.65,
              "y": -27.41
            },
            {
              "x": -28.26,
              "y": -5.19
            },
            {
              "x": -18.8,
              "y": -26.57
            },
            {
              "x": -2.59,
              "y": -14.82
            }
          ],
          "time": 6.673
        },
        {
          "ball": {
            "x": -0.07,
            "y": -21.34,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -31.05,
              "y": 12.94
            },
            {
              "x": -29.48,
              "y": 1.4
            },
            {
              "x": -30.23,
              "y": -12.56
            },
            {
              "x": -22.87,
              "y": -8.04
            },
            {
              "x": -15.98,
              "y": -8.37
            },
            {
              "x": -22.7,
              "y": 4.77
            },
            {
              "x": -24.88,
              "y": -3.43
            },
            {
              "x": -30.34,
              "y": -6.42
            },
            {
              "x": -18.97,
              "y": -18.02
            },
            {
              "x": -47.34,
              "y": -1.17
            },
            {
              "x": -29.93,
              "y": -7.36
            }
          ],
          "awayPlayers": [
            {
              "x": -20.17,
              "y": -7.41
            },
            {
              "x": -30.2,
              "y": -1.39
            },
            {
              "x": 25.0,
              "y": -3.55
            },
            {
              "x": -12.92,
              "y": 10.46
            },
            {
              "x": -25.24,
              "y": 14.44
            },
            {
              "x": -20.16,
              "y": 3.08
            },
            {
              "x": -26.0,
              "y": -16.76
            },
            {
              "x": -28.06,
              "y": -27.46
            },
            {
              "x": -28.68,
              "y": -4.71
            },
            {
              "x": -18.79,
              "y": -27.55
            },
            {
              "x": -0.87,
              "y": -16.33
            }
          ],
          "time": 7.007
        },
        {
          "ball": {
            "x": 1.59,
            "y": -22.0,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -30.15,
              "y": 12.75
            },
            {
              "x": -28.93,
              "y": 1.42
            },
            {
              "x": -29.83,
              "y": -13.0
            },
            {
              "x": -22.01,
              "y": -8.24
            },
            {
              "x": -14.64,
              "y": -8.11
            },
            {
              "x": -22.12,
              "y": 3.04
            },
            {
              "x": -24.21,
              "y": -2.65
            },
            {
              "x": -29.77,
              "y": -6.58
            },
            {
              "x": -18.67,
              "y": -18.9
            },
            {
              "x": -47.2,
              "y": -1.02
            },
            {
              "x": -29.4,
              "y": -7.37
            }
          ],
          "awayPlayers": [
            {
              "x": -19.49,
              "y": -7.74
            },
            {
              "x": -29.82,
              "y": -0.51
            },
            {
              "x": 25.0,
              "y": -3.51
            },
            {
              "x": -11.65,
              "y": 10.26
            },
            {
              "x": -24.5,
              "y": 14.96
            },
            {
              "x": -20.06,
              "y": 3.06
            },
            {
              "x": -25.39,
              "y": -17.28
            },
            {
              "x": -27.5,
              "y": -27.65
            },
            {
              "x": -28.81,
              "y": -4.02
            },
            {
              "x": -18.54,
              "y": -28.2
            },
            {
              "x": -0.18,
              "y": -17.21
            }
          ],
          "time": 7.341
        },
        {
          "ball": {
            "x": 2.85,
            "y": -22.89,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.56,
              "y": 13.08
            },
            {
              "x": -28.64,
              "y": 1.54
            },
            {
              "x": -30.03,
              "y": -13.55
            },
            {
              "x": -21.14,
              "y": -8.45
            },
            {
              "x": -12.81,
              "y": -7.78
            },
            {
              "x": -21.51,
              "y": 1.31
            },
            {
              "x": -23.31,
              "y": -1.78
            },
            {
              "x": -29.53,
              "y": -6.68
            },
            {
              "x": -17.78,
              "y": -19.62
            },
            {
              "x": -47.13,
              "y": -0.83
            },
            {
              "x": -29.21,
              "y": -7.4
            }
          ],
          "awayPlayers": [
            {
              "x": -17.93,
              "y": -8.8
            },
            {
              "x": -30.01,
              "y": 0.8
            },
            {
              "x": 25.0,
              "y": -3.17
            },
            {
              "x": -9.71,
              "y": 9.96
            },
            {
              "x": -23.02,
              "y": 15.8
            },
            {
              "x": -20.09,
              "y": 3.08
            },
            {
              "x": -24.66,
              "y": -17.5
            },
            {
              "x": -27.34,
              "y": -27.91
            },
            {
              "x": -28.22,
              "y": -3.72
            },
            {
              "x": -17.52,
              "y": -28.71
            },
            {
              "x": -0.68,
              "y": -17.53
            }
          ],
          "time": 7.674
        },
        {
          "ball": {
            "x": 3.69,
            "y": -23.61,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.22,
              "y": 13.84
            },
            {
              "x": -28.36,
              "y": 1.76
            },
            {
              "x": -30.3,
              "y": -14.14
            },
            {
              "x": -20.14,
              "y": -8.58
            },
            {
              "x": -10.76,
              "y": -7.39
            },
            {
              "x": -20.73,
              "y": 0.54
            },
            {
              "x": -22.69,
              "y": -1.05
            },
            {
              "x": -29.41,
              "y": -6.8
            },
            {
              "x": -16.92,
              "y": -20.26
            },
            {
              "x": -47.1,
              "y": -0.66
            },
            {
              "x": -29.07,
              "y": -7.32
            }
          ],
          "awayPlayers": [
            {
              "x": -16.46,
              "y": -9.96
            },
            {
              "x": -30.42,
              "y": 2.06
            },
            {
              "x": 25.0,
              "y": -2.77
            },
            {
              "x": -7.57,
              "y": 9.42
            },
            {
              "x": -21.52,
              "y": 16.5
            },
            {
              "x": -20.09,
              "y": 3.22
            },
            {
              "x": -23.92,
              "y": -17.52
            },
            {
              "x": -27.24,
              "y": -28.18
            },
            {
              "x": -27.43,
              "y": -3.31
            },
            {
              "x": -16.2,
              "y": -28.97
            },
            {
              "x": -1.46,
              "y": -17.58
            }
          ],
          "time": 8.008
        },
        {
          "ball": {
            "x": 4.52,
            "y": -24.32,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.14,
              "y": 14.58
            },
            {
              "x": -28.23,
              "y": 1.98
            },
            {
              "x": -30.48,
              "y": -14.65
            },
            {
              "x": -19.68,
              "y": -8.88
            },
            {
              "x": -9.34,
              "y": -7.22
            },
            {
              "x": -20.16,
              "y": 0.47
            },
            {
              "x": -21.97,
              "y": -0.06
            },
            {
              "x": -29.29,
              "y": -7.02
            },
            {
              "x": -16.18,
              "y": -20.58
            },
            {
              "x": -47.02,
              "y": -0.63
            },
            {
              "x": -28.96,
              "y": -7.19
            }
          ],
          "awayPlayers": [
            {
              "x": -14.89,
              "y": -11.17
            },
            {
              "x": -30.51,
              "y": 3.12
            },
            {
              "x": 25.0,
              "y": -2.55
            },
            {
              "x": -5.97,
              "y": 9.1
            },
            {
              "x": -20.39,
              "y": 17.1
            },
            {
              "x": -19.95,
              "y": 3.48
            },
            {
              "x": -23.3,
              "y": -17.69
            },
            {
              "x": -27.15,
              "y": -28.32
            },
            {
              "x": -26.91,
              "y": -3.0
            },
            {
              "x": -15.08,
              "y": -29.43
            },
            {
              "x": -1.77,
              "y": -18.0
            }
          ],
          "time": 8.342
        },
        {
          "ball": {
            "x": 5.35,
            "y": -25.03,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -28.75,
              "y": 14.73
            },
            {
              "x": -27.91,
              "y": 2.15
            },
            {
              "x": -30.17,
              "y": -14.92
            },
            {
              "x": -19.24,
              "y": -9.14
            },
            {
              "x": -8.5,
              "y": -7.22
            },
            {
              "x": -19.84,
              "y": 0.28
            },
            {
              "x": -21.56,
              "y": 0.42
            },
            {
              "x": -28.99,
              "y": -7.3
            },
            {
              "x": -15.94,
              "y": -20.94
            },
            {
              "x": -46.92,
              "y": -0.65
            },
            {
              "x": -28.66,
              "y": -6.95
            }
          ],
          "awayPlayers": [
            {
              "x": -14.29,
              "y": -11.54
            },
            {
              "x": -29.94,
              "y": 3.7
            },
            {
              "x": 25.0,
              "y": -2.61
            },
            {
              "x": -5.08,
              "y": 8.86
            },
            {
              "x": -20.02,
              "y": 17.47
            },
            {
              "x": -19.75,
              "y": 3.86
            },
            {
              "x": -22.93,
              "y": -18.14
            },
            {
              "x": -26.8,
              "y": -28.43
            },
            {
              "x": -26.57,
              "y": -2.54
            },
            {
              "x": -14.54,
              "y": -29.93
            },
            {
              "x": -1.22,
              "y": -18.65
            }
          ],
          "time": 8.675
        },
        {
          "ball": {
            "x": 6.18,
            "y": -25.74,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -28.41,
              "y": 14.93
            },
            {
              "x": -27.66,
              "y": 2.34
            },
            {
              "x": -29.92,
              "y": -15.23
            },
            {
              "x": -18.88,
              "y": -9.34
            },
            {
              "x": -7.84,
              "y": -7.23
            },
            {
              "x": -19.54,
              "y": 0.2
            },
            {
              "x": -21.05,
              "y": 1.1
            },
            {
              "x": -28.72,
              "y": -7.41
            },
            {
              "x": -15.72,
              "y": -21.27
            },
            {
              "x": -46.81,
              "y": -0.64
            },
            {
              "x": -28.39,
              "y": -6.71
            }
          ],
          "awayPlayers": [
            {
              "x": -13.59,
              "y": -12.04
            },
            {
              "x": -29.46,
              "y": 4.29
            },
            {
              "x": 25.0,
              "y": -2.6
            },
            {
              "x": -4.23,
              "y": 8.65
            },
            {
              "x": -19.7,
              "y": 17.85
            },
            {
              "x": -19.54,
              "y": 4.21
            },
            {
              "x": -22.5,
              "y": -18.47
            },
            {
              "x": -26.56,
              "y": -28.49
            },
            {
              "x": -26.24,
              "y": -2.08
            },
            {
              "x": -14.09,
              "y": -30.31
            },
            {
              "x": -0.8,
              "y": -19.24
            }
          ],
          "time": 9.009
        },
        {
          "ball": {
            "x": 7.01,
            "y": -26.46,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -28.03,
              "y": 15.12
            },
            {
              "x": -27.42,
              "y": 2.53
            },
            {
              "x": -29.59,
              "y": -15.51
            },
            {
              "x": -18.48,
              "y": -9.69
            },
            {
              "x": -7.32,
              "y": -7.29
            },
            {
              "x": -19.29,
              "y": 0.07
            },
            {
              "x": -20.46,
              "y": 1.97
            },
            {
              "x": -28.43,
              "y": -7.62
            },
            {
              "x": -15.48,
              "y": -21.64
            },
            {
              "x": -46.7,
              "y": -0.67
            },
            {
              "x": -28.12,
              "y": -6.55
            }
          ],
          "awayPlayers": [
            {
              "x": -12.96,
              "y": -12.41
            },
            {
              "x": -28.93,
              "y": 4.83
            },
            {
              "x": 25.0,
              "y": -2.63
            },
            {
              "x": -3.65,
              "y": 8.55
            },
            {
              "x": -19.39,
              "y": 18.25
            },
            {
              "x": -19.4,
              "y": 4.58
            },
            {
              "x": -22.1,
              "y": -18.83
            },
            {
              "x": -26.23,
              "y": -28.58
            },
            {
              "x": -25.96,
              "y": -1.64
            },
            {
              "x": -13.51,
              "y": -30.79
            },
            {
              "x": -0.42,
              "y": -19.61
            }
          ],
          "time": 9.343
        },
        {
          "ball": {
            "x": 7.74,
            "y": -27.08,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.59,
              "y": 15.24
            },
            {
              "x": -27.02,
              "y": 2.75
            },
            {
              "x": -29.26,
              "y": -15.77
            },
            {
              "x": -17.94,
              "y": -9.93
            },
            {
              "x": -6.63,
              "y": -7.27
            },
            {
              "x": -18.92,
              "y": -0.02
            },
            {
              "x": -20.04,
              "y": 2.58
            },
            {
              "x": -28.05,
              "y": -7.84
            },
            {
              "x": -15.26,
              "y": -21.97
            },
            {
              "x": -46.53,
              "y": -0.7
            },
            {
              "x": -27.72,
              "y": -6.37
            }
          ],
          "awayPlayers": [
            {
              "x": -12.32,
              "y": -12.82
            },
            {
              "x": -28.42,
              "y": 5.34
            },
            {
              "x": 25.0,
              "y": -2.66
            },
            {
              "x": -2.82,
              "y": 8.33
            },
            {
              "x": -19.05,
              "y": 18.59
            },
            {
              "x": -19.15,
              "y": 4.93
            },
            {
              "x": -21.76,
              "y": -19.04
            },
            {
              "x": -25.99,
              "y": -28.65
            },
            {
              "x": -25.55,
              "y": -1.16
            },
            {
              "x": -13.02,
              "y": -31.12
            },
            {
              "x": -0.03,
              "y": -19.96
            }
          ],
          "time": 9.676
        },
        {
          "ball": {
            "x": -0.06,
            "y": -21.55,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -25.93,
              "y": 15.17
            },
            {
              "x": -25.34,
              "y": 3.29
            },
            {
              "x": -26.45,
              "y": -17.86
            },
            {
              "x": -16.7,
              "y": -12.13
            },
            {
              "x": -5.61,
              "y": -8.82
            },
            {
              "x": -17.88,
              "y": -1.03
            },
            {
              "x": -19.38,
              "y": 5.99
            },
            {
              "x": -25.55,
              "y": -9.71
            },
            {
              "x": -15.33,
              "y": -23.13
            },
            {
              "x": -44.76,
              "y": -1.04
            },
            {
              "x": -25.65,
              "y": -5.56
            }
          ],
          "awayPlayers": [
            {
              "x": -10.58,
              "y": -14.83
            },
            {
              "x": -24.2,
              "y": 8.27
            },
            {
              "x": 25.0,
              "y": -3.38
            },
            {
              "x": -1.19,
              "y": 9.2
            },
            {
              "x": -19.25,
              "y": 22.25
            },
            {
              "x": -19.5,
              "y": 7.39
            },
            {
              "x": -20.32,
              "y": -20.64
            },
            {
              "x": -23.91,
              "y": -30.0
            },
            {
              "x": -25.12,
              "y": 0.13
            },
            {
              "x": -11.06,
              "y": -32.97
            },
            {
              "x": 2.44,
              "y": -22.15
            }
          ],
          "time": 11.879
        },
        {
          "ball": {
            "x": -3.69,
            "y": -19.85,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.71,
              "y": 15.39
            },
            {
              "x": -25.52,
              "y": 3.2
            },
            {
              "x": -25.96,
              "y": -18.41
            },
            {
              "x": -17.01,
              "y": -12.95
            },
            {
              "x": -6.21,
              "y": -9.65
            },
            {
              "x": -17.95,
              "y": -1.41
            },
            {
              "x": -19.4,
              "y": 6.88
            },
            {
              "x": -25.3,
              "y": -10.4
            },
            {
              "x": -15.99,
              "y": -23.05
            },
            {
              "x": -44.61,
              "y": -1.16
            },
            {
              "x": -25.5,
              "y": -5.65
            }
          ],
          "awayPlayers": [
            {
              "x": -10.54,
              "y": -15.94
            },
            {
              "x": -24.91,
              "y": 8.46
            },
            {
              "x": 25.0,
              "y": -3.54
            },
            {
              "x": -1.67,
              "y": 9.44
            },
            {
              "x": -19.62,
              "y": 22.36
            },
            {
              "x": -20.18,
              "y": 7.76
            },
            {
              "x": -20.36,
              "y": -20.86
            },
            {
              "x": -23.47,
              "y": -30.09
            },
            {
              "x": -25.46,
              "y": -0.14
            },
            {
              "x": -11.45,
              "y": -33.04
            },
            {
              "x": 2.35,
              "y": -22.69
            }
          ],
          "time": 12.212
        },
        {
          "ball": {
            "x": -6.79,
            "y": -18.41,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.4,
              "y": 15.96
            },
            {
              "x": -25.82,
              "y": 3.78
            },
            {
              "x": -25.93,
              "y": -18.36
            },
            {
              "x": -16.73,
              "y": -13.38
            },
            {
              "x": -6.25,
              "y": -9.82
            },
            {
              "x": -17.76,
              "y": -1.53
            },
            {
              "x": -19.18,
              "y": 7.64
            },
            {
              "x": -25.29,
              "y": -10.54
            },
            {
              "x": -16.07,
              "y": -22.64
            },
            {
              "x": -44.66,
              "y": -1.15
            },
            {
              "x": -25.55,
              "y": -5.53
            }
          ],
          "awayPlayers": [
            {
              "x": -10.09,
              "y": -16.59
            },
            {
              "x": -25.62,
              "y": 9.02
            },
            {
              "x": 25.0,
              "y": -3.36
            },
            {
              "x": -1.66,
              "y": 9.47
            },
            {
              "x": -19.48,
              "y": 22.48
            },
            {
              "x": -20.34,
              "y": 8.28
            },
            {
              "x": -20.05,
              "y": -20.71
            },
            {
              "x": -23.3,
              "y": -30.15
            },
            {
              "x": -25.23,
              "y": -0.06
            },
            {
              "x": -11.54,
              "y": -32.99
            },
            {
              "x": 2.1,
              "y": -22.46
            }
          ],
          "time": 12.546
        },
        {
          "ball": {
            "x": -8.34,
            "y": -17.55,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.48,
              "y": 15.92
            },
            {
              "x": -26.14,
              "y": 4.45
            },
            {
              "x": -25.88,
              "y": -18.38
            },
            {
              "x": -15.77,
              "y": -14.62
            },
            {
              "x": -6.54,
              "y": -10.12
            },
            {
              "x": -17.53,
              "y": -1.87
            },
            {
              "x": -19.24,
              "y": 7.64
            },
            {
              "x": -25.22,
              "y": -10.71
            },
            {
              "x": -16.1,
              "y": -22.42
            },
            {
              "x": -44.66,
              "y": -1.13
            },
            {
              "x": -25.54,
              "y": -5.36
            }
          ],
          "awayPlayers": [
            {
              "x": -9.11,
              "y": -17.84
            },
            {
              "x": -26.35,
              "y": 9.72
            },
            {
              "x": 25.0,
              "y": -3.27
            },
            {
              "x": -1.81,
              "y": 9.54
            },
            {
              "x": -19.3,
              "y": 22.63
            },
            {
              "x": -20.43,
              "y": 8.29
            },
            {
              "x": -19.91,
              "y": -20.44
            },
            {
              "x": -23.21,
              "y": -30.13
            },
            {
              "x": -24.94,
              "y": 0.02
            },
            {
              "x": -11.9,
              "y": -32.76
            },
            {
              "x": 1.6,
              "y": -21.86
            }
          ],
          "time": 12.88
        },
        {
          "ball": {
            "x": -7.61,
            "y": -17.43,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.67,
              "y": 15.76
            },
            {
              "x": -26.42,
              "y": 4.96
            },
            {
              "x": -26.05,
              "y": -18.13
            },
            {
              "x": -14.72,
              "y": -15.39
            },
            {
              "x": -6.92,
              "y": -10.16
            },
            {
              "x": -17.53,
              "y": -2.21
            },
            {
              "x": -19.35,
              "y": 7.61
            },
            {
              "x": -25.26,
              "y": -10.56
            },
            {
              "x": -16.08,
              "y": -22.08
            },
            {
              "x": -44.68,
              "y": -1.13
            },
            {
              "x": -25.64,
              "y": -5.09
            }
          ],
          "awayPlayers": [
            {
              "x": -8.42,
              "y": -18.23
            },
            {
              "x": -26.28,
              "y": 10.0
            },
            {
              "x": 25.0,
              "y": -3.1
            },
            {
              "x": -1.97,
              "y": 9.5
            },
            {
              "x": -19.35,
              "y": 22.71
            },
            {
              "x": -20.56,
              "y": 8.03
            },
            {
              "x": -19.83,
              "y": -20.08
            },
            {
              "x": -23.31,
              "y": -29.86
            },
            {
              "x": -24.53,
              "y": 0.05
            },
            {
              "x": -12.32,
              "y": -32.58
            },
            {
              "x": 1.31,
              "y": -21.4
            }
          ],
          "time": 13.213
        },
        {
          "ball": {
            "x": -7.04,
            "y": -17.4,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.81,
              "y": 15.47
            },
            {
              "x": -26.52,
              "y": 5.01
            },
            {
              "x": -26.14,
              "y": -17.96
            },
            {
              "x": -13.45,
              "y": -15.8
            },
            {
              "x": -7.35,
              "y": -10.07
            },
            {
              "x": -17.64,
              "y": -2.58
            },
            {
              "x": -19.41,
              "y": 7.46
            },
            {
              "x": -25.26,
              "y": -10.51
            },
            {
              "x": -16.16,
              "y": -21.73
            },
            {
              "x": -44.69,
              "y": -1.12
            },
            {
              "x": -25.65,
              "y": -4.92
            }
          ],
          "awayPlayers": [
            {
              "x": -7.71,
              "y": -18.3
            },
            {
              "x": -26.21,
              "y": 10.51
            },
            {
              "x": 25.0,
              "y": -3.04
            },
            {
              "x": -2.15,
              "y": 9.38
            },
            {
              "x": -19.45,
              "y": 22.71
            },
            {
              "x": -20.62,
              "y": 7.63
            },
            {
              "x": -19.74,
              "y": -19.51
            },
            {
              "x": -23.35,
              "y": -29.72
            },
            {
              "x": -24.29,
              "y": 0.01
            },
            {
              "x": -12.79,
              "y": -32.47
            },
            {
              "x": 1.09,
              "y": -20.96
            }
          ],
          "time": 13.547
        },
        {
          "ball": {
            "x": -6.64,
            "y": -16.94,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.92,
              "y": 15.28
            },
            {
              "x": -26.66,
              "y": 5.04
            },
            {
              "x": -26.29,
              "y": -17.63
            },
            {
              "x": -12.34,
              "y": -15.59
            },
            {
              "x": -7.77,
              "y": -9.93
            },
            {
              "x": -17.72,
              "y": -2.84
            },
            {
              "x": -19.43,
              "y": 7.4
            },
            {
              "x": -25.34,
              "y": -10.22
            },
            {
              "x": -16.28,
              "y": -21.37
            },
            {
              "x": -44.74,
              "y": -1.13
            },
            {
              "x": -25.77,
              "y": -4.58
            }
          ],
          "awayPlayers": [
            {
              "x": -7.07,
              "y": -17.84
            },
            {
              "x": -26.18,
              "y": 10.95
            },
            {
              "x": 25.0,
              "y": -2.85
            },
            {
              "x": -2.37,
              "y": 9.22
            },
            {
              "x": -19.54,
              "y": 22.75
            },
            {
              "x": -20.62,
              "y": 7.16
            },
            {
              "x": -19.69,
              "y": -19.02
            },
            {
              "x": -23.35,
              "y": -29.5
            },
            {
              "x": -23.98,
              "y": -0.16
            },
            {
              "x": -13.25,
              "y": -32.41
            },
            {
              "x": 0.96,
              "y": -20.51
            }
          ],
          "time": 13.881
        },
        {
          "ball": {
            "x": -5.93,
            "y": -12.09,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.95,
              "y": 15.24
            },
            {
              "x": -26.67,
              "y": 5.17
            },
            {
              "x": -26.34,
              "y": -17.38
            },
            {
              "x": -11.72,
              "y": -14.83
            },
            {
              "x": -8.12,
              "y": -9.51
            },
            {
              "x": -17.77,
              "y": -2.84
            },
            {
              "x": -19.34,
              "y": 7.46
            },
            {
              "x": -25.33,
              "y": -9.99
            },
            {
              "x": -16.41,
              "y": -20.98
            },
            {
              "x": -44.75,
              "y": -1.12
            },
            {
              "x": -25.61,
              "y": -4.51
            }
          ],
          "awayPlayers": [
            {
              "x": -6.62,
              "y": -17.16
            },
            {
              "x": -26.12,
              "y": 11.53
            },
            {
              "x": 25.0,
              "y": -2.67
            },
            {
              "x": -2.66,
              "y": 9.07
            },
            {
              "x": -19.64,
              "y": 22.87
            },
            {
              "x": -20.61,
              "y": 6.79
            },
            {
              "x": -19.48,
              "y": -18.56
            },
            {
              "x": -23.45,
              "y": -29.16
            },
            {
              "x": -23.88,
              "y": -0.41
            },
            {
              "x": -13.73,
              "y": -32.29
            },
            {
              "x": 0.83,
              "y": -19.8
            }
          ],
          "time": 14.214
        },
        {
          "ball": {
            "x": -5.34,
            "y": -6.07,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.83,
              "y": 15.55
            },
            {
              "x": -26.51,
              "y": 5.42
            },
            {
              "x": -26.49,
              "y": -16.86
            },
            {
              "x": -11.67,
              "y": -13.79
            },
            {
              "x": -8.4,
              "y": -8.93
            },
            {
              "x": -17.7,
              "y": -2.49
            },
            {
              "x": -19.18,
              "y": 7.66
            },
            {
              "x": -25.35,
              "y": -9.51
            },
            {
              "x": -16.48,
              "y": -20.61
            },
            {
              "x": -44.74,
              "y": -1.03
            },
            {
              "x": -25.43,
              "y": -4.37
            }
          ],
          "awayPlayers": [
            {
              "x": -6.32,
              "y": -16.54
            },
            {
              "x": -25.92,
              "y": 12.06
            },
            {
              "x": 25.0,
              "y": -2.45
            },
            {
              "x": -3.15,
              "y": 9.08
            },
            {
              "x": -19.76,
              "y": 23.27
            },
            {
              "x": -20.64,
              "y": 6.62
            },
            {
              "x": -19.37,
              "y": -18.28
            },
            {
              "x": -23.52,
              "y": -28.75
            },
            {
              "x": -23.95,
              "y": -0.51
            },
            {
              "x": -14.17,
              "y": -32.1
            },
            {
              "x": 0.71,
              "y": -18.97
            }
          ],
          "time": 14.548
        },
        {
          "ball": {
            "x": -5.25,
            "y": -0.65,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.48,
              "y": 16.14
            },
            {
              "x": -26.2,
              "y": 5.68
            },
            {
              "x": -26.57,
              "y": -16.41
            },
            {
              "x": -12.06,
              "y": -12.64
            },
            {
              "x": -8.61,
              "y": -7.96
            },
            {
              "x": -17.63,
              "y": -1.71
            },
            {
              "x": -18.99,
              "y": 7.95
            },
            {
              "x": -25.39,
              "y": -9.01
            },
            {
              "x": -16.55,
              "y": -20.12
            },
            {
              "x": -44.74,
              "y": -0.96
            },
            {
              "x": -25.22,
              "y": -4.18
            }
          ],
          "awayPlayers": [
            {
              "x": -6.24,
              "y": -15.81
            },
            {
              "x": -25.55,
              "y": 12.67
            },
            {
              "x": 25.0,
              "y": -2.12
            },
            {
              "x": -3.8,
              "y": 9.11
            },
            {
              "x": -19.85,
              "y": 23.75
            },
            {
              "x": -20.7,
              "y": 6.72
            },
            {
              "x": -19.34,
              "y": -17.31
            },
            {
              "x": -23.56,
              "y": -28.36
            },
            {
              "x": -24.2,
              "y": -0.18
            },
            {
              "x": -14.58,
              "y": -31.8
            },
            {
              "x": 0.55,
              "y": -17.92
            }
          ],
          "time": 14.882
        },
        {
          "ball": {
            "x": -5.45,
            "y": 3.99,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.0,
              "y": 16.9
            },
            {
              "x": -25.97,
              "y": 6.08
            },
            {
              "x": -26.78,
              "y": -15.75
            },
            {
              "x": -12.72,
              "y": -11.53
            },
            {
              "x": -8.71,
              "y": -6.94
            },
            {
              "x": -17.65,
              "y": -0.72
            },
            {
              "x": -18.94,
              "y": 8.42
            },
            {
              "x": -25.45,
              "y": -8.33
            },
            {
              "x": -16.62,
              "y": -19.64
            },
            {
              "x": -44.8,
              "y": -0.83
            },
            {
              "x": -25.28,
              "y": -3.62
            }
          ],
          "awayPlayers": [
            {
              "x": -6.35,
              "y": -14.92
            },
            {
              "x": -25.05,
              "y": 13.15
            },
            {
              "x": 25.0,
              "y": -1.78
            },
            {
              "x": -4.55,
              "y": 9.24
            },
            {
              "x": -19.93,
              "y": 24.3
            },
            {
              "x": -20.78,
              "y": 7.07
            },
            {
              "x": -19.61,
              "y": -16.19
            },
            {
              "x": -23.69,
              "y": -27.92
            },
            {
              "x": -24.51,
              "y": 0.57
            },
            {
              "x": -15.09,
              "y": -31.13
            },
            {
              "x": 0.34,
              "y": -16.92
            }
          ],
          "time": 15.215
        },
        {
          "ball": {
            "x": -5.86,
            "y": 7.76,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.68,
              "y": 17.88
            },
            {
              "x": -25.93,
              "y": 6.75
            },
            {
              "x": -26.89,
              "y": -15.34
            },
            {
              "x": -13.61,
              "y": -10.35
            },
            {
              "x": -8.79,
              "y": -5.69
            },
            {
              "x": -17.85,
              "y": 0.56
            },
            {
              "x": -19.05,
              "y": 9.01
            },
            {
              "x": -25.64,
              "y": -7.84
            },
            {
              "x": -16.72,
              "y": -19.16
            },
            {
              "x": -44.83,
              "y": -0.71
            },
            {
              "x": -25.57,
              "y": -2.56
            }
          ],
          "awayPlayers": [
            {
              "x": -6.69,
              "y": -13.97
            },
            {
              "x": -24.59,
              "y": 13.79
            },
            {
              "x": 25.0,
              "y": -1.49
            },
            {
              "x": -5.26,
              "y": 9.4
            },
            {
              "x": -20.07,
              "y": 24.98
            },
            {
              "x": -20.93,
              "y": 7.67
            },
            {
              "x": -20.05,
              "y": -14.96
            },
            {
              "x": -23.71,
              "y": -27.56
            },
            {
              "x": -24.86,
              "y": 1.69
            },
            {
              "x": -15.69,
              "y": -30.07
            },
            {
              "x": 0.03,
              "y": -15.9
            }
          ],
          "time": 15.549
        },
        {
          "ball": {
            "x": -6.8,
            "y": 9.04,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.5,
              "y": 18.91
            },
            {
              "x": -26.09,
              "y": 7.86
            },
            {
              "x": -27.09,
              "y": -14.8
            },
            {
              "x": -14.62,
              "y": -9.06
            },
            {
              "x": -8.87,
              "y": -4.42
            },
            {
              "x": -18.18,
              "y": 1.84
            },
            {
              "x": -19.28,
              "y": 9.72
            },
            {
              "x": -25.72,
              "y": -7.31
            },
            {
              "x": -16.88,
              "y": -18.62
            },
            {
              "x": -44.92,
              "y": -0.58
            },
            {
              "x": -26.08,
              "y": -1.47
            }
          ],
          "awayPlayers": [
            {
              "x": -7.17,
              "y": -13.04
            },
            {
              "x": -24.22,
              "y": 14.48
            },
            {
              "x": 25.0,
              "y": -1.18
            },
            {
              "x": -6.14,
              "y": 9.73
            },
            {
              "x": -20.2,
              "y": 25.77
            },
            {
              "x": -21.09,
              "y": 8.24
            },
            {
              "x": -20.65,
              "y": -13.61
            },
            {
              "x": -23.9,
              "y": -27.1
            },
            {
              "x": -25.17,
              "y": 2.9
            },
            {
              "x": -16.28,
              "y": -29.03
            },
            {
              "x": -0.36,
              "y": -14.87
            }
          ],
          "time": 15.883
        },
        {
          "ball": {
            "x": -7.89,
            "y": 9.22,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.43,
              "y": 20.01
            },
            {
              "x": -26.17,
              "y": 8.94
            },
            {
              "x": -27.26,
              "y": -14.31
            },
            {
              "x": -15.72,
              "y": -7.57
            },
            {
              "x": -9.0,
              "y": -3.12
            },
            {
              "x": -18.56,
              "y": 3.18
            },
            {
              "x": -19.59,
              "y": 10.55
            },
            {
              "x": -25.91,
              "y": -6.88
            },
            {
              "x": -17.08,
              "y": -18.08
            },
            {
              "x": -44.98,
              "y": -0.46
            },
            {
              "x": -26.64,
              "y": -0.4
            }
          ],
          "awayPlayers": [
            {
              "x": -7.75,
              "y": -12.04
            },
            {
              "x": -24.02,
              "y": 15.35
            },
            {
              "x": 25.0,
              "y": -0.92
            },
            {
              "x": -7.18,
              "y": 9.96
            },
            {
              "x": -20.34,
              "y": 26.57
            },
            {
              "x": -21.34,
              "y": 8.92
            },
            {
              "x": -21.32,
              "y": -12.08
            },
            {
              "x": -24.02,
              "y": -26.73
            },
            {
              "x": -25.42,
              "y": 4.11
            },
            {
              "x": -16.8,
              "y": -28.25
            },
            {
              "x": -0.85,
              "y": -13.79
            }
          ],
          "time": 16.216
        },
        {
          "ball": {
            "x": -8.75,
            "y": 9.26,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.39,
              "y": 20.89
            },
            {
              "x": -26.25,
              "y": 9.78
            },
            {
              "x": -27.5,
              "y": -13.77
            },
            {
              "x": -16.85,
              "y": -6.11
            },
            {
              "x": -9.23,
              "y": -1.87
            },
            {
              "x": -19.01,
              "y": 4.4
            },
            {
              "x": -19.91,
              "y": 11.17
            },
            {
              "x": -26.09,
              "y": -6.53
            },
            {
              "x": -17.34,
              "y": -17.57
            },
            {
              "x": -45.08,
              "y": -0.37
            },
            {
              "x": -27.16,
              "y": 0.49
            }
          ],
          "awayPlayers": [
            {
              "x": -8.39,
              "y": -11.09
            },
            {
              "x": -24.01,
              "y": 16.34
            },
            {
              "x": 25.0,
              "y": -0.65
            },
            {
              "x": -8.26,
              "y": 9.94
            },
            {
              "x": -20.62,
              "y": 27.29
            },
            {
              "x": -21.64,
              "y": 9.35
            },
            {
              "x": -22.05,
              "y": -10.41
            },
            {
              "x": -24.16,
              "y": -26.41
            },
            {
              "x": -25.63,
              "y": 5.17
            },
            {
              "x": -17.39,
              "y": -27.73
            },
            {
              "x": -1.39,
              "y": -12.76
            }
          ],
          "time": 16.55
        },
        {
          "ball": {
            "x": -9.63,
            "y": 9.33,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.41,
              "y": 21.56
            },
            {
              "x": -26.34,
              "y": 10.29
            },
            {
              "x": -27.79,
              "y": -13.18
            },
            {
              "x": -17.93,
              "y": -4.72
            },
            {
              "x": -9.55,
              "y": -0.68
            },
            {
              "x": -19.5,
              "y": 5.44
            },
            {
              "x": -20.3,
              "y": 11.57
            },
            {
              "x": -26.25,
              "y": -6.24
            },
            {
              "x": -17.62,
              "y": -17.11
            },
            {
              "x": -45.21,
              "y": -0.29
            },
            {
              "x": -27.58,
              "y": 1.4
            }
          ],
          "awayPlayers": [
            {
              "x": -9.08,
              "y": -10.16
            },
            {
              "x": -24.02,
              "y": 16.97
            },
            {
              "x": 25.0,
              "y": -0.36
            },
            {
              "x": -9.22,
              "y": 9.64
            },
            {
              "x": -20.98,
              "y": 27.69
            },
            {
              "x": -22.08,
              "y": 9.77
            },
            {
              "x": -22.83,
              "y": -8.59
            },
            {
              "x": -24.44,
              "y": -25.88
            },
            {
              "x": -25.78,
              "y": 5.93
            },
            {
              "x": -18.03,
              "y": -27.29
            },
            {
              "x": -1.95,
              "y": -11.72
            }
          ],
          "time": 16.884
        },
        {
          "ball": {
            "x": -11.05,
            "y": 10.1,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.58,
              "y": 22.13
            },
            {
              "x": -26.56,
              "y": 10.68
            },
            {
              "x": -28.17,
              "y": -12.56
            },
            {
              "x": -19.0,
              "y": -3.49
            },
            {
              "x": -10.02,
              "y": 0.54
            },
            {
              "x": -20.08,
              "y": 6.29
            },
            {
              "x": -20.7,
              "y": 11.72
            },
            {
              "x": -26.46,
              "y": -5.75
            },
            {
              "x": -18.0,
              "y": -16.76
            },
            {
              "x": -45.3,
              "y": -0.18
            },
            {
              "x": -27.99,
              "y": 2.18
            }
          ],
          "awayPlayers": [
            {
              "x": -9.81,
              "y": -9.27
            },
            {
              "x": -24.1,
              "y": 17.33
            },
            {
              "x": 25.0,
              "y": -0.12
            },
            {
              "x": -10.23,
              "y": 9.67
            },
            {
              "x": -21.48,
              "y": 28.16
            },
            {
              "x": -22.64,
              "y": 10.04
            },
            {
              "x": -23.59,
              "y": -6.74
            },
            {
              "x": -24.69,
              "y": -25.43
            },
            {
              "x": -26.08,
              "y": 6.6
            },
            {
              "x": -18.84,
              "y": -26.98
            },
            {
              "x": -2.52,
              "y": -10.75
            }
          ],
          "time": 17.217
        },
        {
          "ball": {
            "x": -12.55,
            "y": 11.11,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -26.96,
              "y": 22.72
            },
            {
              "x": -26.85,
              "y": 11.11
            },
            {
              "x": -28.63,
              "y": -11.86
            },
            {
              "x": -20.05,
              "y": -2.3
            },
            {
              "x": -10.59,
              "y": 1.74
            },
            {
              "x": -20.75,
              "y": 7.15
            },
            {
              "x": -21.14,
              "y": 12.02
            },
            {
              "x": -26.7,
              "y": -4.91
            },
            {
              "x": -18.39,
              "y": -16.45
            },
            {
              "x": -45.5,
              "y": -0.09
            },
            {
              "x": -28.3,
              "y": 2.88
            }
          ],
          "awayPlayers": [
            {
              "x": -10.61,
              "y": -8.35
            },
            {
              "x": -24.28,
              "y": 17.64
            },
            {
              "x": 25.0,
              "y": 0.23
            },
            {
              "x": -11.44,
              "y": 10.23
            },
            {
              "x": -22.0,
              "y": 28.64
            },
            {
              "x": -23.34,
              "y": 10.33
            },
            {
              "x": -24.38,
              "y": -4.86
            },
            {
              "x": -25.06,
              "y": -24.87
            },
            {
              "x": -26.52,
              "y": 7.13
            },
            {
              "x": -19.74,
              "y": -26.74
            },
            {
              "x": -3.08,
              "y": -9.82
            }
          ],
          "time": 17.551
        },
        {
          "ball": {
            "x": -13.72,
            "y": 11.7,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -27.43,
              "y": 23.01
            },
            {
              "x": -27.22,
              "y": 11.57
            },
            {
              "x": -29.12,
              "y": -11.36
            },
            {
              "x": -21.06,
              "y": -1.35
            },
            {
              "x": -11.15,
              "y": 2.85
            },
            {
              "x": -21.4,
              "y": 7.8
            },
            {
              "x": -21.54,
              "y": 12.29
            },
            {
              "x": -26.97,
              "y": -4.14
            },
            {
              "x": -18.8,
              "y": -16.24
            },
            {
              "x": -45.69,
              "y": 0.02
            },
            {
              "x": -28.62,
              "y": 3.6
            }
          ],
          "awayPlayers": [
            {
              "x": -11.43,
              "y": -7.63
            },
            {
              "x": -24.7,
              "y": 18.14
            },
            {
              "x": 25.0,
              "y": 0.46
            },
            {
              "x": -12.7,
              "y": 10.88
            },
            {
              "x": -22.52,
              "y": 29.01
            },
            {
              "x": -24.07,
              "y": 10.48
            },
            {
              "x": -25.16,
              "y": -3.15
            },
            {
              "x": -25.5,
              "y": -24.37
            },
            {
              "x": -27.13,
              "y": 7.48
            },
            {
              "x": -20.77,
              "y": -26.07
            },
            {
              "x": -3.58,
              "y": -9.1
            }
          ],
          "time": 17.885
        },
        {
          "ball": {
            "x": -14.64,
            "y": 11.94,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -28.0,
              "y": 23.19
            },
            {
              "x": -27.62,
              "y": 12.1
            },
            {
              "x": -29.64,
              "y": -10.84
            },
            {
              "x": -21.96,
              "y": -0.49
            },
            {
              "x": -11.74,
              "y": 4.25
            },
            {
              "x": -22.06,
              "y": 8.55
            },
            {
              "x": -21.95,
              "y": 12.58
            },
            {
              "x": -27.87,
              "y": -2.33
            },
            {
              "x": -19.23,
              "y": -16.03
            },
            {
              "x": -45.9,
              "y": 0.11
            },
            {
              "x": -28.91,
              "y": 4.29
            }
          ],
          "awayPlayers": [
            {
              "x": -12.28,
              "y": -6.99
            },
            {
              "x": -25.39,
              "y": 18.6
            },
            {
              "x": 25.0,
              "y": 0.75
            },
            {
              "x": -13.99,
              "y": 11.69
            },
            {
              "x": -22.97,
              "y": 29.4
            },
            {
              "x": -24.76,
              "y": 10.56
            },
            {
              "x": -25.91,
              "y": -1.67
            },
            {
              "x": -25.92,
              "y": -23.82
            },
            {
              "x": -27.79,
              "y": 7.54
            },
            {
              "x": -21.58,
              "y": -25.65
            },
            {
              "x": -4.01,
              "y": -8.49
            }
          ],
          "time": 18.218
        },
        {
          "ball": {
            "x": -16.62,
            "y": 13.01,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -28.73,
              "y": 23.16
            },
            {
              "x": -28.03,
              "y": 13.05
            },
            {
              "x": -30.09,
              "y": -10.53
            },
            {
              "x": -22.83,
              "y": 0.33
            },
            {
              "x": -11.98,
              "y": 4.94
            },
            {
              "x": -22.68,
              "y": 9.26
            },
            {
              "x": -22.34,
              "y": 13.1
            },
            {
              "x": -28.55,
              "y": -1.12
            },
            {
              "x": -19.75,
              "y": -15.75
            },
            {
              "x": -46.1,
              "y": 0.2
            },
            {
              "x": -29.39,
              "y": 5.27
            }
          ],
          "awayPlayers": [
            {
              "x": -13.13,
              "y": -6.43
            },
            {
              "x": -26.25,
              "y": 18.82
            },
            {
              "x": 25.0,
              "y": 0.94
            },
            {
              "x": -15.25,
              "y": 12.23
            },
            {
              "x": -23.32,
              "y": 29.54
            },
            {
              "x": -25.49,
              "y": 10.76
            },
            {
              "x": -26.7,
              "y": -0.46
            },
            {
              "x": -26.41,
              "y": -23.31
            },
            {
              "x": -28.4,
              "y": 7.36
            },
            {
              "x": -22.36,
              "y": -25.07
            },
            {
              "x": -4.49,
              "y": -7.86
            }
          ],
          "time": 18.552
        },
        {
          "ball": {
            "x": -21.7,
            "y": 15.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -29.65,
              "y": 23.0
            },
            {
              "x": -28.5,
              "y": 14.73
            },
            {
              "x": -30.81,
              "y": -10.15
            },
            {
              "x": -23.68,
              "y": 1.27
            },
            {
              "x": -11.07,
              "y": 5.77
            },
            {
              "x": -23.38,
              "y": 10.21
            },
            {
              "x": -22.81,
              "y": 14.11
            },
            {
              "x": -29.26,
              "y": -0.07
            },
            {
              "x": -20.4,
              "y": -15.34
            },
            {
              "x": -46.32,
              "y": 0.32
            },
            {
              "x": -30.09,
              "y": 6.56
            }
          ],
          "awayPlayers": [
            {
              "x": -13.97,
              "y": -5.74
            },
            {
              "x": -27.21,
              "y": 18.96
            },
            {
              "x": 25.0,
              "y": 1.09
            },
            {
              "x": -16.25,
              "y": 12.82
            },
            {
              "x": -23.76,
              "y": 29.7
            },
            {
              "x": -26.24,
              "y": 10.89
            },
            {
              "x": -27.54,
              "y": 0.55
            },
            {
              "x": -26.98,
              "y": -22.55
            },
            {
              "x": -29.0,
              "y": 7.11
            },
            {
              "x": -22.98,
              "y": -24.61
            },
            {
              "x": -4.63,
              "y": -7.26
            }
          ],
          "time": 18.886
        },
        {
          "ball": {
            "x": -26.48,
            "y": 18.3,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -30.6,
              "y": 22.51
            },
            {
              "x": -28.86,
              "y": 16.44
            },
            {
              "x": -31.53,
              "y": -9.88
            },
            {
              "x": -24.62,
              "y": 2.5
            },
            {
              "x": -10.16,
              "y": 6.46
            },
            {
              "x": -24.2,
              "y": 11.06
            },
            {
              "x": -23.46,
              "y": 15.59
            },
            {
              "x": -30.07,
              "y": 0.54
            },
            {
              "x": -21.07,
              "y": -14.93
            },
            {
              "x": -46.54,
              "y": 0.49
            },
            {
              "x": -31.17,
              "y": 8.14
            }
          ],
          "awayPlayers": [
            {
              "x": -14.76,
              "y": -5.05
            },
            {
              "x": -28.09,
              "y": 18.94
            },
            {
              "x": 25.0,
              "y": 1.23
            },
            {
              "x": -16.76,
              "y": 13.06
            },
            {
              "x": -24.38,
              "y": 29.68
            },
            {
              "x": -27.22,
              "y": 11.21
            },
            {
              "x": -28.49,
              "y": 1.32
            },
            {
              "x": -27.67,
              "y": -21.86
            },
            {
              "x": -29.57,
              "y": 6.79
            },
            {
              "x": -23.4,
              "y": -23.58
            },
            {
              "x": -4.0,
              "y": -6.08
            }
          ],
          "time": 19.219
        },
        {
          "ball": {
            "x": -28.98,
            "y": 17.93,
            "z": 0.33
          },
          "homePlayers": [
            {
              "x": -31.62,
              "y": 22.02
            },
            {
              "x": -29.36,
              "y": 17.84
            },
            {
              "x": -32.43,
              "y": -9.69
            },
            {
              "x": -25.42,
              "y": 3.28
            },
            {
              "x": -9.25,
              "y": 7.13
            },
            {
              "x": -25.3,
              "y": 11.82
            },
            {
              "x": -24.36,
              "y": 16.97
            },
            {
              "x": -31.01,
              "y": 0.72
            },
            {
              "x": -21.73,
              "y": -14.56
            },
            {
              "x": -46.78,
              "y": 0.66
            },
            {
              "x": -32.26,
              "y": 9.03
            }
          ],
          "awayPlayers": [
            {
              "x": -15.46,
              "y": -4.34
            },
            {
              "x": -28.81,
              "y": 18.93
            },
            {
              "x": 25.0,
              "y": 1.3
            },
            {
              "x": -16.79,
              "y": 13.32
            },
            {
              "x": -25.11,
              "y": 29.69
            },
            {
              "x": -28.33,
              "y": 11.59
            },
            {
              "x": -29.41,
              "y": 1.88
            },
            {
              "x": -28.72,
              "y": -20.08
            },
            {
              "x": -30.16,
              "y": 6.3
            },
            {
              "x": -23.39,
              "y": -22.62
            },
            {
              "x": -3.52,
              "y": -4.82
            }
          ],
          "time": 19.553
        },
        {
          "ball": {
            "x": -30.13,
            "y": 16.76,
            "z": 0.16
          },
          "homePlayers": [
            {
              "x": -32.68,
              "y": 21.17
            },
            {
              "x": -30.49,
              "y": 18.43
            },
            {
              "x": -33.09,
              "y": -9.59
            },
            {
              "x": -26.24,
              "y": 3.88
            },
            {
              "x": -9.83,
              "y": 7.53
            },
            {
              "x": -26.71,
              "y": 12.31
            },
            {
              "x": -25.4,
              "y": 18.03
            },
            {
              "x": -32.02,
              "y": 0.84
            },
            {
              "x": -22.29,
              "y": -14.19
            },
            {
              "x": -46.99,
              "y": 0.82
            },
            {
              "x": -33.41,
              "y": 9.62
            }
          ],
          "awayPlayers": [
            {
              "x": -16.06,
              "y": -3.63
            },
            {
              "x": -29.27,
              "y": 18.76
            },
            {
              "x": 25.0,
              "y": 1.41
            },
            {
              "x": -16.64,
              "y": 13.57
            },
            {
              "x": -25.88,
              "y": 29.58
            },
            {
              "x": -29.54,
              "y": 12.16
            },
            {
              "x": -30.45,
              "y": 2.41
            },
            {
              "x": -29.85,
              "y": -17.81
            },
            {
              "x": -30.87,
              "y": 5.76
            },
            {
              "x": -23.02,
              "y": -21.82
            },
            {
              "x": -3.18,
              "y": -4.04
            }
          ],
          "time": 19.887
        },
        {
          "ball": {
            "x": -30.89,
            "y": 15.45,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -33.83,
              "y": 20.18
            },
            {
              "x": -31.3,
              "y": 18.38
            },
            {
              "x": -33.83,
              "y": -9.84
            },
            {
              "x": -27.07,
              "y": 4.09
            },
            {
              "x": -10.47,
              "y": 8.1
            },
            {
              "x": -28.37,
              "y": 12.94
            },
            {
              "x": -26.39,
              "y": 18.58
            },
            {
              "x": -33.08,
              "y": 1.16
            },
            {
              "x": -22.76,
              "y": -13.83
            },
            {
              "x": -47.27,
              "y": 0.91
            },
            {
              "x": -34.56,
              "y": 10.01
            }
          ],
          "awayPlayers": [
            {
              "x": -16.61,
              "y": -2.96
            },
            {
              "x": -29.3,
              "y": 18.07
            },
            {
              "x": 25.0,
              "y": 1.47
            },
            {
              "x": -16.45,
              "y": 13.86
            },
            {
              "x": -26.76,
              "y": 29.6
            },
            {
              "x": -30.56,
              "y": 12.73
            },
            {
              "x": -31.59,
              "y": 2.86
            },
            {
              "x": -30.98,
              "y": -15.46
            },
            {
              "x": -31.77,
              "y": 5.35
            },
            {
              "x": -22.54,
              "y": -21.09
            },
            {
              "x": -3.64,
              "y": -3.38
            }
          ],
          "time": 20.22
        }
      ],
      "duration": 20.22,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/d23fd2e0-cfbe-4cb4-a196-55238e848623/486.119"
    },
    {
      "id": "3848_80.0",
      "matchId": "3848",
      "sequenceId": "80.0",
      "dtwScore": 0.1161399138078435,
      "frames": [
        {
          "ball": {
            "x": -11.74,
            "y": -23.9,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -6.9,
              "y": -30.4
            },
            {
              "x": -23.78,
              "y": -31.47
            },
            {
              "x": -32.48,
              "y": 3.52
            },
            {
              "x": -6.34,
              "y": 11.18
            },
            {
              "x": -30.77,
              "y": -6.24
            },
            {
              "x": -45.57,
              "y": -3.56
            },
            {
              "x": -31.0,
              "y": -28.27
            },
            {
              "x": -11.04,
              "y": -22.53
            },
            {
              "x": -33.81,
              "y": -18.97
            },
            {
              "x": -32.9,
              "y": -13.44
            },
            {
              "x": -17.52,
              "y": -11.04
            }
          ],
          "awayPlayers": [
            {
              "x": -30.99,
              "y": -9.49
            },
            {
              "x": 32.27,
              "y": -5.62
            },
            {
              "x": 3.35,
              "y": -12.62
            },
            {
              "x": -2.62,
              "y": -28.95
            },
            {
              "x": -21.94,
              "y": -35.47
            },
            {
              "x": -24.31,
              "y": -1.27
            },
            {
              "x": -18.32,
              "y": -25.63
            },
            {
              "x": -3.45,
              "y": 7.89
            },
            {
              "x": -25.05,
              "y": -26.38
            },
            {
              "x": -20.0,
              "y": -7.19
            },
            {
              "x": -11.64,
              "y": -25.62
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": -11.74,
            "y": -23.9,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -6.9,
              "y": -30.4
            },
            {
              "x": -23.78,
              "y": -31.47
            },
            {
              "x": -32.48,
              "y": 3.52
            },
            {
              "x": -6.34,
              "y": 11.18
            },
            {
              "x": -30.77,
              "y": -6.24
            },
            {
              "x": -45.57,
              "y": -3.56
            },
            {
              "x": -31.0,
              "y": -28.27
            },
            {
              "x": -11.04,
              "y": -22.53
            },
            {
              "x": -33.81,
              "y": -18.97
            },
            {
              "x": -32.9,
              "y": -13.44
            },
            {
              "x": -17.52,
              "y": -11.04
            }
          ],
          "awayPlayers": [
            {
              "x": -30.99,
              "y": -9.49
            },
            {
              "x": 32.27,
              "y": -5.62
            },
            {
              "x": 3.35,
              "y": -12.62
            },
            {
              "x": -2.62,
              "y": -28.95
            },
            {
              "x": -21.94,
              "y": -35.47
            },
            {
              "x": -24.31,
              "y": -1.27
            },
            {
              "x": -18.32,
              "y": -25.63
            },
            {
              "x": -3.45,
              "y": 7.89
            },
            {
              "x": -25.05,
              "y": -26.38
            },
            {
              "x": -20.0,
              "y": -7.19
            },
            {
              "x": -11.64,
              "y": -25.62
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": -12.15,
            "y": -23.58,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": -6.89,
              "y": -30.45
            },
            {
              "x": -23.21,
              "y": -30.98
            },
            {
              "x": -32.22,
              "y": 3.67
            },
            {
              "x": -6.0,
              "y": 11.07
            },
            {
              "x": -30.55,
              "y": -6.46
            },
            {
              "x": -45.51,
              "y": -3.44
            },
            {
              "x": -30.51,
              "y": -27.81
            },
            {
              "x": -11.05,
              "y": -22.72
            },
            {
              "x": -33.47,
              "y": -18.92
            },
            {
              "x": -32.67,
              "y": -13.34
            },
            {
              "x": -17.34,
              "y": -11.32
            }
          ],
          "awayPlayers": [
            {
              "x": -30.66,
              "y": -9.57
            },
            {
              "x": 32.23,
              "y": -5.58
            },
            {
              "x": 3.57,
              "y": -12.57
            },
            {
              "x": -2.38,
              "y": -29.22
            },
            {
              "x": -21.84,
              "y": -35.45
            },
            {
              "x": -23.95,
              "y": -1.37
            },
            {
              "x": -17.68,
              "y": -25.31
            },
            {
              "x": -3.23,
              "y": 7.82
            },
            {
              "x": -24.66,
              "y": -25.9
            },
            {
              "x": -19.74,
              "y": -7.07
            },
            {
              "x": -11.65,
              "y": -24.72
            }
          ],
          "time": 0.167
        },
        {
          "ball": {
            "x": -13.63,
            "y": -23.26,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -6.89,
              "y": -30.52
            },
            {
              "x": -22.35,
              "y": -29.98
            },
            {
              "x": -31.78,
              "y": 3.87
            },
            {
              "x": -5.7,
              "y": 10.9
            },
            {
              "x": -30.23,
              "y": -6.86
            },
            {
              "x": -45.39,
              "y": -3.32
            },
            {
              "x": -29.63,
              "y": -26.95
            },
            {
              "x": -11.42,
              "y": -22.74
            },
            {
              "x": -32.9,
              "y": -18.82
            },
            {
              "x": -32.27,
              "y": -13.21
            },
            {
              "x": -17.21,
              "y": -11.74
            }
          ],
          "awayPlayers": [
            {
              "x": -30.11,
              "y": -9.79
            },
            {
              "x": 32.33,
              "y": -5.48
            },
            {
              "x": 3.78,
              "y": -12.27
            },
            {
              "x": -2.08,
              "y": -29.05
            },
            {
              "x": -21.74,
              "y": -35.4
            },
            {
              "x": -23.42,
              "y": -1.58
            },
            {
              "x": -16.66,
              "y": -24.61
            },
            {
              "x": -2.97,
              "y": 7.95
            },
            {
              "x": -24.03,
              "y": -25.07
            },
            {
              "x": -19.23,
              "y": -6.92
            },
            {
              "x": -11.65,
              "y": -23.82
            }
          ],
          "time": 0.501
        },
        {
          "ball": {
            "x": -14.77,
            "y": -22.96,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -6.95,
              "y": -30.48
            },
            {
              "x": -21.72,
              "y": -28.64
            },
            {
              "x": -31.44,
              "y": 4.13
            },
            {
              "x": -5.5,
              "y": 10.87
            },
            {
              "x": -30.01,
              "y": -7.32
            },
            {
              "x": -45.42,
              "y": -3.1
            },
            {
              "x": -28.57,
              "y": -25.89
            },
            {
              "x": -12.05,
              "y": -22.39
            },
            {
              "x": -32.33,
              "y": -18.7
            },
            {
              "x": -31.89,
              "y": -12.96
            },
            {
              "x": -17.47,
              "y": -12.04
            }
          ],
          "awayPlayers": [
            {
              "x": -29.64,
              "y": -9.93
            },
            {
              "x": 32.44,
              "y": -5.34
            },
            {
              "x": 3.94,
              "y": -11.9
            },
            {
              "x": -1.79,
              "y": -28.86
            },
            {
              "x": -21.76,
              "y": -35.32
            },
            {
              "x": -23.0,
              "y": -1.76
            },
            {
              "x": -16.06,
              "y": -23.69
            },
            {
              "x": -2.87,
              "y": 7.99
            },
            {
              "x": -23.59,
              "y": -24.11
            },
            {
              "x": -18.75,
              "y": -6.75
            },
            {
              "x": -11.63,
              "y": -23.1
            }
          ],
          "time": 0.834
        },
        {
          "ball": {
            "x": -15.69,
            "y": -22.41,
            "z": 0.13
          },
          "homePlayers": [
            {
              "x": -7.1,
              "y": -30.3
            },
            {
              "x": -21.16,
              "y": -27.01
            },
            {
              "x": -31.14,
              "y": 4.43
            },
            {
              "x": -5.55,
              "y": 10.79
            },
            {
              "x": -29.94,
              "y": -7.59
            },
            {
              "x": -45.6,
              "y": -2.77
            },
            {
              "x": -27.57,
              "y": -24.8
            },
            {
              "x": -12.96,
              "y": -22.04
            },
            {
              "x": -31.73,
              "y": -18.57
            },
            {
              "x": -31.45,
              "y": -12.74
            },
            {
              "x": -18.02,
              "y": -12.07
            }
          ],
          "awayPlayers": [
            {
              "x": -29.2,
              "y": -10.05
            },
            {
              "x": 32.3,
              "y": -5.24
            },
            {
              "x": 3.84,
              "y": -11.56
            },
            {
              "x": -1.75,
              "y": -28.38
            },
            {
              "x": -21.77,
              "y": -34.8
            },
            {
              "x": -23.02,
              "y": -1.96
            },
            {
              "x": -16.01,
              "y": -22.81
            },
            {
              "x": -3.03,
              "y": 8.13
            },
            {
              "x": -23.27,
              "y": -23.33
            },
            {
              "x": -18.14,
              "y": -6.48
            },
            {
              "x": -11.53,
              "y": -22.88
            }
          ],
          "time": 1.168
        },
        {
          "ball": {
            "x": -16.69,
            "y": -21.77,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -7.42,
              "y": -29.75
            },
            {
              "x": -20.53,
              "y": -25.11
            },
            {
              "x": -30.96,
              "y": 4.62
            },
            {
              "x": -5.77,
              "y": 10.73
            },
            {
              "x": -29.92,
              "y": -7.72
            },
            {
              "x": -45.95,
              "y": -2.28
            },
            {
              "x": -26.81,
              "y": -23.68
            },
            {
              "x": -13.67,
              "y": -21.81
            },
            {
              "x": -31.13,
              "y": -18.4
            },
            {
              "x": -30.96,
              "y": -12.34
            },
            {
              "x": -18.76,
              "y": -12.02
            }
          ],
          "awayPlayers": [
            {
              "x": -28.77,
              "y": -10.17
            },
            {
              "x": 32.26,
              "y": -5.08
            },
            {
              "x": 3.65,
              "y": -11.2
            },
            {
              "x": -1.77,
              "y": -27.8
            },
            {
              "x": -21.95,
              "y": -34.19
            },
            {
              "x": -23.58,
              "y": -2.07
            },
            {
              "x": -16.54,
              "y": -21.94
            },
            {
              "x": -3.2,
              "y": 8.38
            },
            {
              "x": -23.19,
              "y": -22.59
            },
            {
              "x": -17.54,
              "y": -5.99
            },
            {
              "x": -11.32,
              "y": -22.67
            }
          ],
          "time": 1.502
        },
        {
          "ball": {
            "x": -18.04,
            "y": -21.03,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -7.97,
              "y": -29.02
            },
            {
              "x": -19.89,
              "y": -23.22
            },
            {
              "x": -30.97,
              "y": 4.32
            },
            {
              "x": -6.21,
              "y": 10.63
            },
            {
              "x": -30.04,
              "y": -7.63
            },
            {
              "x": -46.46,
              "y": -1.94
            },
            {
              "x": -26.49,
              "y": -22.96
            },
            {
              "x": -15.03,
              "y": -21.42
            },
            {
              "x": -30.7,
              "y": -18.17
            },
            {
              "x": -30.41,
              "y": -11.94
            },
            {
              "x": -19.63,
              "y": -12.11
            }
          ],
          "awayPlayers": [
            {
              "x": -28.3,
              "y": -10.39
            },
            {
              "x": 32.45,
              "y": -4.87
            },
            {
              "x": 3.35,
              "y": -10.96
            },
            {
              "x": -2.05,
              "y": -27.26
            },
            {
              "x": -22.18,
              "y": -33.4
            },
            {
              "x": -24.71,
              "y": -2.13
            },
            {
              "x": -17.5,
              "y": -21.2
            },
            {
              "x": -3.64,
              "y": 8.58
            },
            {
              "x": -23.3,
              "y": -21.95
            },
            {
              "x": -17.05,
              "y": -5.47
            },
            {
              "x": -11.01,
              "y": -22.46
            }
          ],
          "time": 1.835
        },
        {
          "ball": {
            "x": -21.12,
            "y": -20.53,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -8.71,
              "y": -28.22
            },
            {
              "x": -19.35,
              "y": -21.43
            },
            {
              "x": -31.21,
              "y": 3.58
            },
            {
              "x": -6.64,
              "y": 10.65
            },
            {
              "x": -30.34,
              "y": -7.3
            },
            {
              "x": -47.05,
              "y": -1.73
            },
            {
              "x": -26.53,
              "y": -22.64
            },
            {
              "x": -16.45,
              "y": -20.63
            },
            {
              "x": -30.43,
              "y": -17.93
            },
            {
              "x": -29.77,
              "y": -11.67
            },
            {
              "x": -20.57,
              "y": -12.0
            }
          ],
          "awayPlayers": [
            {
              "x": -27.92,
              "y": -10.59
            },
            {
              "x": 32.13,
              "y": -4.69
            },
            {
              "x": 2.97,
              "y": -10.59
            },
            {
              "x": -2.35,
              "y": -26.73
            },
            {
              "x": -22.61,
              "y": -32.94
            },
            {
              "x": -25.97,
              "y": -2.14
            },
            {
              "x": -18.61,
              "y": -20.85
            },
            {
              "x": -4.18,
              "y": 9.02
            },
            {
              "x": -23.5,
              "y": -21.38
            },
            {
              "x": -16.8,
              "y": -4.85
            },
            {
              "x": -10.56,
              "y": -22.13
            }
          ],
          "time": 2.169
        },
        {
          "ball": {
            "x": -23.58,
            "y": -20.35,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -9.59,
              "y": -27.53
            },
            {
              "x": -19.1,
              "y": -20.05
            },
            {
              "x": -31.61,
              "y": 2.68
            },
            {
              "x": -7.07,
              "y": 10.72
            },
            {
              "x": -30.86,
              "y": -6.69
            },
            {
              "x": -47.71,
              "y": -1.67
            },
            {
              "x": -26.74,
              "y": -22.22
            },
            {
              "x": -17.79,
              "y": -19.72
            },
            {
              "x": -30.33,
              "y": -17.64
            },
            {
              "x": -29.31,
              "y": -11.63
            },
            {
              "x": -21.46,
              "y": -11.68
            }
          ],
          "awayPlayers": [
            {
              "x": -27.88,
              "y": -10.59
            },
            {
              "x": 32.17,
              "y": -4.38
            },
            {
              "x": 2.47,
              "y": -10.2
            },
            {
              "x": -2.9,
              "y": -26.11
            },
            {
              "x": -23.5,
              "y": -32.31
            },
            {
              "x": -27.25,
              "y": -2.03
            },
            {
              "x": -19.82,
              "y": -21.05
            },
            {
              "x": -4.79,
              "y": 9.27
            },
            {
              "x": -23.78,
              "y": -20.71
            },
            {
              "x": -16.87,
              "y": -4.18
            },
            {
              "x": -10.01,
              "y": -21.79
            }
          ],
          "time": 2.503
        },
        {
          "ball": {
            "x": -23.95,
            "y": -20.12,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -10.47,
              "y": -27.11
            },
            {
              "x": -18.93,
              "y": -19.13
            },
            {
              "x": -32.02,
              "y": 1.88
            },
            {
              "x": -7.56,
              "y": 10.6
            },
            {
              "x": -31.43,
              "y": -6.07
            },
            {
              "x": -48.3,
              "y": -1.54
            },
            {
              "x": -26.67,
              "y": -21.76
            },
            {
              "x": -18.98,
              "y": -18.5
            },
            {
              "x": -30.32,
              "y": -17.28
            },
            {
              "x": -29.31,
              "y": -11.65
            },
            {
              "x": -22.43,
              "y": -11.12
            }
          ],
          "awayPlayers": [
            {
              "x": -28.24,
              "y": -10.39
            },
            {
              "x": 31.8,
              "y": -4.26
            },
            {
              "x": 1.93,
              "y": -9.87
            },
            {
              "x": -3.38,
              "y": -25.68
            },
            {
              "x": -24.49,
              "y": -31.82
            },
            {
              "x": -28.3,
              "y": -1.95
            },
            {
              "x": -21.07,
              "y": -21.47
            },
            {
              "x": -5.47,
              "y": 9.55
            },
            {
              "x": -24.08,
              "y": -20.06
            },
            {
              "x": -17.08,
              "y": -3.62
            },
            {
              "x": -9.56,
              "y": -21.34
            }
          ],
          "time": 2.836
        },
        {
          "ball": {
            "x": -24.75,
            "y": -19.29,
            "z": 0.12
          },
          "homePlayers": [
            {
              "x": -11.33,
              "y": -27.0
            },
            {
              "x": -18.87,
              "y": -18.69
            },
            {
              "x": -32.48,
              "y": 1.24
            },
            {
              "x": -8.21,
              "y": 10.71
            },
            {
              "x": -31.92,
              "y": -5.7
            },
            {
              "x": -48.82,
              "y": -1.39
            },
            {
              "x": -26.69,
              "y": -21.2
            },
            {
              "x": -19.9,
              "y": -17.56
            },
            {
              "x": -30.43,
              "y": -16.83
            },
            {
              "x": -29.84,
              "y": -11.61
            },
            {
              "x": -23.51,
              "y": -10.88
            }
          ],
          "awayPlayers": [
            {
              "x": -28.84,
              "y": -10.1
            },
            {
              "x": 31.75,
              "y": -4.04
            },
            {
              "x": 1.44,
              "y": -9.52
            },
            {
              "x": -3.92,
              "y": -25.23
            },
            {
              "x": -25.61,
              "y": -31.41
            },
            {
              "x": -29.14,
              "y": -1.75
            },
            {
              "x": -22.6,
              "y": -21.84
            },
            {
              "x": -6.21,
              "y": 9.94
            },
            {
              "x": -24.58,
              "y": -19.13
            },
            {
              "x": -17.54,
              "y": -2.94
            },
            {
              "x": -9.09,
              "y": -20.85
            }
          ],
          "time": 3.17
        },
        {
          "ball": {
            "x": -25.21,
            "y": -17.66,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -12.4,
              "y": -27.11
            },
            {
              "x": -18.74,
              "y": -18.68
            },
            {
              "x": -32.83,
              "y": 0.64
            },
            {
              "x": -8.86,
              "y": 10.79
            },
            {
              "x": -32.35,
              "y": -5.58
            },
            {
              "x": -49.2,
              "y": -1.34
            },
            {
              "x": -26.94,
              "y": -20.77
            },
            {
              "x": -20.75,
              "y": -16.61
            },
            {
              "x": -30.54,
              "y": -16.31
            },
            {
              "x": -30.59,
              "y": -11.79
            },
            {
              "x": -24.68,
              "y": -10.99
            }
          ],
          "awayPlayers": [
            {
              "x": -29.57,
              "y": -9.86
            },
            {
              "x": 31.64,
              "y": -3.86
            },
            {
              "x": 1.03,
              "y": -9.24
            },
            {
              "x": -4.42,
              "y": -24.86
            },
            {
              "x": -26.78,
              "y": -31.04
            },
            {
              "x": -29.64,
              "y": -1.77
            },
            {
              "x": -24.28,
              "y": -22.2
            },
            {
              "x": -7.13,
              "y": 10.22
            },
            {
              "x": -25.09,
              "y": -18.11
            },
            {
              "x": -18.0,
              "y": -2.48
            },
            {
              "x": -8.87,
              "y": -20.69
            }
          ],
          "time": 3.504
        },
        {
          "ball": {
            "x": -25.49,
            "y": -16.51,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -12.9,
              "y": -26.96
            },
            {
              "x": -18.64,
              "y": -18.88
            },
            {
              "x": -33.17,
              "y": 0.23
            },
            {
              "x": -9.61,
              "y": 11.02
            },
            {
              "x": -32.79,
              "y": -5.75
            },
            {
              "x": -49.4,
              "y": -1.44
            },
            {
              "x": -27.67,
              "y": -20.05
            },
            {
              "x": -21.57,
              "y": -15.64
            },
            {
              "x": -30.54,
              "y": -15.62
            },
            {
              "x": -31.27,
              "y": -12.09
            },
            {
              "x": -25.71,
              "y": -11.14
            }
          ],
          "awayPlayers": [
            {
              "x": -30.38,
              "y": -9.5
            },
            {
              "x": 31.42,
              "y": -3.71
            },
            {
              "x": 0.6,
              "y": -8.97
            },
            {
              "x": -5.01,
              "y": -24.36
            },
            {
              "x": -27.92,
              "y": -30.53
            },
            {
              "x": -29.95,
              "y": -1.74
            },
            {
              "x": -26.2,
              "y": -22.27
            },
            {
              "x": -7.81,
              "y": 10.47
            },
            {
              "x": -25.57,
              "y": -16.88
            },
            {
              "x": -18.75,
              "y": -1.91
            },
            {
              "x": -8.27,
              "y": -20.43
            }
          ],
          "time": 3.837
        },
        {
          "ball": {
            "x": -25.69,
            "y": -14.85,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -12.97,
              "y": -27.1
            },
            {
              "x": -18.6,
              "y": -19.21
            },
            {
              "x": -33.39,
              "y": -0.01
            },
            {
              "x": -10.35,
              "y": 11.17
            },
            {
              "x": -33.23,
              "y": -6.08
            },
            {
              "x": -49.53,
              "y": -1.55
            },
            {
              "x": -28.77,
              "y": -19.31
            },
            {
              "x": -22.43,
              "y": -14.52
            },
            {
              "x": -30.5,
              "y": -14.95
            },
            {
              "x": -31.75,
              "y": -12.19
            },
            {
              "x": -26.3,
              "y": -11.17
            }
          ],
          "awayPlayers": [
            {
              "x": -31.08,
              "y": -9.16
            },
            {
              "x": 31.26,
              "y": -3.54
            },
            {
              "x": 0.21,
              "y": -8.58
            },
            {
              "x": -5.62,
              "y": -23.62
            },
            {
              "x": -28.91,
              "y": -29.8
            },
            {
              "x": -30.08,
              "y": -1.79
            },
            {
              "x": -28.3,
              "y": -21.94
            },
            {
              "x": -8.54,
              "y": 10.78
            },
            {
              "x": -25.91,
              "y": -15.71
            },
            {
              "x": -19.68,
              "y": -1.36
            },
            {
              "x": -7.79,
              "y": -20.14
            }
          ],
          "time": 4.171
        },
        {
          "ball": {
            "x": -25.15,
            "y": -11.01,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": -12.35,
              "y": -27.59
            },
            {
              "x": -18.6,
              "y": -19.43
            },
            {
              "x": -33.5,
              "y": -0.03
            },
            {
              "x": -11.13,
              "y": 11.39
            },
            {
              "x": -33.5,
              "y": -6.41
            },
            {
              "x": -49.67,
              "y": -1.42
            },
            {
              "x": -30.19,
              "y": -18.77
            },
            {
              "x": -23.26,
              "y": -13.38
            },
            {
              "x": -30.57,
              "y": -14.31
            },
            {
              "x": -32.12,
              "y": -11.65
            },
            {
              "x": -26.52,
              "y": -10.92
            }
          ],
          "awayPlayers": [
            {
              "x": -31.61,
              "y": -8.83
            },
            {
              "x": 31.36,
              "y": -3.33
            },
            {
              "x": -0.2,
              "y": -8.24
            },
            {
              "x": -6.31,
              "y": -22.97
            },
            {
              "x": -29.7,
              "y": -28.87
            },
            {
              "x": -30.17,
              "y": -1.79
            },
            {
              "x": -30.39,
              "y": -21.26
            },
            {
              "x": -9.17,
              "y": 11.04
            },
            {
              "x": -26.47,
              "y": -14.55
            },
            {
              "x": -20.76,
              "y": -0.77
            },
            {
              "x": -7.34,
              "y": -19.77
            }
          ],
          "time": 4.505
        },
        {
          "ball": {
            "x": -24.18,
            "y": -6.73,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -11.84,
              "y": -27.98
            },
            {
              "x": -18.53,
              "y": -19.56
            },
            {
              "x": -33.59,
              "y": 0.21
            },
            {
              "x": -11.88,
              "y": 11.7
            },
            {
              "x": -33.61,
              "y": -6.37
            },
            {
              "x": -49.79,
              "y": -1.25
            },
            {
              "x": -31.71,
              "y": -18.31
            },
            {
              "x": -23.94,
              "y": -12.19
            },
            {
              "x": -30.95,
              "y": -13.54
            },
            {
              "x": -32.79,
              "y": -10.26
            },
            {
              "x": -26.68,
              "y": -10.38
            }
          ],
          "awayPlayers": [
            {
              "x": -32.05,
              "y": -8.53
            },
            {
              "x": 30.98,
              "y": -3.11
            },
            {
              "x": -0.57,
              "y": -7.79
            },
            {
              "x": -6.97,
              "y": -22.09
            },
            {
              "x": -30.31,
              "y": -27.8
            },
            {
              "x": -30.42,
              "y": -1.7
            },
            {
              "x": -32.27,
              "y": -20.42
            },
            {
              "x": -10.0,
              "y": 11.43
            },
            {
              "x": -27.23,
              "y": -13.56
            },
            {
              "x": -21.57,
              "y": -0.36
            },
            {
              "x": -7.36,
              "y": -19.45
            }
          ],
          "time": 4.838
        },
        {
          "ball": {
            "x": -23.39,
            "y": -3.36,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -11.88,
              "y": -28.06
            },
            {
              "x": -18.39,
              "y": -19.54
            },
            {
              "x": -33.7,
              "y": 0.63
            },
            {
              "x": -12.68,
              "y": 11.87
            },
            {
              "x": -33.58,
              "y": -5.97
            },
            {
              "x": -50.01,
              "y": -0.9
            },
            {
              "x": -33.0,
              "y": -17.75
            },
            {
              "x": -24.48,
              "y": -10.9
            },
            {
              "x": -31.58,
              "y": -12.7
            },
            {
              "x": -33.41,
              "y": -9.11
            },
            {
              "x": -27.04,
              "y": -9.41
            }
          ],
          "awayPlayers": [
            {
              "x": -32.6,
              "y": -8.09
            },
            {
              "x": 30.98,
              "y": -2.83
            },
            {
              "x": -0.88,
              "y": -7.38
            },
            {
              "x": -7.65,
              "y": -21.19
            },
            {
              "x": -30.88,
              "y": -26.64
            },
            {
              "x": -30.77,
              "y": -1.55
            },
            {
              "x": -33.88,
              "y": -19.42
            },
            {
              "x": -10.7,
              "y": 11.62
            },
            {
              "x": -28.19,
              "y": -12.9
            },
            {
              "x": -22.03,
              "y": -0.19
            },
            {
              "x": -7.32,
              "y": -19.11
            }
          ],
          "time": 5.172
        },
        {
          "ball": {
            "x": -22.79,
            "y": -0.9,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -12.46,
              "y": -27.67
            },
            {
              "x": -18.18,
              "y": -19.42
            },
            {
              "x": -33.91,
              "y": 1.3
            },
            {
              "x": -13.51,
              "y": 11.94
            },
            {
              "x": -33.65,
              "y": -5.08
            },
            {
              "x": -50.18,
              "y": -0.61
            },
            {
              "x": -33.9,
              "y": -16.9
            },
            {
              "x": -24.92,
              "y": -9.52
            },
            {
              "x": -32.34,
              "y": -11.94
            },
            {
              "x": -33.98,
              "y": -8.14
            },
            {
              "x": -27.52,
              "y": -7.85
            }
          ],
          "awayPlayers": [
            {
              "x": -33.29,
              "y": -7.34
            },
            {
              "x": 30.71,
              "y": -2.68
            },
            {
              "x": -1.14,
              "y": -6.98
            },
            {
              "x": -8.14,
              "y": -20.26
            },
            {
              "x": -31.42,
              "y": -25.43
            },
            {
              "x": -31.21,
              "y": -0.91
            },
            {
              "x": -35.16,
              "y": -18.29
            },
            {
              "x": -11.37,
              "y": 11.77
            },
            {
              "x": -29.19,
              "y": -12.45
            },
            {
              "x": -22.24,
              "y": -0.07
            },
            {
              "x": -7.29,
              "y": -18.79
            }
          ],
          "time": 5.506
        },
        {
          "ball": {
            "x": -23.33,
            "y": -0.12,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -13.0,
              "y": -27.32
            },
            {
              "x": -17.97,
              "y": -19.09
            },
            {
              "x": -34.19,
              "y": 2.02
            },
            {
              "x": -14.47,
              "y": 12.07
            },
            {
              "x": -33.8,
              "y": -4.04
            },
            {
              "x": -50.26,
              "y": -0.36
            },
            {
              "x": -34.43,
              "y": -15.82
            },
            {
              "x": -25.38,
              "y": -8.12
            },
            {
              "x": -33.12,
              "y": -11.29
            },
            {
              "x": -34.36,
              "y": -7.55
            },
            {
              "x": -27.94,
              "y": -6.01
            }
          ],
          "awayPlayers": [
            {
              "x": -33.96,
              "y": -6.59
            },
            {
              "x": 30.67,
              "y": -2.42
            },
            {
              "x": -1.37,
              "y": -6.54
            },
            {
              "x": -8.56,
              "y": -19.27
            },
            {
              "x": -32.03,
              "y": -24.22
            },
            {
              "x": -31.61,
              "y": 0.3
            },
            {
              "x": -36.1,
              "y": -17.02
            },
            {
              "x": -12.13,
              "y": 12.05
            },
            {
              "x": -30.21,
              "y": -12.14
            },
            {
              "x": -22.65,
              "y": 0.03
            },
            {
              "x": -7.27,
              "y": -18.41
            }
          ],
          "time": 5.839
        },
        {
          "ball": {
            "x": -24.06,
            "y": -0.44,
            "z": 0.08
          },
          "homePlayers": [
            {
              "x": -13.46,
              "y": -27.01
            },
            {
              "x": -17.77,
              "y": -18.7
            },
            {
              "x": -34.62,
              "y": 2.8
            },
            {
              "x": -15.49,
              "y": 12.27
            },
            {
              "x": -34.22,
              "y": -2.83
            },
            {
              "x": -50.21,
              "y": -0.28
            },
            {
              "x": -34.74,
              "y": -14.68
            },
            {
              "x": -25.9,
              "y": -6.82
            },
            {
              "x": -33.85,
              "y": -10.64
            },
            {
              "x": -34.97,
              "y": -6.43
            },
            {
              "x": -28.27,
              "y": -3.96
            }
          ],
          "awayPlayers": [
            {
              "x": -34.63,
              "y": -5.74
            },
            {
              "x": 30.64,
              "y": -2.18
            },
            {
              "x": -1.63,
              "y": -6.07
            },
            {
              "x": -8.98,
              "y": -18.4
            },
            {
              "x": -32.59,
              "y": -23.09
            },
            {
              "x": -31.89,
              "y": 1.95
            },
            {
              "x": -36.68,
              "y": -15.69
            },
            {
              "x": -13.03,
              "y": 12.26
            },
            {
              "x": -31.15,
              "y": -11.83
            },
            {
              "x": -23.47,
              "y": 0.06
            },
            {
              "x": -7.17,
              "y": -18.07
            }
          ],
          "time": 6.173
        },
        {
          "ball": {
            "x": -24.9,
            "y": 0.01,
            "z": 0.14
          },
          "homePlayers": [
            {
              "x": -14.23,
              "y": -26.62
            },
            {
              "x": -17.54,
              "y": -18.32
            },
            {
              "x": -35.12,
              "y": 3.61
            },
            {
              "x": -16.6,
              "y": 12.55
            },
            {
              "x": -34.72,
              "y": -1.77
            },
            {
              "x": -50.09,
              "y": -0.27
            },
            {
              "x": -34.96,
              "y": -13.6
            },
            {
              "x": -26.47,
              "y": -5.71
            },
            {
              "x": -34.54,
              "y": -9.97
            },
            {
              "x": -35.59,
              "y": -5.35
            },
            {
              "x": -28.42,
              "y": -1.97
            }
          ],
          "awayPlayers": [
            {
              "x": -35.29,
              "y": -4.89
            },
            {
              "x": 30.38,
              "y": -1.95
            },
            {
              "x": -1.94,
              "y": -5.66
            },
            {
              "x": -9.48,
              "y": -17.54
            },
            {
              "x": -33.17,
              "y": -22.04
            },
            {
              "x": -32.16,
              "y": 3.7
            },
            {
              "x": -37.0,
              "y": -14.37
            },
            {
              "x": -13.99,
              "y": 12.53
            },
            {
              "x": -32.0,
              "y": -11.55
            },
            {
              "x": -24.57,
              "y": 0.27
            },
            {
              "x": -7.14,
              "y": -17.71
            }
          ],
          "time": 6.507
        },
        {
          "ball": {
            "x": -25.77,
            "y": 1.03,
            "z": 0.09
          },
          "homePlayers": [
            {
              "x": -14.86,
              "y": -26.34
            },
            {
              "x": -17.25,
              "y": -17.99
            },
            {
              "x": -35.59,
              "y": 4.42
            },
            {
              "x": -17.59,
              "y": 12.73
            },
            {
              "x": -35.31,
              "y": -0.79
            },
            {
              "x": -50.02,
              "y": -0.2
            },
            {
              "x": -35.22,
              "y": -12.54
            },
            {
              "x": -27.0,
              "y": -4.73
            },
            {
              "x": -35.2,
              "y": -9.27
            },
            {
              "x": -36.17,
              "y": -4.39
            },
            {
              "x": -28.62,
              "y": 0.0
            }
          ],
          "awayPlayers": [
            {
              "x": -36.08,
              "y": -3.81
            },
            {
              "x": 30.27,
              "y": -1.74
            },
            {
              "x": -2.27,
              "y": -5.12
            },
            {
              "x": -9.92,
              "y": -16.41
            },
            {
              "x": -33.65,
              "y": -21.11
            },
            {
              "x": -32.67,
              "y": 5.61
            },
            {
              "x": -37.16,
              "y": -13.06
            },
            {
              "x": -15.01,
              "y": 12.94
            },
            {
              "x": -32.81,
              "y": -11.27
            },
            {
              "x": -25.79,
              "y": 0.98
            },
            {
              "x": -7.12,
              "y": -17.25
            }
          ],
          "time": 6.84
        },
        {
          "ball": {
            "x": -27.02,
            "y": 2.27,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -15.45,
              "y": -25.9
            },
            {
              "x": -16.99,
              "y": -17.37
            },
            {
              "x": -36.12,
              "y": 5.65
            },
            {
              "x": -18.44,
              "y": 12.97
            },
            {
              "x": -35.93,
              "y": 0.08
            },
            {
              "x": -49.97,
              "y": -0.13
            },
            {
              "x": -35.53,
              "y": -11.52
            },
            {
              "x": -27.48,
              "y": -3.79
            },
            {
              "x": -35.84,
              "y": -8.6
            },
            {
              "x": -36.62,
              "y": -3.71
            },
            {
              "x": -28.83,
              "y": 1.56
            }
          ],
          "awayPlayers": [
            {
              "x": -36.59,
              "y": -3.16
            },
            {
              "x": 30.45,
              "y": -1.6
            },
            {
              "x": -2.56,
              "y": -4.62
            },
            {
              "x": -10.33,
              "y": -15.52
            },
            {
              "x": -34.15,
              "y": -20.24
            },
            {
              "x": -33.28,
              "y": 7.54
            },
            {
              "x": -37.22,
              "y": -11.8
            },
            {
              "x": -15.88,
              "y": 13.3
            },
            {
              "x": -33.54,
              "y": -10.95
            },
            {
              "x": -26.88,
              "y": 2.02
            },
            {
              "x": -7.08,
              "y": -16.71
            }
          ],
          "time": 7.174
        },
        {
          "ball": {
            "x": -29.19,
            "y": 5.26,
            "z": 0.01
          },
          "homePlayers": [
            {
              "x": -16.16,
              "y": -25.44
            },
            {
              "x": -16.74,
              "y": -16.21
            },
            {
              "x": -36.52,
              "y": 7.2
            },
            {
              "x": -19.37,
              "y": 13.28
            },
            {
              "x": -36.54,
              "y": 0.73
            },
            {
              "x": -49.98,
              "y": -0.01
            },
            {
              "x": -35.92,
              "y": -10.38
            },
            {
              "x": -27.88,
              "y": -2.79
            },
            {
              "x": -36.41,
              "y": -8.0
            },
            {
              "x": -37.18,
              "y": -2.98
            },
            {
              "x": -29.26,
              "y": 2.93
            }
          ],
          "awayPlayers": [
            {
              "x": -37.23,
              "y": -2.22
            },
            {
              "x": 30.1,
              "y": -1.41
            },
            {
              "x": -2.94,
              "y": -4.03
            },
            {
              "x": -10.75,
              "y": -14.38
            },
            {
              "x": -34.6,
              "y": -19.41
            },
            {
              "x": -33.84,
              "y": 9.47
            },
            {
              "x": -37.25,
              "y": -10.52
            },
            {
              "x": -16.89,
              "y": 13.75
            },
            {
              "x": -34.16,
              "y": -10.6
            },
            {
              "x": -27.94,
              "y": 3.0
            },
            {
              "x": -7.16,
              "y": -16.11
            }
          ],
          "time": 7.508
        },
        {
          "ball": {
            "x": -31.01,
            "y": 8.34,
            "z": 0.11
          },
          "homePlayers": [
            {
              "x": -16.89,
              "y": -25.0
            },
            {
              "x": -16.66,
              "y": -15.59
            },
            {
              "x": -36.74,
              "y": 9.21
            },
            {
              "x": -20.31,
              "y": 13.48
            },
            {
              "x": -37.26,
              "y": 1.19
            },
            {
              "x": -50.02,
              "y": 0.22
            },
            {
              "x": -36.3,
              "y": -9.15
            },
            {
              "x": -28.21,
              "y": -1.72
            },
            {
              "x": -36.97,
              "y": -7.48
            },
            {
              "x": -37.73,
              "y": -2.45
            },
            {
              "x": -29.94,
              "y": 3.87
            }
          ],
          "awayPlayers": [
            {
              "x": -37.83,
              "y": -1.66
            },
            {
              "x": 30.08,
              "y": -1.25
            },
            {
              "x": -3.36,
              "y": -3.33
            },
            {
              "x": -11.38,
              "y": -13.38
            },
            {
              "x": -35.02,
              "y": -18.7
            },
            {
              "x": -34.13,
              "y": 11.19
            },
            {
              "x": -37.29,
              "y": -9.32
            },
            {
              "x": -17.85,
              "y": 14.15
            },
            {
              "x": -34.57,
              "y": -10.29
            },
            {
              "x": -29.04,
              "y": 3.5
            },
            {
              "x": -7.22,
              "y": -15.38
            }
          ],
          "time": 7.841
        },
        {
          "ball": {
            "x": -33.52,
            "y": 12.18,
            "z": 0.01
          },
          "homePlayers": [
            {
              "x": -17.85,
              "y": -24.45
            },
            {
              "x": -15.85,
              "y": -15.17
            },
            {
              "x": -36.62,
              "y": 11.17
            },
            {
              "x": -21.68,
              "y": 13.48
            },
            {
              "x": -37.97,
              "y": 1.3
            },
            {
              "x": -49.99,
              "y": 0.49
            },
            {
              "x": -36.54,
              "y": -8.01
            },
            {
              "x": -28.44,
              "y": -0.75
            },
            {
              "x": -37.45,
              "y": -6.84
            },
            {
              "x": -38.51,
              "y": -1.83
            },
            {
              "x": -30.89,
              "y": 4.57
            }
          ],
          "awayPlayers": [
            {
              "x": -38.44,
              "y": -1.19
            },
            {
              "x": 29.56,
              "y": -1.12
            },
            {
              "x": -3.8,
              "y": -2.77
            },
            {
              "x": -11.99,
              "y": -12.38
            },
            {
              "x": -35.39,
              "y": -18.09
            },
            {
              "x": -34.28,
              "y": 12.62
            },
            {
              "x": -37.29,
              "y": -8.3
            },
            {
              "x": -18.78,
              "y": 14.51
            },
            {
              "x": -34.86,
              "y": -10.08
            },
            {
              "x": -30.42,
              "y": 3.77
            },
            {
              "x": -7.53,
              "y": -14.7
            }
          ],
          "time": 8.175
        },
        {
          "ball": {
            "x": -33.55,
            "y": 12.67,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -18.69,
              "y": -24.0
            },
            {
              "x": -14.89,
              "y": -15.0
            },
            {
              "x": -36.33,
              "y": 12.78
            },
            {
              "x": -23.25,
              "y": 12.98
            },
            {
              "x": -38.68,
              "y": 1.45
            },
            {
              "x": -49.9,
              "y": 0.69
            },
            {
              "x": -36.82,
              "y": -6.81
            },
            {
              "x": -28.55,
              "y": 0.15
            },
            {
              "x": -37.96,
              "y": -6.39
            },
            {
              "x": -39.3,
              "y": -1.32
            },
            {
              "x": -31.93,
              "y": 4.92
            }
          ],
          "awayPlayers": [
            {
              "x": -38.96,
              "y": -1.04
            },
            {
              "x": 29.79,
              "y": -1.03
            },
            {
              "x": -4.14,
              "y": -1.96
            },
            {
              "x": -12.56,
              "y": -11.27
            },
            {
              "x": -35.72,
              "y": -17.59
            },
            {
              "x": -34.09,
              "y": 13.47
            },
            {
              "x": -37.36,
              "y": -7.23
            },
            {
              "x": -19.67,
              "y": 15.01
            },
            {
              "x": -35.05,
              "y": -10.04
            },
            {
              "x": -32.07,
              "y": 4.04
            },
            {
              "x": -7.72,
              "y": -13.86
            }
          ],
          "time": 8.509
        },
        {
          "ball": {
            "x": -33.18,
            "y": 12.53,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -20.83,
              "y": -22.45
            },
            {
              "x": -14.04,
              "y": -14.83
            },
            {
              "x": -36.05,
              "y": 13.55
            },
            {
              "x": -24.73,
              "y": 12.55
            },
            {
              "x": -39.26,
              "y": 1.89
            },
            {
              "x": -49.78,
              "y": 0.72
            },
            {
              "x": -37.05,
              "y": -5.64
            },
            {
              "x": -28.6,
              "y": 0.97
            },
            {
              "x": -38.49,
              "y": -6.04
            },
            {
              "x": -39.92,
              "y": -1.08
            },
            {
              "x": -33.18,
              "y": 5.38
            }
          ],
          "awayPlayers": [
            {
              "x": -39.64,
              "y": -0.56
            },
            {
              "x": 29.45,
              "y": -0.92
            },
            {
              "x": -4.48,
              "y": -1.4
            },
            {
              "x": -12.98,
              "y": -10.39
            },
            {
              "x": -36.06,
              "y": -17.14
            },
            {
              "x": -33.64,
              "y": 13.5
            },
            {
              "x": -37.27,
              "y": -6.37
            },
            {
              "x": -20.54,
              "y": 15.49
            },
            {
              "x": -35.41,
              "y": -10.19
            },
            {
              "x": -33.91,
              "y": 4.75
            },
            {
              "x": -8.14,
              "y": -13.17
            }
          ],
          "time": 8.842
        },
        {
          "ball": {
            "x": -33.48,
            "y": 12.34,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -23.65,
              "y": -20.46
            },
            {
              "x": -13.74,
              "y": -14.39
            },
            {
              "x": -35.9,
              "y": 13.46
            },
            {
              "x": -25.97,
              "y": 12.32
            },
            {
              "x": -39.81,
              "y": 2.81
            },
            {
              "x": -49.83,
              "y": 0.88
            },
            {
              "x": -37.28,
              "y": -4.68
            },
            {
              "x": -28.57,
              "y": 1.74
            },
            {
              "x": -39.26,
              "y": -5.81
            },
            {
              "x": -40.29,
              "y": -1.01
            },
            {
              "x": -34.6,
              "y": 6.16
            }
          ],
          "awayPlayers": [
            {
              "x": -40.0,
              "y": -0.12
            },
            {
              "x": 29.57,
              "y": -0.8
            },
            {
              "x": -4.75,
              "y": -0.74
            },
            {
              "x": -13.29,
              "y": -9.66
            },
            {
              "x": -36.52,
              "y": -16.59
            },
            {
              "x": -33.21,
              "y": 13.32
            },
            {
              "x": -36.98,
              "y": -5.57
            },
            {
              "x": -21.62,
              "y": 15.95
            },
            {
              "x": -35.97,
              "y": -10.47
            },
            {
              "x": -35.8,
              "y": 5.94
            },
            {
              "x": -8.16,
              "y": -12.59
            }
          ],
          "time": 9.176
        },
        {
          "ball": {
            "x": -36.47,
            "y": 11.64,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -26.33,
              "y": -18.54
            },
            {
              "x": -13.69,
              "y": -13.86
            },
            {
              "x": -35.88,
              "y": 12.75
            },
            {
              "x": -27.1,
              "y": 12.48
            },
            {
              "x": -40.56,
              "y": 4.22
            },
            {
              "x": -49.95,
              "y": 1.32
            },
            {
              "x": -37.39,
              "y": -3.96
            },
            {
              "x": -28.56,
              "y": 2.44
            },
            {
              "x": -39.94,
              "y": -5.6
            },
            {
              "x": -40.72,
              "y": -0.89
            },
            {
              "x": -36.08,
              "y": 7.09
            }
          ],
          "awayPlayers": [
            {
              "x": -40.14,
              "y": 0.18
            },
            {
              "x": 29.25,
              "y": -0.63
            },
            {
              "x": -5.05,
              "y": -0.22
            },
            {
              "x": -13.84,
              "y": -9.14
            },
            {
              "x": -36.95,
              "y": -15.99
            },
            {
              "x": -32.62,
              "y": 13.4
            },
            {
              "x": -36.42,
              "y": -4.95
            },
            {
              "x": -22.4,
              "y": 16.23
            },
            {
              "x": -36.79,
              "y": -10.68
            },
            {
              "x": -37.7,
              "y": 7.39
            },
            {
              "x": -8.39,
              "y": -12.05
            }
          ],
          "time": 9.51
        },
        {
          "ball": {
            "x": -39.81,
            "y": 10.92,
            "z": 0.05
          },
          "homePlayers": [
            {
              "x": -27.78,
              "y": -17.58
            },
            {
              "x": -13.54,
              "y": -13.2
            },
            {
              "x": -36.17,
              "y": 12.11
            },
            {
              "x": -27.79,
              "y": 12.52
            },
            {
              "x": -41.65,
              "y": 5.83
            },
            {
              "x": -49.91,
              "y": 1.99
            },
            {
              "x": -37.49,
              "y": -3.05
            },
            {
              "x": -28.53,
              "y": 3.11
            },
            {
              "x": -40.73,
              "y": -5.47
            },
            {
              "x": -41.56,
              "y": -0.22
            },
            {
              "x": -37.52,
              "y": 7.8
            }
          ],
          "awayPlayers": [
            {
              "x": -40.75,
              "y": 0.74
            },
            {
              "x": 29.25,
              "y": -0.52
            },
            {
              "x": -5.29,
              "y": 0.45
            },
            {
              "x": -14.41,
              "y": -8.63
            },
            {
              "x": -37.3,
              "y": -15.33
            },
            {
              "x": -32.26,
              "y": 13.61
            },
            {
              "x": -36.04,
              "y": -3.96
            },
            {
              "x": -23.16,
              "y": 16.56
            },
            {
              "x": -37.8,
              "y": -10.6
            },
            {
              "x": -39.8,
              "y": 8.89
            },
            {
              "x": -8.39,
              "y": -11.53
            }
          ],
          "time": 9.843
        },
        {
          "ball": {
            "x": -42.48,
            "y": 10.31,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -28.82,
              "y": -16.89
            },
            {
              "x": -13.58,
              "y": -12.65
            },
            {
              "x": -36.8,
              "y": 11.86
            },
            {
              "x": -28.23,
              "y": 12.86
            },
            {
              "x": -43.27,
              "y": 7.54
            },
            {
              "x": -49.8,
              "y": 2.77
            },
            {
              "x": -37.78,
              "y": -2.23
            },
            {
              "x": -28.48,
              "y": 3.48
            },
            {
              "x": -41.58,
              "y": -5.42
            },
            {
              "x": -42.71,
              "y": 0.55
            },
            {
              "x": -39.04,
              "y": 8.15
            }
          ],
          "awayPlayers": [
            {
              "x": -41.82,
              "y": 1.17
            },
            {
              "x": 29.14,
              "y": -0.41
            },
            {
              "x": -5.58,
              "y": 1.14
            },
            {
              "x": -15.18,
              "y": -7.93
            },
            {
              "x": -37.6,
              "y": -14.63
            },
            {
              "x": -31.19,
              "y": 13.38
            },
            {
              "x": -35.95,
              "y": -2.85
            },
            {
              "x": -23.71,
              "y": 17.0
            },
            {
              "x": -38.91,
              "y": -10.0
            },
            {
              "x": -41.9,
              "y": 9.74
            },
            {
              "x": -8.62,
              "y": -10.81
            }
          ],
          "time": 10.177
        }
      ],
      "duration": 10.177,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/e37033bb-0396-4b60-bd5c-b823b0889d16/1593.227"
    },
    {
      "id": "3827_130.0_subset1",
      "matchId": "3827",
      "sequenceId": "130.0_subset1",
      "dtwScore": 0.11801594467791275,
      "frames": [
        {
          "ball": {
            "x": -6.8,
            "y": -24.28,
            "z": 0.11
          },
          "homePlayers": [
            {
              "x": -7.5,
              "y": -10.96
            },
            {
              "x": -21.12,
              "y": -33.84
            },
            {
              "x": 7.8,
              "y": -21.32
            },
            {
              "x": -25.12,
              "y": -5.79
            },
            {
              "x": -23.99,
              "y": 27.78
            },
            {
              "x": 33.2,
              "y": -5.11
            },
            {
              "x": 5.5,
              "y": -3.29
            },
            {
              "x": -5.96,
              "y": -24.34
            },
            {
              "x": -16.71,
              "y": 4.81
            },
            {
              "x": -11.62,
              "y": -29.72
            },
            {
              "x": 0.32,
              "y": 12.61
            }
          ],
          "awayPlayers": [
            {
              "x": -8.53,
              "y": -2.73
            },
            {
              "x": -13.59,
              "y": -24.63
            },
            {
              "x": -40.97,
              "y": -3.02
            },
            {
              "x": -27.03,
              "y": -7.94
            },
            {
              "x": 1.76,
              "y": -3.15
            },
            {
              "x": -23.49,
              "y": -28.43
            },
            {
              "x": -14.22,
              "y": -11.35
            },
            {
              "x": -23.78,
              "y": 12.46
            },
            {
              "x": -25.03,
              "y": 1.96
            },
            {
              "x": -8.8,
              "y": -21.53
            },
            {
              "x": -13.35,
              "y": -28.78
            }
          ],
          "time": 0.0
        },
        {
          "ball": {
            "x": -5.95,
            "y": -24.31,
            "z": 0.13
          },
          "homePlayers": [
            {
              "x": -7.6,
              "y": -11.39
            },
            {
              "x": -20.95,
              "y": -33.83
            },
            {
              "x": 7.75,
              "y": -21.5
            },
            {
              "x": -25.17,
              "y": -6.26
            },
            {
              "x": -23.81,
              "y": 27.93
            },
            {
              "x": 32.51,
              "y": -5.23
            },
            {
              "x": 5.84,
              "y": -2.61
            },
            {
              "x": -5.58,
              "y": -24.4
            },
            {
              "x": -16.64,
              "y": 5.05
            },
            {
              "x": -11.5,
              "y": -30.14
            },
            {
              "x": -0.31,
              "y": 12.59
            }
          ],
          "awayPlayers": [
            {
              "x": -8.31,
              "y": -3.13
            },
            {
              "x": -13.31,
              "y": -24.43
            },
            {
              "x": -40.85,
              "y": -2.89
            },
            {
              "x": -27.12,
              "y": -8.16
            },
            {
              "x": 1.4,
              "y": -2.92
            },
            {
              "x": -23.27,
              "y": -28.84
            },
            {
              "x": -13.97,
              "y": -11.84
            },
            {
              "x": -23.75,
              "y": 12.99
            },
            {
              "x": -24.84,
              "y": 2.1
            },
            {
              "x": -8.3,
              "y": -21.59
            },
            {
              "x": -13.2,
              "y": -28.44
            }
          ],
          "time": 0.334
        },
        {
          "ball": {
            "x": -5.42,
            "y": -22.39,
            "z": 0.22
          },
          "homePlayers": [
            {
              "x": -7.57,
              "y": -11.83
            },
            {
              "x": -20.75,
              "y": -33.82
            },
            {
              "x": 7.8,
              "y": -21.54
            },
            {
              "x": -25.14,
              "y": -6.68
            },
            {
              "x": -23.53,
              "y": 28.06
            },
            {
              "x": 31.96,
              "y": -5.27
            },
            {
              "x": 6.19,
              "y": -1.73
            },
            {
              "x": -5.11,
              "y": -24.37
            },
            {
              "x": -16.57,
              "y": 5.22
            },
            {
              "x": -11.24,
              "y": -30.57
            },
            {
              "x": -0.92,
              "y": 12.34
            }
          ],
          "awayPlayers": [
            {
              "x": -8.05,
              "y": -3.17
            },
            {
              "x": -12.91,
              "y": -24.19
            },
            {
              "x": -40.7,
              "y": -2.8
            },
            {
              "x": -26.89,
              "y": -8.45
            },
            {
              "x": 1.07,
              "y": -2.64
            },
            {
              "x": -23.15,
              "y": -28.97
            },
            {
              "x": -13.5,
              "y": -12.1
            },
            {
              "x": -23.51,
              "y": 13.69
            },
            {
              "x": -24.42,
              "y": 2.32
            },
            {
              "x": -7.54,
              "y": -21.45
            },
            {
              "x": -13.13,
              "y": -28.12
            }
          ],
          "time": 0.667
        },
        {
          "ball": {
            "x": -5.17,
            "y": -21.63,
            "z": 0.21
          },
          "homePlayers": [
            {
              "x": -7.36,
              "y": -12.34
            },
            {
              "x": -20.56,
              "y": -33.81
            },
            {
              "x": 7.72,
              "y": -21.38
            },
            {
              "x": -25.01,
              "y": -7.05
            },
            {
              "x": -23.19,
              "y": 28.2
            },
            {
              "x": 31.68,
              "y": -5.34
            },
            {
              "x": 6.56,
              "y": -0.85
            },
            {
              "x": -4.75,
              "y": -24.25
            },
            {
              "x": -16.48,
              "y": 5.42
            },
            {
              "x": -10.81,
              "y": -31.04
            },
            {
              "x": -1.48,
              "y": 12.15
            }
          ],
          "awayPlayers": [
            {
              "x": -7.74,
              "y": -3.27
            },
            {
              "x": -12.42,
              "y": -23.94
            },
            {
              "x": -40.59,
              "y": -2.71
            },
            {
              "x": -26.54,
              "y": -8.77
            },
            {
              "x": 0.79,
              "y": -2.41
            },
            {
              "x": -23.09,
              "y": -29.02
            },
            {
              "x": -12.94,
              "y": -12.28
            },
            {
              "x": -23.08,
              "y": 14.19
            },
            {
              "x": -23.91,
              "y": 2.6
            },
            {
              "x": -6.75,
              "y": -21.27
            },
            {
              "x": -13.16,
              "y": -27.91
            }
          ],
          "time": 1.001
        },
        {
          "ball": {
            "x": -5.88,
            "y": -22.03,
            "z": 0.24
          },
          "homePlayers": [
            {
              "x": -7.06,
              "y": -12.8
            },
            {
              "x": -20.41,
              "y": -33.82
            },
            {
              "x": 7.57,
              "y": -21.07
            },
            {
              "x": -24.72,
              "y": -7.61
            },
            {
              "x": -22.93,
              "y": 28.47
            },
            {
              "x": 31.64,
              "y": -5.29
            },
            {
              "x": 6.93,
              "y": 0.15
            },
            {
              "x": -4.63,
              "y": -24.22
            },
            {
              "x": -16.35,
              "y": 5.55
            },
            {
              "x": -10.32,
              "y": -31.2
            },
            {
              "x": -1.99,
              "y": 11.95
            }
          ],
          "awayPlayers": [
            {
              "x": -7.49,
              "y": -3.31
            },
            {
              "x": -11.94,
              "y": -23.64
            },
            {
              "x": -40.53,
              "y": -2.69
            },
            {
              "x": -26.15,
              "y": -9.14
            },
            {
              "x": 0.53,
              "y": -2.06
            },
            {
              "x": -23.08,
              "y": -28.99
            },
            {
              "x": -12.43,
              "y": -12.6
            },
            {
              "x": -22.64,
              "y": 14.63
            },
            {
              "x": -23.39,
              "y": 2.86
            },
            {
              "x": -6.28,
              "y": -21.15
            },
            {
              "x": -13.23,
              "y": -27.78
            }
          ],
          "time": 1.335
        },
        {
          "ball": {
            "x": -6.06,
            "y": -22.45,
            "z": 0.21
          },
          "homePlayers": [
            {
              "x": -6.68,
              "y": -13.18
            },
            {
              "x": -20.31,
              "y": -33.81
            },
            {
              "x": 7.63,
              "y": -20.75
            },
            {
              "x": -24.25,
              "y": -8.4
            },
            {
              "x": -22.64,
              "y": 28.85
            },
            {
              "x": 31.77,
              "y": -5.27
            },
            {
              "x": 7.36,
              "y": 1.26
            },
            {
              "x": -4.81,
              "y": -24.3
            },
            {
              "x": -16.16,
              "y": 5.74
            },
            {
              "x": -9.77,
              "y": -31.27
            },
            {
              "x": -2.37,
              "y": 11.94
            }
          ],
          "awayPlayers": [
            {
              "x": -7.36,
              "y": -3.06
            },
            {
              "x": -11.56,
              "y": -23.35
            },
            {
              "x": -40.56,
              "y": -2.42
            },
            {
              "x": -25.55,
              "y": -9.58
            },
            {
              "x": 0.34,
              "y": -1.61
            },
            {
              "x": -23.07,
              "y": -29.02
            },
            {
              "x": -12.19,
              "y": -12.93
            },
            {
              "x": -22.18,
              "y": 15.13
            },
            {
              "x": -22.9,
              "y": 3.23
            },
            {
              "x": -6.15,
              "y": -21.1
            },
            {
              "x": -13.32,
              "y": -27.68
            }
          ],
          "time": 1.668
        },
        {
          "ball": {
            "x": -6.49,
            "y": -22.9,
            "z": 0.14
          },
          "homePlayers": [
            {
              "x": -6.28,
              "y": -13.51
            },
            {
              "x": -20.23,
              "y": -33.82
            },
            {
              "x": 7.72,
              "y": -20.44
            },
            {
              "x": -23.6,
              "y": -9.62
            },
            {
              "x": -22.33,
              "y": 29.01
            },
            {
              "x": 31.71,
              "y": -5.28
            },
            {
              "x": 7.77,
              "y": 2.25
            },
            {
              "x": -5.31,
              "y": -24.65
            },
            {
              "x": -15.91,
              "y": 5.71
            },
            {
              "x": -9.25,
              "y": -31.25
            },
            {
              "x": -2.7,
              "y": 11.81
            }
          ],
          "awayPlayers": [
            {
              "x": -7.35,
              "y": -2.84
            },
            {
              "x": -11.31,
              "y": -23.29
            },
            {
              "x": -40.52,
              "y": -2.32
            },
            {
              "x": -24.69,
              "y": -10.28
            },
            {
              "x": 0.14,
              "y": -1.36
            },
            {
              "x": -23.12,
              "y": -29.02
            },
            {
              "x": -12.1,
              "y": -13.36
            },
            {
              "x": -21.65,
              "y": 15.42
            },
            {
              "x": -22.44,
              "y": 3.55
            },
            {
              "x": -6.27,
              "y": -21.17
            },
            {
              "x": -13.34,
              "y": -27.7
            }
          ],
          "time": 2.002
        },
        {
          "ball": {
            "x": -7.2,
            "y": -24.03,
            "z": 0.06
          },
          "homePlayers": [
            {
              "x": -5.9,
              "y": -13.82
            },
            {
              "x": -20.18,
              "y": -33.85
            },
            {
              "x": 7.81,
              "y": -20.39
            },
            {
              "x": -22.91,
              "y": -11.15
            },
            {
              "x": -22.11,
              "y": 29.11
            },
            {
              "x": 31.81,
              "y": -5.28
            },
            {
              "x": 8.09,
              "y": 3.08
            },
            {
              "x": -6.2,
              "y": -24.99
            },
            {
              "x": -15.67,
              "y": 5.58
            },
            {
              "x": -8.91,
              "y": -31.33
            },
            {
              "x": -3.04,
              "y": 11.59
            }
          ],
          "awayPlayers": [
            {
              "x": -7.5,
              "y": -2.66
            },
            {
              "x": -11.2,
              "y": -23.59
            },
            {
              "x": -40.54,
              "y": -2.4
            },
            {
              "x": -23.83,
              "y": -11.32
            },
            {
              "x": -0.04,
              "y": -1.13
            },
            {
              "x": -23.18,
              "y": -29.21
            },
            {
              "x": -12.27,
              "y": -13.71
            },
            {
              "x": -21.2,
              "y": 15.61
            },
            {
              "x": -22.14,
              "y": 3.69
            },
            {
              "x": -6.68,
              "y": -21.3
            },
            {
              "x": -13.35,
              "y": -27.78
            }
          ],
          "time": 2.336
        },
        {
          "ball": {
            "x": -7.8,
            "y": -24.98,
            "z": 0.01
          },
          "homePlayers": [
            {
              "x": -5.58,
              "y": -14.17
            },
            {
              "x": -20.15,
              "y": -33.88
            },
            {
              "x": 7.77,
              "y": -20.68
            },
            {
              "x": -22.22,
              "y": -12.88
            },
            {
              "x": -22.11,
              "y": 29.18
            },
            {
              "x": 31.74,
              "y": -5.3
            },
            {
              "x": 8.37,
              "y": 3.32
            },
            {
              "x": -7.41,
              "y": -25.24
            },
            {
              "x": -15.52,
              "y": 5.18
            },
            {
              "x": -8.81,
              "y": -31.5
            },
            {
              "x": -3.45,
              "y": 11.31
            }
          ],
          "awayPlayers": [
            {
              "x": -7.86,
              "y": -2.64
            },
            {
              "x": -11.23,
              "y": -23.98
            },
            {
              "x": -40.69,
              "y": -2.75
            },
            {
              "x": -23.13,
              "y": -12.72
            },
            {
              "x": -0.29,
              "y": -1.0
            },
            {
              "x": -23.31,
              "y": -29.46
            },
            {
              "x": -12.67,
              "y": -14.11
            },
            {
              "x": -20.95,
              "y": 15.49
            },
            {
              "x": -22.2,
              "y": 3.56
            },
            {
              "x": -7.35,
              "y": -21.49
            },
            {
              "x": -13.47,
              "y": -27.76
            }
          ],
          "time": 2.669
        },
        {
          "ball": {
            "x": -10.13,
            "y": -23.2,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": -5.33,
              "y": -14.55
            },
            {
              "x": -20.16,
              "y": -33.87
            },
            {
              "x": 7.63,
              "y": -21.0
            },
            {
              "x": -21.71,
              "y": -14.41
            },
            {
              "x": -22.31,
              "y": 29.29
            },
            {
              "x": 31.63,
              "y": -5.32
            },
            {
              "x": 8.62,
              "y": 2.73
            },
            {
              "x": -8.78,
              "y": -25.35
            },
            {
              "x": -15.53,
              "y": 4.93
            },
            {
              "x": -8.87,
              "y": -31.61
            },
            {
              "x": -3.9,
              "y": 11.18
            }
          ],
          "awayPlayers": [
            {
              "x": -8.4,
              "y": -2.7
            },
            {
              "x": -11.57,
              "y": -24.15
            },
            {
              "x": -40.87,
              "y": -3.08
            },
            {
              "x": -22.57,
              "y": -14.1
            },
            {
              "x": -0.52,
              "y": -0.76
            },
            {
              "x": -23.46,
              "y": -29.69
            },
            {
              "x": -13.34,
              "y": -14.57
            },
            {
              "x": -21.01,
              "y": 15.48
            },
            {
              "x": -22.57,
              "y": 3.29
            },
            {
              "x": -8.2,
              "y": -21.55
            },
            {
              "x": -13.79,
              "y": -27.58
            }
          ],
          "time": 3.003
        },
        {
          "ball": {
            "x": -14.23,
            "y": -20.1,
            "z": 0.07
          },
          "homePlayers": [
            {
              "x": -5.2,
              "y": -14.78
            },
            {
              "x": -20.27,
              "y": -33.81
            },
            {
              "x": 7.39,
              "y": -21.19
            },
            {
              "x": -21.4,
              "y": -15.56
            },
            {
              "x": -22.6,
              "y": 29.2
            },
            {
              "x": 31.43,
              "y": -5.3
            },
            {
              "x": 8.75,
              "y": 2.03
            },
            {
              "x": -10.3,
              "y": -25.47
            },
            {
              "x": -15.62,
              "y": 4.49
            },
            {
              "x": -8.93,
              "y": -31.62
            },
            {
              "x": -4.35,
              "y": 11.11
            }
          ],
          "awayPlayers": [
            {
              "x": -9.04,
              "y": -2.83
            },
            {
              "x": -12.38,
              "y": -24.23
            },
            {
              "x": -41.04,
              "y": -3.41
            },
            {
              "x": -22.08,
              "y": -15.24
            },
            {
              "x": -0.77,
              "y": -0.52
            },
            {
              "x": -23.63,
              "y": -29.75
            },
            {
              "x": -14.31,
              "y": -15.01
            },
            {
              "x": -21.15,
              "y": 15.14
            },
            {
              "x": -23.09,
              "y": 2.86
            },
            {
              "x": -8.96,
              "y": -21.59
            },
            {
              "x": -14.41,
              "y": -27.23
            }
          ],
          "time": 3.337
        },
        {
          "ball": {
            "x": -18.22,
            "y": -17.96,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -5.23,
              "y": -14.85
            },
            {
              "x": -20.57,
              "y": -33.67
            },
            {
              "x": 7.1,
              "y": -21.07
            },
            {
              "x": -21.39,
              "y": -16.23
            },
            {
              "x": -22.99,
              "y": 29.06
            },
            {
              "x": 31.41,
              "y": -5.25
            },
            {
              "x": 8.5,
              "y": 1.28
            },
            {
              "x": -11.84,
              "y": -25.09
            },
            {
              "x": -15.83,
              "y": 4.19
            },
            {
              "x": -8.94,
              "y": -31.34
            },
            {
              "x": -4.79,
              "y": 11.05
            }
          ],
          "awayPlayers": [
            {
              "x": -9.71,
              "y": -2.93
            },
            {
              "x": -13.58,
              "y": -24.19
            },
            {
              "x": -41.27,
              "y": -3.73
            },
            {
              "x": -21.82,
              "y": -15.93
            },
            {
              "x": -1.04,
              "y": -0.15
            },
            {
              "x": -23.91,
              "y": -29.42
            },
            {
              "x": -15.58,
              "y": -15.52
            },
            {
              "x": -21.42,
              "y": 14.86
            },
            {
              "x": -23.65,
              "y": 2.36
            },
            {
              "x": -9.66,
              "y": -21.48
            },
            {
              "x": -15.17,
              "y": -26.96
            }
          ],
          "time": 3.67
        },
        {
          "ball": {
            "x": -20.8,
            "y": -16.55,
            "z": 0.28
          },
          "homePlayers": [
            {
              "x": -5.42,
              "y": -14.73
            },
            {
              "x": -21.0,
              "y": -33.49
            },
            {
              "x": 6.86,
              "y": -20.91
            },
            {
              "x": -21.52,
              "y": -16.36
            },
            {
              "x": -23.44,
              "y": 29.01
            },
            {
              "x": 31.22,
              "y": -5.11
            },
            {
              "x": 8.12,
              "y": 1.23
            },
            {
              "x": -13.31,
              "y": -23.86
            },
            {
              "x": -16.13,
              "y": 3.94
            },
            {
              "x": -8.93,
              "y": -30.99
            },
            {
              "x": -5.2,
              "y": 11.05
            }
          ],
          "awayPlayers": [
            {
              "x": -10.41,
              "y": -2.9
            },
            {
              "x": -15.08,
              "y": -23.94
            },
            {
              "x": -41.56,
              "y": -4.02
            },
            {
              "x": -21.92,
              "y": -16.19
            },
            {
              "x": -1.32,
              "y": 0.16
            },
            {
              "x": -24.29,
              "y": -28.64
            },
            {
              "x": -17.17,
              "y": -15.81
            },
            {
              "x": -21.78,
              "y": 14.58
            },
            {
              "x": -24.29,
              "y": 1.9
            },
            {
              "x": -10.24,
              "y": -21.33
            },
            {
              "x": -16.03,
              "y": -26.68
            }
          ],
          "time": 4.004
        },
        {
          "ball": {
            "x": -21.22,
            "y": -15.28,
            "z": 0.33
          },
          "homePlayers": [
            {
              "x": -5.7,
              "y": -14.6
            },
            {
              "x": -21.5,
              "y": -33.31
            },
            {
              "x": 6.53,
              "y": -20.83
            },
            {
              "x": -21.64,
              "y": -16.2
            },
            {
              "x": -23.93,
              "y": 29.09
            },
            {
              "x": 31.05,
              "y": -4.99
            },
            {
              "x": 7.57,
              "y": 0.92
            },
            {
              "x": -14.55,
              "y": -22.08
            },
            {
              "x": -16.49,
              "y": 3.74
            },
            {
              "x": -9.02,
              "y": -30.36
            },
            {
              "x": -5.55,
              "y": 11.15
            }
          ],
          "awayPlayers": [
            {
              "x": -11.14,
              "y": -2.84
            },
            {
              "x": -16.71,
              "y": -23.16
            },
            {
              "x": -41.99,
              "y": -4.17
            },
            {
              "x": -22.31,
              "y": -16.02
            },
            {
              "x": -1.57,
              "y": 0.49
            },
            {
              "x": -24.82,
              "y": -27.39
            },
            {
              "x": -18.76,
              "y": -15.97
            },
            {
              "x": -22.23,
              "y": 14.48
            },
            {
              "x": -24.93,
              "y": 1.41
            },
            {
              "x": -10.73,
              "y": -21.03
            },
            {
              "x": -16.84,
              "y": -26.46
            }
          ],
          "time": 4.338
        },
        {
          "ball": {
            "x": -20.92,
            "y": -14.83,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -6.08,
              "y": -14.53
            },
            {
              "x": -22.03,
              "y": -33.15
            },
            {
              "x": 6.34,
              "y": -20.75
            },
            {
              "x": -21.83,
              "y": -15.87
            },
            {
              "x": -24.43,
              "y": 29.09
            },
            {
              "x": 30.77,
              "y": -4.89
            },
            {
              "x": 7.05,
              "y": 0.6
            },
            {
              "x": -15.69,
              "y": -20.1
            },
            {
              "x": -16.95,
              "y": 3.55
            },
            {
              "x": -9.25,
              "y": -29.62
            },
            {
              "x": -5.9,
              "y": 11.17
            }
          ],
          "awayPlayers": [
            {
              "x": -11.96,
              "y": -2.83
            },
            {
              "x": -18.33,
              "y": -22.09
            },
            {
              "x": -42.42,
              "y": -4.28
            },
            {
              "x": -22.88,
              "y": -15.84
            },
            {
              "x": -1.83,
              "y": 0.72
            },
            {
              "x": -25.44,
              "y": -25.93
            },
            {
              "x": -20.12,
              "y": -15.51
            },
            {
              "x": -22.74,
              "y": 14.31
            },
            {
              "x": -25.61,
              "y": 0.88
            },
            {
              "x": -11.11,
              "y": -20.71
            },
            {
              "x": -17.55,
              "y": -26.25
            }
          ],
          "time": 4.671
        },
        {
          "ball": {
            "x": -20.59,
            "y": -14.96,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -6.17,
              "y": -14.52
            },
            {
              "x": -22.14,
              "y": -33.12
            },
            {
              "x": 6.32,
              "y": -20.74
            },
            {
              "x": -21.87,
              "y": -15.86
            },
            {
              "x": -24.53,
              "y": 29.05
            },
            {
              "x": 30.78,
              "y": -4.87
            },
            {
              "x": 6.98,
              "y": 0.51
            },
            {
              "x": -15.92,
              "y": -19.71
            },
            {
              "x": -17.04,
              "y": 3.5
            },
            {
              "x": -9.31,
              "y": -29.44
            },
            {
              "x": -5.98,
              "y": 11.13
            }
          ],
          "awayPlayers": [
            {
              "x": -12.14,
              "y": -2.84
            },
            {
              "x": -18.64,
              "y": -21.86
            },
            {
              "x": -42.53,
              "y": -4.29
            },
            {
              "x": -23.0,
              "y": -15.78
            },
            {
              "x": -1.89,
              "y": 0.77
            },
            {
              "x": -25.59,
              "y": -25.59
            },
            {
              "x": -20.36,
              "y": -15.37
            },
            {
              "x": -22.84,
              "y": 14.25
            },
            {
              "x": -25.75,
              "y": 0.75
            },
            {
              "x": -11.17,
              "y": -20.64
            },
            {
              "x": -17.68,
              "y": -26.21
            }
          ],
          "time": 4.738
        },
        {
          "ball": {
            "x": -19.78,
            "y": -15.21,
            "z": 0.01
          },
          "homePlayers": [
            {
              "x": -6.35,
              "y": -14.51
            },
            {
              "x": -22.36,
              "y": -33.07
            },
            {
              "x": 6.29,
              "y": -20.74
            },
            {
              "x": -21.94,
              "y": -15.85
            },
            {
              "x": -24.73,
              "y": 28.94
            },
            {
              "x": 30.72,
              "y": -4.81
            },
            {
              "x": 6.67,
              "y": 0.41
            },
            {
              "x": -16.37,
              "y": -18.94
            },
            {
              "x": -17.22,
              "y": 3.36
            },
            {
              "x": -9.44,
              "y": -29.05
            },
            {
              "x": -6.16,
              "y": 11.04
            }
          ],
          "awayPlayers": [
            {
              "x": -12.54,
              "y": -2.88
            },
            {
              "x": -19.26,
              "y": -21.4
            },
            {
              "x": -42.73,
              "y": -4.35
            },
            {
              "x": -23.26,
              "y": -15.63
            },
            {
              "x": -2.02,
              "y": 0.84
            },
            {
              "x": -25.91,
              "y": -24.91
            },
            {
              "x": -20.78,
              "y": -15.05
            },
            {
              "x": -23.05,
              "y": 14.12
            },
            {
              "x": -26.0,
              "y": 0.46
            },
            {
              "x": -11.28,
              "y": -20.49
            },
            {
              "x": -17.93,
              "y": -26.15
            }
          ],
          "time": 4.838
        },
        {
          "ball": {
            "x": -17.73,
            "y": -15.77,
            "z": 0.06
          },
          "homePlayers": [
            {
              "x": -6.87,
              "y": -14.54
            },
            {
              "x": -22.88,
              "y": -33.01
            },
            {
              "x": 6.2,
              "y": -20.66
            },
            {
              "x": -22.31,
              "y": -15.58
            },
            {
              "x": -25.18,
              "y": 28.51
            },
            {
              "x": 30.46,
              "y": -4.68
            },
            {
              "x": 6.04,
              "y": 0.17
            },
            {
              "x": -17.36,
              "y": -16.99
            },
            {
              "x": -17.73,
              "y": 3.06
            },
            {
              "x": -9.78,
              "y": -28.1
            },
            {
              "x": -6.52,
              "y": 10.71
            }
          ],
          "awayPlayers": [
            {
              "x": -13.57,
              "y": -3.05
            },
            {
              "x": -20.69,
              "y": -20.35
            },
            {
              "x": -43.3,
              "y": -4.4
            },
            {
              "x": -23.91,
              "y": -15.39
            },
            {
              "x": -2.39,
              "y": 0.91
            },
            {
              "x": -26.74,
              "y": -23.28
            },
            {
              "x": -21.52,
              "y": -13.99
            },
            {
              "x": -23.6,
              "y": 13.71
            },
            {
              "x": -26.68,
              "y": -0.17
            },
            {
              "x": -11.53,
              "y": -20.19
            },
            {
              "x": -18.44,
              "y": -26.07
            }
          ],
          "time": 5.172
        },
        {
          "ball": {
            "x": -16.86,
            "y": -14.61,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -7.43,
              "y": -14.49
            },
            {
              "x": -23.37,
              "y": -32.87
            },
            {
              "x": 5.75,
              "y": -20.48
            },
            {
              "x": -22.7,
              "y": -15.45
            },
            {
              "x": -25.55,
              "y": 27.98
            },
            {
              "x": 30.31,
              "y": -4.55
            },
            {
              "x": 5.39,
              "y": -0.11
            },
            {
              "x": -18.01,
              "y": -15.12
            },
            {
              "x": -18.38,
              "y": 2.83
            },
            {
              "x": -10.06,
              "y": -27.09
            },
            {
              "x": -6.8,
              "y": 10.35
            }
          ],
          "awayPlayers": [
            {
              "x": -14.56,
              "y": -3.25
            },
            {
              "x": -21.89,
              "y": -19.21
            },
            {
              "x": -44.02,
              "y": -4.13
            },
            {
              "x": -24.58,
              "y": -14.9
            },
            {
              "x": -2.72,
              "y": 0.91
            },
            {
              "x": -27.46,
              "y": -21.74
            },
            {
              "x": -21.79,
              "y": -13.28
            },
            {
              "x": -24.16,
              "y": 13.31
            },
            {
              "x": -27.35,
              "y": -0.62
            },
            {
              "x": -11.72,
              "y": -19.77
            },
            {
              "x": -18.82,
              "y": -25.95
            }
          ],
          "time": 5.506
        },
        {
          "ball": {
            "x": -16.5,
            "y": -12.97,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -8.01,
              "y": -14.32
            },
            {
              "x": -23.85,
              "y": -32.67
            },
            {
              "x": 5.18,
              "y": -20.11
            },
            {
              "x": -23.26,
              "y": -15.11
            },
            {
              "x": -25.86,
              "y": 27.58
            },
            {
              "x": 30.24,
              "y": -4.33
            },
            {
              "x": 4.84,
              "y": -0.32
            },
            {
              "x": -18.05,
              "y": -13.35
            },
            {
              "x": -19.16,
              "y": 2.78
            },
            {
              "x": -10.23,
              "y": -26.06
            },
            {
              "x": -7.02,
              "y": 10.06
            }
          ],
          "awayPlayers": [
            {
              "x": -15.37,
              "y": -3.56
            },
            {
              "x": -22.73,
              "y": -17.95
            },
            {
              "x": -44.8,
              "y": -3.65
            },
            {
              "x": -25.23,
              "y": -14.39
            },
            {
              "x": -3.1,
              "y": 0.8
            },
            {
              "x": -28.08,
              "y": -20.34
            },
            {
              "x": -21.74,
              "y": -12.56
            },
            {
              "x": -24.76,
              "y": 12.92
            },
            {
              "x": -27.93,
              "y": -0.81
            },
            {
              "x": -11.97,
              "y": -19.09
            },
            {
              "x": -19.07,
              "y": -25.71
            }
          ],
          "time": 5.839
        },
        {
          "ball": {
            "x": -16.26,
            "y": -11.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -8.54,
              "y": -14.03
            },
            {
              "x": -24.28,
              "y": -32.43
            },
            {
              "x": 4.6,
              "y": -19.61
            },
            {
              "x": -23.84,
              "y": -15.23
            },
            {
              "x": -26.08,
              "y": 27.16
            },
            {
              "x": 30.15,
              "y": -4.08
            },
            {
              "x": 4.37,
              "y": -0.42
            },
            {
              "x": -17.53,
              "y": -12.03
            },
            {
              "x": -20.0,
              "y": 2.54
            },
            {
              "x": -10.37,
              "y": -25.03
            },
            {
              "x": -7.36,
              "y": 9.95
            }
          ],
          "awayPlayers": [
            {
              "x": -16.03,
              "y": -3.66
            },
            {
              "x": -23.24,
              "y": -16.61
            },
            {
              "x": -45.56,
              "y": -3.08
            },
            {
              "x": -25.93,
              "y": -13.57
            },
            {
              "x": -3.48,
              "y": 0.72
            },
            {
              "x": -28.53,
              "y": -19.09
            },
            {
              "x": -21.59,
              "y": -11.66
            },
            {
              "x": -25.42,
              "y": 12.63
            },
            {
              "x": -28.35,
              "y": -0.59
            },
            {
              "x": -12.23,
              "y": -18.16
            },
            {
              "x": -19.26,
              "y": -25.36
            }
          ],
          "time": 6.173
        },
        {
          "ball": {
            "x": -15.88,
            "y": -10.8,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -8.91,
              "y": -13.57
            },
            {
              "x": -24.71,
              "y": -32.07
            },
            {
              "x": -0.14,
              "y": -23.98
            },
            {
              "x": -24.54,
              "y": -15.21
            },
            {
              "x": -26.21,
              "y": 26.84
            },
            {
              "x": 29.99,
              "y": -3.85
            },
            {
              "x": 4.03,
              "y": -0.53
            },
            {
              "x": -16.7,
              "y": -10.89
            },
            {
              "x": -20.75,
              "y": 1.99
            },
            {
              "x": -10.51,
              "y": -24.03
            },
            {
              "x": -7.94,
              "y": 9.96
            }
          ],
          "awayPlayers": [
            {
              "x": -16.73,
              "y": -3.58
            },
            {
              "x": -23.34,
              "y": -15.43
            },
            {
              "x": -46.06,
              "y": -2.49
            },
            {
              "x": -26.57,
              "y": -12.58
            },
            {
              "x": -3.88,
              "y": 0.64
            },
            {
              "x": -28.87,
              "y": -17.87
            },
            {
              "x": -21.45,
              "y": -10.48
            },
            {
              "x": -26.12,
              "y": 12.38
            },
            {
              "x": -28.36,
              "y": -0.16
            },
            {
              "x": -12.52,
              "y": -17.1
            },
            {
              "x": -19.41,
              "y": -24.91
            }
          ],
          "time": 6.507
        },
        {
          "ball": {
            "x": -15.41,
            "y": -9.22,
            "z": 0.03
          },
          "homePlayers": [
            {
              "x": -9.17,
              "y": -13.09
            },
            {
              "x": -25.22,
              "y": -31.52
            },
            {
              "x": -1.93,
              "y": -25.7
            },
            {
              "x": -25.33,
              "y": -14.94
            },
            {
              "x": -26.33,
              "y": 26.77
            },
            {
              "x": 30.13,
              "y": -3.59
            },
            {
              "x": 3.71,
              "y": -0.33
            },
            {
              "x": -15.92,
              "y": -9.66
            },
            {
              "x": -21.58,
              "y": 1.35
            },
            {
              "x": -10.69,
              "y": -22.99
            },
            {
              "x": -8.84,
              "y": 10.26
            }
          ],
          "awayPlayers": [
            {
              "x": -17.55,
              "y": -3.43
            },
            {
              "x": -23.31,
              "y": -14.27
            },
            {
              "x": -46.33,
              "y": -1.83
            },
            {
              "x": -27.36,
              "y": -11.11
            },
            {
              "x": -4.22,
              "y": 0.69
            },
            {
              "x": -29.17,
              "y": -16.63
            },
            {
              "x": -21.33,
              "y": -9.09
            },
            {
              "x": -26.91,
              "y": 12.22
            },
            {
              "x": -27.89,
              "y": 0.39
            },
            {
              "x": -12.84,
              "y": -16.01
            },
            {
              "x": -19.67,
              "y": -24.33
            }
          ],
          "time": 6.84
        },
        {
          "ball": {
            "x": -15.09,
            "y": -7.23,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -9.39,
              "y": -12.53
            },
            {
              "x": -25.88,
              "y": -30.62
            },
            {
              "x": -1.45,
              "y": -25.22
            },
            {
              "x": -26.32,
              "y": -14.03
            },
            {
              "x": -26.59,
              "y": 26.95
            },
            {
              "x": 30.05,
              "y": -3.3
            },
            {
              "x": 3.43,
              "y": -0.1
            },
            {
              "x": -15.42,
              "y": -8.05
            },
            {
              "x": -22.61,
              "y": 0.98
            },
            {
              "x": -10.91,
              "y": -21.96
            },
            {
              "x": -9.99,
              "y": 10.65
            }
          ],
          "awayPlayers": [
            {
              "x": -18.41,
              "y": -2.96
            },
            {
              "x": -23.34,
              "y": -13.06
            },
            {
              "x": -46.38,
              "y": -1.21
            },
            {
              "x": -28.05,
              "y": -9.79
            },
            {
              "x": -4.58,
              "y": 0.9
            },
            {
              "x": -29.53,
              "y": -15.32
            },
            {
              "x": -21.3,
              "y": -7.57
            },
            {
              "x": -27.76,
              "y": 12.12
            },
            {
              "x": -27.08,
              "y": 0.66
            },
            {
              "x": -13.27,
              "y": -14.89
            },
            {
              "x": -20.21,
              "y": -23.56
            }
          ],
          "time": 7.174
        },
        {
          "ball": {
            "x": -14.79,
            "y": -5.56,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -9.62,
              "y": -11.95
            },
            {
              "x": -26.6,
              "y": -29.77
            },
            {
              "x": 1.07,
              "y": -22.29
            },
            {
              "x": -27.3,
              "y": -12.97
            },
            {
              "x": -27.01,
              "y": 27.13
            },
            {
              "x": 30.05,
              "y": -2.91
            },
            {
              "x": 3.01,
              "y": 0.33
            },
            {
              "x": -15.08,
              "y": -6.32
            },
            {
              "x": -23.75,
              "y": 0.7
            },
            {
              "x": -11.14,
              "y": -21.02
            },
            {
              "x": -11.29,
              "y": 11.3
            }
          ],
          "awayPlayers": [
            {
              "x": -19.08,
              "y": -2.23
            },
            {
              "x": -23.56,
              "y": -11.88
            },
            {
              "x": -46.34,
              "y": -0.88
            },
            {
              "x": -28.72,
              "y": -8.65
            },
            {
              "x": -4.95,
              "y": 1.24
            },
            {
              "x": -29.99,
              "y": -14.07
            },
            {
              "x": -21.36,
              "y": -5.97
            },
            {
              "x": -28.68,
              "y": 12.2
            },
            {
              "x": -26.65,
              "y": 1.13
            },
            {
              "x": -13.77,
              "y": -13.84
            },
            {
              "x": -21.11,
              "y": -22.74
            }
          ],
          "time": 7.508
        },
        {
          "ball": {
            "x": -14.63,
            "y": -3.8,
            "z": 0.09
          },
          "homePlayers": [
            {
              "x": -9.84,
              "y": -11.39
            },
            {
              "x": -27.32,
              "y": -28.87
            },
            {
              "x": 3.06,
              "y": -19.15
            },
            {
              "x": -28.21,
              "y": -11.94
            },
            {
              "x": -27.54,
              "y": 27.13
            },
            {
              "x": 29.79,
              "y": -2.51
            },
            {
              "x": 2.61,
              "y": 0.76
            },
            {
              "x": -14.92,
              "y": -4.74
            },
            {
              "x": -24.92,
              "y": 0.6
            },
            {
              "x": -11.39,
              "y": -20.17
            },
            {
              "x": -12.69,
              "y": 11.97
            }
          ],
          "awayPlayers": [
            {
              "x": -19.53,
              "y": -1.07
            },
            {
              "x": -23.91,
              "y": -10.79
            },
            {
              "x": -46.25,
              "y": -0.77
            },
            {
              "x": -29.28,
              "y": -7.59
            },
            {
              "x": -5.37,
              "y": 1.57
            },
            {
              "x": -30.5,
              "y": -12.89
            },
            {
              "x": -21.39,
              "y": -4.59
            },
            {
              "x": -29.56,
              "y": 12.59
            },
            {
              "x": -26.84,
              "y": 1.83
            },
            {
              "x": -14.39,
              "y": -12.78
            },
            {
              "x": -22.27,
              "y": -21.93
            }
          ],
          "time": 7.841
        },
        {
          "ball": {
            "x": -15.42,
            "y": -0.13,
            "z": 0.2
          },
          "homePlayers": [
            {
              "x": -10.08,
              "y": -10.8
            },
            {
              "x": -28.08,
              "y": -27.99
            },
            {
              "x": 3.24,
              "y": -17.01
            },
            {
              "x": -29.1,
              "y": -10.93
            },
            {
              "x": -28.11,
              "y": 26.98
            },
            {
              "x": 29.61,
              "y": -2.07
            },
            {
              "x": 2.23,
              "y": 1.25
            },
            {
              "x": -15.03,
              "y": -3.23
            },
            {
              "x": -26.02,
              "y": 0.73
            },
            {
              "x": -11.66,
              "y": -19.36
            },
            {
              "x": -14.17,
              "y": 12.78
            }
          ],
          "awayPlayers": [
            {
              "x": -19.88,
              "y": 0.27
            },
            {
              "x": -24.37,
              "y": -9.76
            },
            {
              "x": -46.22,
              "y": -0.53
            },
            {
              "x": -29.88,
              "y": -6.43
            },
            {
              "x": -6.91,
              "y": 2.82
            },
            {
              "x": -31.05,
              "y": -11.79
            },
            {
              "x": -21.47,
              "y": -3.22
            },
            {
              "x": -30.41,
              "y": 13.39
            },
            {
              "x": -27.59,
              "y": 2.74
            },
            {
              "x": -15.1,
              "y": -11.75
            },
            {
              "x": -23.56,
              "y": -21.16
            }
          ],
          "time": 8.175
        },
        {
          "ball": {
            "x": -17.42,
            "y": 5.14,
            "z": 0.04
          },
          "homePlayers": [
            {
              "x": -10.32,
              "y": -10.09
            },
            {
              "x": -28.88,
              "y": -27.02
            },
            {
              "x": 2.31,
              "y": -16.05
            },
            {
              "x": -30.0,
              "y": -9.96
            },
            {
              "x": -28.82,
              "y": 26.82
            },
            {
              "x": 29.4,
              "y": -1.64
            },
            {
              "x": 1.72,
              "y": 1.8
            },
            {
              "x": -15.44,
              "y": -1.97
            },
            {
              "x": -27.05,
              "y": 1.31
            },
            {
              "x": -11.95,
              "y": -18.63
            },
            {
              "x": -15.79,
              "y": 13.71
            }
          ],
          "awayPlayers": [
            {
              "x": -20.27,
              "y": 1.75
            },
            {
              "x": -24.93,
              "y": -8.77
            },
            {
              "x": -46.3,
              "y": -0.14
            },
            {
              "x": -30.5,
              "y": -5.31
            },
            {
              "x": -14.11,
              "y": 8.13
            },
            {
              "x": -31.68,
              "y": -10.71
            },
            {
              "x": -21.69,
              "y": -1.89
            },
            {
              "x": -31.13,
              "y": 14.28
            },
            {
              "x": -28.59,
              "y": 3.59
            },
            {
              "x": -15.86,
              "y": -10.75
            },
            {
              "x": -24.89,
              "y": -20.36
            }
          ],
          "time": 8.509
        },
        {
          "ball": {
            "x": -19.03,
            "y": 9.03,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -10.54,
              "y": -9.38
            },
            {
              "x": -29.78,
              "y": -25.97
            },
            {
              "x": 1.63,
              "y": -15.17
            },
            {
              "x": -30.91,
              "y": -9.06
            },
            {
              "x": -29.65,
              "y": 26.75
            },
            {
              "x": 29.15,
              "y": -1.28
            },
            {
              "x": 1.23,
              "y": 2.28
            },
            {
              "x": -16.05,
              "y": -1.02
            },
            {
              "x": -27.94,
              "y": 1.95
            },
            {
              "x": -12.23,
              "y": -17.92
            },
            {
              "x": -17.47,
              "y": 14.31
            }
          ],
          "awayPlayers": [
            {
              "x": -20.87,
              "y": 3.28
            },
            {
              "x": -25.59,
              "y": -7.82
            },
            {
              "x": -46.35,
              "y": 0.18
            },
            {
              "x": -31.24,
              "y": -4.31
            },
            {
              "x": -21.52,
              "y": 13.59
            },
            {
              "x": -32.38,
              "y": -9.64
            },
            {
              "x": -22.06,
              "y": -0.64
            },
            {
              "x": -31.81,
              "y": 15.29
            },
            {
              "x": -29.7,
              "y": 4.32
            },
            {
              "x": -16.65,
              "y": -9.9
            },
            {
              "x": -26.22,
              "y": -19.58
            }
          ],
          "time": 8.842
        },
        {
          "ball": {
            "x": -20.13,
            "y": 11.66,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -10.82,
              "y": -8.45
            },
            {
              "x": -30.79,
              "y": -24.75
            },
            {
              "x": 1.21,
              "y": -14.51
            },
            {
              "x": -31.88,
              "y": -8.26
            },
            {
              "x": -30.57,
              "y": 26.53
            },
            {
              "x": 28.83,
              "y": -0.96
            },
            {
              "x": 0.8,
              "y": 2.74
            },
            {
              "x": -16.89,
              "y": -0.3
            },
            {
              "x": -28.89,
              "y": 2.64
            },
            {
              "x": -12.55,
              "y": -17.3
            },
            {
              "x": -19.1,
              "y": 14.58
            }
          ],
          "awayPlayers": [
            {
              "x": -21.74,
              "y": 4.81
            },
            {
              "x": -26.35,
              "y": -6.95
            },
            {
              "x": -46.51,
              "y": 0.45
            },
            {
              "x": -32.15,
              "y": -3.27
            },
            {
              "x": -28.3,
              "y": 17.71
            },
            {
              "x": -33.21,
              "y": -8.68
            },
            {
              "x": -22.68,
              "y": 0.42
            },
            {
              "x": -32.47,
              "y": 16.08
            },
            {
              "x": -30.91,
              "y": 5.08
            },
            {
              "x": -17.47,
              "y": -9.09
            },
            {
              "x": -27.53,
              "y": -18.74
            }
          ],
          "time": 9.176
        },
        {
          "ball": {
            "x": -21.25,
            "y": 13.93,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -11.2,
              "y": -7.24
            },
            {
              "x": -31.93,
              "y": -23.33
            },
            {
              "x": 0.97,
              "y": -13.86
            },
            {
              "x": -32.95,
              "y": -7.59
            },
            {
              "x": -31.57,
              "y": 26.38
            },
            {
              "x": 28.84,
              "y": -0.75
            },
            {
              "x": 0.43,
              "y": 3.31
            },
            {
              "x": -17.87,
              "y": 0.26
            },
            {
              "x": -29.93,
              "y": 3.26
            },
            {
              "x": -12.94,
              "y": -16.59
            },
            {
              "x": -20.59,
              "y": 14.76
            }
          ],
          "awayPlayers": [
            {
              "x": -22.89,
              "y": 6.46
            },
            {
              "x": -27.22,
              "y": -6.2
            },
            {
              "x": -46.75,
              "y": 0.7
            },
            {
              "x": -33.19,
              "y": -2.19
            },
            {
              "x": -29.04,
              "y": 18.1
            },
            {
              "x": -34.14,
              "y": -7.78
            },
            {
              "x": -23.53,
              "y": 1.36
            },
            {
              "x": -33.27,
              "y": 16.65
            },
            {
              "x": -32.19,
              "y": 5.86
            },
            {
              "x": -18.36,
              "y": -8.28
            },
            {
              "x": -28.87,
              "y": -17.86
            }
          ],
          "time": 9.51
        },
        {
          "ball": {
            "x": -23.18,
            "y": 14.77,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -11.4,
              "y": -6.51
            },
            {
              "x": -33.16,
              "y": -21.71
            },
            {
              "x": 0.58,
              "y": -13.25
            },
            {
              "x": -34.15,
              "y": -7.19
            },
            {
              "x": -32.55,
              "y": 26.18
            },
            {
              "x": 28.51,
              "y": -0.52
            },
            {
              "x": -0.01,
              "y": 3.66
            },
            {
              "x": -18.93,
              "y": 0.81
            },
            {
              "x": -31.11,
              "y": 3.92
            },
            {
              "x": -13.35,
              "y": -15.87
            },
            {
              "x": -22.1,
              "y": 15.05
            }
          ],
          "awayPlayers": [
            {
              "x": -24.2,
              "y": 8.22
            },
            {
              "x": -28.17,
              "y": -5.36
            },
            {
              "x": -47.12,
              "y": 0.94
            },
            {
              "x": -34.26,
              "y": -1.04
            },
            {
              "x": -30.34,
              "y": 18.11
            },
            {
              "x": -35.22,
              "y": -7.18
            },
            {
              "x": -24.58,
              "y": 2.2
            },
            {
              "x": -34.1,
              "y": 16.99
            },
            {
              "x": -33.53,
              "y": 6.72
            },
            {
              "x": -19.22,
              "y": -7.39
            },
            {
              "x": -30.25,
              "y": -16.92
            }
          ],
          "time": 9.843
        },
        {
          "ball": {
            "x": -25.13,
            "y": 15.13,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -11.36,
              "y": -6.02
            },
            {
              "x": -34.45,
              "y": -19.97
            },
            {
              "x": 0.23,
              "y": -12.24
            },
            {
              "x": -35.44,
              "y": -7.01
            },
            {
              "x": -33.51,
              "y": 26.07
            },
            {
              "x": 28.4,
              "y": -0.32
            },
            {
              "x": -0.64,
              "y": 3.97
            },
            {
              "x": -20.01,
              "y": 1.22
            },
            {
              "x": -32.32,
              "y": 4.46
            },
            {
              "x": -13.79,
              "y": -15.04
            },
            {
              "x": -23.89,
              "y": 15.57
            }
          ],
          "awayPlayers": [
            {
              "x": -25.71,
              "y": 10.19
            },
            {
              "x": -29.28,
              "y": -4.26
            },
            {
              "x": -47.58,
              "y": 1.24
            },
            {
              "x": -35.45,
              "y": 0.1
            },
            {
              "x": -31.19,
              "y": 18.28
            },
            {
              "x": -36.46,
              "y": -6.75
            },
            {
              "x": -25.71,
              "y": 2.9
            },
            {
              "x": -35.0,
              "y": 17.17
            },
            {
              "x": -34.8,
              "y": 7.6
            },
            {
              "x": -20.08,
              "y": -6.53
            },
            {
              "x": -31.78,
              "y": -15.84
            }
          ],
          "time": 10.177
        },
        {
          "ball": {
            "x": -26.9,
            "y": 15.73,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -11.54,
              "y": -5.4
            },
            {
              "x": -35.81,
              "y": -18.12
            },
            {
              "x": -0.29,
              "y": -11.36
            },
            {
              "x": -36.86,
              "y": -6.81
            },
            {
              "x": -34.5,
              "y": 25.81
            },
            {
              "x": 27.88,
              "y": -0.07
            },
            {
              "x": -1.37,
              "y": 4.13
            },
            {
              "x": -21.2,
              "y": 1.53
            },
            {
              "x": -33.55,
              "y": 4.95
            },
            {
              "x": -14.36,
              "y": -14.18
            },
            {
              "x": -25.89,
              "y": 15.9
            }
          ],
          "awayPlayers": [
            {
              "x": -27.32,
              "y": 11.96
            },
            {
              "x": -30.29,
              "y": -3.41
            },
            {
              "x": -48.03,
              "y": 1.49
            },
            {
              "x": -36.7,
              "y": 1.15
            },
            {
              "x": -32.79,
              "y": 17.81
            },
            {
              "x": -37.84,
              "y": -6.42
            },
            {
              "x": -26.89,
              "y": 3.46
            },
            {
              "x": -35.92,
              "y": 17.26
            },
            {
              "x": -35.93,
              "y": 8.58
            },
            {
              "x": -20.97,
              "y": -5.6
            },
            {
              "x": -33.51,
              "y": -14.63
            }
          ],
          "time": 10.511
        },
        {
          "ball": {
            "x": -29.18,
            "y": 15.03,
            "z": 0.02
          },
          "homePlayers": [
            {
              "x": -11.97,
              "y": -4.81
            },
            {
              "x": -37.19,
              "y": -16.23
            },
            {
              "x": -0.69,
              "y": -10.41
            },
            {
              "x": -38.23,
              "y": -6.38
            },
            {
              "x": -35.56,
              "y": 25.67
            },
            {
              "x": 27.88,
              "y": 0.08
            },
            {
              "x": -2.13,
              "y": 4.37
            },
            {
              "x": -22.5,
              "y": 1.72
            },
            {
              "x": -34.77,
              "y": 5.4
            },
            {
              "x": -15.04,
              "y": -13.35
            },
            {
              "x": -27.55,
              "y": 16.11
            }
          ],
          "awayPlayers": [
            {
              "x": -29.0,
              "y": 13.48
            },
            {
              "x": -31.22,
              "y": -2.71
            },
            {
              "x": -48.47,
              "y": 1.76
            },
            {
              "x": -37.98,
              "y": 2.15
            },
            {
              "x": -33.59,
              "y": 17.65
            },
            {
              "x": -39.26,
              "y": -6.04
            },
            {
              "x": -28.05,
              "y": 3.84
            },
            {
              "x": -36.83,
              "y": 17.33
            },
            {
              "x": -36.74,
              "y": 9.44
            },
            {
              "x": -21.88,
              "y": -4.72
            },
            {
              "x": -35.62,
              "y": -13.21
            }
          ],
          "time": 10.844
        },
        {
          "ball": {
            "x": -32.47,
            "y": 10.79,
            "z": 0.0
          },
          "homePlayers": [
            {
              "x": -12.8,
              "y": -3.82
            },
            {
              "x": -38.55,
              "y": -14.38
            },
            {
              "x": -1.12,
              "y": -9.82
            },
            {
              "x": -39.48,
              "y": -5.33
            },
            {
              "x": -36.58,
              "y": 25.53
            },
            {
              "x": 27.39,
              "y": 0.23
            },
            {
              "x": -2.79,
              "y": 4.66
            },
            {
              "x": -23.96,
              "y": 1.88
            },
            {
              "x": -35.75,
              "y": 5.79
            },
            {
              "x": -15.75,
              "y": -12.67
            },
            {
              "x": -28.44,
              "y": 16.23
            }
          ],
          "awayPlayers": [
            {
              "x": -30.6,
              "y": 14.64
            },
            {
              "x": -31.98,
              "y": -2.23
            },
            {
              "x": -48.68,
              "y": 1.71
            },
            {
              "x": -38.79,
              "y": 2.93
            },
            {
              "x": -34.65,
              "y": 17.29
            },
            {
              "x": -40.59,
              "y": -5.31
            },
            {
              "x": -29.27,
              "y": 4.26
            },
            {
              "x": -37.61,
              "y": 17.39
            },
            {
              "x": -37.38,
              "y": 10.1
            },
            {
              "x": -22.77,
              "y": -3.83
            },
            {
              "x": -37.03,
              "y": -11.36
            }
          ],
          "time": 11.178
        },
        {
          "ball": {
            "x": -34.83,
            "y": 7.4,
            "z": 0.06
          },
          "homePlayers": [
            {
              "x": -13.6,
              "y": -3.15
            },
            {
              "x": -39.67,
              "y": -12.74
            },
            {
              "x": -1.42,
              "y": -9.3
            },
            {
              "x": -40.28,
              "y": -4.01
            },
            {
              "x": -37.47,
              "y": 25.23
            },
            {
              "x": 27.27,
              "y": 0.28
            },
            {
              "x": -3.41,
              "y": 4.94
            },
            {
              "x": -25.51,
              "y": 1.7
            },
            {
              "x": -36.48,
              "y": 5.99
            },
            {
              "x": -16.48,
              "y": -12.12
            },
            {
              "x": -28.66,
              "y": 16.53
            }
          ],
          "awayPlayers": [
            {
              "x": -31.99,
              "y": 15.28
            },
            {
              "x": -32.8,
              "y": -1.51
            },
            {
              "x": -48.81,
              "y": 1.58
            },
            {
              "x": -38.92,
              "y": 3.43
            },
            {
              "x": -35.03,
              "y": 17.27
            },
            {
              "x": -41.48,
              "y": -4.18
            },
            {
              "x": -30.54,
              "y": 4.58
            },
            {
              "x": -38.31,
              "y": 17.45
            },
            {
              "x": -37.87,
              "y": 10.1
            },
            {
              "x": -23.67,
              "y": -3.1
            },
            {
              "x": -38.73,
              "y": -4.84
            }
          ],
          "time": 11.512
        }
      ],
      "duration": 11.512,
      "videoUrl": "https://epitome-staging.gradientsports.com/en/film_room/d8cab85d-4f7d-4b69-b3c3-6e9eaf99986f/3119.92"
    }
  ]
}